//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordInput | undefined): Observable<ForgotPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForgotPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForgotPasswordOutput>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<ForgotPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForgotPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForgotPasswordOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkResetCodeExpireDate(body: CheckResetCodeExpireDateInput | undefined): Observable<CheckResetCodeExpireDateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/CheckResetCodeExpireDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckResetCodeExpireDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckResetCodeExpireDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckResetCodeExpireDateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckResetCodeExpireDateOutput>;
        }));
    }

    protected processCheckResetCodeExpireDate(response: HttpResponseBase): Observable<CheckResetCodeExpireDateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckResetCodeExpireDateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckResetCodeExpireDateOutput>(null as any);
    }
}

@Injectable()
export class AdministrativoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getGraficoAssinatura(): Observable<GraficoResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administrativo/GetGraficoAssinatura";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraficoAssinatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraficoAssinatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GraficoResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GraficoResponseDto[]>;
        }));
    }

    protected processGetGraficoAssinatura(response: HttpResponseBase): Observable<GraficoResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GraficoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GraficoResponseDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getGraficoConsultas(): Observable<GraficoResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administrativo/GetGraficoConsultas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraficoConsultas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraficoConsultas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GraficoResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GraficoResponseDto[]>;
        }));
    }

    protected processGetGraficoConsultas(response: HttpResponseBase): Observable<GraficoResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GraficoResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GraficoResponseDto[]>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @return Success
     */
    getInformacoesHome(dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined): Observable<InformacoesHomeAdminDto> {
        let url_ = this.baseUrl + "/api/services/app/Administrativo/GetInformacoesHome?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "dataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacoesHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacoesHome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformacoesHomeAdminDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformacoesHomeAdminDto>;
        }));
    }

    protected processGetInformacoesHome(response: HttpResponseBase): Observable<InformacoesHomeAdminDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformacoesHomeAdminDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InformacoesHomeAdminDto>(null as any);
    }
}

@Injectable()
export class AgendaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    getAgendaProfissional(profissionalId: string | undefined, clinicaId: string | null | undefined): Observable<AgendaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetAgendaProfissional?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgendaProfissional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgendaProfissional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaDto[]>;
        }));
    }

    protected processGetAgendaProfissional(response: HttpResponseBase): Observable<AgendaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AgendaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgendaDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AgendaDto> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AgendaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgendaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgendaDto>(null as any);
    }

    /**
     * @param clinicaId (optional) 
     * @param profissionalId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(clinicaId: string | null | undefined, profissionalId: string | null | undefined, keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AgendaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetAll?";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "ProfissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AgendaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgendaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgendaDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAgendaDto | undefined): Observable<AgendaDto> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AgendaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgendaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgendaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAgendaDto | undefined): Observable<AgendaDto> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AgendaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgendaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgendaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    alternarSuspensao(body: GuidEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/AlternarSuspensao";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAlternarSuspensao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAlternarSuspensao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAlternarSuspensao(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getDaysOfWeek(): Observable<Int32NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetDaysOfWeek";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDaysOfWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDaysOfWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NameValueDto[]>;
        }));
    }

    protected processGetDaysOfWeek(response: HttpResponseBase): Observable<Int32NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Int32NameValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32NameValueDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createHorarioDisponivel(body: CreateHorarioDisponivelDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/CreateHorarioDisponivel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHorarioDisponivel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHorarioDisponivel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateHorarioDisponivel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AlergiaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAlergiaDto | undefined): Observable<AlergiaDto> {
        let url_ = this.baseUrl + "/api/services/app/Alergia/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlergiaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlergiaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AlergiaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlergiaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlergiaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAlergiaDto | undefined): Observable<AlergiaDto> {
        let url_ = this.baseUrl + "/api/services/app/Alergia/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlergiaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlergiaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AlergiaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlergiaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlergiaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Alergia/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AlergiaDto> {
        let url_ = this.baseUrl + "/api/services/app/Alergia/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlergiaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlergiaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlergiaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlergiaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlergiaDto>(null as any);
    }

    /**
     * @param substancia (optional) 
     * @param tipoAlergia (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(substancia: string | null | undefined, tipoAlergia: TipoAlergiaEnum | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AlergiaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Alergia/GetAll?";
        if (substancia !== undefined && substancia !== null)
            url_ += "Substancia=" + encodeURIComponent("" + substancia) + "&";
        if (tipoAlergia === null)
            throw new Error("The parameter 'tipoAlergia' cannot be null.");
        else if (tipoAlergia !== undefined)
            url_ += "TipoAlergia=" + encodeURIComponent("" + tipoAlergia) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlergiaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlergiaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AlergiaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlergiaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlergiaDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAlergiasToSelect(): Observable<SelectItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alergia/GetAlergiasToSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlergiasToSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlergiasToSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectItemDto[]>;
        }));
    }

    protected processGetAlergiasToSelect(response: HttpResponseBase): Observable<SelectItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectItemDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAlergias(input: string | null | undefined): Observable<AlergiaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alergia/GetAlergias?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlergias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlergias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlergiaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlergiaDto[]>;
        }));
    }

    protected processGetAlergias(response: HttpResponseBase): Observable<AlergiaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AlergiaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlergiaDto[]>(null as any);
    }
}

@Injectable()
export class AlteracaoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAlteracao(body: CreateAlteracaoDto | undefined): Observable<AlteracaoDto> {
        let url_ = this.baseUrl + "/api/services/app/Alteracao/CreateAlteracao";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlteracao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlteracao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlteracaoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlteracaoDto>;
        }));
    }

    protected processCreateAlteracao(response: HttpResponseBase): Observable<AlteracaoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlteracaoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlteracaoDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param sincronizado (optional) 
     * @return Success
     */
    getAlteracao(pacienteId: string | undefined, sincronizado: boolean | null | undefined): Observable<AlteracaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alteracao/GetAlteracao?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (sincronizado !== undefined && sincronizado !== null)
            url_ += "sincronizado=" + encodeURIComponent("" + sincronizado) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlteracao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlteracao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlteracaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlteracaoDto[]>;
        }));
    }

    protected processGetAlteracao(response: HttpResponseBase): Observable<AlteracaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AlteracaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlteracaoDto[]>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param data (optional) 
     * @return Success
     */
    getAlteracaoData(pacienteId: string | undefined, data: string | null | undefined): Observable<AlteracaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alteracao/GetAlteracaoData?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlteracaoData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlteracaoData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlteracaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlteracaoDto[]>;
        }));
    }

    protected processGetAlteracaoData(response: HttpResponseBase): Observable<AlteracaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AlteracaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlteracaoDto[]>(null as any);
    }

    /**
     * @param atualizacaoId (optional) 
     * @return Success
     */
    updateAlteracao(atualizacaoId: string | undefined): Observable<AlteracaoDto> {
        let url_ = this.baseUrl + "/api/services/app/Alteracao/UpdateAlteracao?";
        if (atualizacaoId === null)
            throw new Error("The parameter 'atualizacaoId' cannot be null.");
        else if (atualizacaoId !== undefined)
            url_ += "atualizacaoId=" + encodeURIComponent("" + atualizacaoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAlteracao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAlteracao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlteracaoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlteracaoDto>;
        }));
    }

    protected processUpdateAlteracao(response: HttpResponseBase): Observable<AlteracaoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlteracaoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlteracaoDto>(null as any);
    }

    /**
     * @return Success
     */
    getHoraServidor(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Alteracao/GetHoraServidor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHoraServidor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHoraServidor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetHoraServidor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class AlturaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAltura(body: CreateAlturaDto | undefined): Observable<AlturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Altura/CreateAltura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAltura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAltura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlturaDto>;
        }));
    }

    protected processCreateAltura(response: HttpResponseBase): Observable<AlturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlturaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAltura(body: UpdateAlturaDto | undefined): Observable<AlturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Altura/UpdateAltura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAltura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAltura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlturaDto>;
        }));
    }

    protected processUpdateAltura(response: HttpResponseBase): Observable<AlturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlturaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoAltura(body: AlturaDto | undefined): Observable<AlturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Altura/DeletarDadoAltura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoAltura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoAltura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlturaDto>;
        }));
    }

    protected processDeletarDadoAltura(response: HttpResponseBase): Observable<AlturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlturaDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<AlturaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Altura/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlturaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlturaDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<AlturaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AlturaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlturaDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AlturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Altura/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlturaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlturaDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AlturaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Altura/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlturaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlturaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AlturaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlturaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlturaDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Altura/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ArquivoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param url (optional) 
     * @return Success
     */
    getTemporaryLink(url: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/GetTemporaryLink?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemporaryLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemporaryLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTemporaryLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFile(id: string | undefined): Observable<ArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/GetFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<ArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto>(null as any);
    }

    /**
     * @param acessoProntuarioId (optional) 
     * @param pacienteId (optional) 
     * @param arquivoPaiId (optional) 
     * @param keyboard (optional) 
     * @return Success
     */
    getFileByPacienteAndParent(acessoProntuarioId: string | null | undefined, pacienteId: string | undefined, arquivoPaiId: string | null | undefined, keyboard: string | null | undefined): Observable<ArquivoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/GetFileByPacienteAndParent?";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "AcessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (arquivoPaiId !== undefined && arquivoPaiId !== null)
            url_ += "ArquivoPaiId=" + encodeURIComponent("" + arquivoPaiId) + "&";
        if (keyboard !== undefined && keyboard !== null)
            url_ += "Keyboard=" + encodeURIComponent("" + keyboard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileByPacienteAndParent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileByPacienteAndParent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto[]>;
        }));
    }

    protected processGetFileByPacienteAndParent(response: HttpResponseBase): Observable<ArquivoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArquivoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto[]>(null as any);
    }

    /**
     * @param acessoProntuarioId (optional) 
     * @param pacienteId (optional) 
     * @param arquivoPaiId (optional) 
     * @param keyboard (optional) 
     * @return Success
     */
    getAllFileByPaciente(acessoProntuarioId: string | null | undefined, pacienteId: string | undefined, arquivoPaiId: string | null | undefined, keyboard: string | null | undefined): Observable<ArquivoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/GetAllFileByPaciente?";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "AcessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (arquivoPaiId !== undefined && arquivoPaiId !== null)
            url_ += "ArquivoPaiId=" + encodeURIComponent("" + arquivoPaiId) + "&";
        if (keyboard !== undefined && keyboard !== null)
            url_ += "Keyboard=" + encodeURIComponent("" + keyboard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFileByPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFileByPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto[]>;
        }));
    }

    protected processGetAllFileByPaciente(response: HttpResponseBase): Observable<ArquivoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArquivoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createArquivo(body: CreateArquivoDto[] | null | undefined): Observable<ArquivoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/CreateArquivo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateArquivo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateArquivo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto[]>;
        }));
    }

    protected processCreateArquivo(response: HttpResponseBase): Observable<ArquivoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArquivoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto[]>(null as any);
    }

    /**
     * @param acessoProntuarioId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createArquivoMedicoConvidado(acessoProntuarioId: string | null | undefined, body: CreateArquivoDto[] | null | undefined): Observable<ArquivoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/CreateArquivoMedicoConvidado?";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateArquivoMedicoConvidado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateArquivoMedicoConvidado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto[]>;
        }));
    }

    protected processCreateArquivoMedicoConvidado(response: HttpResponseBase): Observable<ArquivoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArquivoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameArquivo(body: RenameArquivoDto | undefined): Observable<ArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/RenameArquivo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameArquivo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameArquivo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto>;
        }));
    }

    protected processRenameArquivo(response: HttpResponseBase): Observable<ArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param origem (optional) 
     * @return Success
     */
    deleteArquivo(id: string | undefined, origem: TipoOrigemEnum | undefined): Observable<ArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/DeleteArquivo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (origem === null)
            throw new Error("The parameter 'origem' cannot be null.");
        else if (origem !== undefined)
            url_ += "origem=" + encodeURIComponent("" + origem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArquivo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArquivo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto>;
        }));
    }

    protected processDeleteArquivo(response: HttpResponseBase): Observable<ArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto>(null as any);
    }

    /**
     * @param arquivoId (optional) 
     * @return Success
     */
    removerStatusVip(arquivoId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/RemoverStatusVip?";
        if (arquivoId === null)
            throw new Error("The parameter 'arquivoId' cannot be null.");
        else if (arquivoId !== undefined)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoverStatusVip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoverStatusVip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoverStatusVip(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param arquivoId (optional) 
     * @param pacienteId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    tornarArquivoVip(arquivoId: string | undefined, pacienteId: string | undefined, clinicaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/TornarArquivoVip?";
        if (arquivoId === null)
            throw new Error("The parameter 'arquivoId' cannot be null.");
        else if (arquivoId !== undefined)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (clinicaId === null)
            throw new Error("The parameter 'clinicaId' cannot be null.");
        else if (clinicaId !== undefined)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTornarArquivoVip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTornarArquivoVip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTornarArquivoVip(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getTamanhoArquivos(pacienteId: string | undefined, userId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Arquivo/GetTamanhoArquivos?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTamanhoArquivos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTamanhoArquivos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTamanhoArquivos(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class AssinaturaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAssinaturaDto | undefined): Observable<AssinaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssinaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssinaturaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AssinaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssinaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssinaturaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createByApple(body: CreateAssinaturaDto | undefined): Observable<AssinaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/CreateByApple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateByApple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateByApple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssinaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssinaturaDto>;
        }));
    }

    protected processCreateByApple(response: HttpResponseBase): Observable<AssinaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssinaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssinaturaDto>(null as any);
    }

    /**
     * @param usuarioId (optional) 
     * @return Success
     */
    activeOrDeActiveAssinatura(usuarioId: number | undefined): Observable<AssinaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/ActiveOrDeActiveAssinatura?";
        if (usuarioId === null)
            throw new Error("The parameter 'usuarioId' cannot be null.");
        else if (usuarioId !== undefined)
            url_ += "usuarioId=" + encodeURIComponent("" + usuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveOrDeActiveAssinatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveOrDeActiveAssinatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssinaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssinaturaDto>;
        }));
    }

    protected processActiveOrDeActiveAssinatura(response: HttpResponseBase): Observable<AssinaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssinaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssinaturaDto>(null as any);
    }

    /**
     * @param idUsuario (optional) 
     * @return Success
     */
    obterAssinatura(idUsuario: number | null | undefined): Observable<AssinaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/ObterAssinatura?";
        if (idUsuario !== undefined && idUsuario !== null)
            url_ += "idUsuario=" + encodeURIComponent("" + idUsuario) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObterAssinatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObterAssinatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssinaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssinaturaDto>;
        }));
    }

    protected processObterAssinatura(response: HttpResponseBase): Observable<AssinaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssinaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssinaturaDto>(null as any);
    }

    /**
     * @return Success
     */
    verificaAssinaturaRegular(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/VerificaAssinaturaRegular";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificaAssinaturaRegular(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificaAssinaturaRegular(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificaAssinaturaRegular(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    verificarAssinaturaValida(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/VerificarAssinaturaValida";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAssinaturaValida(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAssinaturaValida(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAssinaturaValida(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    obterMeiosDePagamentoCartao(): Observable<PaymentMethod[]> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/ObterMeiosDePagamentoCartao";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObterMeiosDePagamentoCartao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObterMeiosDePagamentoCartao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethod[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethod[]>;
        }));
    }

    protected processObterMeiosDePagamentoCartao(response: HttpResponseBase): Observable<PaymentMethod[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PaymentMethod.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethod[]>(null as any);
    }

    /**
     * @return Success
     */
    obterVersaoApple(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/ObterVersaoApple";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObterVersaoApple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObterVersaoApple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processObterVersaoApple(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param nome (optional) 
     * @param cpf (optional) 
     * @param numero (optional) 
     * @param mesVencimento (optional) 
     * @param anoVencimento (optional) 
     * @param cvv (optional) 
     * @return Success
     */
    getTokenCartao(nome: string | null | undefined, cpf: string | null | undefined, numero: string | null | undefined, mesVencimento: number | undefined, anoVencimento: number | undefined, cvv: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/GetTokenCartao?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (cpf !== undefined && cpf !== null)
            url_ += "Cpf=" + encodeURIComponent("" + cpf) + "&";
        if (numero !== undefined && numero !== null)
            url_ += "Numero=" + encodeURIComponent("" + numero) + "&";
        if (mesVencimento === null)
            throw new Error("The parameter 'mesVencimento' cannot be null.");
        else if (mesVencimento !== undefined)
            url_ += "MesVencimento=" + encodeURIComponent("" + mesVencimento) + "&";
        if (anoVencimento === null)
            throw new Error("The parameter 'anoVencimento' cannot be null.");
        else if (anoVencimento !== undefined)
            url_ += "AnoVencimento=" + encodeURIComponent("" + anoVencimento) + "&";
        if (cvv !== undefined && cvv !== null)
            url_ += "Cvv=" + encodeURIComponent("" + cvv) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenCartao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenCartao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTokenCartao(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param bin (optional) 
     * @return Success
     */
    getBanderiaCartao(bin: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/GetBanderiaCartao?";
        if (bin !== undefined && bin !== null)
            url_ += "bin=" + encodeURIComponent("" + bin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBanderiaCartao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanderiaCartao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBanderiaCartao(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @param userId (optional) 
     * @param tipoUsuario (optional) 
     * @return Success
     */
    cancelarAssinatura(id: string | undefined, userId: number | undefined, tipoUsuario: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/CancelarAssinatura?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tipoUsuario === null)
            throw new Error("The parameter 'tipoUsuario' cannot be null.");
        else if (tipoUsuario !== undefined)
            url_ += "tipoUsuario=" + encodeURIComponent("" + tipoUsuario) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelarAssinatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelarAssinatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelarAssinatura(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, userId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssinaturaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Assinatura/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssinaturaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssinaturaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssinaturaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssinaturaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssinaturaDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class AutoCompleteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param showCategory (optional) 
     * @return Success
     */
    getAutocompleteMedicamentos(keyword: string | null | undefined, showCategory: boolean | undefined): Observable<MentionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AutoComplete/GetAutocompleteMedicamentos?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (showCategory === null)
            throw new Error("The parameter 'showCategory' cannot be null.");
        else if (showCategory !== undefined)
            url_ += "showCategory=" + encodeURIComponent("" + showCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutocompleteMedicamentos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutocompleteMedicamentos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MentionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MentionDto[]>;
        }));
    }

    protected processGetAutocompleteMedicamentos(response: HttpResponseBase): Observable<MentionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MentionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentionDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param showCategory (optional) 
     * @return Success
     */
    getAutocompleteProcedimentos(keyword: string | null | undefined, showCategory: boolean | undefined): Observable<MentionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AutoComplete/GetAutocompleteProcedimentos?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (showCategory === null)
            throw new Error("The parameter 'showCategory' cannot be null.");
        else if (showCategory !== undefined)
            url_ += "showCategory=" + encodeURIComponent("" + showCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutocompleteProcedimentos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutocompleteProcedimentos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MentionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MentionDto[]>;
        }));
    }

    protected processGetAutocompleteProcedimentos(response: HttpResponseBase): Observable<MentionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MentionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentionDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getAutocompleteCid(keyword: string | null | undefined): Observable<MentionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AutoComplete/GetAutocompleteCid?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutocompleteCid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutocompleteCid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MentionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MentionDto[]>;
        }));
    }

    protected processGetAutocompleteCid(response: HttpResponseBase): Observable<MentionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MentionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentionDto[]>(null as any);
    }
}

@Injectable()
export class BatimentosCardiacosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBatimentosCardiacos(body: CreateBatimentosCardiacosDto | undefined): Observable<BatimentosCardiacosDto> {
        let url_ = this.baseUrl + "/api/services/app/BatimentosCardiacos/CreateBatimentosCardiacos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatimentosCardiacos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatimentosCardiacos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatimentosCardiacosDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatimentosCardiacosDto>;
        }));
    }

    protected processCreateBatimentosCardiacos(response: HttpResponseBase): Observable<BatimentosCardiacosDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatimentosCardiacosDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatimentosCardiacosDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBatimentosCardiacos(body: UpdateBatimentosCardiacosDto | undefined): Observable<BatimentosCardiacosDto> {
        let url_ = this.baseUrl + "/api/services/app/BatimentosCardiacos/UpdateBatimentosCardiacos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBatimentosCardiacos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBatimentosCardiacos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatimentosCardiacosDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatimentosCardiacosDto>;
        }));
    }

    protected processUpdateBatimentosCardiacos(response: HttpResponseBase): Observable<BatimentosCardiacosDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatimentosCardiacosDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatimentosCardiacosDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoBatimento(body: BatimentosCardiacosDto | undefined): Observable<BatimentosCardiacosDto> {
        let url_ = this.baseUrl + "/api/services/app/BatimentosCardiacos/DeletarDadoBatimento";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoBatimento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoBatimento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatimentosCardiacosDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatimentosCardiacosDto>;
        }));
    }

    protected processDeletarDadoBatimento(response: HttpResponseBase): Observable<BatimentosCardiacosDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatimentosCardiacosDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatimentosCardiacosDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicial (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicial: string | null | undefined, dataFinal: string | null | undefined): Observable<BatimentosCardiacosDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BatimentosCardiacos/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicial !== undefined && dataInicial !== null)
            url_ += "dataInicial=" + encodeURIComponent("" + dataInicial) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatimentosCardiacosDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatimentosCardiacosDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<BatimentosCardiacosDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BatimentosCardiacosDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatimentosCardiacosDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<BatimentosCardiacosDto> {
        let url_ = this.baseUrl + "/api/services/app/BatimentosCardiacos/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatimentosCardiacosDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatimentosCardiacosDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BatimentosCardiacosDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatimentosCardiacosDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatimentosCardiacosDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BatimentosCardiacosDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BatimentosCardiacos/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatimentosCardiacosDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatimentosCardiacosDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BatimentosCardiacosDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatimentosCardiacosDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatimentosCardiacosDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BatimentosCardiacos/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class CertificadoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getSecureData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Certificado/GetSecureData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetSecureData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ChatNotificacaoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    atualizarNotificacao(body: ChatNotificacaoDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChatNotificacao/AtualizarNotificacao";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtualizarNotificacao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtualizarNotificacao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAtualizarNotificacao(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param equipeId (optional) 
     * @return Success
     */
    atualizarNotificacaoByUserId(userId: number | undefined, equipeId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChatNotificacao/AtualizarNotificacaoByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (equipeId === null)
            throw new Error("The parameter 'equipeId' cannot be null.");
        else if (equipeId !== undefined)
            url_ += "equipeId=" + encodeURIComponent("" + equipeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtualizarNotificacaoByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtualizarNotificacaoByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAtualizarNotificacaoByUserId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getNotificacoes(): Observable<ChatNotificacaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChatNotificacao/GetNotificacoes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificacoes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificacoes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatNotificacaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatNotificacaoDto[]>;
        }));
    }

    protected processGetNotificacoes(response: HttpResponseBase): Observable<ChatNotificacaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ChatNotificacaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatNotificacaoDto[]>(null as any);
    }
}

@Injectable()
export class ChatServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enviarMensagem(body: ChatMensagemDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChatService/EnviarMensagem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarMensagem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarMensagem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnviarMensagem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enviarAnexos(body: ChatMensagemDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChatService/EnviarAnexos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarAnexos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarAnexos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnviarAnexos(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param clinicaId (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    getEquipesToChat(clinicaId: string | null | undefined, profissionalId: string | null | undefined): Observable<NewChatInformationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChatService/GetEquipesToChat?";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEquipesToChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquipesToChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewChatInformationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewChatInformationsDto[]>;
        }));
    }

    protected processGetEquipesToChat(response: HttpResponseBase): Observable<NewChatInformationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NewChatInformationsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewChatInformationsDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param equipeId (optional) 
     * @return Success
     */
    getChatMessages(userId: number | undefined, equipeId: string | null | undefined): Observable<ChatMensagemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChatService/GetChatMessages?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (equipeId !== undefined && equipeId !== null)
            url_ += "equipeId=" + encodeURIComponent("" + equipeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMensagemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMensagemDto[]>;
        }));
    }

    protected processGetChatMessages(response: HttpResponseBase): Observable<ChatMensagemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ChatMensagemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChatMensagemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getNewChats(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ChatService/GetNewChats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewChats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewChats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNewChats(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }
}

@Injectable()
export class CidServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CidDto> {
        let url_ = this.baseUrl + "/api/services/app/Cid/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CidDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CidDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CidDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CidDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CidDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CidDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cid/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CidDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CidDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CidDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CidDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CidDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCidDto | undefined): Observable<CidDto> {
        let url_ = this.baseUrl + "/api/services/app/Cid/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CidDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CidDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CidDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CidDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CidDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCidDto | undefined): Observable<CidDto> {
        let url_ = this.baseUrl + "/api/services/app/Cid/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CidDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CidDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CidDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CidDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CidDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cid/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    readTable(body: ImportTableDto | undefined): Observable<CreateCidDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cid/ReadTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCidDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCidDto[]>;
        }));
    }

    protected processReadTable(response: HttpResponseBase): Observable<CreateCidDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateCidDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateCidDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: CreateCidDto[] | null | undefined): Observable<CidDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cid/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CidDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CidDto[]>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<CidDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CidDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CidDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param tipo (optional) 
     * @param count (optional) 
     * @param prefix (optional) 
     * @return Success
     */
    getAutoComplete(keyword: string | null | undefined, tipo: string | null | undefined, count: number | undefined, prefix: string | undefined): Observable<MentionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cid/GetAutoComplete?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (tipo !== undefined && tipo !== null)
            url_ += "tipo=" + encodeURIComponent("" + tipo) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (prefix === null)
            throw new Error("The parameter 'prefix' cannot be null.");
        else if (prefix !== undefined)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MentionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MentionDto[]>;
        }));
    }

    protected processGetAutoComplete(response: HttpResponseBase): Observable<MentionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MentionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentionDto[]>(null as any);
    }
}

@Injectable()
export class ClinicaMedicaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ClinicaMedicaDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicaMedicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicaMedicaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClinicaMedicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicaMedicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicaMedicaDto>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @return Success
     */
    getByTenantId(tenancyName: string | null | undefined): Observable<DadosBasicosClinicaMedicaDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/GetByTenantId?";
        if (tenancyName !== undefined && tenancyName !== null)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DadosBasicosClinicaMedicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DadosBasicosClinicaMedicaDto>;
        }));
    }

    protected processGetByTenantId(response: HttpResponseBase): Observable<DadosBasicosClinicaMedicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DadosBasicosClinicaMedicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DadosBasicosClinicaMedicaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateClinicaMedicaDto | undefined): Observable<ClinicaMedicaDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicaMedicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicaMedicaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClinicaMedicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicaMedicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicaMedicaDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClinicaMedicaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicaMedicaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicaMedicaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ClinicaMedicaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicaMedicaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicaMedicaDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateClinicaMedicaDto | undefined): Observable<ClinicaMedicaDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicaMedicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicaMedicaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ClinicaMedicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicaMedicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicaMedicaDto>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @return Success
     */
    getClinicasByProfissionalSaudeId(profissionalId: string | undefined): Observable<ClinicaMedicaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/GetClinicasByProfissionalSaudeId?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClinicasByProfissionalSaudeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClinicasByProfissionalSaudeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicaMedicaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicaMedicaDto[]>;
        }));
    }

    protected processGetClinicasByProfissionalSaudeId(response: HttpResponseBase): Observable<ClinicaMedicaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ClinicaMedicaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicaMedicaDto[]>(null as any);
    }

    /**
     * @param clinicaId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @return Success
     */
    getInformacoesToHome(clinicaId: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined): Observable<HomeInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/GetInformacoesToHome?";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "dataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacoesToHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacoesToHome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeInformationDto>;
        }));
    }

    protected processGetInformacoesToHome(response: HttpResponseBase): Observable<HomeInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HomeInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeInformationDto>(null as any);
    }

    /**
     * @param avatar (optional) 
     * @return Success
     */
    getAvatar(avatar: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedica/GetAvatar?";
        if (avatar !== undefined && avatar !== null)
            url_ += "avatar=" + encodeURIComponent("" + avatar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAvatar(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class ClinicaMedicaConvenioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adicionarVinculo(body: ClinicaMedicaConvenioDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedicaConvenio/AdicionarVinculo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdicionarVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdicionarVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdicionarVinculo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removerVinculo(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedicaConvenio/RemoverVinculo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoverVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoverVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoverVinculo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ClinicaMedicaPacienteVipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPacienteVip(body: CreateClinicaMedicaPacienteVipDto | undefined): Observable<ClinicaMedicaPacienteVipDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedicaPacienteVip/CreatePacienteVip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePacienteVip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePacienteVip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicaMedicaPacienteVipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicaMedicaPacienteVipDto>;
        }));
    }

    protected processCreatePacienteVip(response: HttpResponseBase): Observable<ClinicaMedicaPacienteVipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicaMedicaPacienteVipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicaMedicaPacienteVipDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedicaPacienteVip/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProfissioanaisComAcesso(id: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedicaPacienteVip/GetProfissioanaisComAcesso?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfissioanaisComAcesso(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfissioanaisComAcesso(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfissioanaisComAcesso(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePacienteVipAcessos(body: UpdateClinicaMedicaPacienteVipDto | undefined): Observable<ClinicaMedicaPacienteVipDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicaMedicaPacienteVip/UpdatePacienteVipAcessos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePacienteVipAcessos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePacienteVipAcessos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicaMedicaPacienteVipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicaMedicaPacienteVipDto>;
        }));
    }

    protected processUpdatePacienteVipAcessos(response: HttpResponseBase): Observable<ClinicaMedicaPacienteVipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicaMedicaPacienteVipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicaMedicaPacienteVipDto>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ConsultaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    alterarStatus(id: string | undefined, body: StatusConsultaEnum | undefined): Observable<ConsultaDto> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/AlterarStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAlterarStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAlterarStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDto>;
        }));
    }

    protected processAlterarStatus(response: HttpResponseBase): Observable<ConsultaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateConsultaDto | undefined): Observable<ConsultaDto> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ConsultaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param nomeProfissional (optional) 
     * @param nomePaciente (optional) 
     * @param tipoConsulta (optional) 
     * @param statusConsulta (optional) 
     * @param pacienteId (optional) 
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @param proximasConsultas (optional) 
     * @param filtro (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, nomeProfissional: string | null | undefined, nomePaciente: string | null | undefined, tipoConsulta: TipoConsultaEnum | undefined, statusConsulta: StatusConsultaEnum | undefined, pacienteId: string | null | undefined, profissionalId: string | null | undefined, clinicaId: string | null | undefined, proximasConsultas: boolean | undefined, filtro: FiltroConsultaEnum | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ConsultaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (nomeProfissional !== undefined && nomeProfissional !== null)
            url_ += "NomeProfissional=" + encodeURIComponent("" + nomeProfissional) + "&";
        if (nomePaciente !== undefined && nomePaciente !== null)
            url_ += "NomePaciente=" + encodeURIComponent("" + nomePaciente) + "&";
        if (tipoConsulta === null)
            throw new Error("The parameter 'tipoConsulta' cannot be null.");
        else if (tipoConsulta !== undefined)
            url_ += "TipoConsulta=" + encodeURIComponent("" + tipoConsulta) + "&";
        if (statusConsulta === null)
            throw new Error("The parameter 'statusConsulta' cannot be null.");
        else if (statusConsulta !== undefined)
            url_ += "StatusConsulta=" + encodeURIComponent("" + statusConsulta) + "&";
        if (pacienteId !== undefined && pacienteId !== null)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "ProfissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (proximasConsultas === null)
            throw new Error("The parameter 'proximasConsultas' cannot be null.");
        else if (proximasConsultas !== undefined)
            url_ += "ProximasConsultas=" + encodeURIComponent("" + proximasConsultas) + "&";
        if (filtro === null)
            throw new Error("The parameter 'filtro' cannot be null.");
        else if (filtro !== undefined)
            url_ += "Filtro=" + encodeURIComponent("" + filtro) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ConsultaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ConsultaDto> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ConsultaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateConsultaDto | undefined): Observable<ConsultaDto> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ConsultaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    remarcarConsulta(body: UpdateConsultaDto | undefined): Observable<ConsultaDto> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/RemarcarConsulta";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemarcarConsulta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemarcarConsulta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDto>;
        }));
    }

    protected processRemarcarConsulta(response: HttpResponseBase): Observable<ConsultaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    solicitarCancelamento(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/SolicitarCancelamento?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSolicitarCancelamento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSolicitarCancelamento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSolicitarCancelamento(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTeleConsulta(id: string | undefined): Observable<VideoSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/GetTeleConsulta?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeleConsulta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeleConsulta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoSessionDto>;
        }));
    }

    protected processGetTeleConsulta(response: HttpResponseBase): Observable<VideoSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoSessionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VideoSessionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    minhasConsultas(body: PagedConsultasResultRequestDto | undefined): Observable<ConsultaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/MinhasConsultas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMinhasConsultas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMinhasConsultas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultaDtoPagedResultDto>;
        }));
    }

    protected processMinhasConsultas(response: HttpResponseBase): Observable<ConsultaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsultaDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editarObservacao(body: UpdateObservacaoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/EditarObservacao";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditarObservacao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditarObservacao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditarObservacao(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param profissionalSaudeId (optional) 
     * @return Success
     */
    getObservacaoConsulta(pacienteId: string | undefined, profissionalSaudeId: string | undefined): Observable<ObservacaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/GetObservacaoConsulta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (profissionalSaudeId === null)
            throw new Error("The parameter 'profissionalSaudeId' cannot be null.");
        else if (profissionalSaudeId !== undefined)
            url_ += "ProfissionalSaudeId=" + encodeURIComponent("" + profissionalSaudeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObservacaoConsulta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObservacaoConsulta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservacaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservacaoDto[]>;
        }));
    }

    protected processGetObservacaoConsulta(response: HttpResponseBase): Observable<ObservacaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ObservacaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObservacaoDto[]>(null as any);
    }

    /**
     * @param url (optional) 
     * @return Success
     */
    getTemporaryLink(url: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/GetTemporaryLink?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemporaryLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemporaryLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTemporaryLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    solicitarExame(body: SolicitarExameDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/SolicitarExame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSolicitarExame(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSolicitarExame(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSolicitarExame(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    anexarExame(body: AnexarExameDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/AnexarExame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnexarExame(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnexarExame(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAnexarExame(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adicionarNovoAnexo(body: AnexarExameDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/AdicionarNovoAnexo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdicionarNovoAnexo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdicionarNovoAnexo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdicionarNovoAnexo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    anexarPrescricao(body: AnexarPrescricaoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Consulta/AnexarPrescricao";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnexarPrescricao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnexarPrescricao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAnexarPrescricao(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ConvenioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateConvenioDto | undefined): Observable<ConvenioDto> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvenioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvenioDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ConvenioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvenioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConvenioDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ConvenioDto> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvenioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvenioDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ConvenioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvenioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConvenioDto>(null as any);
    }

    /**
     * @param nomeOrCpnj (optional) 
     * @param ativo (optional) 
     * @param autoGestao (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(nomeOrCpnj: string | null | undefined, ativo: boolean | null | undefined, autoGestao: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ConvenioDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/GetAll?";
        if (nomeOrCpnj !== undefined && nomeOrCpnj !== null)
            url_ += "NomeOrCpnj=" + encodeURIComponent("" + nomeOrCpnj) + "&";
        if (ativo !== undefined && ativo !== null)
            url_ += "Ativo=" + encodeURIComponent("" + ativo) + "&";
        if (autoGestao !== undefined && autoGestao !== null)
            url_ += "AutoGestao=" + encodeURIComponent("" + autoGestao) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvenioDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvenioDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ConvenioDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvenioDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConvenioDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activeOrDeActivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/ActiveOrDeActivate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveOrDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveOrDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActiveOrDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateConvenioDto | undefined): Observable<ConvenioDto> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvenioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvenioDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ConvenioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvenioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConvenioDto>(null as any);
    }

    /**
     * @param cnpj (optional) 
     * @return Success
     */
    getInformacoesEmpresa(cnpj: string | null | undefined): Observable<DadosEmpresaDto> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/GetInformacoesEmpresa?";
        if (cnpj !== undefined && cnpj !== null)
            url_ += "cnpj=" + encodeURIComponent("" + cnpj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacoesEmpresa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacoesEmpresa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DadosEmpresaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DadosEmpresaDto>;
        }));
    }

    protected processGetInformacoesEmpresa(response: HttpResponseBase): Observable<DadosEmpresaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DadosEmpresaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DadosEmpresaDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    getConveniosSemVinculoPaciente(pacienteId: string | undefined): Observable<ConvenioDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/GetConveniosSemVinculoPaciente?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConveniosSemVinculoPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConveniosSemVinculoPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvenioDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvenioDto[]>;
        }));
    }

    protected processGetConveniosSemVinculoPaciente(response: HttpResponseBase): Observable<ConvenioDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConvenioDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConvenioDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getConvenios(): Observable<ConvenioDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Convenio/GetConvenios";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConvenios(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConvenios(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvenioDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvenioDto[]>;
        }));
    }

    protected processGetConvenios(response: HttpResponseBase): Observable<ConvenioDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConvenioDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConvenioDto[]>(null as any);
    }
}

@Injectable()
export class CustoAdicionalMensalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    criarPagamento(body: CreatePagamentoCustoAdicionalDto | undefined): Observable<CustoAdicionalMensalDto> {
        let url_ = this.baseUrl + "/api/services/app/CustoAdicionalMensal/CriarPagamento";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCriarPagamento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCriarPagamento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustoAdicionalMensalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustoAdicionalMensalDto>;
        }));
    }

    protected processCriarPagamento(response: HttpResponseBase): Observable<CustoAdicionalMensalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustoAdicionalMensalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustoAdicionalMensalDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    get(userId: number | undefined): Observable<CustoAdicionalMensalDto> {
        let url_ = this.baseUrl + "/api/services/app/CustoAdicionalMensal/Get?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustoAdicionalMensalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustoAdicionalMensalDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustoAdicionalMensalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustoAdicionalMensalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustoAdicionalMensalDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, userId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustoAdicionalMensalDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustoAdicionalMensal/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustoAdicionalMensalDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustoAdicionalMensalDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustoAdicionalMensalDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustoAdicionalMensalDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustoAdicionalMensalDtoPagedResultDto>(null as any);
    }

    /**
     * @param nome (optional) 
     * @param cpf (optional) 
     * @param numero (optional) 
     * @param mesVencimento (optional) 
     * @param anoVencimento (optional) 
     * @param cvv (optional) 
     * @return Success
     */
    getTokenCartao(nome: string | null | undefined, cpf: string | null | undefined, numero: string | null | undefined, mesVencimento: number | undefined, anoVencimento: number | undefined, cvv: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CustoAdicionalMensal/GetTokenCartao?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (cpf !== undefined && cpf !== null)
            url_ += "Cpf=" + encodeURIComponent("" + cpf) + "&";
        if (numero !== undefined && numero !== null)
            url_ += "Numero=" + encodeURIComponent("" + numero) + "&";
        if (mesVencimento === null)
            throw new Error("The parameter 'mesVencimento' cannot be null.");
        else if (mesVencimento !== undefined)
            url_ += "MesVencimento=" + encodeURIComponent("" + mesVencimento) + "&";
        if (anoVencimento === null)
            throw new Error("The parameter 'anoVencimento' cannot be null.");
        else if (anoVencimento !== undefined)
            url_ += "AnoVencimento=" + encodeURIComponent("" + anoVencimento) + "&";
        if (cvv !== undefined && cvv !== null)
            url_ += "Cvv=" + encodeURIComponent("" + cvv) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenCartao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenCartao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTokenCartao(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class DorArticularServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDorArticular(body: CreateDorArticularDto | undefined): Observable<DorArticularDto> {
        let url_ = this.baseUrl + "/api/services/app/DorArticular/CreateDorArticular";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDorArticular(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDorArticular(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DorArticularDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DorArticularDto>;
        }));
    }

    protected processCreateDorArticular(response: HttpResponseBase): Observable<DorArticularDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DorArticularDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DorArticularDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDorArticular(body: UpdateDorArticularDto | undefined): Observable<DorArticularDto> {
        let url_ = this.baseUrl + "/api/services/app/DorArticular/UpdateDorArticular";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDorArticular(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDorArticular(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DorArticularDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DorArticularDto>;
        }));
    }

    protected processUpdateDorArticular(response: HttpResponseBase): Observable<DorArticularDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DorArticularDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DorArticularDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoDorArticular(body: DorArticularDto | undefined): Observable<DorArticularDto> {
        let url_ = this.baseUrl + "/api/services/app/DorArticular/DeletarDadoDorArticular";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoDorArticular(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoDorArticular(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DorArticularDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DorArticularDto>;
        }));
    }

    protected processDeletarDadoDorArticular(response: HttpResponseBase): Observable<DorArticularDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DorArticularDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DorArticularDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<DorArticularDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DorArticular/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DorArticularDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DorArticularDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<DorArticularDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DorArticularDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DorArticularDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<DorArticularDto> {
        let url_ = this.baseUrl + "/api/services/app/DorArticular/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DorArticularDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DorArticularDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DorArticularDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DorArticularDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DorArticularDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DorArticularDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DorArticular/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DorArticularDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DorArticularDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DorArticularDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DorArticularDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DorArticularDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DorArticular/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class AppServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param _format (optional) 
     * @param _secretCode (optional) 
     * @return Success
     */
    downloadProntuarioGet(documentId: string, _format: string | null | undefined, _secretCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/app/download-prontuario/{documentId}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (_format !== undefined && _format !== null)
            url_ += "_format=" + encodeURIComponent("" + _format) + "&";
        if (_secretCode !== undefined && _secretCode !== null)
            url_ += "_secretCode=" + encodeURIComponent("" + _secretCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProntuarioGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProntuarioGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadProntuarioGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadProntuarioOptions(documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/app/download-prontuario/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProntuarioOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProntuarioOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadProntuarioOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DownloadProntuarioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param _secretCode (optional) 
     * @return Success
     */
    arquivoAssinadoGet(documentId: string, _secretCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/app/download-prontuario/{documentId}/arquivo-assinado?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (_secretCode !== undefined && _secretCode !== null)
            url_ += "_secretCode=" + encodeURIComponent("" + _secretCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArquivoAssinadoGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArquivoAssinadoGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArquivoAssinadoGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    arquivoAssinadoOptions(documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/app/download-prontuario/{documentId}/arquivo-assinado";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArquivoAssinadoOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArquivoAssinadoOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArquivoAssinadoOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EnumServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param enumName (optional) 
     * @return Success
     */
    getByEnumName(enumName: string | null | undefined): Observable<EnumDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Enum/GetByEnumName?";
        if (enumName !== undefined && enumName !== null)
            url_ += "enumName=" + encodeURIComponent("" + enumName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEnumName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEnumName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDtoListResultDto>;
        }));
    }

    protected processGetByEnumName(response: HttpResponseBase): Observable<EnumDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnumDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDtoListResultDto>(null as any);
    }
}

@Injectable()
export class EquipeClinicaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activeOrDeActive(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EquipeClinica/ActiveOrDeActive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveOrDeActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveOrDeActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActiveOrDeActive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEquipeClinicaDto | undefined): Observable<EquipeClinicaDto> {
        let url_ = this.baseUrl + "/api/services/app/EquipeClinica/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipeClinicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipeClinicaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EquipeClinicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipeClinicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EquipeClinicaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<EquipeClinicaDto> {
        let url_ = this.baseUrl + "/api/services/app/EquipeClinica/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipeClinicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipeClinicaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EquipeClinicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipeClinicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EquipeClinicaDto>(null as any);
    }

    /**
     * @param nome (optional) 
     * @param ativo (optional) 
     * @param ordemCresente (optional) 
     * @param clinicaId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(nome: string | null | undefined, ativo: boolean | null | undefined, ordemCresente: boolean | undefined, clinicaId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EquipeClinicaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EquipeClinica/GetAll?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (ativo !== undefined && ativo !== null)
            url_ += "Ativo=" + encodeURIComponent("" + ativo) + "&";
        if (ordemCresente === null)
            throw new Error("The parameter 'ordemCresente' cannot be null.");
        else if (ordemCresente !== undefined)
            url_ += "OrdemCresente=" + encodeURIComponent("" + ordemCresente) + "&";
        if (clinicaId === null)
            throw new Error("The parameter 'clinicaId' cannot be null.");
        else if (clinicaId !== undefined)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipeClinicaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipeClinicaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EquipeClinicaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipeClinicaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EquipeClinicaDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEquipeClinicaDto | undefined): Observable<EquipeClinicaDto> {
        let url_ = this.baseUrl + "/api/services/app/EquipeClinica/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipeClinicaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipeClinicaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EquipeClinicaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipeClinicaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EquipeClinicaDto>(null as any);
    }
}

@Injectable()
export class EventoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<EventoDto> {
        let url_ = this.baseUrl + "/api/services/app/Evento/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EventoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventoDto>(null as any);
    }

    /**
     * @param inicio (optional) 
     * @param fim (optional) 
     * @param agendaId (optional) 
     * @param profissionalId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inicio: moment.Moment | undefined, fim: moment.Moment | undefined, agendaId: string | undefined, profissionalId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EventoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Evento/GetAll?";
        if (inicio === null)
            throw new Error("The parameter 'inicio' cannot be null.");
        else if (inicio !== undefined)
            url_ += "Inicio=" + encodeURIComponent(inicio ? "" + inicio.toISOString() : "") + "&";
        if (fim === null)
            throw new Error("The parameter 'fim' cannot be null.");
        else if (fim !== undefined)
            url_ += "Fim=" + encodeURIComponent(fim ? "" + fim.toISOString() : "") + "&";
        if (agendaId === null)
            throw new Error("The parameter 'agendaId' cannot be null.");
        else if (agendaId !== undefined)
            url_ += "AgendaId=" + encodeURIComponent("" + agendaId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "ProfissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EventoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventoDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEventoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Evento/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEventoDto | undefined): Observable<EventoDto> {
        let url_ = this.baseUrl + "/api/services/app/Evento/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EventoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventoDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Evento/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param agendaId (optional) 
     * @return Success
     */
    getHorariosDisponiveis(profissionalId: string | undefined, clinicaId: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, agendaId: string | null | undefined): Observable<HorarioLivreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Evento/GetHorariosDisponiveis?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "ProfissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (agendaId !== undefined && agendaId !== null)
            url_ += "AgendaId=" + encodeURIComponent("" + agendaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHorariosDisponiveis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHorariosDisponiveis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HorarioLivreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HorarioLivreDto[]>;
        }));
    }

    protected processGetHorariosDisponiveis(response: HttpResponseBase): Observable<HorarioLivreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HorarioLivreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HorarioLivreDto[]>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param agendaId (optional) 
     * @return Success
     */
    getHorariosDisponiveisPorDia(profissionalId: string | undefined, clinicaId: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, agendaId: string | null | undefined): Observable<DiaLivreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Evento/GetHorariosDisponiveisPorDia?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "ProfissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (agendaId !== undefined && agendaId !== null)
            url_ += "AgendaId=" + encodeURIComponent("" + agendaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHorariosDisponiveisPorDia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHorariosDisponiveisPorDia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiaLivreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiaLivreDto[]>;
        }));
    }

    protected processGetHorariosDisponiveisPorDia(response: HttpResponseBase): Observable<DiaLivreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DiaLivreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiaLivreDto[]>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @return Success
     */
    obterEventosDoDia(agendaId: string, profissionalId: string | null | undefined, data: moment.Moment): Observable<EventoAgendaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Evento/ObterEventosDoDia?";
        if (agendaId === undefined || agendaId === null)
            throw new Error("The parameter 'agendaId' must be defined and cannot be null.");
        else
            url_ += "AgendaId=" + encodeURIComponent("" + agendaId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "ProfissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (data === undefined || data === null)
            throw new Error("The parameter 'data' must be defined and cannot be null.");
        else
            url_ += "Data=" + encodeURIComponent(data ? "" + data.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObterEventosDoDia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObterEventosDoDia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventoAgendaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventoAgendaDto[]>;
        }));
    }

    protected processObterEventosDoDia(response: HttpResponseBase): Observable<EventoAgendaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EventoAgendaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventoAgendaDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    criarEventoAgenda(body: CriarEventoAgendaInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Evento/CriarEventoAgenda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCriarEventoAgenda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCriarEventoAgenda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCriarEventoAgenda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    excluirEventoAgenda(body: ExcluirEventoAgendaInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Evento/ExcluirEventoAgenda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcluirEventoAgenda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcluirEventoAgenda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExcluirEventoAgenda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    excluirDiaAgenda(body: ExcluirDiaAgendaInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Evento/ExcluirDiaAgenda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcluirDiaAgenda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcluirDiaAgenda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExcluirDiaAgenda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    alterarProfissionalEventoAgenda(body: AlterarProfissionalEventoAgendaInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Evento/AlterarProfissionalEventoAgenda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAlterarProfissionalEventoAgenda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAlterarProfissionalEventoAgenda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAlterarProfissionalEventoAgenda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FrequenciaRespiratoriaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFrequenciaRespiratoria(body: CreateFrequenciaRespiratoriaDto | undefined): Observable<FrequenciaRespiratoriaDto> {
        let url_ = this.baseUrl + "/api/services/app/FrequenciaRespiratoria/CreateFrequenciaRespiratoria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFrequenciaRespiratoria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFrequenciaRespiratoria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrequenciaRespiratoriaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrequenciaRespiratoriaDto>;
        }));
    }

    protected processCreateFrequenciaRespiratoria(response: HttpResponseBase): Observable<FrequenciaRespiratoriaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrequenciaRespiratoriaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FrequenciaRespiratoriaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFrequenciaRespiratoria(body: UpdateFrequenciaRespiratoriaDto | undefined): Observable<FrequenciaRespiratoriaDto> {
        let url_ = this.baseUrl + "/api/services/app/FrequenciaRespiratoria/UpdateFrequenciaRespiratoria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFrequenciaRespiratoria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFrequenciaRespiratoria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrequenciaRespiratoriaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrequenciaRespiratoriaDto>;
        }));
    }

    protected processUpdateFrequenciaRespiratoria(response: HttpResponseBase): Observable<FrequenciaRespiratoriaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrequenciaRespiratoriaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FrequenciaRespiratoriaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoFrequenciaRespiratoria(body: FrequenciaRespiratoriaDto | undefined): Observable<FrequenciaRespiratoriaDto> {
        let url_ = this.baseUrl + "/api/services/app/FrequenciaRespiratoria/DeletarDadoFrequenciaRespiratoria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoFrequenciaRespiratoria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoFrequenciaRespiratoria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrequenciaRespiratoriaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrequenciaRespiratoriaDto>;
        }));
    }

    protected processDeletarDadoFrequenciaRespiratoria(response: HttpResponseBase): Observable<FrequenciaRespiratoriaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrequenciaRespiratoriaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FrequenciaRespiratoriaDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<FrequenciaRespiratoriaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FrequenciaRespiratoria/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrequenciaRespiratoriaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrequenciaRespiratoriaDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<FrequenciaRespiratoriaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FrequenciaRespiratoriaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FrequenciaRespiratoriaDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<FrequenciaRespiratoriaDto> {
        let url_ = this.baseUrl + "/api/services/app/FrequenciaRespiratoria/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrequenciaRespiratoriaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrequenciaRespiratoriaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FrequenciaRespiratoriaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrequenciaRespiratoriaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FrequenciaRespiratoriaDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FrequenciaRespiratoriaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FrequenciaRespiratoria/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrequenciaRespiratoriaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrequenciaRespiratoriaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FrequenciaRespiratoriaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrequenciaRespiratoriaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FrequenciaRespiratoriaDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FrequenciaRespiratoria/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class FuncionarioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param clinicaMedicaId (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(clinicaMedicaId: string | undefined, body: CreateFuncionarioDto | undefined): Observable<FuncionarioDto> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/Create?";
        if (clinicaMedicaId === null)
            throw new Error("The parameter 'clinicaMedicaId' cannot be null.");
        else if (clinicaMedicaId !== undefined)
            url_ += "clinicaMedicaId=" + encodeURIComponent("" + clinicaMedicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuncionarioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuncionarioDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FuncionarioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuncionarioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuncionarioDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFuncionarioDto | undefined): Observable<FuncionarioDto> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuncionarioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuncionarioDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FuncionarioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuncionarioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuncionarioDto>(null as any);
    }

    /**
     * @param clinicaMedicaId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createFuncionarioFromPaciente(clinicaMedicaId: string | undefined, body: CreateFuncionarioDto | undefined): Observable<FuncionarioDto> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/CreateFuncionarioFromPaciente?";
        if (clinicaMedicaId === null)
            throw new Error("The parameter 'clinicaMedicaId' cannot be null.");
        else if (clinicaMedicaId !== undefined)
            url_ += "clinicaMedicaId=" + encodeURIComponent("" + clinicaMedicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFuncionarioFromPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFuncionarioFromPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuncionarioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuncionarioDto>;
        }));
    }

    protected processCreateFuncionarioFromPaciente(response: HttpResponseBase): Observable<FuncionarioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuncionarioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuncionarioDto>(null as any);
    }

    /**
     * @param clinicaMedicaId (optional) 
     * @param body (optional) 
     * @return Success
     */
    vincularFuncionarioClinica(clinicaMedicaId: string | undefined, body: CreateFuncionarioDto | undefined): Observable<FuncionarioDto> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/VincularFuncionarioClinica?";
        if (clinicaMedicaId === null)
            throw new Error("The parameter 'clinicaMedicaId' cannot be null.");
        else if (clinicaMedicaId !== undefined)
            url_ += "clinicaMedicaId=" + encodeURIComponent("" + clinicaMedicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVincularFuncionarioClinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVincularFuncionarioClinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuncionarioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuncionarioDto>;
        }));
    }

    protected processVincularFuncionarioClinica(response: HttpResponseBase): Observable<FuncionarioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuncionarioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuncionarioDto>(null as any);
    }

    /**
     * @param funcionarioId (optional) 
     * @param clinicaMedicaId (optional) 
     * @return Success
     */
    desvincularFuncionarioClinica(funcionarioId: string | undefined, clinicaMedicaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/DesvincularFuncionarioClinica?";
        if (funcionarioId === null)
            throw new Error("The parameter 'funcionarioId' cannot be null.");
        else if (funcionarioId !== undefined)
            url_ += "funcionarioId=" + encodeURIComponent("" + funcionarioId) + "&";
        if (clinicaMedicaId === null)
            throw new Error("The parameter 'clinicaMedicaId' cannot be null.");
        else if (clinicaMedicaId !== undefined)
            url_ += "clinicaMedicaId=" + encodeURIComponent("" + clinicaMedicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesvincularFuncionarioClinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesvincularFuncionarioClinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDesvincularFuncionarioClinica(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param nome (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param clininaMedicaId (optional) 
     * @return Success
     */
    getAllFuncionarios(nome: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, clininaMedicaId: string | null | undefined): Observable<FuncionarioDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/GetAllFuncionarios?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (clininaMedicaId !== undefined && clininaMedicaId !== null)
            url_ += "clininaMedicaId=" + encodeURIComponent("" + clininaMedicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFuncionarios(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFuncionarios(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuncionarioDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuncionarioDtoPagedResultDto>;
        }));
    }

    protected processGetAllFuncionarios(response: HttpResponseBase): Observable<FuncionarioDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuncionarioDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FuncionarioDtoPagedResultDto>(null as any);
    }

    /**
     * @param cns (optional) 
     * @param cpf (optional) 
     * @return Success
     */
    cnsExistsOrInvalid(cns: string | null | undefined, cpf: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/CnsExistsOrInvalid?";
        if (cns !== undefined && cns !== null)
            url_ += "cns=" + encodeURIComponent("" + cns) + "&";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCnsExistsOrInvalid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCnsExistsOrInvalid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCnsExistsOrInvalid(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param clinicaId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @return Success
     */
    getInformacoesToHome(clinicaId: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined): Observable<HomeInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/GetInformacoesToHome?";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "dataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacoesToHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacoesToHome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeInformationDto>;
        }));
    }

    protected processGetInformacoesToHome(response: HttpResponseBase): Observable<HomeInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HomeInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeInformationDto>(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    emailExists(email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/EmailExists?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEmailExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    cpfInvalid(cpf: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/CpfInvalid?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpfInvalid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpfInvalid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCpfInvalid(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    cpfExistToPaciente(cpf: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/CpfExistToPaciente?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpfExistToPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpfExistToPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCpfExistToPaciente(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    cpfExistToFuncionario(cpf: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Funcionario/CpfExistToFuncionario?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpfExistToFuncionario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpfExistToFuncionario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCpfExistToFuncionario(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class GlicoseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGlicose(body: CreateGlicoseDto | undefined): Observable<GlicoseDto> {
        let url_ = this.baseUrl + "/api/services/app/Glicose/CreateGlicose";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGlicose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGlicose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlicoseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlicoseDto>;
        }));
    }

    protected processCreateGlicose(response: HttpResponseBase): Observable<GlicoseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlicoseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlicoseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGlicose(body: UpdateGlicoseDto | undefined): Observable<GlicoseDto> {
        let url_ = this.baseUrl + "/api/services/app/Glicose/UpdateGlicose";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGlicose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGlicose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlicoseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlicoseDto>;
        }));
    }

    protected processUpdateGlicose(response: HttpResponseBase): Observable<GlicoseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlicoseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlicoseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoGlicose(body: GlicoseDto | undefined): Observable<GlicoseDto> {
        let url_ = this.baseUrl + "/api/services/app/Glicose/DeletarDadoGlicose";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoGlicose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoGlicose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlicoseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlicoseDto>;
        }));
    }

    protected processDeletarDadoGlicose(response: HttpResponseBase): Observable<GlicoseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlicoseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlicoseDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<GlicoseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Glicose/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlicoseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlicoseDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<GlicoseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GlicoseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlicoseDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<GlicoseDto> {
        let url_ = this.baseUrl + "/api/services/app/Glicose/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlicoseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlicoseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GlicoseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlicoseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlicoseDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GlicoseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Glicose/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlicoseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlicoseDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GlicoseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlicoseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlicoseDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Glicose/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class GrupoMonitoramentoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activeOrDeActive(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GrupoMonitoramento/ActiveOrDeActive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveOrDeActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveOrDeActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActiveOrDeActive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateGrupoMonitoramentoDto | undefined): Observable<GrupoMonitoramentoDto> {
        let url_ = this.baseUrl + "/api/services/app/GrupoMonitoramento/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrupoMonitoramentoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrupoMonitoramentoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<GrupoMonitoramentoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrupoMonitoramentoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GrupoMonitoramentoDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<GrupoMonitoramentoDto> {
        let url_ = this.baseUrl + "/api/services/app/GrupoMonitoramento/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrupoMonitoramentoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrupoMonitoramentoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GrupoMonitoramentoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrupoMonitoramentoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GrupoMonitoramentoDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param profisioanalId (optional) 
     * @param clinicaId (optional) 
     * @param grafico (optional) 
     * @return Success
     */
    getLimitesToGrafico(pacienteId: string | undefined, profisioanalId: string | null | undefined, clinicaId: string | null | undefined, grafico: GraficoMonitoramentoEnum | undefined): Observable<GraficoMonitoramentoDto> {
        let url_ = this.baseUrl + "/api/services/app/GrupoMonitoramento/GetLimitesToGrafico?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (profisioanalId !== undefined && profisioanalId !== null)
            url_ += "profisioanalId=" + encodeURIComponent("" + profisioanalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (grafico === null)
            throw new Error("The parameter 'grafico' cannot be null.");
        else if (grafico !== undefined)
            url_ += "grafico=" + encodeURIComponent("" + grafico) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLimitesToGrafico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLimitesToGrafico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GraficoMonitoramentoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GraficoMonitoramentoDto>;
        }));
    }

    protected processGetLimitesToGrafico(response: HttpResponseBase): Observable<GraficoMonitoramentoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraficoMonitoramentoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GraficoMonitoramentoDto>(null as any);
    }

    /**
     * @param nome (optional) 
     * @param ordemCresente (optional) 
     * @param clinicaId (optional) 
     * @param profisionalId (optional) 
     * @param ativo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(nome: string | null | undefined, ordemCresente: boolean | undefined, clinicaId: string | null | undefined, profisionalId: string | null | undefined, ativo: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GrupoMonitoramentoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GrupoMonitoramento/GetAll?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (ordemCresente === null)
            throw new Error("The parameter 'ordemCresente' cannot be null.");
        else if (ordemCresente !== undefined)
            url_ += "OrdemCresente=" + encodeURIComponent("" + ordemCresente) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (profisionalId !== undefined && profisionalId !== null)
            url_ += "ProfisionalId=" + encodeURIComponent("" + profisionalId) + "&";
        if (ativo !== undefined && ativo !== null)
            url_ += "Ativo=" + encodeURIComponent("" + ativo) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrupoMonitoramentoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrupoMonitoramentoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GrupoMonitoramentoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrupoMonitoramentoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GrupoMonitoramentoDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateGrupoMonitoramentoDto | undefined): Observable<GrupoMonitoramentoDto> {
        let url_ = this.baseUrl + "/api/services/app/GrupoMonitoramento/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrupoMonitoramentoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrupoMonitoramentoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GrupoMonitoramentoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrupoMonitoramentoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GrupoMonitoramentoDto>(null as any);
    }

    /**
     * @param pacientesIds (optional) 
     * @param graficos (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getDadosGraficosByPaciente(pacientesIds: string[] | null | undefined, graficos: GraficoMonitoramentoEnum[] | null | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<PacienteDadosGraficoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GrupoMonitoramento/GetDadosGraficosByPaciente?";
        if (pacientesIds !== undefined && pacientesIds !== null)
            pacientesIds && pacientesIds.forEach(item => { url_ += "pacientesIds=" + encodeURIComponent("" + item) + "&"; });
        if (graficos !== undefined && graficos !== null)
            graficos && graficos.forEach(item => { url_ += "graficos=" + encodeURIComponent("" + item) + "&"; });
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDadosGraficosByPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDadosGraficosByPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDadosGraficoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDadosGraficoDto[]>;
        }));
    }

    protected processGetDadosGraficosByPaciente(response: HttpResponseBase): Observable<PacienteDadosGraficoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PacienteDadosGraficoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDadosGraficoDto[]>(null as any);
    }
}

@Injectable()
export class HumorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createHumor(body: CreateHumorDto | undefined): Observable<HumorDto> {
        let url_ = this.baseUrl + "/api/services/app/Humor/CreateHumor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHumor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHumor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HumorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HumorDto>;
        }));
    }

    protected processCreateHumor(response: HttpResponseBase): Observable<HumorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HumorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HumorDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHumor(body: UpdateHumorDto | undefined): Observable<HumorDto> {
        let url_ = this.baseUrl + "/api/services/app/Humor/UpdateHumor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHumor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHumor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HumorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HumorDto>;
        }));
    }

    protected processUpdateHumor(response: HttpResponseBase): Observable<HumorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HumorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HumorDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoHumor(body: HumorDto | undefined): Observable<HumorDto> {
        let url_ = this.baseUrl + "/api/services/app/Humor/DeletarDadoHumor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoHumor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoHumor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HumorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HumorDto>;
        }));
    }

    protected processDeletarDadoHumor(response: HttpResponseBase): Observable<HumorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HumorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HumorDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<HumorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Humor/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HumorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HumorDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<HumorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HumorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HumorDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<HumorDto> {
        let url_ = this.baseUrl + "/api/services/app/Humor/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HumorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HumorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HumorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HumorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HumorDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HumorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Humor/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HumorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HumorDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HumorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HumorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HumorDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Humor/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ImcServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createObjetivoImc(body: CreateObjetivoImcDto | undefined): Observable<ObjetivoImcDto> {
        let url_ = this.baseUrl + "/api/services/app/Imc/CreateObjetivoImc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateObjetivoImc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateObjetivoImc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjetivoImcDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjetivoImcDto>;
        }));
    }

    protected processCreateObjetivoImc(response: HttpResponseBase): Observable<ObjetivoImcDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjetivoImcDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjetivoImcDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateObjetivoImc(body: UpdateObjetivoImcDto | undefined): Observable<ObjetivoImcDto> {
        let url_ = this.baseUrl + "/api/services/app/Imc/UpdateObjetivoImc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateObjetivoImc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateObjetivoImc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjetivoImcDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjetivoImcDto>;
        }));
    }

    protected processUpdateObjetivoImc(response: HttpResponseBase): Observable<ObjetivoImcDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjetivoImcDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjetivoImcDto>(null as any);
    }

    /**
     * @param paceinteId (optional) 
     * @return Success
     */
    getObjetivoImc(paceinteId: string | undefined): Observable<ObjetivoImcDto> {
        let url_ = this.baseUrl + "/api/services/app/Imc/GetObjetivoImc?";
        if (paceinteId === null)
            throw new Error("The parameter 'paceinteId' cannot be null.");
        else if (paceinteId !== undefined)
            url_ += "paceinteId=" + encodeURIComponent("" + paceinteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObjetivoImc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObjetivoImc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjetivoImcDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjetivoImcDto>;
        }));
    }

    protected processGetObjetivoImc(response: HttpResponseBase): Observable<ObjetivoImcDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjetivoImcDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjetivoImcDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteObjetivoImc(id: string | undefined): Observable<ObjetivoImcDto> {
        let url_ = this.baseUrl + "/api/services/app/Imc/DeleteObjetivoImc?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteObjetivoImc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObjetivoImc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjetivoImcDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjetivoImcDto>;
        }));
    }

    protected processDeleteObjetivoImc(response: HttpResponseBase): Observable<ObjetivoImcDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjetivoImcDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjetivoImcDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<ImcDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Imc/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImcDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImcDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<ImcDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ImcDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImcDto[]>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ImcDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Imc/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImcDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImcDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ImcDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImcDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImcDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Imc/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class MedicamentoSigtapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<MedicamentoSigtapDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoSigtap/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoSigtapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoSigtapDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicamentoSigtapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicamentoSigtapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoSigtapDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MedicamentoSigtapDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoSigtap/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoSigtapDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoSigtapDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicamentoSigtapDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicamentoSigtapDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoSigtapDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicamentoSigtapDto | undefined): Observable<MedicamentoSigtapDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoSigtap/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoSigtapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoSigtapDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicamentoSigtapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicamentoSigtapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoSigtapDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicamentoSigtapDto | undefined): Observable<MedicamentoSigtapDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoSigtap/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoSigtapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoSigtapDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicamentoSigtapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicamentoSigtapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoSigtapDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoSigtap/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    readTable(body: ImportTableDto | undefined): Observable<CreateMedicamentoSigtapDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoSigtap/ReadTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMedicamentoSigtapDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMedicamentoSigtapDto[]>;
        }));
    }

    protected processReadTable(response: HttpResponseBase): Observable<CreateMedicamentoSigtapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateMedicamentoSigtapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateMedicamentoSigtapDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: CreateMedicamentoSigtapDto[] | null | undefined): Observable<MedicamentoSigtapDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoSigtap/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoSigtapDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoSigtapDto[]>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<MedicamentoSigtapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicamentoSigtapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoSigtapDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param tipo (optional) 
     * @param count (optional) 
     * @param prefix (optional) 
     * @return Success
     */
    getAutoComplete(keyword: string | null | undefined, tipo: string | null | undefined, count: number | undefined, prefix: string | undefined): Observable<MentionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoSigtap/GetAutoComplete?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (tipo !== undefined && tipo !== null)
            url_ += "tipo=" + encodeURIComponent("" + tipo) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (prefix === null)
            throw new Error("The parameter 'prefix' cannot be null.");
        else if (prefix !== undefined)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MentionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MentionDto[]>;
        }));
    }

    protected processGetAutoComplete(response: HttpResponseBase): Observable<MentionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MentionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentionDto[]>(null as any);
    }
}

@Injectable()
export class MedicamentoTissServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param tipo (optional) 
     * @param count (optional) 
     * @param prefix (optional) 
     * @return Success
     */
    getAutoComplete(keyword: string | null | undefined, tipo: string | null | undefined, count: number | undefined, prefix: string | undefined): Observable<MentionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoTiss/GetAutoComplete?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (tipo !== undefined && tipo !== null)
            url_ += "tipo=" + encodeURIComponent("" + tipo) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (prefix === null)
            throw new Error("The parameter 'prefix' cannot be null.");
        else if (prefix !== undefined)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MentionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MentionDto[]>;
        }));
    }

    protected processGetAutoComplete(response: HttpResponseBase): Observable<MentionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MentionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentionDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<MedicamentoTissDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoTiss/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoTissDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoTissDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicamentoTissDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicamentoTissDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoTissDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MedicamentoTissDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoTiss/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoTissDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoTissDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicamentoTissDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicamentoTissDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoTissDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicamentoTissDto | undefined): Observable<MedicamentoTissDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoTiss/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoTissDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoTissDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicamentoTissDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicamentoTissDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoTissDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicamentoTissDto | undefined): Observable<MedicamentoTissDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoTiss/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoTissDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoTissDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicamentoTissDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicamentoTissDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoTissDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoTiss/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    readTable(body: ImportTableDto | undefined): Observable<CreateMedicamentoTissDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoTiss/ReadTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMedicamentoTissDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMedicamentoTissDto[]>;
        }));
    }

    protected processReadTable(response: HttpResponseBase): Observable<CreateMedicamentoTissDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateMedicamentoTissDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateMedicamentoTissDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: CreateMedicamentoTissDto[] | null | undefined): Observable<MedicamentoTissDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicamentoTiss/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicamentoTissDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicamentoTissDto[]>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<MedicamentoTissDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MedicamentoTissDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedicamentoTissDto[]>(null as any);
    }
}

@Injectable()
export class MotorizacaoServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param pacienteId (optional) 
     * @param grafico (optional) 
     * @return Success
     */
    getDadosGraficoHome(pacienteId: string | undefined, grafico: GraficoMonitoramentoEnum | undefined): Observable<MotorizacaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MotorizacaoService/GetDadosGraficoHome?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (grafico === null)
            throw new Error("The parameter 'grafico' cannot be null.");
        else if (grafico !== undefined)
            url_ += "grafico=" + encodeURIComponent("" + grafico) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDadosGraficoHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDadosGraficoHome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MotorizacaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MotorizacaoDto[]>;
        }));
    }

    protected processGetDadosGraficoHome(response: HttpResponseBase): Observable<MotorizacaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MotorizacaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorizacaoDto[]>(null as any);
    }
}

@Injectable()
export class NotificacaoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NotificacaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notificacao/GetAll?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificacaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificacaoDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NotificacaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NotificacaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificacaoDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<NotificacaoDto> {
        let url_ = this.baseUrl + "/api/services/app/Notificacao/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificacaoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificacaoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NotificacaoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificacaoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificacaoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNotificacaoEnvioToken(body: CreateNotificacaoDto | undefined): Observable<NotificacaoDto> {
        let url_ = this.baseUrl + "/api/services/app/Notificacao/CreateNotificacaoEnvioToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNotificacaoEnvioToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNotificacaoEnvioToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificacaoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificacaoDto>;
        }));
    }

    protected processCreateNotificacaoEnvioToken(response: HttpResponseBase): Observable<NotificacaoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificacaoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificacaoDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    hasNotification(pacienteId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Notificacao/HasNotification?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processHasNotification(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param notificacaoId (optional) 
     * @return Success
     */
    marcaComoLida(notificacaoId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notificacao/MarcaComoLida?";
        if (notificacaoId === null)
            throw new Error("The parameter 'notificacaoId' cannot be null.");
        else if (notificacaoId !== undefined)
            url_ += "notificacaoId=" + encodeURIComponent("" + notificacaoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarcaComoLida(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarcaComoLida(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarcaComoLida(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    marcaTodasComoLida(pacienteId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notificacao/MarcaTodasComoLida?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarcaTodasComoLida(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarcaTodasComoLida(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarcaTodasComoLida(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param plataforma (optional) 
     * @return Success
     */
    getConfigPushNotification(plataforma: string | null | undefined): Observable<PushNotificationConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Notificacao/GetConfigPushNotification?";
        if (plataforma !== undefined && plataforma !== null)
            url_ += "plataforma=" + encodeURIComponent("" + plataforma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigPushNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigPushNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PushNotificationConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PushNotificationConfigDto>;
        }));
    }

    protected processGetConfigPushNotification(response: HttpResponseBase): Observable<PushNotificationConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PushNotificationConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PushNotificationConfigDto>(null as any);
    }
}

@Injectable()
export class OximetriaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOximetria(body: CreateOximentriaDto | undefined): Observable<OximetriaDto> {
        let url_ = this.baseUrl + "/api/services/app/Oximetria/CreateOximetria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOximetria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOximetria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OximetriaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OximetriaDto>;
        }));
    }

    protected processCreateOximetria(response: HttpResponseBase): Observable<OximetriaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OximetriaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OximetriaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOximetria(body: UpdateOximetriaDto | undefined): Observable<OximetriaDto> {
        let url_ = this.baseUrl + "/api/services/app/Oximetria/UpdateOximetria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOximetria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOximetria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OximetriaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OximetriaDto>;
        }));
    }

    protected processUpdateOximetria(response: HttpResponseBase): Observable<OximetriaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OximetriaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OximetriaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoOximetria(body: OximetriaDto | undefined): Observable<OximetriaDto> {
        let url_ = this.baseUrl + "/api/services/app/Oximetria/DeletarDadoOximetria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoOximetria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoOximetria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OximetriaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OximetriaDto>;
        }));
    }

    protected processDeletarDadoOximetria(response: HttpResponseBase): Observable<OximetriaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OximetriaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OximetriaDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<OximetriaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Oximetria/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OximetriaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OximetriaDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<OximetriaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OximetriaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OximetriaDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<OximetriaDto> {
        let url_ = this.baseUrl + "/api/services/app/Oximetria/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OximetriaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OximetriaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OximetriaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OximetriaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OximetriaDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OximetriaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Oximetria/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OximetriaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OximetriaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OximetriaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OximetriaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OximetriaDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Oximetria/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class PacienteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param pacienteId (optional) 
     * @param clinicaName (optional) 
     * @return Success
     */
    getPacienteByClinica(pacienteId: string | undefined, clinicaName: string | null | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetPacienteByClinica?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (clinicaName !== undefined && clinicaName !== null)
            url_ += "clinicaName=" + encodeURIComponent("" + clinicaName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPacienteByClinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPacienteByClinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processGetPacienteByClinica(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPacienteByUserId(id: number | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetPacienteByUserId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPacienteByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPacienteByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processGetPacienteByUserId(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    getByCpf(cpf: string | null | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetByCpf?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCpf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCpf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processGetByCpf(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param avatar (optional) 
     * @return Success
     */
    getAvatar(avatar: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetAvatar?";
        if (avatar !== undefined && avatar !== null)
            url_ += "avatar=" + encodeURIComponent("" + avatar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAvatar(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePacienteDto | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePacienteDto | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAvatar(body: UpdateAvatarDto | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/UpdateAvatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processUpdateAvatar(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    getResponsavelLegal(pacienteId: string | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetResponsavelLegal?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResponsavelLegal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResponsavelLegal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processGetResponsavelLegal(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    alterarResponsavelLegal(body: AlterarResponsavelLegalDto | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/AlterarResponsavelLegal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAlterarResponsavelLegal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAlterarResponsavelLegal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processAlterarResponsavelLegal(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param clinicaId (optional) 
     * @param profissionalSaudeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, clinicaId: string | null | undefined, profissionalSaudeId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PacienteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (profissionalSaudeId !== undefined && profissionalSaudeId !== null)
            url_ += "ProfissionalSaudeId=" + encodeURIComponent("" + profissionalSaudeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PacienteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDtoPagedResultDto>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    getPacientesForGroup(profissionalId: string | null | undefined, clinicaId: string | null | undefined): Observable<PacienteGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetPacientesForGroup?";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPacientesForGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPacientesForGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteGroupDto[]>;
        }));
    }

    protected processGetPacientesForGroup(response: HttpResponseBase): Observable<PacienteGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PacienteGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteGroupDto[]>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getDadosPacientesGroup(ids: string[] | null | undefined): Observable<PacienteGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetDadosPacientesGroup?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDadosPacientesGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDadosPacientesGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteGroupDto[]>;
        }));
    }

    protected processGetDadosPacientesGroup(response: HttpResponseBase): Observable<PacienteGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PacienteGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteGroupDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    gerarPdfFichaPaciente(body: GerarFichaPacienteDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GerarPdfFichaPaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGerarPdfFichaPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGerarPdfFichaPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGerarPdfFichaPaciente(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDadosProntuario(body: PacienteDto | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/UpdateDadosProntuario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDadosProntuario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDadosProntuario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processUpdateDadosProntuario(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    getEndereco(pacienteId: string | undefined): Observable<EnderecoDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetEndereco?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndereco(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndereco(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnderecoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnderecoDto>;
        }));
    }

    protected processGetEndereco(response: HttpResponseBase): Observable<EnderecoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnderecoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnderecoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEndereco(body: CreateEnderecoPacienteDto | undefined): Observable<EnderecoDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/CreateEndereco";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEndereco(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEndereco(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnderecoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnderecoDto>;
        }));
    }

    protected processCreateEndereco(response: HttpResponseBase): Observable<EnderecoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnderecoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnderecoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEndereco(body: UpdateEnderecoDto | undefined): Observable<EnderecoDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/UpdateEndereco";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEndereco(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEndereco(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnderecoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnderecoDto>;
        }));
    }

    protected processUpdateEndereco(response: HttpResponseBase): Observable<EnderecoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnderecoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnderecoDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEndereco(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/DeleteEndereco?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEndereco(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEndereco(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEndereco(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param itemLength (optional) 
     * @param pacienteId (optional) 
     * @return Success
     */
    getHistorico(pageSize: number | undefined, itemLength: number | undefined, pacienteId: string | null | undefined): Observable<HistoricoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetHistorico?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (itemLength === null)
            throw new Error("The parameter 'itemLength' cannot be null.");
        else if (itemLength !== undefined)
            url_ += "itemLength=" + encodeURIComponent("" + itemLength) + "&";
        if (pacienteId !== undefined && pacienteId !== null)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistorico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistorico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricoDto[]>;
        }));
    }

    protected processGetHistorico(response: HttpResponseBase): Observable<HistoricoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HistoricoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HistoricoDto[]>(null as any);
    }

    /**
     * @return Success
     */
    createTokenOtp(): Observable<TokenDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/CreateTokenOtp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTokenOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTokenOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDto>;
        }));
    }

    protected processCreateTokenOtp(response: HttpResponseBase): Observable<TokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenDto>(null as any);
    }

    /**
     * @param cns (optional) 
     * @param pacientId (optional) 
     * @return Success
     */
    cnsExistsOrInvalid(cns: string | null | undefined, pacientId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/CnsExistsOrInvalid?";
        if (cns !== undefined && cns !== null)
            url_ += "cns=" + encodeURIComponent("" + cns) + "&";
        if (pacientId !== undefined && pacientId !== null)
            url_ += "pacientId=" + encodeURIComponent("" + pacientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCnsExistsOrInvalid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCnsExistsOrInvalid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCnsExistsOrInvalid(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param pacientId (optional) 
     * @return Success
     */
    cpfExistsOrInvalid(cpf: string | null | undefined, pacientId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/CpfExistsOrInvalid?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        if (pacientId !== undefined && pacientId !== null)
            url_ += "pacientId=" + encodeURIComponent("" + pacientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpfExistsOrInvalid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpfExistsOrInvalid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCpfExistsOrInvalid(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @param cpf (optional) 
     * @return Success
     */
    emailExists(email: string | null | undefined, cpf: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/EmailExists?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEmailExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    verificarResponsavelLegal(cpf: string | null | undefined): Observable<VerificarResponsavelLegalDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/VerificarResponsavelLegal?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarResponsavelLegal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarResponsavelLegal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerificarResponsavelLegalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerificarResponsavelLegalDto>;
        }));
    }

    protected processVerificarResponsavelLegal(response: HttpResponseBase): Observable<VerificarResponsavelLegalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificarResponsavelLegalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VerificarResponsavelLegalDto>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    getDependentes(cpf: string | null | undefined): Observable<PacienteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetDependentes?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDependentes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDependentes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto[]>;
        }));
    }

    protected processGetDependentes(response: HttpResponseBase): Observable<PacienteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PacienteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto[]>(null as any);
    }

    /**
     * @param dependenteId (optional) 
     * @return Success
     */
    getDependente(dependenteId: string | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetDependente?";
        if (dependenteId === null)
            throw new Error("The parameter 'dependenteId' cannot be null.");
        else if (dependenteId !== undefined)
            url_ += "dependenteId=" + encodeURIComponent("" + dependenteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDependente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDependente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processGetDependente(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    getNomePaciente(pacienteId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetNomePaciente?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNomePaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomePaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNomePaciente(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarEmailAlternativo(body: EmailAlternativoDto | undefined): Observable<EmailAlternativoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/DeletarEmailAlternativo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarEmailAlternativo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarEmailAlternativo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAlternativoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAlternativoDto[]>;
        }));
    }

    protected processDeletarEmailAlternativo(response: HttpResponseBase): Observable<EmailAlternativoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmailAlternativoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailAlternativoDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAllEmailsAlternativos(id: string | undefined): Observable<EmailAlternativoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetAllEmailsAlternativos?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmailsAlternativos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmailsAlternativos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAlternativoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAlternativoDto[]>;
        }));
    }

    protected processGetAllEmailsAlternativos(response: HttpResponseBase): Observable<EmailAlternativoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmailAlternativoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailAlternativoDto[]>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    getAllEmailsAlternativosCpf(cpf: string | null | undefined): Observable<EmailAlternativoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetAllEmailsAlternativosCpf?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmailsAlternativosCpf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmailsAlternativosCpf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAlternativoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAlternativoDto[]>;
        }));
    }

    protected processGetAllEmailsAlternativosCpf(response: HttpResponseBase): Observable<EmailAlternativoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmailAlternativoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailAlternativoDto[]>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    deleteAllEmail(pacienteId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/DeleteAllEmail?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param idPaciente (optional) 
     * @return Success
     */
    getUserId(idPaciente: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetUserId?";
        if (idPaciente === null)
            throw new Error("The parameter 'idPaciente' cannot be null.");
        else if (idPaciente !== undefined)
            url_ += "idPaciente=" + encodeURIComponent("" + idPaciente) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUserId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param pacienteId (optional) 
     * @return Success
     */
    getInformacoesHome(dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, pacienteId: string | undefined): Observable<InformacoesHomePacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetInformacoesHome?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "dataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacoesHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacoesHome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformacoesHomePacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformacoesHomePacienteDto>;
        }));
    }

    protected processGetInformacoesHome(response: HttpResponseBase): Observable<InformacoesHomePacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformacoesHomePacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InformacoesHomePacienteDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    getAlergiasPaciente(pacienteId: string | undefined): Observable<PacienteAlergiaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetAlergiasPaciente?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlergiasPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlergiasPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteAlergiaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteAlergiaDto[]>;
        }));
    }

    protected processGetAlergiasPaciente(response: HttpResponseBase): Observable<PacienteAlergiaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PacienteAlergiaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteAlergiaDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param clinicaId (optional) 
     * @param profissionalSaudeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAdmin(keyword: string | null | undefined, clinicaId: string | null | undefined, profissionalSaudeId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PacienteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/GetAllAdmin?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (profissionalSaudeId !== undefined && profissionalSaudeId !== null)
            url_ += "ProfissionalSaudeId=" + encodeURIComponent("" + profissionalSaudeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDtoPagedResultDto>;
        }));
    }

    protected processGetAllAdmin(response: HttpResponseBase): Observable<PacienteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDtoPagedResultDto>(null as any);
    }

    /**
     * @param cpfOrPassaporte (optional) 
     * @return Success
     */
    existeCadastro(cpfOrPassaporte: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/ExisteCadastro?";
        if (cpfOrPassaporte !== undefined && cpfOrPassaporte !== null)
            url_ += "cpfOrPassaporte=" + encodeURIComponent("" + cpfOrPassaporte) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExisteCadastro(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExisteCadastro(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExisteCadastro(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Paciente/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PacienteAlergiaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePacienteAlergiaDto | undefined): Observable<PacienteAlergiaDto> {
        let url_ = this.baseUrl + "/api/services/app/PacienteAlergia/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteAlergiaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteAlergiaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PacienteAlergiaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteAlergiaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteAlergiaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PacienteAlergia/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PacienteAlergiaDto> {
        let url_ = this.baseUrl + "/api/services/app/PacienteAlergia/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteAlergiaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteAlergiaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PacienteAlergiaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteAlergiaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteAlergiaDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param substancia (optional) 
     * @param tipoAlergia (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(pacienteId: string | undefined, substancia: string | null | undefined, tipoAlergia: TipoAlergiaEnum | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PacienteAlergiaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PacienteAlergia/GetAll?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (substancia !== undefined && substancia !== null)
            url_ += "Substancia=" + encodeURIComponent("" + substancia) + "&";
        if (tipoAlergia === null)
            throw new Error("The parameter 'tipoAlergia' cannot be null.");
        else if (tipoAlergia !== undefined)
            url_ += "TipoAlergia=" + encodeURIComponent("" + tipoAlergia) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteAlergiaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteAlergiaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PacienteAlergiaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteAlergiaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteAlergiaDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    getAllAlergiasList(pacienteId: string | undefined): Observable<PacienteAlergiaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PacienteAlergia/GetAllAlergiasList?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAlergiasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAlergiasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteAlergiaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteAlergiaDto[]>;
        }));
    }

    protected processGetAllAlergiasList(response: HttpResponseBase): Observable<PacienteAlergiaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PacienteAlergiaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteAlergiaDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePacienteAlergiaDto | undefined): Observable<PacienteAlergiaDto> {
        let url_ = this.baseUrl + "/api/services/app/PacienteAlergia/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteAlergiaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteAlergiaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PacienteAlergiaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteAlergiaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteAlergiaDto>(null as any);
    }
}

@Injectable()
export class PacienteClinicaMedicaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enviarTokenPaciente(body: PacienteClincaMedicaDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PacienteClinicaMedica/EnviarTokenPaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarTokenPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarTokenPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEnviarTokenPaciente(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    vincularPacienteClinica(body: PacienteClincaMedicaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PacienteClinicaMedica/VincularPacienteClinica";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVincularPacienteClinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVincularPacienteClinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVincularPacienteClinica(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    existeVinculo(body: PacienteClincaMedicaDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PacienteClinicaMedica/ExisteVinculo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExisteVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExisteVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExisteVinculo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class PacienteClinicaMedicaServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param pacienteId (optional) 
     * @param clinicaMedicaId (optional) 
     * @return Success
     */
    vincularPacienteClinica(pacienteId: string | undefined, clinicaMedicaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PacienteClinicaMedicaService/VincularPacienteClinica?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (clinicaMedicaId === null)
            throw new Error("The parameter 'clinicaMedicaId' cannot be null.");
        else if (clinicaMedicaId !== undefined)
            url_ += "clinicaMedicaId=" + encodeURIComponent("" + clinicaMedicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVincularPacienteClinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVincularPacienteClinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVincularPacienteClinica(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PacienteConvenioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activeOrDeActive(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PacienteConvenio/ActiveOrDeActive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveOrDeActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveOrDeActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActiveOrDeActive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PacienteConvenioDto | undefined): Observable<PacienteConvenioDto> {
        let url_ = this.baseUrl + "/api/services/app/PacienteConvenio/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteConvenioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteConvenioDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PacienteConvenioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteConvenioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteConvenioDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param nomeConvenio (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(pacienteId: string | undefined, nomeConvenio: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PacienteConvenioDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PacienteConvenio/GetAll?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (nomeConvenio !== undefined && nomeConvenio !== null)
            url_ += "NomeConvenio=" + encodeURIComponent("" + nomeConvenio) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteConvenioDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteConvenioDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PacienteConvenioDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteConvenioDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteConvenioDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PacienteConvenioDto | undefined): Observable<PacienteConvenioDto> {
        let url_ = this.baseUrl + "/api/services/app/PacienteConvenio/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteConvenioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteConvenioDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PacienteConvenioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteConvenioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteConvenioDto>(null as any);
    }
}

@Injectable()
export class PesoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPeso(body: CreatePesoDto | undefined): Observable<PesoDto> {
        let url_ = this.baseUrl + "/api/services/app/Peso/CreatePeso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePeso(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePeso(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesoDto>;
        }));
    }

    protected processCreatePeso(response: HttpResponseBase): Observable<PesoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PesoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PesoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePeso(body: UpdatePesoDto | undefined): Observable<PesoDto> {
        let url_ = this.baseUrl + "/api/services/app/Peso/UpdatePeso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePeso(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePeso(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesoDto>;
        }));
    }

    protected processUpdatePeso(response: HttpResponseBase): Observable<PesoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PesoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PesoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateObjetivoPeso(body: ObjetivoPeso | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Peso/UpdateObjetivoPeso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateObjetivoPeso(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateObjetivoPeso(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateObjetivoPeso(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoPeso(body: PesoDto | undefined): Observable<PesoDto> {
        let url_ = this.baseUrl + "/api/services/app/Peso/DeletarDadoPeso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoPeso(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoPeso(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesoDto>;
        }));
    }

    protected processDeletarDadoPeso(response: HttpResponseBase): Observable<PesoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PesoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PesoDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined): Observable<PesoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Peso/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesoDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<PesoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PesoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PesoDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PesoDto> {
        let url_ = this.baseUrl + "/api/services/app/Peso/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PesoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PesoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PesoDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PesoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Peso/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PesoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PesoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PesoDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    getObjetivoPesoByPaciente(pacienteId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Peso/GetObjetivoPesoByPaciente?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObjetivoPesoByPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObjetivoPesoByPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetObjetivoPesoByPaciente(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @return Success
     */
    deletarObjetivo(pacienteId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Peso/DeletarObjetivo?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarObjetivo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarObjetivo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletarObjetivo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Peso/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class PlanoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePlanoDto | undefined): Observable<PlanoDto> {
        let url_ = this.baseUrl + "/api/services/app/Plano/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanoDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PlanoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanoDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Plano/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    suspendOrActivate(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Plano/SuspendOrActivate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendOrActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendOrActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSuspendOrActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PlanoDto> {
        let url_ = this.baseUrl + "/api/services/app/Plano/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PlanoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanoDto>(null as any);
    }

    /**
     * @param nome (optional) 
     * @param ordemCrescente (optional) 
     * @param publicoAlvo (optional) 
     * @param suspenso (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(nome: string | null | undefined, ordemCrescente: boolean | undefined, publicoAlvo: number[] | null | undefined, suspenso: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PlanoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Plano/GetAll?";
        if (nome !== undefined && nome !== null)
            url_ += "Nome=" + encodeURIComponent("" + nome) + "&";
        if (ordemCrescente === null)
            throw new Error("The parameter 'ordemCrescente' cannot be null.");
        else if (ordemCrescente !== undefined)
            url_ += "OrdemCrescente=" + encodeURIComponent("" + ordemCrescente) + "&";
        if (publicoAlvo !== undefined && publicoAlvo !== null)
            publicoAlvo && publicoAlvo.forEach(item => { url_ += "PublicoAlvo=" + encodeURIComponent("" + item) + "&"; });
        if (suspenso !== undefined && suspenso !== null)
            url_ += "Suspenso=" + encodeURIComponent("" + suspenso) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PlanoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanoDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePlanoDto | undefined): Observable<PlanoDto> {
        let url_ = this.baseUrl + "/api/services/app/Plano/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanoDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PlanoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanoDto>(null as any);
    }

    /**
     * @return Success
     */
    getPlanosMobile(): Observable<PlanoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Plano/GetPlanosMobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanosMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanosMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanoDto[]>;
        }));
    }

    protected processGetPlanosMobile(response: HttpResponseBase): Observable<PlanoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlanoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanoDto[]>(null as any);
    }

    /**
     * @param publicoAlvo (optional) 
     * @return Success
     */
    getPlanosByPublicoAlvo(publicoAlvo: PublicoAlvoEnum | undefined): Observable<PlanoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Plano/GetPlanosByPublicoAlvo?";
        if (publicoAlvo === null)
            throw new Error("The parameter 'publicoAlvo' cannot be null.");
        else if (publicoAlvo !== undefined)
            url_ += "publicoAlvo=" + encodeURIComponent("" + publicoAlvo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanosByPublicoAlvo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanosByPublicoAlvo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanoDto[]>;
        }));
    }

    protected processGetPlanosByPublicoAlvo(response: HttpResponseBase): Observable<PlanoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PlanoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanoDto[]>(null as any);
    }
}

@Injectable()
export class PrescricaoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param clinicaMedicaId (optional) 
     * @param profissionalId (optional) 
     * @param pacienteId (optional) 
     * @param cidId (optional) 
     * @param procedimentoTussId (optional) 
     * @param procedimentoSigtapId (optional) 
     * @param medicamentoTissId (optional) 
     * @param medicamentoSigtapId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPrescricao(clinicaMedicaId: string | null | undefined, profissionalId: string | null | undefined, pacienteId: string | undefined, cidId: string | null | undefined, procedimentoTussId: string | null | undefined, procedimentoSigtapId: string | null | undefined, medicamentoTissId: string | null | undefined, medicamentoSigtapId: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PrescricaoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Prescricao/GetPrescricao?";
        if (clinicaMedicaId !== undefined && clinicaMedicaId !== null)
            url_ += "ClinicaMedicaId=" + encodeURIComponent("" + clinicaMedicaId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "ProfissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (cidId !== undefined && cidId !== null)
            url_ += "CidId=" + encodeURIComponent("" + cidId) + "&";
        if (procedimentoTussId !== undefined && procedimentoTussId !== null)
            url_ += "ProcedimentoTussId=" + encodeURIComponent("" + procedimentoTussId) + "&";
        if (procedimentoSigtapId !== undefined && procedimentoSigtapId !== null)
            url_ += "ProcedimentoSigtapId=" + encodeURIComponent("" + procedimentoSigtapId) + "&";
        if (medicamentoTissId !== undefined && medicamentoTissId !== null)
            url_ += "MedicamentoTissId=" + encodeURIComponent("" + medicamentoTissId) + "&";
        if (medicamentoSigtapId !== undefined && medicamentoSigtapId !== null)
            url_ += "MedicamentoSigtapId=" + encodeURIComponent("" + medicamentoSigtapId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescricao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescricao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrescricaoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrescricaoDtoPagedResultDto>;
        }));
    }

    protected processGetPrescricao(response: HttpResponseBase): Observable<PrescricaoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescricaoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescricaoDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param clinicaId (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    getNomePescricoes(pacienteId: string | undefined, clinicaId: string | null | undefined, profissionalId: string | null | undefined): Observable<TipoPrescricaoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Prescricao/GetNomePescricoes?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNomePescricoes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomePescricoes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipoPrescricaoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipoPrescricaoDto[]>;
        }));
    }

    protected processGetNomePescricoes(response: HttpResponseBase): Observable<TipoPrescricaoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipoPrescricaoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipoPrescricaoDto[]>(null as any);
    }
}

@Injectable()
export class PressaoArterialServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPressoaArterial(body: CreatePressaoArterialDto | undefined): Observable<PressaoArterialDto> {
        let url_ = this.baseUrl + "/api/services/app/PressaoArterial/CreatePressoaArterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePressoaArterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePressoaArterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressaoArterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressaoArterialDto>;
        }));
    }

    protected processCreatePressoaArterial(response: HttpResponseBase): Observable<PressaoArterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressaoArterialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PressaoArterialDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePressaoArterial(body: UpdatePressaoArterialDto | undefined): Observable<PressaoArterialDto> {
        let url_ = this.baseUrl + "/api/services/app/PressaoArterial/UpdatePressaoArterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePressaoArterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePressaoArterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressaoArterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressaoArterialDto>;
        }));
    }

    protected processUpdatePressaoArterial(response: HttpResponseBase): Observable<PressaoArterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressaoArterialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PressaoArterialDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoPressao(body: PressaoArterialDto | undefined): Observable<PressaoArterialDto> {
        let url_ = this.baseUrl + "/api/services/app/PressaoArterial/DeletarDadoPressao";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoPressao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoPressao(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressaoArterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressaoArterialDto>;
        }));
    }

    protected processDeletarDadoPressao(response: HttpResponseBase): Observable<PressaoArterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressaoArterialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PressaoArterialDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicial (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicial: string | null | undefined, dataFinal: string | null | undefined): Observable<PressaoArterialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PressaoArterial/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicial !== undefined && dataInicial !== null)
            url_ += "dataInicial=" + encodeURIComponent("" + dataInicial) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressaoArterialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressaoArterialDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<PressaoArterialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PressaoArterialDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PressaoArterialDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PressaoArterialDto> {
        let url_ = this.baseUrl + "/api/services/app/PressaoArterial/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressaoArterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressaoArterialDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PressaoArterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressaoArterialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PressaoArterialDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PressaoArterialDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PressaoArterial/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressaoArterialDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressaoArterialDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PressaoArterialDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressaoArterialDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PressaoArterialDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximoSistolica (optional) 
     * @param limiteMinimoSistolica (optional) 
     * @param limiteMaximoDiastolica (optional) 
     * @param limiteMinimoDiastolica (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximoSistolica: number | null | undefined, limiteMinimoSistolica: number | null | undefined, limiteMaximoDiastolica: number | null | undefined, limiteMinimoDiastolica: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PressaoArterial/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximoSistolica !== undefined && limiteMaximoSistolica !== null)
            url_ += "limiteMaximoSistolica=" + encodeURIComponent("" + limiteMaximoSistolica) + "&";
        if (limiteMinimoSistolica !== undefined && limiteMinimoSistolica !== null)
            url_ += "limiteMinimoSistolica=" + encodeURIComponent("" + limiteMinimoSistolica) + "&";
        if (limiteMaximoDiastolica !== undefined && limiteMaximoDiastolica !== null)
            url_ += "limiteMaximoDiastolica=" + encodeURIComponent("" + limiteMaximoDiastolica) + "&";
        if (limiteMinimoDiastolica !== undefined && limiteMinimoDiastolica !== null)
            url_ += "limiteMinimoDiastolica=" + encodeURIComponent("" + limiteMinimoDiastolica) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ProcedimentoSigtapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ProcedimentoSigtapDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoSigtap/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoSigtapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoSigtapDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcedimentoSigtapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedimentoSigtapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoSigtapDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProcedimentoSigtapDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoSigtap/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoSigtapDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoSigtapDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProcedimentoSigtapDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedimentoSigtapDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoSigtapDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProcedimentoSigtapDto | undefined): Observable<ProcedimentoSigtapDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoSigtap/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoSigtapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoSigtapDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProcedimentoSigtapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedimentoSigtapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoSigtapDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProcedimentoSigtapDto | undefined): Observable<ProcedimentoSigtapDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoSigtap/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoSigtapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoSigtapDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProcedimentoSigtapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedimentoSigtapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoSigtapDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoSigtap/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    readTable(body: ImportTableDto | undefined): Observable<CreateProcedimentoSigtapDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoSigtap/ReadTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProcedimentoSigtapDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProcedimentoSigtapDto[]>;
        }));
    }

    protected processReadTable(response: HttpResponseBase): Observable<CreateProcedimentoSigtapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateProcedimentoSigtapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateProcedimentoSigtapDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: CreateProcedimentoSigtapDto[] | null | undefined): Observable<ProcedimentoSigtapDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoSigtap/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoSigtapDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoSigtapDto[]>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ProcedimentoSigtapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProcedimentoSigtapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoSigtapDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param tipo (optional) 
     * @param count (optional) 
     * @param prefix (optional) 
     * @return Success
     */
    getAutoComplete(keyword: string | null | undefined, tipo: string | null | undefined, count: number | undefined, prefix: string | undefined): Observable<MentionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoSigtap/GetAutoComplete?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (tipo !== undefined && tipo !== null)
            url_ += "tipo=" + encodeURIComponent("" + tipo) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (prefix === null)
            throw new Error("The parameter 'prefix' cannot be null.");
        else if (prefix !== undefined)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MentionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MentionDto[]>;
        }));
    }

    protected processGetAutoComplete(response: HttpResponseBase): Observable<MentionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MentionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentionDto[]>(null as any);
    }
}

@Injectable()
export class ProcedimentoTussServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ProcedimentoTussDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoTuss/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoTussDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoTussDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcedimentoTussDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedimentoTussDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoTussDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProcedimentoTussDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoTuss/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoTussDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoTussDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProcedimentoTussDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedimentoTussDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoTussDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProcedimentoTussDto | undefined): Observable<ProcedimentoTussDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoTuss/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoTussDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoTussDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProcedimentoTussDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedimentoTussDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoTussDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProcedimentoTussDto | undefined): Observable<ProcedimentoTussDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoTuss/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoTussDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoTussDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProcedimentoTussDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcedimentoTussDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoTussDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoTuss/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    readTable(body: ImportTableDto | undefined): Observable<CreateProcedimentoTussDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoTuss/ReadTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProcedimentoTussDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProcedimentoTussDto[]>;
        }));
    }

    protected processReadTable(response: HttpResponseBase): Observable<CreateProcedimentoTussDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateProcedimentoTussDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateProcedimentoTussDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: CreateProcedimentoTussDto[] | null | undefined): Observable<ProcedimentoTussDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoTuss/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcedimentoTussDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcedimentoTussDto[]>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<ProcedimentoTussDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProcedimentoTussDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcedimentoTussDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param tipo (optional) 
     * @param count (optional) 
     * @param prefix (optional) 
     * @return Success
     */
    getAutoComplete(keyword: string | null | undefined, tipo: string | null | undefined, count: number | undefined, prefix: string | undefined): Observable<MentionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProcedimentoTuss/GetAutoComplete?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (tipo !== undefined && tipo !== null)
            url_ += "tipo=" + encodeURIComponent("" + tipo) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (prefix === null)
            throw new Error("The parameter 'prefix' cannot be null.");
        else if (prefix !== undefined)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MentionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MentionDto[]>;
        }));
    }

    protected processGetAutoComplete(response: HttpResponseBase): Observable<MentionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MentionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MentionDto[]>(null as any);
    }
}

@Injectable()
export class ProfissionalSaudeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    getByCpf(cpf: string | null | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetByCpf?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCpf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCpf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processGetByCpf(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProfissionalSaudeDto | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAnonymous(body: CreateProfissionalSaudeDto | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/CreateAnonymous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAnonymous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processCreateAnonymous(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    gerarAssinaturaProfissional(emailAddress: string | null | undefined, userId: number | undefined, body: CreateProfissionalSaudeDto | undefined): Observable<AssinaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GerarAssinaturaProfissional?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGerarAssinaturaProfissional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGerarAssinaturaProfissional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssinaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssinaturaDto>;
        }));
    }

    protected processGerarAssinaturaProfissional(response: HttpResponseBase): Observable<AssinaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssinaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssinaturaDto>(null as any);
    }

    /**
     * @param clinicaId (optional) 
     * @return Success
     */
    getProfissionais(clinicaId: string | null | undefined): Observable<ProfissionalSaudeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetProfissionais?";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfissionais(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfissionais(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto[]>;
        }));
    }

    protected processGetProfissionais(response: HttpResponseBase): Observable<ProfissionalSaudeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProfissionalSaudeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param clinicaId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, clinicaId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProfissionalSaudeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProfissionalSaudeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDtoPagedResultDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param clinicaId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAdmin(keyword: string | null | undefined, clinicaId: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProfissionalSaudeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetAllAdmin?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "ClinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDtoPagedResultDto>;
        }));
    }

    protected processGetAllAdmin(response: HttpResponseBase): Observable<ProfissionalSaudeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProfissionalSaudeDto | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param profissionaId (optional) 
     * @return Success
     */
    habilitarAssinaturaDigital(profissionaId: string | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/HabilitarAssinaturaDigital?";
        if (profissionaId === null)
            throw new Error("The parameter 'profissionaId' cannot be null.");
        else if (profissionaId !== undefined)
            url_ += "profissionaId=" + encodeURIComponent("" + profissionaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHabilitarAssinaturaDigital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHabilitarAssinaturaDigital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processHabilitarAssinaturaDigital(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param profissionaId (optional) 
     * @return Success
     */
    exibirNaListagemDeNovaConsulta(profissionaId: string | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/ExibirNaListagemDeNovaConsulta?";
        if (profissionaId === null)
            throw new Error("The parameter 'profissionaId' cannot be null.");
        else if (profissionaId !== undefined)
            url_ += "profissionaId=" + encodeURIComponent("" + profissionaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExibirNaListagemDeNovaConsulta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExibirNaListagemDeNovaConsulta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processExibirNaListagemDeNovaConsulta(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param profissionaId (optional) 
     * @return Success
     */
    desabilitarAssinaturaDigital(profissionaId: string | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/DesabilitarAssinaturaDigital?";
        if (profissionaId === null)
            throw new Error("The parameter 'profissionaId' cannot be null.");
        else if (profissionaId !== undefined)
            url_ += "profissionaId=" + encodeURIComponent("" + profissionaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDesabilitarAssinaturaDigital(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDesabilitarAssinaturaDigital(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processDesabilitarAssinaturaDigital(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param avatar (optional) 
     * @return Success
     */
    getAvatar(avatar: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetAvatar?";
        if (avatar !== undefined && avatar !== null)
            url_ += "avatar=" + encodeURIComponent("" + avatar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAvatar(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cadastrarCertificado(body: ProfissionalSaudeDto | undefined): Observable<ProfissionalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/CadastrarCertificado";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCadastrarCertificado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCadastrarCertificado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto>;
        }));
    }

    protected processCadastrarCertificado(response: HttpResponseBase): Observable<ProfissionalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    activeOrDeActiveVinculoClinica(profissionalId: string | undefined, clinicaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/ActiveOrDeActiveVinculoClinica?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId === null)
            throw new Error("The parameter 'clinicaId' cannot be null.");
        else if (clinicaId !== undefined)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveOrDeActiveVinculoClinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveOrDeActiveVinculoClinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActiveOrDeActiveVinculoClinica(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    cpfExistsOrInvalid(cpf: string | null | undefined, profissionalId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/CpfExistsOrInvalid?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpfExistsOrInvalid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpfExistsOrInvalid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCpfExistsOrInvalid(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param cns (optional) 
     * @param cpf (optional) 
     * @return Success
     */
    cnsExistsOrInvalid(cns: string | null | undefined, cpf: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/CnsExistsOrInvalid?";
        if (cns !== undefined && cns !== null)
            url_ += "cns=" + encodeURIComponent("" + cns) + "&";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCnsExistsOrInvalid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCnsExistsOrInvalid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCnsExistsOrInvalid(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @param cpf (optional) 
     * @return Success
     */
    emailExists(email: string | null | undefined, cpf: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/EmailExists?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEmailExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssinatura(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetAssinatura?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssinatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssinatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAssinatura(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param clinicaId (optional) 
     * @return Success
     */
    getProfissionaisByClinica(clinicaId: string | undefined): Observable<EssentialProfisisonalSaudeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetProfissionaisByClinica?";
        if (clinicaId === null)
            throw new Error("The parameter 'clinicaId' cannot be null.");
        else if (clinicaId !== undefined)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfissionaisByClinica(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfissionaisByClinica(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EssentialProfisisonalSaudeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EssentialProfisisonalSaudeDto[]>;
        }));
    }

    protected processGetProfissionaisByClinica(response: HttpResponseBase): Observable<EssentialProfisisonalSaudeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EssentialProfisisonalSaudeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EssentialProfisisonalSaudeDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEssentialProfissionaisById(id: string | undefined): Observable<EssentialProfisisonalSaudeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetEssentialProfissionaisById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEssentialProfissionaisById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEssentialProfissionaisById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EssentialProfisisonalSaudeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EssentialProfisisonalSaudeDto>;
        }));
    }

    protected processGetEssentialProfissionaisById(response: HttpResponseBase): Observable<EssentialProfisisonalSaudeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EssentialProfisisonalSaudeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EssentialProfisisonalSaudeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    obterProfissionais(body: PagedProfissionalSaudeResultRequestDto | undefined): Observable<ProfissionalSaudeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/ObterProfissionais";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObterProfissionais(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObterProfissionais(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDtoPagedResultDto>;
        }));
    }

    protected processObterProfissionais(response: HttpResponseBase): Observable<ProfissionalSaudeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDtoPagedResultDto>(null as any);
    }

    /**
     * @param clinicaId (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    getInformacoesHome(clinicaId: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, profissionalId: string | undefined): Observable<InformacoesHomeProfissionalDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetInformacoesHome?";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "dataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformacoesHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformacoesHome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformacoesHomeProfissionalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformacoesHomeProfissionalDto>;
        }));
    }

    protected processGetInformacoesHome(response: HttpResponseBase): Observable<InformacoesHomeProfissionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformacoesHomeProfissionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InformacoesHomeProfissionalDto>(null as any);
    }

    /**
     * @param profissionais (optional) 
     * @return Success
     */
    getProfissionaisById(profissionais: string[] | null | undefined): Observable<ProfissionalSaudeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaude/GetProfissionaisById?";
        if (profissionais !== undefined && profissionais !== null)
            profissionais && profissionais.forEach(item => { url_ += "profissionais=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfissionaisById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfissionaisById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeDto[]>;
        }));
    }

    protected processGetProfissionaisById(response: HttpResponseBase): Observable<ProfissionalSaudeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProfissionalSaudeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeDto[]>(null as any);
    }
}

@Injectable()
export class ProfissionalSaudeClinicaMedicaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param profisionalId (optional) 
     * @return Success
     */
    temRespostaPedente(profisionalId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudeClinicaMedica/TemRespostaPedente?";
        if (profisionalId === null)
            throw new Error("The parameter 'profisionalId' cannot be null.");
        else if (profisionalId !== undefined)
            url_ += "profisionalId=" + encodeURIComponent("" + profisionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTemRespostaPedente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemRespostaPedente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTemRespostaPedente(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param vinculoId (optional) 
     * @param body (optional) 
     * @return Success
     */
    alterarStatusVinculo(vinculoId: string | undefined, body: RespostaProfissionalEnum | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudeClinicaMedica/AlterarStatusVinculo?";
        if (vinculoId === null)
            throw new Error("The parameter 'vinculoId' cannot be null.");
        else if (vinculoId !== undefined)
            url_ += "vinculoId=" + encodeURIComponent("" + vinculoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAlterarStatusVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAlterarStatusVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAlterarStatusVinculo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @param nomeClinica (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getVinculosClinicaProfissional(profissionalId: string | undefined, nomeClinica: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProfissionalSaudeClinicaMedicaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudeClinicaMedica/GetVinculosClinicaProfissional?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "ProfissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (nomeClinica !== undefined && nomeClinica !== null)
            url_ += "NomeClinica=" + encodeURIComponent("" + nomeClinica) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVinculosClinicaProfissional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVinculosClinicaProfissional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfissionalSaudeClinicaMedicaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfissionalSaudeClinicaMedicaDtoPagedResultDto>;
        }));
    }

    protected processGetVinculosClinicaProfissional(response: HttpResponseBase): Observable<ProfissionalSaudeClinicaMedicaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfissionalSaudeClinicaMedicaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfissionalSaudeClinicaMedicaDtoPagedResultDto>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    solicitarVinculo(profissionalId: string | undefined, clinicaId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudeClinicaMedica/SolicitarVinculo?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId === null)
            throw new Error("The parameter 'clinicaId' cannot be null.");
        else if (clinicaId !== undefined)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSolicitarVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSolicitarVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSolicitarVinculo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removerVinculo(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudeClinicaMedica/RemoverVinculo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoverVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoverVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoverVinculo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    atualizarListaEmailsTelefones(body: ProfissionalSaudeClinicaMedicaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudeClinicaMedica/AtualizarListaEmailsTelefones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtualizarListaEmailsTelefones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtualizarListaEmailsTelefones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAtualizarListaEmailsTelefones(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProfissionalSaudeConvenioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adicionarVinculo(body: ProfissionalSaudeConvenioDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudeConvenio/AdicionarVinculo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdicionarVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdicionarVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdicionarVinculo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removerVinculo(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudeConvenio/RemoverVinculo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoverVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoverVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoverVinculo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProfissionalSaudePacienteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enviarTokenPaciente(body: ProfissionalSaudePacienteDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudePaciente/EnviarTokenPaciente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarTokenPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarTokenPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEnviarTokenPaciente(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    vincularPacienteProfissional(body: ProfissionalSaudePacienteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudePaciente/VincularPacienteProfissional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVincularPacienteProfissional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVincularPacienteProfissional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVincularPacienteProfissional(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    existeVinculo(body: ProfissionalSaudePacienteDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudePaciente/ExisteVinculo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExisteVinculo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExisteVinculo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExisteVinculo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @return Success
     */
    hasPacientes(profissionalId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudePaciente/HasPacientes?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasPacientes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasPacientes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasPacientes(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ProfissionalSaudePacienteServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param pacienteId (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    vincularPacienteProfissional(pacienteId: string | undefined, profissionalId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfissionalSaudePacienteService/VincularPacienteProfissional?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVincularPacienteProfissional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVincularPacienteProfissional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVincularPacienteProfissional(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProntuarioMedicoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param url (optional) 
     * @param acessoProntuarioId (optional) 
     * @return Success
     */
    getTemporaryLink(url: string | null | undefined, acessoProntuarioId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetTemporaryLink?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemporaryLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemporaryLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTemporaryLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFormularioValidar(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetFormularioValidar?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularioValidar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularioValidar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFormularioValidar(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getListaLinksTemporarios(body: TemporaryLinkDto | undefined): Observable<TemporaryLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetListaLinksTemporarios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListaLinksTemporarios(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListaLinksTemporarios(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemporaryLinkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemporaryLinkDto>;
        }));
    }

    protected processGetListaLinksTemporarios(response: HttpResponseBase): Observable<TemporaryLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemporaryLinkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemporaryLinkDto>(null as any);
    }

    /**
     * @param arquivoId (optional) 
     * @param acessoProntuarioId (optional) 
     * @return Success
     */
    getTemplate(arquivoId: string | undefined, acessoProntuarioId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetTemplate?";
        if (arquivoId === null)
            throw new Error("The parameter 'arquivoId' cannot be null.");
        else if (arquivoId !== undefined)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param arquivoId (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    getProntuario(arquivoId: string | undefined, profissionalId: string | undefined): Observable<ValidarCertificadoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetProntuario?";
        if (arquivoId === null)
            throw new Error("The parameter 'arquivoId' cannot be null.");
        else if (arquivoId !== undefined)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProntuario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProntuario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidarCertificadoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidarCertificadoDto>;
        }));
    }

    protected processGetProntuario(response: HttpResponseBase): Observable<ValidarCertificadoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidarCertificadoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidarCertificadoDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    darBaixaProntuario(id: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/DarBaixaProntuario?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDarBaixaProntuario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDarBaixaProntuario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDarBaixaProntuario(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param acessoProntuarioId (optional) 
     * @return Success
     */
    getAcessoProntuarioMedico(acessoProntuarioId: string | undefined): Observable<AcessoProntuarioDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetAcessoProntuarioMedico?";
        if (acessoProntuarioId === null)
            throw new Error("The parameter 'acessoProntuarioId' cannot be null.");
        else if (acessoProntuarioId !== undefined)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcessoProntuarioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcessoProntuarioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcessoProntuarioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcessoProntuarioDto>;
        }));
    }

    protected processGetAcessoProntuarioMedico(response: HttpResponseBase): Observable<AcessoProntuarioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcessoProntuarioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AcessoProntuarioDto>(null as any);
    }

    /**
     * @param assinaturaMedico (optional) 
     * @param idProfissional (optional) 
     * @param template (optional) 
     * @param haveCertificado (optional) 
     * @param numeroAtendimento (optional) 
     * @param clinicaName (optional) 
     * @param arquivoId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveProntuarioMedico(assinaturaMedico: string | null | undefined, idProfissional: string | null | undefined, template: string | null | undefined, haveCertificado: boolean | undefined, numeroAtendimento: string | null | undefined, clinicaName: string | null | undefined, arquivoId: string | null | undefined, body: ProntuarioMedicoDto | undefined): Observable<ArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/SaveProntuarioMedico?";
        if (assinaturaMedico !== undefined && assinaturaMedico !== null)
            url_ += "assinaturaMedico=" + encodeURIComponent("" + assinaturaMedico) + "&";
        if (idProfissional !== undefined && idProfissional !== null)
            url_ += "idProfissional=" + encodeURIComponent("" + idProfissional) + "&";
        if (template !== undefined && template !== null)
            url_ += "template=" + encodeURIComponent("" + template) + "&";
        if (haveCertificado === null)
            throw new Error("The parameter 'haveCertificado' cannot be null.");
        else if (haveCertificado !== undefined)
            url_ += "haveCertificado=" + encodeURIComponent("" + haveCertificado) + "&";
        if (numeroAtendimento !== undefined && numeroAtendimento !== null)
            url_ += "numeroAtendimento=" + encodeURIComponent("" + numeroAtendimento) + "&";
        if (clinicaName !== undefined && clinicaName !== null)
            url_ += "clinicaName=" + encodeURIComponent("" + clinicaName) + "&";
        if (arquivoId !== undefined && arquivoId !== null)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProntuarioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProntuarioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto>;
        }));
    }

    protected processSaveProntuarioMedico(response: HttpResponseBase): Observable<ArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto>(null as any);
    }

    /**
     * @param idProfissional (optional) 
     * @param clinicaName (optional) 
     * @param body (optional) 
     * @return Success
     */
    createRascunhoProntuarioMedico(idProfissional: string | undefined, clinicaName: string | null | undefined, body: ProntuarioMedicoDto | undefined): Observable<ArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/CreateRascunhoProntuarioMedico?";
        if (idProfissional === null)
            throw new Error("The parameter 'idProfissional' cannot be null.");
        else if (idProfissional !== undefined)
            url_ += "idProfissional=" + encodeURIComponent("" + idProfissional) + "&";
        if (clinicaName !== undefined && clinicaName !== null)
            url_ += "clinicaName=" + encodeURIComponent("" + clinicaName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRascunhoProntuarioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRascunhoProntuarioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto>;
        }));
    }

    protected processCreateRascunhoProntuarioMedico(response: HttpResponseBase): Observable<ArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto>(null as any);
    }

    /**
     * @param arquivoId (optional) 
     * @param profisionalSaudeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProntuarioMedico(arquivoId: string | undefined, profisionalSaudeId: string | undefined, body: ProntuarioMedicoDto | undefined): Observable<ArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/UpdateProntuarioMedico?";
        if (arquivoId === null)
            throw new Error("The parameter 'arquivoId' cannot be null.");
        else if (arquivoId !== undefined)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        if (profisionalSaudeId === null)
            throw new Error("The parameter 'profisionalSaudeId' cannot be null.");
        else if (profisionalSaudeId !== undefined)
            url_ += "profisionalSaudeId=" + encodeURIComponent("" + profisionalSaudeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProntuarioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProntuarioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto>;
        }));
    }

    protected processUpdateProntuarioMedico(response: HttpResponseBase): Observable<ArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto>(null as any);
    }

    /**
     * @param arquivoId (optional) 
     * @param profisionalSaudeId (optional) 
     * @return Success
     */
    excluirProntuarioMedico(arquivoId: string | undefined, profisionalSaudeId: string | undefined): Observable<ArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/ExcluirProntuarioMedico?";
        if (arquivoId === null)
            throw new Error("The parameter 'arquivoId' cannot be null.");
        else if (arquivoId !== undefined)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        if (profisionalSaudeId === null)
            throw new Error("The parameter 'profisionalSaudeId' cannot be null.");
        else if (profisionalSaudeId !== undefined)
            url_ += "profisionalSaudeId=" + encodeURIComponent("" + profisionalSaudeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcluirProntuarioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcluirProntuarioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto>;
        }));
    }

    protected processExcluirProntuarioMedico(response: HttpResponseBase): Observable<ArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    getUltimosProntuariosCriados(pacienteId: string | undefined, profissionalId: string | undefined, clinicaId: string | null | undefined): Observable<UltimosProntuariosCriadosDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetUltimosProntuariosCriados?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUltimosProntuariosCriados(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUltimosProntuariosCriados(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UltimosProntuariosCriadosDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UltimosProntuariosCriadosDto>;
        }));
    }

    protected processGetUltimosProntuariosCriados(response: HttpResponseBase): Observable<UltimosProntuariosCriadosDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UltimosProntuariosCriadosDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UltimosProntuariosCriadosDto>(null as any);
    }

    /**
     * @param clinicaName (optional) 
     * @return Success
     */
    getNumeroAtendimento(clinicaName: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetNumeroAtendimento?";
        if (clinicaName !== undefined && clinicaName !== null)
            url_ += "clinicaName=" + encodeURIComponent("" + clinicaName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumeroAtendimento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumeroAtendimento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNumeroAtendimento(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportPdfProntuarioMedico(body: ProntuarioMedicoDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/ExportPdfProntuarioMedico";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPdfProntuarioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPdfProntuarioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportPdfProntuarioMedico(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param profissionalId (optional) 
     * @param template (optional) 
     * @param numeroAtendimento (optional) 
     * @param body (optional) 
     * @return Success
     */
    getPdfToSign(profissionalId: string | undefined, template: string | null | undefined, numeroAtendimento: string | null | undefined, body: ProntuarioMedicoDto | undefined): Observable<ProntuarioMedicoToSign> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetPdfToSign?";
        if (profissionalId === null)
            throw new Error("The parameter 'profissionalId' cannot be null.");
        else if (profissionalId !== undefined)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (template !== undefined && template !== null)
            url_ += "template=" + encodeURIComponent("" + template) + "&";
        if (numeroAtendimento !== undefined && numeroAtendimento !== null)
            url_ += "numeroAtendimento=" + encodeURIComponent("" + numeroAtendimento) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfToSign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfToSign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioMedicoToSign>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioMedicoToSign>;
        }));
    }

    protected processGetPdfToSign(response: HttpResponseBase): Observable<ProntuarioMedicoToSign> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProntuarioMedicoToSign.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioMedicoToSign>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFileProntuarioMedico(body: ProntuarioMedicoDto[] | null | undefined): Observable<ArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/UploadFileProntuarioMedico";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFileProntuarioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFileProntuarioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArquivoDto>;
        }));
    }

    protected processUploadFileProntuarioMedico(response: HttpResponseBase): Observable<ArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArquivoDto>(null as any);
    }

    /**
     * @param arquivoId (optional) 
     * @return Success
     */
    getFileById(arquivoId: string | undefined): Observable<ProntuarioArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetFileById?";
        if (arquivoId === null)
            throw new Error("The parameter 'arquivoId' cannot be null.");
        else if (arquivoId !== undefined)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioArquivoDto>;
        }));
    }

    protected processGetFileById(response: HttpResponseBase): Observable<ProntuarioArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProntuarioArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioArquivoDto>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param acessoProntuarioId (optional) 
     * @return Success
     */
    getPacienteProntuarioByCpf(cpf: string | null | undefined, acessoProntuarioId: string | undefined): Observable<PacienteDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetPacienteProntuarioByCpf?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        if (acessoProntuarioId === null)
            throw new Error("The parameter 'acessoProntuarioId' cannot be null.");
        else if (acessoProntuarioId !== undefined)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPacienteProntuarioByCpf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPacienteProntuarioByCpf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PacienteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PacienteDto>;
        }));
    }

    protected processGetPacienteProntuarioByCpf(response: HttpResponseBase): Observable<PacienteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PacienteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PacienteDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param acessoProntuarioId (optional) 
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    getFileByPaciente(pacienteId: string | null | undefined, acessoProntuarioId: string | null | undefined, profissionalId: string | null | undefined, clinicaId: string | null | undefined): Observable<ProntuarioArquivoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetFileByPaciente?";
        if (pacienteId !== undefined && pacienteId !== null)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileByPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileByPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioArquivoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioArquivoDto[]>;
        }));
    }

    protected processGetFileByPaciente(response: HttpResponseBase): Observable<ProntuarioArquivoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProntuarioArquivoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioArquivoDto[]>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRascunhosByPaciente(pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProntuarioArquivoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetRascunhosByPaciente?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRascunhosByPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRascunhosByPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioArquivoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioArquivoDtoPagedResultDto>;
        }));
    }

    protected processGetRascunhosByPaciente(response: HttpResponseBase): Observable<ProntuarioArquivoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProntuarioArquivoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioArquivoDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param acessoProntuarioId (optional) 
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    getFileDependente(pacienteId: string | undefined, acessoProntuarioId: string | undefined, profissionalId: string | null | undefined, clinicaId: string | null | undefined): Observable<ProntuarioArquivoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetFileDependente?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (acessoProntuarioId === null)
            throw new Error("The parameter 'acessoProntuarioId' cannot be null.");
        else if (acessoProntuarioId !== undefined)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileDependente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileDependente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioArquivoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioArquivoDto[]>;
        }));
    }

    protected processGetFileDependente(response: HttpResponseBase): Observable<ProntuarioArquivoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProntuarioArquivoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioArquivoDto[]>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param arquivoId (optional) 
     * @param acessoProntuarioId (optional) 
     * @param profissionalId (optional) 
     * @param clinicaId (optional) 
     * @return Success
     */
    getSpecificFileByPaciente(pacienteId: string | null | undefined, arquivoId: string | undefined, acessoProntuarioId: string | null | undefined, profissionalId: string | null | undefined, clinicaId: string | null | undefined): Observable<ProntuarioArquivoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetSpecificFileByPaciente?";
        if (pacienteId !== undefined && pacienteId !== null)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (arquivoId === null)
            throw new Error("The parameter 'arquivoId' cannot be null.");
        else if (arquivoId !== undefined)
            url_ += "arquivoId=" + encodeURIComponent("" + arquivoId) + "&";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        if (clinicaId !== undefined && clinicaId !== null)
            url_ += "clinicaId=" + encodeURIComponent("" + clinicaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecificFileByPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecificFileByPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioArquivoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioArquivoDto>;
        }));
    }

    protected processGetSpecificFileByPaciente(response: HttpResponseBase): Observable<ProntuarioArquivoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProntuarioArquivoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioArquivoDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param acessoProntuarioId (optional) 
     * @param clinicaid (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    getHistoricoByPaciente(pacienteId: string | null | undefined, acessoProntuarioId: string | null | undefined, clinicaid: string | null | undefined, profissionalId: string | null | undefined): Observable<HistoricoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetHistoricoByPaciente?";
        if (pacienteId !== undefined && pacienteId !== null)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        if (clinicaid !== undefined && clinicaid !== null)
            url_ += "clinicaid=" + encodeURIComponent("" + clinicaid) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricoByPaciente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricoByPaciente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricoDto[]>;
        }));
    }

    protected processGetHistoricoByPaciente(response: HttpResponseBase): Observable<HistoricoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HistoricoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HistoricoDto[]>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param acessoProntuarioId (optional) 
     * @param clinicaid (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    getHistoricoByPacienteAgrupado(pacienteId: string | null | undefined, acessoProntuarioId: string | null | undefined, clinicaid: string | null | undefined, profissionalId: string | null | undefined): Observable<ProntuarioHistoricoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetHistoricoByPacienteAgrupado?";
        if (pacienteId !== undefined && pacienteId !== null)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        if (clinicaid !== undefined && clinicaid !== null)
            url_ += "clinicaid=" + encodeURIComponent("" + clinicaid) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricoByPacienteAgrupado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricoByPacienteAgrupado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioHistoricoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioHistoricoDto[]>;
        }));
    }

    protected processGetHistoricoByPacienteAgrupado(response: HttpResponseBase): Observable<ProntuarioHistoricoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProntuarioHistoricoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioHistoricoDto[]>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param acessoProntuarioId (optional) 
     * @param clinicaid (optional) 
     * @param profissionalId (optional) 
     * @return Success
     */
    getHistoricoDependenteAgrupado(pacienteId: string | undefined, acessoProntuarioId: string | undefined, clinicaid: string | null | undefined, profissionalId: string | null | undefined): Observable<ProntuarioHistoricoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetHistoricoDependenteAgrupado?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (acessoProntuarioId === null)
            throw new Error("The parameter 'acessoProntuarioId' cannot be null.");
        else if (acessoProntuarioId !== undefined)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        if (clinicaid !== undefined && clinicaid !== null)
            url_ += "clinicaid=" + encodeURIComponent("" + clinicaid) + "&";
        if (profissionalId !== undefined && profissionalId !== null)
            url_ += "profissionalId=" + encodeURIComponent("" + profissionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricoDependenteAgrupado(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricoDependenteAgrupado(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioHistoricoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioHistoricoDto[]>;
        }));
    }

    protected processGetHistoricoDependenteAgrupado(response: HttpResponseBase): Observable<ProntuarioHistoricoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProntuarioHistoricoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioHistoricoDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validarAcessoOtp(body: CreateAcessoProntuarioDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/ValidarAcessoOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidarAcessoOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidarAcessoOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processValidarAcessoOtp(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enviarArquivoEmail(body: EnviarProntuarioDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/EnviarArquivoEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarArquivoEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarArquivoEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnviarArquivoEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enviarArquivoWhatsapp(body: EnviarProntuarioDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/EnviarArquivoWhatsapp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnviarArquivoWhatsapp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnviarArquivoWhatsapp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEnviarArquivoWhatsapp(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFormularioMedico(body: CreateFormularioMedicoDto | undefined): Observable<FormularioMedicoDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/CreateFormularioMedico";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFormularioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFormularioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormularioMedicoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormularioMedicoDto>;
        }));
    }

    protected processCreateFormularioMedico(response: HttpResponseBase): Observable<FormularioMedicoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormularioMedicoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormularioMedicoDto>(null as any);
    }

    /**
     * @param url (optional) 
     * @param acessoProntuarioId (optional) 
     * @return Success
     */
    getTemporaryLinkFormularioMedico(url: string | null | undefined, acessoProntuarioId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetTemporaryLinkFormularioMedico?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemporaryLinkFormularioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemporaryLinkFormularioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTemporaryLinkFormularioMedico(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getFormularioMedico(): Observable<FormularioMedicoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetFormularioMedico";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularioMedico(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularioMedico(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormularioMedicoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormularioMedicoDto[]>;
        }));
    }

    protected processGetFormularioMedico(response: HttpResponseBase): Observable<FormularioMedicoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FormularioMedicoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormularioMedicoDto[]>(null as any);
    }

    /**
     * @param acessoProntuarioId (optional) 
     * @return Success
     */
    getProfissional(acessoProntuarioId: string | null | undefined): Observable<ProntuarioProfissionalDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetProfissional?";
        if (acessoProntuarioId !== undefined && acessoProntuarioId !== null)
            url_ += "acessoProntuarioId=" + encodeURIComponent("" + acessoProntuarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfissional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfissional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProntuarioProfissionalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProntuarioProfissionalDto>;
        }));
    }

    protected processGetProfissional(response: HttpResponseBase): Observable<ProntuarioProfissionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProntuarioProfissionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProntuarioProfissionalDto>(null as any);
    }

    /**
     * @param idPastaPai (optional) 
     * @param body (optional) 
     * @return Success
     */
    moveArquivo(idPastaPai: string | null | undefined, body: ProntuarioArquivoDto[] | null | undefined): Observable<MoveProntuarioDto> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/MoveArquivo?";
        if (idPastaPai !== undefined && idPastaPai !== null)
            url_ += "idPastaPai=" + encodeURIComponent("" + idPastaPai) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveArquivo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveArquivo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveProntuarioDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveProntuarioDto>;
        }));
    }

    protected processMoveArquivo(response: HttpResponseBase): Observable<MoveProntuarioDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveProntuarioDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoveProntuarioDto>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    getAssinatura(cpf: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetAssinatura?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssinatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssinatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAssinatura(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    getNomeAssinatura(cpf: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetNomeAssinatura?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNomeAssinatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomeAssinatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNomeAssinatura(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssinaturaDocumento(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetAssinaturaDocumento?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssinaturaDocumento(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssinaturaDocumento(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAssinaturaDocumento(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param idArquivo (optional) 
     * @return Success
     */
    getArquivoPdfBase64(idArquivo: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/GetArquivoPdfBase64?";
        if (idArquivo === null)
            throw new Error("The parameter 'idArquivo' cannot be null.");
        else if (idArquivo !== undefined)
            url_ += "idArquivo=" + encodeURIComponent("" + idArquivo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArquivoPdfBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArquivoPdfBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetArquivoPdfBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    inicializarBry(body: BryInitializeRequestDto | undefined): Observable<InicializacaoAssinaturaResponse> {
        let url_ = this.baseUrl + "/api/services/app/ProntuarioMedico/InicializarBry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInicializarBry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInicializarBry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InicializacaoAssinaturaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InicializacaoAssinaturaResponse>;
        }));
    }

    protected processInicializarBry(response: HttpResponseBase): Observable<InicializacaoAssinaturaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InicializacaoAssinaturaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InicializacaoAssinaturaResponse>(null as any);
    }
}

@Injectable()
export class QualidadeSonoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createQualidadeSono(body: CreateQualidadeSonoDto | undefined): Observable<QualidadeSonoDto> {
        let url_ = this.baseUrl + "/api/services/app/QualidadeSono/CreateQualidadeSono";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQualidadeSono(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQualidadeSono(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualidadeSonoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualidadeSonoDto>;
        }));
    }

    protected processCreateQualidadeSono(response: HttpResponseBase): Observable<QualidadeSonoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualidadeSonoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualidadeSonoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQualidadeSono(body: UpdateQualidadeSonoDto | undefined): Observable<QualidadeSonoDto> {
        let url_ = this.baseUrl + "/api/services/app/QualidadeSono/UpdateQualidadeSono";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQualidadeSono(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQualidadeSono(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualidadeSonoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualidadeSonoDto>;
        }));
    }

    protected processUpdateQualidadeSono(response: HttpResponseBase): Observable<QualidadeSonoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualidadeSonoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualidadeSonoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoQualidadeSono(body: QualidadeSonoDto | undefined): Observable<QualidadeSonoDto> {
        let url_ = this.baseUrl + "/api/services/app/QualidadeSono/DeletarDadoQualidadeSono";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoQualidadeSono(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoQualidadeSono(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualidadeSonoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualidadeSonoDto>;
        }));
    }

    protected processDeletarDadoQualidadeSono(response: HttpResponseBase): Observable<QualidadeSonoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualidadeSonoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualidadeSonoDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicial (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicial: string | null | undefined, dataFinal: string | null | undefined): Observable<QualidadeSonoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QualidadeSono/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicial !== undefined && dataInicial !== null)
            url_ += "dataInicial=" + encodeURIComponent("" + dataInicial) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualidadeSonoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualidadeSonoDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<QualidadeSonoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(QualidadeSonoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualidadeSonoDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<QualidadeSonoDto> {
        let url_ = this.baseUrl + "/api/services/app/QualidadeSono/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualidadeSonoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualidadeSonoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<QualidadeSonoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualidadeSonoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualidadeSonoDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QualidadeSono/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<QualidadeSonoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/QualidadeSono/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualidadeSonoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualidadeSonoDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<QualidadeSonoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualidadeSonoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualidadeSonoDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class RegistroAcessoProntuarioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param unumName (optional) 
     * @param body (optional) 
     * @return Success
     */
    createRegistroProntuario(unumName: string | null | undefined, body: CreateRegistroAcessoProntuarioDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegistroAcessoProntuario/CreateRegistroProntuario?";
        if (unumName !== undefined && unumName !== null)
            url_ += "unumName=" + encodeURIComponent("" + unumName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRegistroProntuario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRegistroProntuario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateRegistroProntuario(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param unumName (optional) 
     * @param body (optional) 
     * @return Success
     */
    createRegistroEnviarProntuario(unumName: string | null | undefined, body: CreateRegistroAcessoProntuarioDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegistroAcessoProntuario/CreateRegistroEnviarProntuario?";
        if (unumName !== undefined && unumName !== null)
            url_ += "unumName=" + encodeURIComponent("" + unumName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRegistroEnviarProntuario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRegistroEnviarProntuario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateRegistroEnviarProntuario(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param nomePaciente (optional) 
     * @param cpfPaciente (optional) 
     * @param nomeProfissional (optional) 
     * @param cpfProfissional (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(nomePaciente: string | null | undefined, cpfPaciente: string | null | undefined, nomeProfissional: string | null | undefined, cpfProfissional: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFinal: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RegistroAcessoProntuarioDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RegistroAcessoProntuario/GetAll?";
        if (nomePaciente !== undefined && nomePaciente !== null)
            url_ += "NomePaciente=" + encodeURIComponent("" + nomePaciente) + "&";
        if (cpfPaciente !== undefined && cpfPaciente !== null)
            url_ += "CpfPaciente=" + encodeURIComponent("" + cpfPaciente) + "&";
        if (nomeProfissional !== undefined && nomeProfissional !== null)
            url_ += "NomeProfissional=" + encodeURIComponent("" + nomeProfissional) + "&";
        if (cpfProfissional !== undefined && cpfProfissional !== null)
            url_ += "CpfProfissional=" + encodeURIComponent("" + cpfProfissional) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent(dataFinal ? "" + dataFinal.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistroAcessoProntuarioDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistroAcessoProntuarioDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RegistroAcessoProntuarioDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistroAcessoProntuarioDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistroAcessoProntuarioDtoPagedResultDto>(null as any);
    }

    /**
     * @param nomePaciente (optional) 
     * @param cpfPaciente (optional) 
     * @param nomeProfissional (optional) 
     * @param cpfProfissional (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRelatorio(nomePaciente: string | null | undefined, cpfPaciente: string | null | undefined, nomeProfissional: string | null | undefined, cpfProfissional: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFinal: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RegistroAcessoProntuario/GetRelatorio?";
        if (nomePaciente !== undefined && nomePaciente !== null)
            url_ += "NomePaciente=" + encodeURIComponent("" + nomePaciente) + "&";
        if (cpfPaciente !== undefined && cpfPaciente !== null)
            url_ += "CpfPaciente=" + encodeURIComponent("" + cpfPaciente) + "&";
        if (nomeProfissional !== undefined && nomeProfissional !== null)
            url_ += "NomeProfissional=" + encodeURIComponent("" + nomeProfissional) + "&";
        if (cpfProfissional !== undefined && cpfProfissional !== null)
            url_ += "CpfProfissional=" + encodeURIComponent("" + cpfProfissional) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent(dataFinal ? "" + dataFinal.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatorio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatorio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRelatorio(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class RegistroClasseServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<RegistroClasseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RegistroClasseService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistroClasseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistroClasseDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RegistroClasseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RegistroClasseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistroClasseDto[]>(null as any);
    }
}

@Injectable()
export class RegistroRespostaPacienteClinicaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRegistroRespostaPacienteClinicaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegistroRespostaPacienteClinica/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RelatorioServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportRelatorioPlano(body: PagedRelatoriosResultRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Relatorio/ExportRelatorioPlano";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRelatorioPlano(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRelatorioPlano(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportRelatorioPlano(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportRelatorioPacienteProfissional(body: PagedRelatoriosResultRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Relatorio/ExportRelatorioPacienteProfissional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRelatorioPacienteProfissional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRelatorioPacienteProfissional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportRelatorioPacienteProfissional(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param publicoAlvo (optional) 
     * @param id (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param descricao (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRelatorioPlano(publicoAlvo: PublicoAlvoEnum | undefined, id: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, descricao: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RelatorioDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Relatorio/GetRelatorioPlano?";
        if (publicoAlvo === null)
            throw new Error("The parameter 'publicoAlvo' cannot be null.");
        else if (publicoAlvo !== undefined)
            url_ += "PublicoAlvo=" + encodeURIComponent("" + publicoAlvo) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (descricao !== undefined && descricao !== null)
            url_ += "Descricao=" + encodeURIComponent("" + descricao) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatorioPlano(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatorioPlano(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelatorioDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelatorioDtoPagedResultDto>;
        }));
    }

    protected processGetRelatorioPlano(response: HttpResponseBase): Observable<RelatorioDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelatorioDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RelatorioDtoPagedResultDto>(null as any);
    }

    /**
     * @param publicoAlvo (optional) 
     * @param id (optional) 
     * @param dataInicio (optional) 
     * @param dataFim (optional) 
     * @param descricao (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRelatorioPacienteProfissional(publicoAlvo: PublicoAlvoEnum | undefined, id: string | null | undefined, dataInicio: moment.Moment | null | undefined, dataFim: moment.Moment | null | undefined, descricao: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RelatorioDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Relatorio/GetRelatorioPacienteProfissional?";
        if (publicoAlvo === null)
            throw new Error("The parameter 'publicoAlvo' cannot be null.");
        else if (publicoAlvo !== undefined)
            url_ += "PublicoAlvo=" + encodeURIComponent("" + publicoAlvo) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent(dataInicio ? "" + dataInicio.toISOString() : "") + "&";
        if (dataFim !== undefined && dataFim !== null)
            url_ += "DataFim=" + encodeURIComponent(dataFim ? "" + dataFim.toISOString() : "") + "&";
        if (descricao !== undefined && descricao !== null)
            url_ += "Descricao=" + encodeURIComponent("" + descricao) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatorioPacienteProfissional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatorioPacienteProfissional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelatorioDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelatorioDtoPagedResultDto>;
        }));
    }

    protected processGetRelatorioPacienteProfissional(response: HttpResponseBase): Observable<RelatorioDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelatorioDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RelatorioDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenancyName (optional) 
     * @return Success
     */
    getCurrentLoginInformations(tenancyName: string | null | undefined): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations?";
        if (tenancyName !== undefined && tenancyName !== null)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    getMyRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetMyRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetMyRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }
}

@Injectable()
export class TemperaturaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTemperatura(body: CreateTemperaturaDto | undefined): Observable<TemperaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperatura/CreateTemperatura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTemperatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTemperatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemperaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemperaturaDto>;
        }));
    }

    protected processCreateTemperatura(response: HttpResponseBase): Observable<TemperaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemperaturaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTemperatura(body: UpdateTemperaturaDto | undefined): Observable<TemperaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperatura/UpdateTemperatura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTemperatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTemperatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemperaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemperaturaDto>;
        }));
    }

    protected processUpdateTemperatura(response: HttpResponseBase): Observable<TemperaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemperaturaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletarDadoTemperatura(body: TemperaturaDto | undefined): Observable<TemperaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperatura/DeletarDadoTemperatura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletarDadoTemperatura(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletarDadoTemperatura(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemperaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemperaturaDto>;
        }));
    }

    protected processDeletarDadoTemperatura(response: HttpResponseBase): Observable<TemperaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemperaturaDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicial (optional) 
     * @param dataFinal (optional) 
     * @return Success
     */
    getByPacienteId(pacienteId: string | undefined, dataInicial: string | null | undefined, dataFinal: string | null | undefined): Observable<TemperaturaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Temperatura/GetByPacienteId?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicial !== undefined && dataInicial !== null)
            url_ += "dataInicial=" + encodeURIComponent("" + dataInicial) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPacienteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPacienteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemperaturaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemperaturaDto[]>;
        }));
    }

    protected processGetByPacienteId(response: HttpResponseBase): Observable<TemperaturaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TemperaturaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemperaturaDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<TemperaturaDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperatura/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemperaturaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemperaturaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TemperaturaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperaturaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemperaturaDto>(null as any);
    }

    /**
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param pacienteId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(dataInicio: string | null | undefined, dataFinal: string | null | undefined, pacienteId: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TemperaturaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperatura/GetAll?";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "DataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "DataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "PacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemperaturaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemperaturaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TemperaturaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperaturaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemperaturaDtoPagedResultDto>(null as any);
    }

    /**
     * @param pacienteId (optional) 
     * @param dataInicio (optional) 
     * @param dataFinal (optional) 
     * @param limiteMaximo (optional) 
     * @param limiteMinimo (optional) 
     * @return Success
     */
    verificarAlerta(pacienteId: string | undefined, dataInicio: string | null | undefined, dataFinal: string | null | undefined, limiteMaximo: number | null | undefined, limiteMinimo: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Temperatura/VerificarAlerta?";
        if (pacienteId === null)
            throw new Error("The parameter 'pacienteId' cannot be null.");
        else if (pacienteId !== undefined)
            url_ += "pacienteId=" + encodeURIComponent("" + pacienteId) + "&";
        if (dataInicio !== undefined && dataInicio !== null)
            url_ += "dataInicio=" + encodeURIComponent("" + dataInicio) + "&";
        if (dataFinal !== undefined && dataFinal !== null)
            url_ += "dataFinal=" + encodeURIComponent("" + dataFinal) + "&";
        if (limiteMaximo !== undefined && limiteMaximo !== null)
            url_ += "limiteMaximo=" + encodeURIComponent("" + limiteMaximo) + "&";
        if (limiteMinimo !== undefined && limiteMinimo !== null)
            url_ += "limiteMinimo=" + encodeURIComponent("" + limiteMinimo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerificarAlerta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerificarAlerta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerificarAlerta(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }
}

@Injectable()
export class TokenNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateToken(body: CreateTokenNotificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TokenNotification/CreateOrUpdateToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param dependenteId (optional) 
     * @return Success
     */
    deleteDependente(dependenteId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteDependente?";
        if (dependenteId === null)
            throw new Error("The parameter 'dependenteId' cannot be null.");
        else if (dependenteId !== undefined)
            url_ += "dependenteId=" + encodeURIComponent("" + dependenteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDependente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDependente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDependente(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }

    /**
     * @param login (optional) 
     * @param isEmail (optional) 
     * @return Success
     */
    isActive(login: string | null | undefined, isEmail: boolean | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/IsActive?";
        if (login !== undefined && login !== null)
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        if (isEmail === null)
            throw new Error("The parameter 'isEmail' cannot be null.");
        else if (isEmail !== undefined)
            url_ += "isEmail=" + encodeURIComponent("" + isEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processIsActive(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }
}

@Injectable()
export class WebHookServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    handleUpdateMercadoPago(body: MercadoPagoWebhookPayloadDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebHookService/HandleUpdateMercadoPago";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleUpdateMercadoPago(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleUpdateMercadoPago(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleUpdateMercadoPago(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    handleUpdateShiftPay(body: ShiftPayWebhookPayloadDto | undefined): Observable<ShiftPayWebhookResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/WebHookService/HandleUpdateShiftPay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleUpdateShiftPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleUpdateShiftPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftPayWebhookResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftPayWebhookResponseDto>;
        }));
    }

    protected processHandleUpdateShiftPay(response: HttpResponseBase): Observable<ShiftPayWebhookResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftPayWebhookResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShiftPayWebhookResponseDto>(null as any);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenancyName: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenancyName: string | undefined;
}

export class ForgotPasswordInput implements IForgotPasswordInput {
    emailAddress: string | undefined;
    cpfCnpj: string | undefined;
    tenancyName: string | undefined;
    expirationDate: moment.Moment;

    constructor(data?: IForgotPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.cpfCnpj = _data["cpfCnpj"];
            this.tenancyName = _data["tenancyName"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ForgotPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["cpfCnpj"] = this.cpfCnpj;
        data["tenancyName"] = this.tenancyName;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ForgotPasswordInput {
        const json = this.toJSON();
        let result = new ForgotPasswordInput();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordInput {
    emailAddress: string | undefined;
    cpfCnpj: string | undefined;
    tenancyName: string | undefined;
    expirationDate: moment.Moment;
}

export class ForgotPasswordOutput implements IForgotPasswordOutput {
    success: boolean;
    isPaciente: boolean;

    constructor(data?: IForgotPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.isPaciente = _data["isPaciente"];
        }
    }

    static fromJS(data: any): ForgotPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["isPaciente"] = this.isPaciente;
        return data;
    }

    clone(): ForgotPasswordOutput {
        const json = this.toJSON();
        let result = new ForgotPasswordOutput();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordOutput {
    success: boolean;
    isPaciente: boolean;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId: number;
    newPassword: string;
    resetCode: string;
    dataHora: moment.Moment | undefined;
    cpf: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
            this.resetCode = _data["resetCode"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.cpf = _data["cpf"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        data["resetCode"] = this.resetCode;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["cpf"] = this.cpf;
        return data;
    }

    clone(): ResetPasswordInput {
        const json = this.toJSON();
        let result = new ResetPasswordInput();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordInput {
    userId: number;
    newPassword: string;
    resetCode: string;
    dataHora: moment.Moment | undefined;
    cpf: string | undefined;
}

export class CheckResetCodeExpireDateInput implements ICheckResetCodeExpireDateInput {
    userId: number;
    resetCode: string;
    dataHora: moment.Moment | undefined;
    cpf: string | undefined;

    constructor(data?: ICheckResetCodeExpireDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.cpf = _data["cpf"];
        }
    }

    static fromJS(data: any): CheckResetCodeExpireDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResetCodeExpireDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["cpf"] = this.cpf;
        return data;
    }

    clone(): CheckResetCodeExpireDateInput {
        const json = this.toJSON();
        let result = new CheckResetCodeExpireDateInput();
        result.init(json);
        return result;
    }
}

export interface ICheckResetCodeExpireDateInput {
    userId: number;
    resetCode: string;
    dataHora: moment.Moment | undefined;
    cpf: string | undefined;
}

export class CheckResetCodeExpireDateOutput implements ICheckResetCodeExpireDateOutput {
    isExpired: boolean;
    emailAddress: string | undefined;
    cpf: string | undefined;

    constructor(data?: ICheckResetCodeExpireDateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isExpired = _data["isExpired"];
            this.emailAddress = _data["emailAddress"];
            this.cpf = _data["cpf"];
        }
    }

    static fromJS(data: any): CheckResetCodeExpireDateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResetCodeExpireDateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExpired"] = this.isExpired;
        data["emailAddress"] = this.emailAddress;
        data["cpf"] = this.cpf;
        return data;
    }

    clone(): CheckResetCodeExpireDateOutput {
        const json = this.toJSON();
        let result = new CheckResetCodeExpireDateOutput();
        result.init(json);
        return result;
    }
}

export interface ICheckResetCodeExpireDateOutput {
    isExpired: boolean;
    emailAddress: string | undefined;
    cpf: string | undefined;
}

export class GraficoResponseDto implements IGraficoResponseDto {
    data: moment.Moment;
    valor: number;

    constructor(data?: IGraficoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? moment(_data["data"].toString()) : <any>undefined;
            this.valor = _data["valor"];
        }
    }

    static fromJS(data: any): GraficoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GraficoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toISOString() : <any>undefined;
        data["valor"] = this.valor;
        return data;
    }

    clone(): GraficoResponseDto {
        const json = this.toJSON();
        let result = new GraficoResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGraficoResponseDto {
    data: moment.Moment;
    valor: number;
}

export class InformacoesHomeAdminDto implements IInformacoesHomeAdminDto {
    totalPacientes: number;
    totalClincias: number;
    totalProfissionais: number;

    constructor(data?: IInformacoesHomeAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPacientes = _data["totalPacientes"];
            this.totalClincias = _data["totalClincias"];
            this.totalProfissionais = _data["totalProfissionais"];
        }
    }

    static fromJS(data: any): InformacoesHomeAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformacoesHomeAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPacientes"] = this.totalPacientes;
        data["totalClincias"] = this.totalClincias;
        data["totalProfissionais"] = this.totalProfissionais;
        return data;
    }

    clone(): InformacoesHomeAdminDto {
        const json = this.toJSON();
        let result = new InformacoesHomeAdminDto();
        result.init(json);
        return result;
    }
}

export interface IInformacoesHomeAdminDto {
    totalPacientes: number;
    totalClincias: number;
    totalProfissionais: number;
}

export enum TipoSala {
    _0 = 0,
    _1 = 1,
}

export class EssentialProfisisonalSaudeDto implements IEssentialProfisisonalSaudeDto {
    id: string;
    cpf: string | undefined;
    nome: string | undefined;
    urlFotoPerfil: string | undefined;

    constructor(data?: IEssentialProfisisonalSaudeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cpf = _data["cpf"];
            this.nome = _data["nome"];
            this.urlFotoPerfil = _data["urlFotoPerfil"];
        }
    }

    static fromJS(data: any): EssentialProfisisonalSaudeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EssentialProfisisonalSaudeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cpf"] = this.cpf;
        data["nome"] = this.nome;
        data["urlFotoPerfil"] = this.urlFotoPerfil;
        return data;
    }

    clone(): EssentialProfisisonalSaudeDto {
        const json = this.toJSON();
        let result = new EssentialProfisisonalSaudeDto();
        result.init(json);
        return result;
    }
}

export interface IEssentialProfisisonalSaudeDto {
    id: string;
    cpf: string | undefined;
    nome: string | undefined;
    urlFotoPerfil: string | undefined;
}

export class AgendaProfissionalDto implements IAgendaProfissionalDto {
    profissionalSaudeId: string;
    profissionalSaude: EssentialProfisisonalSaudeDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAgendaProfissionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.profissionalSaude = _data["profissionalSaude"] ? EssentialProfisisonalSaudeDto.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AgendaProfissionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgendaProfissionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): AgendaProfissionalDto {
        const json = this.toJSON();
        let result = new AgendaProfissionalDto();
        result.init(json);
        return result;
    }
}

export interface IAgendaProfissionalDto {
    profissionalSaudeId: string;
    profissionalSaude: EssentialProfisisonalSaudeDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class HorarioDisponivelDto implements IHorarioDisponivelDto {
    diaDaSemana: DayOfWeek;
    inicio: string | undefined;
    fim: string | undefined;
    id: string;

    constructor(data?: IHorarioDisponivelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaDaSemana = _data["diaDaSemana"];
            this.inicio = _data["inicio"];
            this.fim = _data["fim"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HorarioDisponivelDto {
        data = typeof data === 'object' ? data : {};
        let result = new HorarioDisponivelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaDaSemana"] = this.diaDaSemana;
        data["inicio"] = this.inicio;
        data["fim"] = this.fim;
        data["id"] = this.id;
        return data;
    }

    clone(): HorarioDisponivelDto {
        const json = this.toJSON();
        let result = new HorarioDisponivelDto();
        result.init(json);
        return result;
    }
}

export interface IHorarioDisponivelDto {
    diaDaSemana: DayOfWeek;
    inicio: string | undefined;
    fim: string | undefined;
    id: string;
}

export class AgendaDto implements IAgendaDto {
    nomeSala: string | undefined;
    horarioInicio: string | undefined;
    horarioFim: string | undefined;
    duracaoConsulta: number;
    tipoSala: TipoSala;
    suspenso: boolean;
    profissionais: AgendaProfissionalDto[] | undefined;
    horariosDisponiveis: HorarioDisponivelDto[] | undefined;
    id: string;

    constructor(data?: IAgendaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomeSala = _data["nomeSala"];
            this.horarioInicio = _data["horarioInicio"];
            this.horarioFim = _data["horarioFim"];
            this.duracaoConsulta = _data["duracaoConsulta"];
            this.tipoSala = _data["tipoSala"];
            this.suspenso = _data["suspenso"];
            if (Array.isArray(_data["profissionais"])) {
                this.profissionais = [] as any;
                for (let item of _data["profissionais"])
                    this.profissionais.push(AgendaProfissionalDto.fromJS(item));
            }
            if (Array.isArray(_data["horariosDisponiveis"])) {
                this.horariosDisponiveis = [] as any;
                for (let item of _data["horariosDisponiveis"])
                    this.horariosDisponiveis.push(HorarioDisponivelDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AgendaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgendaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeSala"] = this.nomeSala;
        data["horarioInicio"] = this.horarioInicio;
        data["horarioFim"] = this.horarioFim;
        data["duracaoConsulta"] = this.duracaoConsulta;
        data["tipoSala"] = this.tipoSala;
        data["suspenso"] = this.suspenso;
        if (Array.isArray(this.profissionais)) {
            data["profissionais"] = [];
            for (let item of this.profissionais)
                data["profissionais"].push(item.toJSON());
        }
        if (Array.isArray(this.horariosDisponiveis)) {
            data["horariosDisponiveis"] = [];
            for (let item of this.horariosDisponiveis)
                data["horariosDisponiveis"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): AgendaDto {
        const json = this.toJSON();
        let result = new AgendaDto();
        result.init(json);
        return result;
    }
}

export interface IAgendaDto {
    nomeSala: string | undefined;
    horarioInicio: string | undefined;
    horarioFim: string | undefined;
    duracaoConsulta: number;
    tipoSala: TipoSala;
    suspenso: boolean;
    profissionais: AgendaProfissionalDto[] | undefined;
    horariosDisponiveis: HorarioDisponivelDto[] | undefined;
    id: string;
}

export class AgendaDtoPagedResultDto implements IAgendaDtoPagedResultDto {
    totalCount: number;
    items: AgendaDto[] | undefined;

    constructor(data?: IAgendaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AgendaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgendaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgendaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): AgendaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgendaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgendaDtoPagedResultDto {
    totalCount: number;
    items: AgendaDto[] | undefined;
}

export class CreateAgendaDto implements ICreateAgendaDto {
    clinicaId: string | undefined;
    nomeSala: string;
    horarioInicio: string;
    horarioFim: string;
    duracaoConsulta: number;
    tipoSala: TipoSala;
    profissionaisIds: string[] | undefined;
    diasDaSemana: DayOfWeek[] | undefined;

    constructor(data?: ICreateAgendaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaId = _data["clinicaId"];
            this.nomeSala = _data["nomeSala"];
            this.horarioInicio = _data["horarioInicio"];
            this.horarioFim = _data["horarioFim"];
            this.duracaoConsulta = _data["duracaoConsulta"];
            this.tipoSala = _data["tipoSala"];
            if (Array.isArray(_data["profissionaisIds"])) {
                this.profissionaisIds = [] as any;
                for (let item of _data["profissionaisIds"])
                    this.profissionaisIds.push(item);
            }
            if (Array.isArray(_data["diasDaSemana"])) {
                this.diasDaSemana = [] as any;
                for (let item of _data["diasDaSemana"])
                    this.diasDaSemana.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAgendaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgendaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaId"] = this.clinicaId;
        data["nomeSala"] = this.nomeSala;
        data["horarioInicio"] = this.horarioInicio;
        data["horarioFim"] = this.horarioFim;
        data["duracaoConsulta"] = this.duracaoConsulta;
        data["tipoSala"] = this.tipoSala;
        if (Array.isArray(this.profissionaisIds)) {
            data["profissionaisIds"] = [];
            for (let item of this.profissionaisIds)
                data["profissionaisIds"].push(item);
        }
        if (Array.isArray(this.diasDaSemana)) {
            data["diasDaSemana"] = [];
            for (let item of this.diasDaSemana)
                data["diasDaSemana"].push(item);
        }
        return data;
    }

    clone(): CreateAgendaDto {
        const json = this.toJSON();
        let result = new CreateAgendaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAgendaDto {
    clinicaId: string | undefined;
    nomeSala: string;
    horarioInicio: string;
    horarioFim: string;
    duracaoConsulta: number;
    tipoSala: TipoSala;
    profissionaisIds: string[] | undefined;
    diasDaSemana: DayOfWeek[] | undefined;
}

export class UpdateAgendaDto implements IUpdateAgendaDto {
    nomeSala: string;
    horarioInicio: string;
    horarioFim: string;
    duracaoConsulta: number;
    tipoSala: TipoSala;
    profissionaisIds: string[] | undefined;
    id: string;

    constructor(data?: IUpdateAgendaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomeSala = _data["nomeSala"];
            this.horarioInicio = _data["horarioInicio"];
            this.horarioFim = _data["horarioFim"];
            this.duracaoConsulta = _data["duracaoConsulta"];
            this.tipoSala = _data["tipoSala"];
            if (Array.isArray(_data["profissionaisIds"])) {
                this.profissionaisIds = [] as any;
                for (let item of _data["profissionaisIds"])
                    this.profissionaisIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAgendaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgendaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeSala"] = this.nomeSala;
        data["horarioInicio"] = this.horarioInicio;
        data["horarioFim"] = this.horarioFim;
        data["duracaoConsulta"] = this.duracaoConsulta;
        data["tipoSala"] = this.tipoSala;
        if (Array.isArray(this.profissionaisIds)) {
            data["profissionaisIds"] = [];
            for (let item of this.profissionaisIds)
                data["profissionaisIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateAgendaDto {
        const json = this.toJSON();
        let result = new UpdateAgendaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAgendaDto {
    nomeSala: string;
    horarioInicio: string;
    horarioFim: string;
    duracaoConsulta: number;
    tipoSala: TipoSala;
    profissionaisIds: string[] | undefined;
    id: string;
}

export class GuidEntityDto implements IGuidEntityDto {
    id: string;

    constructor(data?: IGuidEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GuidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): GuidEntityDto {
        const json = this.toJSON();
        let result = new GuidEntityDto();
        result.init(json);
        return result;
    }
}

export interface IGuidEntityDto {
    id: string;
}

export class Int32NameValueDto implements IInt32NameValueDto {
    name: string | undefined;
    value: number;

    constructor(data?: IInt32NameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Int32NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Int32NameValueDto {
        const json = this.toJSON();
        let result = new Int32NameValueDto();
        result.init(json);
        return result;
    }
}

export interface IInt32NameValueDto {
    name: string | undefined;
    value: number;
}

export class CreateHorarioDisponivelDto implements ICreateHorarioDisponivelDto {
    agendaId: string;
    diaDaSemana: DayOfWeek;
    inicio: string;
    fim: string;

    constructor(data?: ICreateHorarioDisponivelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agendaId = _data["agendaId"];
            this.diaDaSemana = _data["diaDaSemana"];
            this.inicio = _data["inicio"];
            this.fim = _data["fim"];
        }
    }

    static fromJS(data: any): CreateHorarioDisponivelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHorarioDisponivelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agendaId"] = this.agendaId;
        data["diaDaSemana"] = this.diaDaSemana;
        data["inicio"] = this.inicio;
        data["fim"] = this.fim;
        return data;
    }

    clone(): CreateHorarioDisponivelDto {
        const json = this.toJSON();
        let result = new CreateHorarioDisponivelDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHorarioDisponivelDto {
    agendaId: string;
    diaDaSemana: DayOfWeek;
    inicio: string;
    fim: string;
}

export enum TipoAlergiaEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class CreateAlergiaDto implements ICreateAlergiaDto {
    substancia: string;
    observacao: string | undefined;
    tipoAlergia: TipoAlergiaEnum;

    constructor(data?: ICreateAlergiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.substancia = _data["substancia"];
            this.observacao = _data["observacao"];
            this.tipoAlergia = _data["tipoAlergia"];
        }
    }

    static fromJS(data: any): CreateAlergiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlergiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["substancia"] = this.substancia;
        data["observacao"] = this.observacao;
        data["tipoAlergia"] = this.tipoAlergia;
        return data;
    }

    clone(): CreateAlergiaDto {
        const json = this.toJSON();
        let result = new CreateAlergiaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAlergiaDto {
    substancia: string;
    observacao: string | undefined;
    tipoAlergia: TipoAlergiaEnum;
}

export class AlergiaDto implements IAlergiaDto {
    substancia: string | undefined;
    observacao: string | undefined;
    tipoAlergia: TipoAlergiaEnum;
    creatorUserId: number | undefined;
    readonly tipoAlergiaString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: IAlergiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.substancia = _data["substancia"];
            this.observacao = _data["observacao"];
            this.tipoAlergia = _data["tipoAlergia"];
            this.creatorUserId = _data["creatorUserId"];
            (<any>this).tipoAlergiaString = _data["tipoAlergiaString"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlergiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlergiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["substancia"] = this.substancia;
        data["observacao"] = this.observacao;
        data["tipoAlergia"] = this.tipoAlergia;
        data["creatorUserId"] = this.creatorUserId;
        data["tipoAlergiaString"] = this.tipoAlergiaString;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): AlergiaDto {
        const json = this.toJSON();
        let result = new AlergiaDto();
        result.init(json);
        return result;
    }
}

export interface IAlergiaDto {
    substancia: string | undefined;
    observacao: string | undefined;
    tipoAlergia: TipoAlergiaEnum;
    creatorUserId: number | undefined;
    tipoAlergiaString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    id: string;
}

export class UpdateAlergiaDto implements IUpdateAlergiaDto {
    substancia: string;
    observacao: string | undefined;
    tipoAlergia: TipoAlergiaEnum;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdateAlergiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.substancia = _data["substancia"];
            this.observacao = _data["observacao"];
            this.tipoAlergia = _data["tipoAlergia"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAlergiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlergiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["substancia"] = this.substancia;
        data["observacao"] = this.observacao;
        data["tipoAlergia"] = this.tipoAlergia;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateAlergiaDto {
        const json = this.toJSON();
        let result = new UpdateAlergiaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAlergiaDto {
    substancia: string;
    observacao: string | undefined;
    tipoAlergia: TipoAlergiaEnum;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class AlergiaDtoPagedResultDto implements IAlergiaDtoPagedResultDto {
    totalCount: number;
    items: AlergiaDto[] | undefined;

    constructor(data?: IAlergiaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AlergiaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlergiaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlergiaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): AlergiaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AlergiaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAlergiaDtoPagedResultDto {
    totalCount: number;
    items: AlergiaDto[] | undefined;
}

export class SelectItemDto implements ISelectItemDto {
    id: string;
    descricao: string | undefined;

    constructor(data?: ISelectItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descricao = _data["descricao"];
        }
    }

    static fromJS(data: any): SelectItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descricao"] = this.descricao;
        return data;
    }

    clone(): SelectItemDto {
        const json = this.toJSON();
        let result = new SelectItemDto();
        result.init(json);
        return result;
    }
}

export interface ISelectItemDto {
    id: string;
    descricao: string | undefined;
}

export enum TipoOrigemEnum {
    _0 = 0,
    _1 = 1,
}

export enum TipoOperacaoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CreateAlteracaoDto implements ICreateAlteracaoDto {
    arquivoId: string | undefined;
    parentId: string | undefined;
    pacienteId: string;
    origem: TipoOrigemEnum;
    isFolder: boolean;
    oldName: string | undefined;
    newName: string | undefined;
    operacao: TipoOperacaoEnum;
    dataModificacao: moment.Moment;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    id: string;

    constructor(data?: ICreateAlteracaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoId = _data["arquivoId"];
            this.parentId = _data["parentId"];
            this.pacienteId = _data["pacienteId"];
            this.origem = _data["origem"];
            this.isFolder = _data["isFolder"];
            this.oldName = _data["oldName"];
            this.newName = _data["newName"];
            this.operacao = _data["operacao"];
            this.dataModificacao = _data["dataModificacao"] ? moment(_data["dataModificacao"].toString()) : <any>undefined;
            this.ordemProfissionalSaude = _data["ordemProfissionalSaude"];
            this.ordemPaciente = _data["ordemPaciente"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateAlteracaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlteracaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoId"] = this.arquivoId;
        data["parentId"] = this.parentId;
        data["pacienteId"] = this.pacienteId;
        data["origem"] = this.origem;
        data["isFolder"] = this.isFolder;
        data["oldName"] = this.oldName;
        data["newName"] = this.newName;
        data["operacao"] = this.operacao;
        data["dataModificacao"] = this.dataModificacao ? this.dataModificacao.toISOString() : <any>undefined;
        data["ordemProfissionalSaude"] = this.ordemProfissionalSaude;
        data["ordemPaciente"] = this.ordemPaciente;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateAlteracaoDto {
        const json = this.toJSON();
        let result = new CreateAlteracaoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAlteracaoDto {
    arquivoId: string | undefined;
    parentId: string | undefined;
    pacienteId: string;
    origem: TipoOrigemEnum;
    isFolder: boolean;
    oldName: string | undefined;
    newName: string | undefined;
    operacao: TipoOperacaoEnum;
    dataModificacao: moment.Moment;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    id: string;
}

export class AlteracaoDto implements IAlteracaoDto {
    arquivoId: string | undefined;
    parentId: string | undefined;
    pacienteId: string;
    origem: string | undefined;
    isFolder: boolean;
    oldName: string | undefined;
    newName: string | undefined;
    operacao: string | undefined;
    dataModificacao: moment.Moment;
    dataSincronizacao: moment.Moment | undefined;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    id: string;

    constructor(data?: IAlteracaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoId = _data["arquivoId"];
            this.parentId = _data["parentId"];
            this.pacienteId = _data["pacienteId"];
            this.origem = _data["origem"];
            this.isFolder = _data["isFolder"];
            this.oldName = _data["oldName"];
            this.newName = _data["newName"];
            this.operacao = _data["operacao"];
            this.dataModificacao = _data["dataModificacao"] ? moment(_data["dataModificacao"].toString()) : <any>undefined;
            this.dataSincronizacao = _data["dataSincronizacao"] ? moment(_data["dataSincronizacao"].toString()) : <any>undefined;
            this.ordemProfissionalSaude = _data["ordemProfissionalSaude"];
            this.ordemPaciente = _data["ordemPaciente"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlteracaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlteracaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoId"] = this.arquivoId;
        data["parentId"] = this.parentId;
        data["pacienteId"] = this.pacienteId;
        data["origem"] = this.origem;
        data["isFolder"] = this.isFolder;
        data["oldName"] = this.oldName;
        data["newName"] = this.newName;
        data["operacao"] = this.operacao;
        data["dataModificacao"] = this.dataModificacao ? this.dataModificacao.toISOString() : <any>undefined;
        data["dataSincronizacao"] = this.dataSincronizacao ? this.dataSincronizacao.toISOString() : <any>undefined;
        data["ordemProfissionalSaude"] = this.ordemProfissionalSaude;
        data["ordemPaciente"] = this.ordemPaciente;
        data["id"] = this.id;
        return data;
    }

    clone(): AlteracaoDto {
        const json = this.toJSON();
        let result = new AlteracaoDto();
        result.init(json);
        return result;
    }
}

export interface IAlteracaoDto {
    arquivoId: string | undefined;
    parentId: string | undefined;
    pacienteId: string;
    origem: string | undefined;
    isFolder: boolean;
    oldName: string | undefined;
    newName: string | undefined;
    operacao: string | undefined;
    dataModificacao: moment.Moment;
    dataSincronizacao: moment.Moment | undefined;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    id: string;
}

export class CreateAlturaDto implements ICreateAlturaDto {
    valorAltura: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateAlturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorAltura = _data["valorAltura"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateAlturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorAltura"] = this.valorAltura;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateAlturaDto {
        const json = this.toJSON();
        let result = new CreateAlturaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAlturaDto {
    valorAltura: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class AlturaDto implements IAlturaDto {
    valorAltura: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IAlturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorAltura = _data["valorAltura"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorAltura"] = this.valorAltura;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): AlturaDto {
        const json = this.toJSON();
        let result = new AlturaDto();
        result.init(json);
        return result;
    }
}

export interface IAlturaDto {
    valorAltura: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class UpdateAlturaDto implements IUpdateAlturaDto {
    valorAltura: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateAlturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorAltura = _data["valorAltura"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAlturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorAltura"] = this.valorAltura;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateAlturaDto {
        const json = this.toJSON();
        let result = new UpdateAlturaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAlturaDto {
    valorAltura: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class AlturaDtoPagedResultDto implements IAlturaDtoPagedResultDto {
    totalCount: number;
    items: AlturaDto[] | undefined;

    constructor(data?: IAlturaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AlturaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlturaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlturaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): AlturaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AlturaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAlturaDtoPagedResultDto {
    totalCount: number;
    items: AlturaDto[] | undefined;
}

export enum StatusProntuarioEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ArquivoDto implements IArquivoDto {
    nome: string | undefined;
    nomeAntigo: string | undefined;
    extensaoArquivo: string | undefined;
    ehPasta: boolean;
    tamanho: number;
    arquivoPaiId: string | undefined;
    pacienteId: string;
    clinicaId: string | undefined;
    urlArquivo: string | undefined;
    ultimaAlteracao: moment.Moment;
    tipoArquivo: string | undefined;
    acessoProntuarioId: string | undefined;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    creationTime: moment.Moment;
    codigo: string | undefined;
    observacao: string | undefined;
    localizacao: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    darBaixa: boolean | undefined;
    quantidadeArquivos: number;
    template: string | undefined;
    vip: boolean;
    isDefault: boolean;
    base64Arquivo: string | undefined;
    statusProntuario: StatusProntuarioEnum;
    readonly statusProntuarioString: string | undefined;
    clinicaMedicaPacienteVipId: string | undefined;
    id: string;

    constructor(data?: IArquivoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.nomeAntigo = _data["nomeAntigo"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.ehPasta = _data["ehPasta"];
            this.tamanho = _data["tamanho"];
            this.arquivoPaiId = _data["arquivoPaiId"];
            this.pacienteId = _data["pacienteId"];
            this.clinicaId = _data["clinicaId"];
            this.urlArquivo = _data["urlArquivo"];
            this.ultimaAlteracao = _data["ultimaAlteracao"] ? moment(_data["ultimaAlteracao"].toString()) : <any>undefined;
            this.tipoArquivo = _data["tipoArquivo"];
            this.acessoProntuarioId = _data["acessoProntuarioId"];
            this.ordemProfissionalSaude = _data["ordemProfissionalSaude"];
            this.ordemPaciente = _data["ordemPaciente"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.codigo = _data["codigo"];
            this.observacao = _data["observacao"];
            this.localizacao = _data["localizacao"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.darBaixa = _data["darBaixa"];
            this.quantidadeArquivos = _data["quantidadeArquivos"];
            this.template = _data["template"];
            this.vip = _data["vip"];
            this.isDefault = _data["isDefault"];
            this.base64Arquivo = _data["base64Arquivo"];
            this.statusProntuario = _data["statusProntuario"];
            (<any>this).statusProntuarioString = _data["statusProntuarioString"];
            this.clinicaMedicaPacienteVipId = _data["clinicaMedicaPacienteVipId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ArquivoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArquivoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["nomeAntigo"] = this.nomeAntigo;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["ehPasta"] = this.ehPasta;
        data["tamanho"] = this.tamanho;
        data["arquivoPaiId"] = this.arquivoPaiId;
        data["pacienteId"] = this.pacienteId;
        data["clinicaId"] = this.clinicaId;
        data["urlArquivo"] = this.urlArquivo;
        data["ultimaAlteracao"] = this.ultimaAlteracao ? this.ultimaAlteracao.toISOString() : <any>undefined;
        data["tipoArquivo"] = this.tipoArquivo;
        data["acessoProntuarioId"] = this.acessoProntuarioId;
        data["ordemProfissionalSaude"] = this.ordemProfissionalSaude;
        data["ordemPaciente"] = this.ordemPaciente;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["codigo"] = this.codigo;
        data["observacao"] = this.observacao;
        data["localizacao"] = this.localizacao;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["darBaixa"] = this.darBaixa;
        data["quantidadeArquivos"] = this.quantidadeArquivos;
        data["template"] = this.template;
        data["vip"] = this.vip;
        data["isDefault"] = this.isDefault;
        data["base64Arquivo"] = this.base64Arquivo;
        data["statusProntuario"] = this.statusProntuario;
        data["statusProntuarioString"] = this.statusProntuarioString;
        data["clinicaMedicaPacienteVipId"] = this.clinicaMedicaPacienteVipId;
        data["id"] = this.id;
        return data;
    }

    clone(): ArquivoDto {
        const json = this.toJSON();
        let result = new ArquivoDto();
        result.init(json);
        return result;
    }
}

export interface IArquivoDto {
    nome: string | undefined;
    nomeAntigo: string | undefined;
    extensaoArquivo: string | undefined;
    ehPasta: boolean;
    tamanho: number;
    arquivoPaiId: string | undefined;
    pacienteId: string;
    clinicaId: string | undefined;
    urlArquivo: string | undefined;
    ultimaAlteracao: moment.Moment;
    tipoArquivo: string | undefined;
    acessoProntuarioId: string | undefined;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    creationTime: moment.Moment;
    codigo: string | undefined;
    observacao: string | undefined;
    localizacao: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    darBaixa: boolean | undefined;
    quantidadeArquivos: number;
    template: string | undefined;
    vip: boolean;
    isDefault: boolean;
    base64Arquivo: string | undefined;
    statusProntuario: StatusProntuarioEnum;
    statusProntuarioString: string | undefined;
    clinicaMedicaPacienteVipId: string | undefined;
    id: string;
}

export class CreateArquivoDto implements ICreateArquivoDto {
    id: string | undefined;
    arquivoPaiId: string | undefined;
    ehPasta: boolean;
    pacienteId: string;
    clinicaId: string | undefined;
    extensaoArquivo: string | undefined;
    nome: string | undefined;
    tamanho: number;
    base64Arquivo: string | undefined;
    tipoArquivo: string | undefined;
    template: string | undefined;
    acessoProntuarioId: string | undefined;
    codigo: string | undefined;
    codigoValidacaoIti: string | undefined;
    observacao: string | undefined;
    localizacao: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    darBaixa: boolean | undefined;
    vip: boolean;
    isDefault: boolean;
    statusProntuario: StatusProntuarioEnum;
    origem: TipoOrigemEnum;
    clinicaMedicaPacienteVipId: string | undefined;

    constructor(data?: ICreateArquivoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.arquivoPaiId = _data["arquivoPaiId"];
            this.ehPasta = _data["ehPasta"];
            this.pacienteId = _data["pacienteId"];
            this.clinicaId = _data["clinicaId"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.nome = _data["nome"];
            this.tamanho = _data["tamanho"];
            this.base64Arquivo = _data["base64Arquivo"];
            this.tipoArquivo = _data["tipoArquivo"];
            this.template = _data["template"];
            this.acessoProntuarioId = _data["acessoProntuarioId"];
            this.codigo = _data["codigo"];
            this.codigoValidacaoIti = _data["codigoValidacaoIti"];
            this.observacao = _data["observacao"];
            this.localizacao = _data["localizacao"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.darBaixa = _data["darBaixa"];
            this.vip = _data["vip"];
            this.isDefault = _data["isDefault"];
            this.statusProntuario = _data["statusProntuario"];
            this.origem = _data["origem"];
            this.clinicaMedicaPacienteVipId = _data["clinicaMedicaPacienteVipId"];
        }
    }

    static fromJS(data: any): CreateArquivoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArquivoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["arquivoPaiId"] = this.arquivoPaiId;
        data["ehPasta"] = this.ehPasta;
        data["pacienteId"] = this.pacienteId;
        data["clinicaId"] = this.clinicaId;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["nome"] = this.nome;
        data["tamanho"] = this.tamanho;
        data["base64Arquivo"] = this.base64Arquivo;
        data["tipoArquivo"] = this.tipoArquivo;
        data["template"] = this.template;
        data["acessoProntuarioId"] = this.acessoProntuarioId;
        data["codigo"] = this.codigo;
        data["codigoValidacaoIti"] = this.codigoValidacaoIti;
        data["observacao"] = this.observacao;
        data["localizacao"] = this.localizacao;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["darBaixa"] = this.darBaixa;
        data["vip"] = this.vip;
        data["isDefault"] = this.isDefault;
        data["statusProntuario"] = this.statusProntuario;
        data["origem"] = this.origem;
        data["clinicaMedicaPacienteVipId"] = this.clinicaMedicaPacienteVipId;
        return data;
    }

    clone(): CreateArquivoDto {
        const json = this.toJSON();
        let result = new CreateArquivoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateArquivoDto {
    id: string | undefined;
    arquivoPaiId: string | undefined;
    ehPasta: boolean;
    pacienteId: string;
    clinicaId: string | undefined;
    extensaoArquivo: string | undefined;
    nome: string | undefined;
    tamanho: number;
    base64Arquivo: string | undefined;
    tipoArquivo: string | undefined;
    template: string | undefined;
    acessoProntuarioId: string | undefined;
    codigo: string | undefined;
    codigoValidacaoIti: string | undefined;
    observacao: string | undefined;
    localizacao: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    darBaixa: boolean | undefined;
    vip: boolean;
    isDefault: boolean;
    statusProntuario: StatusProntuarioEnum;
    origem: TipoOrigemEnum;
    clinicaMedicaPacienteVipId: string | undefined;
}

export class RenameArquivoDto implements IRenameArquivoDto {
    nome: string;
    origem: TipoOrigemEnum;
    id: string;

    constructor(data?: IRenameArquivoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.origem = _data["origem"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RenameArquivoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RenameArquivoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["origem"] = this.origem;
        data["id"] = this.id;
        return data;
    }

    clone(): RenameArquivoDto {
        const json = this.toJSON();
        let result = new RenameArquivoDto();
        result.init(json);
        return result;
    }
}

export interface IRenameArquivoDto {
    nome: string;
    origem: TipoOrigemEnum;
    id: string;
}

export enum TipoPagamentoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class CartaoCreditoDto implements ICartaoCreditoDto {
    cardToken: string | undefined;
    emissor: string | undefined;
    cpf: string | undefined;
    nome: string | undefined;

    constructor(data?: ICartaoCreditoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardToken = _data["cardToken"];
            this.emissor = _data["emissor"];
            this.cpf = _data["cpf"];
            this.nome = _data["nome"];
        }
    }

    static fromJS(data: any): CartaoCreditoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartaoCreditoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardToken"] = this.cardToken;
        data["emissor"] = this.emissor;
        data["cpf"] = this.cpf;
        data["nome"] = this.nome;
        return data;
    }

    clone(): CartaoCreditoDto {
        const json = this.toJSON();
        let result = new CartaoCreditoDto();
        result.init(json);
        return result;
    }
}

export interface ICartaoCreditoDto {
    cardToken: string | undefined;
    emissor: string | undefined;
    cpf: string | undefined;
    nome: string | undefined;
}

export class EnderecoAssinaturaDto implements IEnderecoAssinaturaDto {
    city: string | undefined;
    federalUnit: string | undefined;
    neighborhood: string | undefined;
    streetName: string | undefined;
    streetNumber: string | undefined;
    zipCode: string | undefined;

    constructor(data?: IEnderecoAssinaturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.federalUnit = _data["federalUnit"];
            this.neighborhood = _data["neighborhood"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): EnderecoAssinaturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnderecoAssinaturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["federalUnit"] = this.federalUnit;
        data["neighborhood"] = this.neighborhood;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["zipCode"] = this.zipCode;
        return data;
    }

    clone(): EnderecoAssinaturaDto {
        const json = this.toJSON();
        let result = new EnderecoAssinaturaDto();
        result.init(json);
        return result;
    }
}

export interface IEnderecoAssinaturaDto {
    city: string | undefined;
    federalUnit: string | undefined;
    neighborhood: string | undefined;
    streetName: string | undefined;
    streetNumber: string | undefined;
    zipCode: string | undefined;
}

export class CreateAssinaturaDto implements ICreateAssinaturaDto {
    tipoPagamento: TipoPagamentoEnum;
    cartaoCredito: CartaoCreditoDto;
    planoId: string;
    ehAnual: boolean;
    endereco: EnderecoAssinaturaDto;

    constructor(data?: ICreateAssinaturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoPagamento = _data["tipoPagamento"];
            this.cartaoCredito = _data["cartaoCredito"] ? CartaoCreditoDto.fromJS(_data["cartaoCredito"]) : <any>undefined;
            this.planoId = _data["planoId"];
            this.ehAnual = _data["ehAnual"];
            this.endereco = _data["endereco"] ? EnderecoAssinaturaDto.fromJS(_data["endereco"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAssinaturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssinaturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoPagamento"] = this.tipoPagamento;
        data["cartaoCredito"] = this.cartaoCredito ? this.cartaoCredito.toJSON() : <any>undefined;
        data["planoId"] = this.planoId;
        data["ehAnual"] = this.ehAnual;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateAssinaturaDto {
        const json = this.toJSON();
        let result = new CreateAssinaturaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAssinaturaDto {
    tipoPagamento: TipoPagamentoEnum;
    cartaoCredito: CartaoCreditoDto;
    planoId: string;
    ehAnual: boolean;
    endereco: EnderecoAssinaturaDto;
}

export enum PublicoAlvoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PlanoBeneficiosDto implements IPlanoBeneficiosDto {
    descricao: string | undefined;
    planoId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPlanoBeneficiosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.planoId = _data["planoId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlanoBeneficiosDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanoBeneficiosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["planoId"] = this.planoId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PlanoBeneficiosDto {
        const json = this.toJSON();
        let result = new PlanoBeneficiosDto();
        result.init(json);
        return result;
    }
}

export interface IPlanoBeneficiosDto {
    descricao: string | undefined;
    planoId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PlanoDto implements IPlanoDto {
    nome: string | undefined;
    valorAnual: number;
    valorMensal: number;
    limiteMb: number;
    temLimitePacientes: boolean;
    temCustoAdicionalPacientes: boolean;
    limitePacientes: number;
    valorCustoAdicionalPacientes: number;
    descricao: string | undefined;
    suspenso: boolean;
    idAppleAnual: string | undefined;
    idAppleMensal: string | undefined;
    publicoAlvo: PublicoAlvoEnum;
    free: boolean;
    isDefault: boolean;
    isTryout: boolean;
    onlyAdmins: boolean;
    duracaoTryout: number | undefined;
    readonly publicoAlvoString: string | undefined;
    planoBeneficios: PlanoBeneficiosDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPlanoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.valorAnual = _data["valorAnual"];
            this.valorMensal = _data["valorMensal"];
            this.limiteMb = _data["limiteMb"];
            this.temLimitePacientes = _data["temLimitePacientes"];
            this.temCustoAdicionalPacientes = _data["temCustoAdicionalPacientes"];
            this.limitePacientes = _data["limitePacientes"];
            this.valorCustoAdicionalPacientes = _data["valorCustoAdicionalPacientes"];
            this.descricao = _data["descricao"];
            this.suspenso = _data["suspenso"];
            this.idAppleAnual = _data["idAppleAnual"];
            this.idAppleMensal = _data["idAppleMensal"];
            this.publicoAlvo = _data["publicoAlvo"];
            this.free = _data["free"];
            this.isDefault = _data["isDefault"];
            this.isTryout = _data["isTryout"];
            this.onlyAdmins = _data["onlyAdmins"];
            this.duracaoTryout = _data["duracaoTryout"];
            (<any>this).publicoAlvoString = _data["publicoAlvoString"];
            if (Array.isArray(_data["planoBeneficios"])) {
                this.planoBeneficios = [] as any;
                for (let item of _data["planoBeneficios"])
                    this.planoBeneficios.push(PlanoBeneficiosDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlanoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["valorAnual"] = this.valorAnual;
        data["valorMensal"] = this.valorMensal;
        data["limiteMb"] = this.limiteMb;
        data["temLimitePacientes"] = this.temLimitePacientes;
        data["temCustoAdicionalPacientes"] = this.temCustoAdicionalPacientes;
        data["limitePacientes"] = this.limitePacientes;
        data["valorCustoAdicionalPacientes"] = this.valorCustoAdicionalPacientes;
        data["descricao"] = this.descricao;
        data["suspenso"] = this.suspenso;
        data["idAppleAnual"] = this.idAppleAnual;
        data["idAppleMensal"] = this.idAppleMensal;
        data["publicoAlvo"] = this.publicoAlvo;
        data["free"] = this.free;
        data["isDefault"] = this.isDefault;
        data["isTryout"] = this.isTryout;
        data["onlyAdmins"] = this.onlyAdmins;
        data["duracaoTryout"] = this.duracaoTryout;
        data["publicoAlvoString"] = this.publicoAlvoString;
        if (Array.isArray(this.planoBeneficios)) {
            data["planoBeneficios"] = [];
            for (let item of this.planoBeneficios)
                data["planoBeneficios"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PlanoDto {
        const json = this.toJSON();
        let result = new PlanoDto();
        result.init(json);
        return result;
    }
}

export interface IPlanoDto {
    nome: string | undefined;
    valorAnual: number;
    valorMensal: number;
    limiteMb: number;
    temLimitePacientes: boolean;
    temCustoAdicionalPacientes: boolean;
    limitePacientes: number;
    valorCustoAdicionalPacientes: number;
    descricao: string | undefined;
    suspenso: boolean;
    idAppleAnual: string | undefined;
    idAppleMensal: string | undefined;
    publicoAlvo: PublicoAlvoEnum;
    free: boolean;
    isDefault: boolean;
    isTryout: boolean;
    onlyAdmins: boolean;
    duracaoTryout: number | undefined;
    publicoAlvoString: string | undefined;
    planoBeneficios: PlanoBeneficiosDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum TipoAssinaturaEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class AssinaturaDto implements IAssinaturaDto {
    valor: number;
    mercadoPagoId: number | undefined;
    preapprovalId: string | undefined;
    shiftPayPagamentoId: string | undefined;
    shiftPayAssinaturaId: string | undefined;
    status: string | undefined;
    qrCode: string | undefined;
    qrCodeBase64: string | undefined;
    boletoUrl: string | undefined;
    boletoLinhaDigitavel: string | undefined;
    dataAssinatura: moment.Moment;
    dataEncerramento: moment.Moment | undefined;
    dataCancelamento: moment.Moment | undefined;
    ativo: boolean;
    plano: PlanoDto;
    planoId: string | undefined;
    usuarioId: number;
    tipoAssinatura: TipoAssinaturaEnum;
    readonly tipoAssinaturaString: string | undefined;
    id: string;

    constructor(data?: IAssinaturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valor = _data["valor"];
            this.mercadoPagoId = _data["mercadoPagoId"];
            this.preapprovalId = _data["preapprovalId"];
            this.shiftPayPagamentoId = _data["shiftPayPagamentoId"];
            this.shiftPayAssinaturaId = _data["shiftPayAssinaturaId"];
            this.status = _data["status"];
            this.qrCode = _data["qrCode"];
            this.qrCodeBase64 = _data["qrCodeBase64"];
            this.boletoUrl = _data["boletoUrl"];
            this.boletoLinhaDigitavel = _data["boletoLinhaDigitavel"];
            this.dataAssinatura = _data["dataAssinatura"] ? moment(_data["dataAssinatura"].toString()) : <any>undefined;
            this.dataEncerramento = _data["dataEncerramento"] ? moment(_data["dataEncerramento"].toString()) : <any>undefined;
            this.dataCancelamento = _data["dataCancelamento"] ? moment(_data["dataCancelamento"].toString()) : <any>undefined;
            this.ativo = _data["ativo"];
            this.plano = _data["plano"] ? PlanoDto.fromJS(_data["plano"]) : <any>undefined;
            this.planoId = _data["planoId"];
            this.usuarioId = _data["usuarioId"];
            this.tipoAssinatura = _data["tipoAssinatura"];
            (<any>this).tipoAssinaturaString = _data["tipoAssinaturaString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssinaturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssinaturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valor"] = this.valor;
        data["mercadoPagoId"] = this.mercadoPagoId;
        data["preapprovalId"] = this.preapprovalId;
        data["shiftPayPagamentoId"] = this.shiftPayPagamentoId;
        data["shiftPayAssinaturaId"] = this.shiftPayAssinaturaId;
        data["status"] = this.status;
        data["qrCode"] = this.qrCode;
        data["qrCodeBase64"] = this.qrCodeBase64;
        data["boletoUrl"] = this.boletoUrl;
        data["boletoLinhaDigitavel"] = this.boletoLinhaDigitavel;
        data["dataAssinatura"] = this.dataAssinatura ? this.dataAssinatura.toISOString() : <any>undefined;
        data["dataEncerramento"] = this.dataEncerramento ? this.dataEncerramento.toISOString() : <any>undefined;
        data["dataCancelamento"] = this.dataCancelamento ? this.dataCancelamento.toISOString() : <any>undefined;
        data["ativo"] = this.ativo;
        data["plano"] = this.plano ? this.plano.toJSON() : <any>undefined;
        data["planoId"] = this.planoId;
        data["usuarioId"] = this.usuarioId;
        data["tipoAssinatura"] = this.tipoAssinatura;
        data["tipoAssinaturaString"] = this.tipoAssinaturaString;
        data["id"] = this.id;
        return data;
    }

    clone(): AssinaturaDto {
        const json = this.toJSON();
        let result = new AssinaturaDto();
        result.init(json);
        return result;
    }
}

export interface IAssinaturaDto {
    valor: number;
    mercadoPagoId: number | undefined;
    preapprovalId: string | undefined;
    shiftPayPagamentoId: string | undefined;
    shiftPayAssinaturaId: string | undefined;
    status: string | undefined;
    qrCode: string | undefined;
    qrCodeBase64: string | undefined;
    boletoUrl: string | undefined;
    boletoLinhaDigitavel: string | undefined;
    dataAssinatura: moment.Moment;
    dataEncerramento: moment.Moment | undefined;
    dataCancelamento: moment.Moment | undefined;
    ativo: boolean;
    plano: PlanoDto;
    planoId: string | undefined;
    usuarioId: number;
    tipoAssinatura: TipoAssinaturaEnum;
    tipoAssinaturaString: string | undefined;
    id: string;
}

export class PaymentMethodSettingsBin implements IPaymentMethodSettingsBin {
    pattern: string | undefined;
    exclusionPattern: string | undefined;
    installmentsPattern: string | undefined;

    constructor(data?: IPaymentMethodSettingsBin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["pattern"];
            this.exclusionPattern = _data["exclusionPattern"];
            this.installmentsPattern = _data["installmentsPattern"];
        }
    }

    static fromJS(data: any): PaymentMethodSettingsBin {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodSettingsBin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern;
        data["exclusionPattern"] = this.exclusionPattern;
        data["installmentsPattern"] = this.installmentsPattern;
        return data;
    }

    clone(): PaymentMethodSettingsBin {
        const json = this.toJSON();
        let result = new PaymentMethodSettingsBin();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodSettingsBin {
    pattern: string | undefined;
    exclusionPattern: string | undefined;
    installmentsPattern: string | undefined;
}

export class PaymentMethodSettingsCardNumber implements IPaymentMethodSettingsCardNumber {
    length: string | undefined;
    validation: string | undefined;

    constructor(data?: IPaymentMethodSettingsCardNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.length = _data["length"];
            this.validation = _data["validation"];
        }
    }

    static fromJS(data: any): PaymentMethodSettingsCardNumber {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodSettingsCardNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["validation"] = this.validation;
        return data;
    }

    clone(): PaymentMethodSettingsCardNumber {
        const json = this.toJSON();
        let result = new PaymentMethodSettingsCardNumber();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodSettingsCardNumber {
    length: string | undefined;
    validation: string | undefined;
}

export class PaymentMethodSettingsSecurityCode implements IPaymentMethodSettingsSecurityCode {
    mode: string | undefined;
    length: number | undefined;
    cardLocation: string | undefined;

    constructor(data?: IPaymentMethodSettingsSecurityCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.length = _data["length"];
            this.cardLocation = _data["cardLocation"];
        }
    }

    static fromJS(data: any): PaymentMethodSettingsSecurityCode {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodSettingsSecurityCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["length"] = this.length;
        data["cardLocation"] = this.cardLocation;
        return data;
    }

    clone(): PaymentMethodSettingsSecurityCode {
        const json = this.toJSON();
        let result = new PaymentMethodSettingsSecurityCode();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodSettingsSecurityCode {
    mode: string | undefined;
    length: number | undefined;
    cardLocation: string | undefined;
}

export class PaymentMethodSettings implements IPaymentMethodSettings {
    bin: PaymentMethodSettingsBin;
    cardNumber: PaymentMethodSettingsCardNumber;
    securityCode: PaymentMethodSettingsSecurityCode;

    constructor(data?: IPaymentMethodSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bin = _data["bin"] ? PaymentMethodSettingsBin.fromJS(_data["bin"]) : <any>undefined;
            this.cardNumber = _data["cardNumber"] ? PaymentMethodSettingsCardNumber.fromJS(_data["cardNumber"]) : <any>undefined;
            this.securityCode = _data["securityCode"] ? PaymentMethodSettingsSecurityCode.fromJS(_data["securityCode"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentMethodSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bin"] = this.bin ? this.bin.toJSON() : <any>undefined;
        data["cardNumber"] = this.cardNumber ? this.cardNumber.toJSON() : <any>undefined;
        data["securityCode"] = this.securityCode ? this.securityCode.toJSON() : <any>undefined;
        return data;
    }

    clone(): PaymentMethodSettings {
        const json = this.toJSON();
        let result = new PaymentMethodSettings();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodSettings {
    bin: PaymentMethodSettingsBin;
    cardNumber: PaymentMethodSettingsCardNumber;
    securityCode: PaymentMethodSettingsSecurityCode;
}

export class PaymentMethodFinancialInstitutions implements IPaymentMethodFinancialInstitutions {
    id: number | undefined;
    description: string | undefined;

    constructor(data?: IPaymentMethodFinancialInstitutions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PaymentMethodFinancialInstitutions {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodFinancialInstitutions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): PaymentMethodFinancialInstitutions {
        const json = this.toJSON();
        let result = new PaymentMethodFinancialInstitutions();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodFinancialInstitutions {
    id: number | undefined;
    description: string | undefined;
}

export class MercadoPagoResponse implements IMercadoPagoResponse {
    readonly statusCode: number;
    readonly headers: { [key: string]: string; } | undefined;
    readonly content: string | undefined;

    constructor(data?: IMercadoPagoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            if (_data["headers"]) {
                (<any>this).headers = {} as any;
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        (<any>(<any>this).headers)[key] = _data["headers"][key];
                }
            }
            (<any>this).content = _data["content"];
        }
    }

    static fromJS(data: any): MercadoPagoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoPagoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    (<any>data["headers"])[key] = (<any>this.headers)[key];
            }
        }
        data["content"] = this.content;
        return data;
    }

    clone(): MercadoPagoResponse {
        const json = this.toJSON();
        let result = new MercadoPagoResponse();
        result.init(json);
        return result;
    }
}

export interface IMercadoPagoResponse {
    statusCode: number;
    headers: { [key: string]: string; } | undefined;
    content: string | undefined;
}

export class PaymentMethod implements IPaymentMethod {
    id: string | undefined;
    name: string | undefined;
    paymentTypeId: string | undefined;
    status: string | undefined;
    secureThumbnail: string | undefined;
    thumbnail: string | undefined;
    deferredCapture: string | undefined;
    settings: PaymentMethodSettings[] | undefined;
    additionalInfoNeeded: string[] | undefined;
    minAllowedAmount: number | undefined;
    maxAllowedAmount: number | undefined;
    accreditationTime: number | undefined;
    financialInstitutions: PaymentMethodFinancialInstitutions[] | undefined;
    processingModes: string[] | undefined;
    apiResponse: MercadoPagoResponse;

    constructor(data?: IPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.status = _data["status"];
            this.secureThumbnail = _data["secureThumbnail"];
            this.thumbnail = _data["thumbnail"];
            this.deferredCapture = _data["deferredCapture"];
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(PaymentMethodSettings.fromJS(item));
            }
            if (Array.isArray(_data["additionalInfoNeeded"])) {
                this.additionalInfoNeeded = [] as any;
                for (let item of _data["additionalInfoNeeded"])
                    this.additionalInfoNeeded.push(item);
            }
            this.minAllowedAmount = _data["minAllowedAmount"];
            this.maxAllowedAmount = _data["maxAllowedAmount"];
            this.accreditationTime = _data["accreditationTime"];
            if (Array.isArray(_data["financialInstitutions"])) {
                this.financialInstitutions = [] as any;
                for (let item of _data["financialInstitutions"])
                    this.financialInstitutions.push(PaymentMethodFinancialInstitutions.fromJS(item));
            }
            if (Array.isArray(_data["processingModes"])) {
                this.processingModes = [] as any;
                for (let item of _data["processingModes"])
                    this.processingModes.push(item);
            }
            this.apiResponse = _data["apiResponse"] ? MercadoPagoResponse.fromJS(_data["apiResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["paymentTypeId"] = this.paymentTypeId;
        data["status"] = this.status;
        data["secureThumbnail"] = this.secureThumbnail;
        data["thumbnail"] = this.thumbnail;
        data["deferredCapture"] = this.deferredCapture;
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalInfoNeeded)) {
            data["additionalInfoNeeded"] = [];
            for (let item of this.additionalInfoNeeded)
                data["additionalInfoNeeded"].push(item);
        }
        data["minAllowedAmount"] = this.minAllowedAmount;
        data["maxAllowedAmount"] = this.maxAllowedAmount;
        data["accreditationTime"] = this.accreditationTime;
        if (Array.isArray(this.financialInstitutions)) {
            data["financialInstitutions"] = [];
            for (let item of this.financialInstitutions)
                data["financialInstitutions"].push(item.toJSON());
        }
        if (Array.isArray(this.processingModes)) {
            data["processingModes"] = [];
            for (let item of this.processingModes)
                data["processingModes"].push(item);
        }
        data["apiResponse"] = this.apiResponse ? this.apiResponse.toJSON() : <any>undefined;
        return data;
    }

    clone(): PaymentMethod {
        const json = this.toJSON();
        let result = new PaymentMethod();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethod {
    id: string | undefined;
    name: string | undefined;
    paymentTypeId: string | undefined;
    status: string | undefined;
    secureThumbnail: string | undefined;
    thumbnail: string | undefined;
    deferredCapture: string | undefined;
    settings: PaymentMethodSettings[] | undefined;
    additionalInfoNeeded: string[] | undefined;
    minAllowedAmount: number | undefined;
    maxAllowedAmount: number | undefined;
    accreditationTime: number | undefined;
    financialInstitutions: PaymentMethodFinancialInstitutions[] | undefined;
    processingModes: string[] | undefined;
    apiResponse: MercadoPagoResponse;
}

export class AssinaturaDtoPagedResultDto implements IAssinaturaDtoPagedResultDto {
    totalCount: number;
    items: AssinaturaDto[] | undefined;

    constructor(data?: IAssinaturaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssinaturaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssinaturaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssinaturaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): AssinaturaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssinaturaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssinaturaDtoPagedResultDto {
    totalCount: number;
    items: AssinaturaDto[] | undefined;
}

export class MentionDto implements IMentionDto {
    uid: string;
    id: string | undefined;
    text: string | undefined;
    tipo: string | undefined;
    disabled: boolean;

    constructor(data?: IMentionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.id = _data["id"];
            this.text = _data["text"];
            this.tipo = _data["tipo"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): MentionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MentionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["id"] = this.id;
        data["text"] = this.text;
        data["tipo"] = this.tipo;
        data["disabled"] = this.disabled;
        return data;
    }

    clone(): MentionDto {
        const json = this.toJSON();
        let result = new MentionDto();
        result.init(json);
        return result;
    }
}

export interface IMentionDto {
    uid: string;
    id: string | undefined;
    text: string | undefined;
    tipo: string | undefined;
    disabled: boolean;
}

export class CreateBatimentosCardiacosDto implements ICreateBatimentosCardiacosDto {
    valorBps: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateBatimentosCardiacosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorBps = _data["valorBps"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateBatimentosCardiacosDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBatimentosCardiacosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorBps"] = this.valorBps;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateBatimentosCardiacosDto {
        const json = this.toJSON();
        let result = new CreateBatimentosCardiacosDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBatimentosCardiacosDto {
    valorBps: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class BatimentosCardiacosDto implements IBatimentosCardiacosDto {
    valorBps: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IBatimentosCardiacosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorBps = _data["valorBps"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BatimentosCardiacosDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatimentosCardiacosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorBps"] = this.valorBps;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): BatimentosCardiacosDto {
        const json = this.toJSON();
        let result = new BatimentosCardiacosDto();
        result.init(json);
        return result;
    }
}

export interface IBatimentosCardiacosDto {
    valorBps: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class UpdateBatimentosCardiacosDto implements IUpdateBatimentosCardiacosDto {
    valorBps: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateBatimentosCardiacosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorBps = _data["valorBps"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateBatimentosCardiacosDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBatimentosCardiacosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorBps"] = this.valorBps;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateBatimentosCardiacosDto {
        const json = this.toJSON();
        let result = new UpdateBatimentosCardiacosDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBatimentosCardiacosDto {
    valorBps: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class BatimentosCardiacosDtoPagedResultDto implements IBatimentosCardiacosDtoPagedResultDto {
    totalCount: number;
    items: BatimentosCardiacosDto[] | undefined;

    constructor(data?: IBatimentosCardiacosDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BatimentosCardiacosDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatimentosCardiacosDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatimentosCardiacosDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): BatimentosCardiacosDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BatimentosCardiacosDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBatimentosCardiacosDtoPagedResultDto {
    totalCount: number;
    items: BatimentosCardiacosDto[] | undefined;
}

export class ChatNotificacaoDto implements IChatNotificacaoDto {
    equipeId: string | undefined;
    nomeEquipe: string | undefined;
    nomeRemetente: string | undefined;
    mensagemNotificacao: string | undefined;
    dataNotificacao: string | undefined;
    visto: boolean;
    destinatarioId: number;
    remetenteId: number;
    mensagemId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IChatNotificacaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipeId = _data["equipeId"];
            this.nomeEquipe = _data["nomeEquipe"];
            this.nomeRemetente = _data["nomeRemetente"];
            this.mensagemNotificacao = _data["mensagemNotificacao"];
            this.dataNotificacao = _data["dataNotificacao"];
            this.visto = _data["visto"];
            this.destinatarioId = _data["destinatarioId"];
            this.remetenteId = _data["remetenteId"];
            this.mensagemId = _data["mensagemId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatNotificacaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatNotificacaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipeId"] = this.equipeId;
        data["nomeEquipe"] = this.nomeEquipe;
        data["nomeRemetente"] = this.nomeRemetente;
        data["mensagemNotificacao"] = this.mensagemNotificacao;
        data["dataNotificacao"] = this.dataNotificacao;
        data["visto"] = this.visto;
        data["destinatarioId"] = this.destinatarioId;
        data["remetenteId"] = this.remetenteId;
        data["mensagemId"] = this.mensagemId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ChatNotificacaoDto {
        const json = this.toJSON();
        let result = new ChatNotificacaoDto();
        result.init(json);
        return result;
    }
}

export interface IChatNotificacaoDto {
    equipeId: string | undefined;
    nomeEquipe: string | undefined;
    nomeRemetente: string | undefined;
    mensagemNotificacao: string | undefined;
    dataNotificacao: string | undefined;
    visto: boolean;
    destinatarioId: number;
    remetenteId: number;
    mensagemId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class EnderecoDto implements IEnderecoDto {
    cep: string | undefined;
    logradouro: string | undefined;
    numero: string | undefined;
    bairro: string | undefined;
    cidade: string | undefined;
    estado: string | undefined;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string | undefined;
    id: string;

    constructor(data?: IEnderecoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cep = _data["cep"];
            this.logradouro = _data["logradouro"];
            this.numero = _data["numero"];
            this.bairro = _data["bairro"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.complemento = _data["complemento"];
            this.referencia = _data["referencia"];
            this.codigoIbge = _data["codigoIbge"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EnderecoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnderecoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cep"] = this.cep;
        data["logradouro"] = this.logradouro;
        data["numero"] = this.numero;
        data["bairro"] = this.bairro;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["complemento"] = this.complemento;
        data["referencia"] = this.referencia;
        data["codigoIbge"] = this.codigoIbge;
        data["id"] = this.id;
        return data;
    }

    clone(): EnderecoDto {
        const json = this.toJSON();
        let result = new EnderecoDto();
        result.init(json);
        return result;
    }
}

export interface IEnderecoDto {
    cep: string | undefined;
    logradouro: string | undefined;
    numero: string | undefined;
    bairro: string | undefined;
    cidade: string | undefined;
    estado: string | undefined;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string | undefined;
    id: string;
}

export class ClinicaMedicaDto implements IClinicaMedicaDto {
    razaoSocial: string | undefined;
    nomeFantasia: string | undefined;
    cnpj: string | undefined;
    cnes: string | undefined;
    logomarca: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    celular: string | undefined;
    numeroRegistroConselho: string | undefined;
    tenancyName: string | undefined;
    endereco: EnderecoDto;
    enderecoId: string;
    adminUser: number | undefined;
    assinatura: AssinaturaDto;
    totalPacientes: number;
    totalProfissionais: number;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    id: string;

    constructor(data?: IClinicaMedicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.razaoSocial = _data["razaoSocial"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.cnpj = _data["cnpj"];
            this.cnes = _data["cnes"];
            this.logomarca = _data["logomarca"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.celular = _data["celular"];
            this.numeroRegistroConselho = _data["numeroRegistroConselho"];
            this.tenancyName = _data["tenancyName"];
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.enderecoId = _data["enderecoId"];
            this.adminUser = _data["adminUser"];
            this.assinatura = _data["assinatura"] ? AssinaturaDto.fromJS(_data["assinatura"]) : <any>undefined;
            this.totalPacientes = _data["totalPacientes"];
            this.totalProfissionais = _data["totalProfissionais"];
            this.avatar = _data["avatar"];
            this.nomeAvatar = _data["nomeAvatar"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClinicaMedicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicaMedicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["razaoSocial"] = this.razaoSocial;
        data["nomeFantasia"] = this.nomeFantasia;
        data["cnpj"] = this.cnpj;
        data["cnes"] = this.cnes;
        data["logomarca"] = this.logomarca;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["celular"] = this.celular;
        data["numeroRegistroConselho"] = this.numeroRegistroConselho;
        data["tenancyName"] = this.tenancyName;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["enderecoId"] = this.enderecoId;
        data["adminUser"] = this.adminUser;
        data["assinatura"] = this.assinatura ? this.assinatura.toJSON() : <any>undefined;
        data["totalPacientes"] = this.totalPacientes;
        data["totalProfissionais"] = this.totalProfissionais;
        data["avatar"] = this.avatar;
        data["nomeAvatar"] = this.nomeAvatar;
        data["id"] = this.id;
        return data;
    }

    clone(): ClinicaMedicaDto {
        const json = this.toJSON();
        let result = new ClinicaMedicaDto();
        result.init(json);
        return result;
    }
}

export interface IClinicaMedicaDto {
    razaoSocial: string | undefined;
    nomeFantasia: string | undefined;
    cnpj: string | undefined;
    cnes: string | undefined;
    logomarca: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    celular: string | undefined;
    numeroRegistroConselho: string | undefined;
    tenancyName: string | undefined;
    endereco: EnderecoDto;
    enderecoId: string;
    adminUser: number | undefined;
    assinatura: AssinaturaDto;
    totalPacientes: number;
    totalProfissionais: number;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    id: string;
}

export class EquipeProfissionalDto implements IEquipeProfissionalDto {
    profissionalId: string;
    profissionalSaude: EssentialProfisisonalSaudeDto;
    equipeId: string;
    equipesCLinica: EquipeClinicaDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEquipeProfissionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalId = _data["profissionalId"];
            this.profissionalSaude = _data["profissionalSaude"] ? EssentialProfisisonalSaudeDto.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.equipeId = _data["equipeId"];
            this.equipesCLinica = _data["equipesCLinica"] ? EquipeClinicaDto.fromJS(_data["equipesCLinica"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EquipeProfissionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipeProfissionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalId"] = this.profissionalId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["equipeId"] = this.equipeId;
        data["equipesCLinica"] = this.equipesCLinica ? this.equipesCLinica.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): EquipeProfissionalDto {
        const json = this.toJSON();
        let result = new EquipeProfissionalDto();
        result.init(json);
        return result;
    }
}

export interface IEquipeProfissionalDto {
    profissionalId: string;
    profissionalSaude: EssentialProfisisonalSaudeDto;
    equipeId: string;
    equipesCLinica: EquipeClinicaDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class EquipeClinicaDto implements IEquipeClinicaDto {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedicaDto;
    nome: string | undefined;
    descricao: string | undefined;
    especialidade: string | undefined;
    ativo: boolean;
    liderId: string;
    lider: EssentialProfisisonalSaudeDto;
    equipeProfissionais: EquipeProfissionalDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEquipeClinicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.clinicaMedica = _data["clinicaMedica"] ? ClinicaMedicaDto.fromJS(_data["clinicaMedica"]) : <any>undefined;
            this.nome = _data["nome"];
            this.descricao = _data["descricao"];
            this.especialidade = _data["especialidade"];
            this.ativo = _data["ativo"];
            this.liderId = _data["liderId"];
            this.lider = _data["lider"] ? EssentialProfisisonalSaudeDto.fromJS(_data["lider"]) : <any>undefined;
            if (Array.isArray(_data["equipeProfissionais"])) {
                this.equipeProfissionais = [] as any;
                for (let item of _data["equipeProfissionais"])
                    this.equipeProfissionais.push(EquipeProfissionalDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EquipeClinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipeClinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["clinicaMedica"] = this.clinicaMedica ? this.clinicaMedica.toJSON() : <any>undefined;
        data["nome"] = this.nome;
        data["descricao"] = this.descricao;
        data["especialidade"] = this.especialidade;
        data["ativo"] = this.ativo;
        data["liderId"] = this.liderId;
        data["lider"] = this.lider ? this.lider.toJSON() : <any>undefined;
        if (Array.isArray(this.equipeProfissionais)) {
            data["equipeProfissionais"] = [];
            for (let item of this.equipeProfissionais)
                data["equipeProfissionais"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): EquipeClinicaDto {
        const json = this.toJSON();
        let result = new EquipeClinicaDto();
        result.init(json);
        return result;
    }
}

export interface IEquipeClinicaDto {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedicaDto;
    nome: string | undefined;
    descricao: string | undefined;
    especialidade: string | undefined;
    ativo: boolean;
    liderId: string;
    lider: EssentialProfisisonalSaudeDto;
    equipeProfissionais: EquipeProfissionalDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string | undefined;
    emailAddress: string;
    isActive: boolean;
    isDeleted: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    nomeFotoPerfil: string | undefined;
    urlFotoPerfil: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.nomeFotoPerfil = _data["nomeFotoPerfil"];
            this.urlFotoPerfil = _data["urlFotoPerfil"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["nomeFotoPerfil"] = this.nomeFotoPerfil;
        data["urlFotoPerfil"] = this.urlFotoPerfil;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string | undefined;
    emailAddress: string;
    isActive: boolean;
    isDeleted: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    nomeFotoPerfil: string | undefined;
    urlFotoPerfil: string | undefined;
}

export class DestinatarioChatMensagemDto implements IDestinatarioChatMensagemDto {
    destinatarioId: number;
    destinatario: UserDto;
    chatMensagemId: string;
    visto: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IDestinatarioChatMensagemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinatarioId = _data["destinatarioId"];
            this.destinatario = _data["destinatario"] ? UserDto.fromJS(_data["destinatario"]) : <any>undefined;
            this.chatMensagemId = _data["chatMensagemId"];
            this.visto = _data["visto"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DestinatarioChatMensagemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DestinatarioChatMensagemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinatarioId"] = this.destinatarioId;
        data["destinatario"] = this.destinatario ? this.destinatario.toJSON() : <any>undefined;
        data["chatMensagemId"] = this.chatMensagemId;
        data["visto"] = this.visto;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): DestinatarioChatMensagemDto {
        const json = this.toJSON();
        let result = new DestinatarioChatMensagemDto();
        result.init(json);
        return result;
    }
}

export interface IDestinatarioChatMensagemDto {
    destinatarioId: number;
    destinatario: UserDto;
    chatMensagemId: string;
    visto: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ChatMensagemDto implements IChatMensagemDto {
    nomeRemetente: string | undefined;
    mensagem: string | undefined;
    anexoB64: string | undefined;
    url: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    remetenteId: number;
    equipeId: string | undefined;
    equipe: EquipeClinicaDto;
    dataHoraEnvio: moment.Moment;
    destinatarios: DestinatarioChatMensagemDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IChatMensagemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomeRemetente = _data["nomeRemetente"];
            this.mensagem = _data["mensagem"];
            this.anexoB64 = _data["anexoB64"];
            this.url = _data["url"];
            this.nomeArquivo = _data["nomeArquivo"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.remetenteId = _data["remetenteId"];
            this.equipeId = _data["equipeId"];
            this.equipe = _data["equipe"] ? EquipeClinicaDto.fromJS(_data["equipe"]) : <any>undefined;
            this.dataHoraEnvio = _data["dataHoraEnvio"] ? moment(_data["dataHoraEnvio"].toString()) : <any>undefined;
            if (Array.isArray(_data["destinatarios"])) {
                this.destinatarios = [] as any;
                for (let item of _data["destinatarios"])
                    this.destinatarios.push(DestinatarioChatMensagemDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMensagemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMensagemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeRemetente"] = this.nomeRemetente;
        data["mensagem"] = this.mensagem;
        data["anexoB64"] = this.anexoB64;
        data["url"] = this.url;
        data["nomeArquivo"] = this.nomeArquivo;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["remetenteId"] = this.remetenteId;
        data["equipeId"] = this.equipeId;
        data["equipe"] = this.equipe ? this.equipe.toJSON() : <any>undefined;
        data["dataHoraEnvio"] = this.dataHoraEnvio ? this.dataHoraEnvio.toISOString() : <any>undefined;
        if (Array.isArray(this.destinatarios)) {
            data["destinatarios"] = [];
            for (let item of this.destinatarios)
                data["destinatarios"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ChatMensagemDto {
        const json = this.toJSON();
        let result = new ChatMensagemDto();
        result.init(json);
        return result;
    }
}

export interface IChatMensagemDto {
    nomeRemetente: string | undefined;
    mensagem: string | undefined;
    anexoB64: string | undefined;
    url: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    remetenteId: number;
    equipeId: string | undefined;
    equipe: EquipeClinicaDto;
    dataHoraEnvio: moment.Moment;
    destinatarios: DestinatarioChatMensagemDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class NewChatInformationsDto implements INewChatInformationsDto {
    equipeId: string;
    clinicaId: string;
    nomeEquipe: string | undefined;
    profisionais: string[] | undefined;
    userIdUltimaMensagem: number | undefined;
    ultimaMensagem: string | undefined;
    dataHota: moment.Moment | undefined;
    clinicaNome: string | undefined;

    constructor(data?: INewChatInformationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipeId = _data["equipeId"];
            this.clinicaId = _data["clinicaId"];
            this.nomeEquipe = _data["nomeEquipe"];
            if (Array.isArray(_data["profisionais"])) {
                this.profisionais = [] as any;
                for (let item of _data["profisionais"])
                    this.profisionais.push(item);
            }
            this.userIdUltimaMensagem = _data["userIdUltimaMensagem"];
            this.ultimaMensagem = _data["ultimaMensagem"];
            this.dataHota = _data["dataHota"] ? moment(_data["dataHota"].toString()) : <any>undefined;
            this.clinicaNome = _data["clinicaNome"];
        }
    }

    static fromJS(data: any): NewChatInformationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewChatInformationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipeId"] = this.equipeId;
        data["clinicaId"] = this.clinicaId;
        data["nomeEquipe"] = this.nomeEquipe;
        if (Array.isArray(this.profisionais)) {
            data["profisionais"] = [];
            for (let item of this.profisionais)
                data["profisionais"].push(item);
        }
        data["userIdUltimaMensagem"] = this.userIdUltimaMensagem;
        data["ultimaMensagem"] = this.ultimaMensagem;
        data["dataHota"] = this.dataHota ? this.dataHota.toISOString() : <any>undefined;
        data["clinicaNome"] = this.clinicaNome;
        return data;
    }

    clone(): NewChatInformationsDto {
        const json = this.toJSON();
        let result = new NewChatInformationsDto();
        result.init(json);
        return result;
    }
}

export interface INewChatInformationsDto {
    equipeId: string;
    clinicaId: string;
    nomeEquipe: string | undefined;
    profisionais: string[] | undefined;
    userIdUltimaMensagem: number | undefined;
    ultimaMensagem: string | undefined;
    dataHota: moment.Moment | undefined;
    clinicaNome: string | undefined;
}

export class CidDto implements ICidDto {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: ICidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CidDto {
        data = typeof data === 'object' ? data : {};
        let result = new CidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): CidDto {
        const json = this.toJSON();
        let result = new CidDto();
        result.init(json);
        return result;
    }
}

export interface ICidDto {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class CidDtoPagedResultDto implements ICidDtoPagedResultDto {
    totalCount: number;
    items: CidDto[] | undefined;

    constructor(data?: ICidDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CidDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CidDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CidDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CidDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CidDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICidDtoPagedResultDto {
    totalCount: number;
    items: CidDto[] | undefined;
}

export class CreateCidDto implements ICreateCidDto {
    codigo: string | undefined;
    descricao: string | undefined;

    constructor(data?: ICreateCidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
        }
    }

    static fromJS(data: any): CreateCidDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        return data;
    }

    clone(): CreateCidDto {
        const json = this.toJSON();
        let result = new CreateCidDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCidDto {
    codigo: string | undefined;
    descricao: string | undefined;
}

export class UpdateCidDto implements IUpdateCidDto {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IUpdateCidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCidDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCidDto {
        const json = this.toJSON();
        let result = new UpdateCidDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCidDto {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class ImportTableDto implements IImportTableDto {
    base64: string | undefined;

    constructor(data?: IImportTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): ImportTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }

    clone(): ImportTableDto {
        const json = this.toJSON();
        let result = new ImportTableDto();
        result.init(json);
        return result;
    }
}

export interface IImportTableDto {
    base64: string | undefined;
}

export class DadosBasicosClinicaMedicaDto implements IDadosBasicosClinicaMedicaDto {
    nome: string | undefined;
    logomarca: string | undefined;

    constructor(data?: IDadosBasicosClinicaMedicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.logomarca = _data["logomarca"];
        }
    }

    static fromJS(data: any): DadosBasicosClinicaMedicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DadosBasicosClinicaMedicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["logomarca"] = this.logomarca;
        return data;
    }

    clone(): DadosBasicosClinicaMedicaDto {
        const json = this.toJSON();
        let result = new DadosBasicosClinicaMedicaDto();
        result.init(json);
        return result;
    }
}

export interface IDadosBasicosClinicaMedicaDto {
    nome: string | undefined;
    logomarca: string | undefined;
}

export class CreateEnderecoDto implements ICreateEnderecoDto {
    cep: string;
    logradouro: string;
    numero: string | undefined;
    bairro: string;
    cidade: string;
    estado: string;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string;

    constructor(data?: ICreateEnderecoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cep = _data["cep"];
            this.logradouro = _data["logradouro"];
            this.numero = _data["numero"];
            this.bairro = _data["bairro"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.complemento = _data["complemento"];
            this.referencia = _data["referencia"];
            this.codigoIbge = _data["codigoIbge"];
        }
    }

    static fromJS(data: any): CreateEnderecoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEnderecoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cep"] = this.cep;
        data["logradouro"] = this.logradouro;
        data["numero"] = this.numero;
        data["bairro"] = this.bairro;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["complemento"] = this.complemento;
        data["referencia"] = this.referencia;
        data["codigoIbge"] = this.codigoIbge;
        return data;
    }

    clone(): CreateEnderecoDto {
        const json = this.toJSON();
        let result = new CreateEnderecoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEnderecoDto {
    cep: string;
    logradouro: string;
    numero: string | undefined;
    bairro: string;
    cidade: string;
    estado: string;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string;
}

export class CreateClinicaMedicaDto implements ICreateClinicaMedicaDto {
    tenancyName: string;
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    cnes: string;
    logomarcaBase64: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    tamanhoArquivo: number;
    tipoArquivo: string | undefined;
    email: string;
    telefone: string;
    celular: string;
    numeroRegistroConselho: string;
    endereco: CreateEnderecoDto;
    senha: string;
    enderecoAssinatura: EnderecoAssinaturaDto;
    cartaoCredito: CartaoCreditoDto;
    isAnual: boolean;
    planoId: string | undefined;
    tipoPagamento: TipoPagamentoEnum;

    constructor(data?: ICreateClinicaMedicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.endereco = new CreateEnderecoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.razaoSocial = _data["razaoSocial"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.cnpj = _data["cnpj"];
            this.cnes = _data["cnes"];
            this.logomarcaBase64 = _data["logomarcaBase64"];
            this.nomeArquivo = _data["nomeArquivo"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.tamanhoArquivo = _data["tamanhoArquivo"];
            this.tipoArquivo = _data["tipoArquivo"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.celular = _data["celular"];
            this.numeroRegistroConselho = _data["numeroRegistroConselho"];
            this.endereco = _data["endereco"] ? CreateEnderecoDto.fromJS(_data["endereco"]) : new CreateEnderecoDto();
            this.senha = _data["senha"];
            this.enderecoAssinatura = _data["enderecoAssinatura"] ? EnderecoAssinaturaDto.fromJS(_data["enderecoAssinatura"]) : <any>undefined;
            this.cartaoCredito = _data["cartaoCredito"] ? CartaoCreditoDto.fromJS(_data["cartaoCredito"]) : <any>undefined;
            this.isAnual = _data["isAnual"];
            this.planoId = _data["planoId"];
            this.tipoPagamento = _data["tipoPagamento"];
        }
    }

    static fromJS(data: any): CreateClinicaMedicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClinicaMedicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["razaoSocial"] = this.razaoSocial;
        data["nomeFantasia"] = this.nomeFantasia;
        data["cnpj"] = this.cnpj;
        data["cnes"] = this.cnes;
        data["logomarcaBase64"] = this.logomarcaBase64;
        data["nomeArquivo"] = this.nomeArquivo;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["tamanhoArquivo"] = this.tamanhoArquivo;
        data["tipoArquivo"] = this.tipoArquivo;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["celular"] = this.celular;
        data["numeroRegistroConselho"] = this.numeroRegistroConselho;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["senha"] = this.senha;
        data["enderecoAssinatura"] = this.enderecoAssinatura ? this.enderecoAssinatura.toJSON() : <any>undefined;
        data["cartaoCredito"] = this.cartaoCredito ? this.cartaoCredito.toJSON() : <any>undefined;
        data["isAnual"] = this.isAnual;
        data["planoId"] = this.planoId;
        data["tipoPagamento"] = this.tipoPagamento;
        return data;
    }

    clone(): CreateClinicaMedicaDto {
        const json = this.toJSON();
        let result = new CreateClinicaMedicaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateClinicaMedicaDto {
    tenancyName: string;
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    cnes: string;
    logomarcaBase64: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    tamanhoArquivo: number;
    tipoArquivo: string | undefined;
    email: string;
    telefone: string;
    celular: string;
    numeroRegistroConselho: string;
    endereco: CreateEnderecoDto;
    senha: string;
    enderecoAssinatura: EnderecoAssinaturaDto;
    cartaoCredito: CartaoCreditoDto;
    isAnual: boolean;
    planoId: string | undefined;
    tipoPagamento: TipoPagamentoEnum;
}

export class ClinicaMedicaDtoPagedResultDto implements IClinicaMedicaDtoPagedResultDto {
    totalCount: number;
    items: ClinicaMedicaDto[] | undefined;

    constructor(data?: IClinicaMedicaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ClinicaMedicaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClinicaMedicaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicaMedicaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClinicaMedicaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClinicaMedicaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClinicaMedicaDtoPagedResultDto {
    totalCount: number;
    items: ClinicaMedicaDto[] | undefined;
}

export class UpdateEnderecoDto implements IUpdateEnderecoDto {
    cep: string;
    logradouro: string;
    numero: string | undefined;
    bairro: string;
    cidade: string;
    estado: string;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string;
    id: string;

    constructor(data?: IUpdateEnderecoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cep = _data["cep"];
            this.logradouro = _data["logradouro"];
            this.numero = _data["numero"];
            this.bairro = _data["bairro"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.complemento = _data["complemento"];
            this.referencia = _data["referencia"];
            this.codigoIbge = _data["codigoIbge"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEnderecoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnderecoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cep"] = this.cep;
        data["logradouro"] = this.logradouro;
        data["numero"] = this.numero;
        data["bairro"] = this.bairro;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["complemento"] = this.complemento;
        data["referencia"] = this.referencia;
        data["codigoIbge"] = this.codigoIbge;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateEnderecoDto {
        const json = this.toJSON();
        let result = new UpdateEnderecoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEnderecoDto {
    cep: string;
    logradouro: string;
    numero: string | undefined;
    bairro: string;
    cidade: string;
    estado: string;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string;
    id: string;
}

export class UpdateClinicaMedicaDto implements IUpdateClinicaMedicaDto {
    tenancyName: string;
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    cnes: string;
    logomarca: string | undefined;
    logomarcaBase64: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    tamanhoArquivo: number;
    tipoArquivo: string | undefined;
    email: string;
    telefone: string;
    celular: string;
    numeroRegistroConselho: string;
    endereco: UpdateEnderecoDto;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    id: string;

    constructor(data?: IUpdateClinicaMedicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.endereco = new UpdateEnderecoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.razaoSocial = _data["razaoSocial"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.cnpj = _data["cnpj"];
            this.cnes = _data["cnes"];
            this.logomarca = _data["logomarca"];
            this.logomarcaBase64 = _data["logomarcaBase64"];
            this.nomeArquivo = _data["nomeArquivo"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.tamanhoArquivo = _data["tamanhoArquivo"];
            this.tipoArquivo = _data["tipoArquivo"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.celular = _data["celular"];
            this.numeroRegistroConselho = _data["numeroRegistroConselho"];
            this.endereco = _data["endereco"] ? UpdateEnderecoDto.fromJS(_data["endereco"]) : new UpdateEnderecoDto();
            this.avatar = _data["avatar"];
            this.nomeAvatar = _data["nomeAvatar"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClinicaMedicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClinicaMedicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["razaoSocial"] = this.razaoSocial;
        data["nomeFantasia"] = this.nomeFantasia;
        data["cnpj"] = this.cnpj;
        data["cnes"] = this.cnes;
        data["logomarca"] = this.logomarca;
        data["logomarcaBase64"] = this.logomarcaBase64;
        data["nomeArquivo"] = this.nomeArquivo;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["tamanhoArquivo"] = this.tamanhoArquivo;
        data["tipoArquivo"] = this.tipoArquivo;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["celular"] = this.celular;
        data["numeroRegistroConselho"] = this.numeroRegistroConselho;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["avatar"] = this.avatar;
        data["nomeAvatar"] = this.nomeAvatar;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateClinicaMedicaDto {
        const json = this.toJSON();
        let result = new UpdateClinicaMedicaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateClinicaMedicaDto {
    tenancyName: string;
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    cnes: string;
    logomarca: string | undefined;
    logomarcaBase64: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    tamanhoArquivo: number;
    tipoArquivo: string | undefined;
    email: string;
    telefone: string;
    celular: string;
    numeroRegistroConselho: string;
    endereco: UpdateEnderecoDto;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    id: string;
}

export class HomeInformationDto implements IHomeInformationDto {
    totalProfissionais: number;
    totalPacientes: number;
    totalFuncionarios: number;

    constructor(data?: IHomeInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfissionais = _data["totalProfissionais"];
            this.totalPacientes = _data["totalPacientes"];
            this.totalFuncionarios = _data["totalFuncionarios"];
        }
    }

    static fromJS(data: any): HomeInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfissionais"] = this.totalProfissionais;
        data["totalPacientes"] = this.totalPacientes;
        data["totalFuncionarios"] = this.totalFuncionarios;
        return data;
    }

    clone(): HomeInformationDto {
        const json = this.toJSON();
        let result = new HomeInformationDto();
        result.init(json);
        return result;
    }
}

export interface IHomeInformationDto {
    totalProfissionais: number;
    totalPacientes: number;
    totalFuncionarios: number;
}

export class ClinicaMedicaConvenioDto implements IClinicaMedicaConvenioDto {
    clinicaMedicaId: string;
    convenioId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IClinicaMedicaConvenioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.convenioId = _data["convenioId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClinicaMedicaConvenioDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicaMedicaConvenioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["convenioId"] = this.convenioId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ClinicaMedicaConvenioDto {
        const json = this.toJSON();
        let result = new ClinicaMedicaConvenioDto();
        result.init(json);
        return result;
    }
}

export interface IClinicaMedicaConvenioDto {
    clinicaMedicaId: string;
    convenioId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateClinicaMedicaPacienteVipDto implements ICreateClinicaMedicaPacienteVipDto {
    profissionalResponsavelId: string | undefined;
    pacienteId: string;
    clinicaMedicaId: string;

    constructor(data?: ICreateClinicaMedicaPacienteVipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalResponsavelId = _data["profissionalResponsavelId"];
            this.pacienteId = _data["pacienteId"];
            this.clinicaMedicaId = _data["clinicaMedicaId"];
        }
    }

    static fromJS(data: any): CreateClinicaMedicaPacienteVipDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClinicaMedicaPacienteVipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalResponsavelId"] = this.profissionalResponsavelId;
        data["pacienteId"] = this.pacienteId;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        return data;
    }

    clone(): CreateClinicaMedicaPacienteVipDto {
        const json = this.toJSON();
        let result = new CreateClinicaMedicaPacienteVipDto();
        result.init(json);
        return result;
    }
}

export interface ICreateClinicaMedicaPacienteVipDto {
    profissionalResponsavelId: string | undefined;
    pacienteId: string;
    clinicaMedicaId: string;
}

export class ProfissionalAcessoPacienteVipDto implements IProfissionalAcessoPacienteVipDto {
    profissionalSaudeId: string;
    clinicaMedicaPacienteVipId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalAcessoPacienteVipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.clinicaMedicaPacienteVipId = _data["clinicaMedicaPacienteVipId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalAcessoPacienteVipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalAcessoPacienteVipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["clinicaMedicaPacienteVipId"] = this.clinicaMedicaPacienteVipId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalAcessoPacienteVipDto {
        const json = this.toJSON();
        let result = new ProfissionalAcessoPacienteVipDto();
        result.init(json);
        return result;
    }
}

export interface IProfissionalAcessoPacienteVipDto {
    profissionalSaudeId: string;
    clinicaMedicaPacienteVipId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ClinicaMedicaPacienteVipDto implements IClinicaMedicaPacienteVipDto {
    profissionalResponsavelId: string | undefined;
    pacienteId: string;
    clinicaMedicaId: string;
    nomeProfissional: string | undefined;
    profissionaisComAcesso: ProfissionalAcessoPacienteVipDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IClinicaMedicaPacienteVipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalResponsavelId = _data["profissionalResponsavelId"];
            this.pacienteId = _data["pacienteId"];
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.nomeProfissional = _data["nomeProfissional"];
            if (Array.isArray(_data["profissionaisComAcesso"])) {
                this.profissionaisComAcesso = [] as any;
                for (let item of _data["profissionaisComAcesso"])
                    this.profissionaisComAcesso.push(ProfissionalAcessoPacienteVipDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClinicaMedicaPacienteVipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicaMedicaPacienteVipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalResponsavelId"] = this.profissionalResponsavelId;
        data["pacienteId"] = this.pacienteId;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["nomeProfissional"] = this.nomeProfissional;
        if (Array.isArray(this.profissionaisComAcesso)) {
            data["profissionaisComAcesso"] = [];
            for (let item of this.profissionaisComAcesso)
                data["profissionaisComAcesso"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ClinicaMedicaPacienteVipDto {
        const json = this.toJSON();
        let result = new ClinicaMedicaPacienteVipDto();
        result.init(json);
        return result;
    }
}

export interface IClinicaMedicaPacienteVipDto {
    profissionalResponsavelId: string | undefined;
    pacienteId: string;
    clinicaMedicaId: string;
    nomeProfissional: string | undefined;
    profissionaisComAcesso: ProfissionalAcessoPacienteVipDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UpdateClinicaMedicaPacienteVipDto implements IUpdateClinicaMedicaPacienteVipDto {
    profissionalResponsavelId: string | undefined;
    pacienteId: string;
    clinicaMedicaId: string;
    profissionaisComAcesso: ProfissionalAcessoPacienteVipDto[] | undefined;
    novosProfissionaisComAcesso: ProfissionalAcessoPacienteVipDto[] | undefined;
    profissionaisComAcessoRemovidos: ProfissionalAcessoPacienteVipDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdateClinicaMedicaPacienteVipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalResponsavelId = _data["profissionalResponsavelId"];
            this.pacienteId = _data["pacienteId"];
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            if (Array.isArray(_data["profissionaisComAcesso"])) {
                this.profissionaisComAcesso = [] as any;
                for (let item of _data["profissionaisComAcesso"])
                    this.profissionaisComAcesso.push(ProfissionalAcessoPacienteVipDto.fromJS(item));
            }
            if (Array.isArray(_data["novosProfissionaisComAcesso"])) {
                this.novosProfissionaisComAcesso = [] as any;
                for (let item of _data["novosProfissionaisComAcesso"])
                    this.novosProfissionaisComAcesso.push(ProfissionalAcessoPacienteVipDto.fromJS(item));
            }
            if (Array.isArray(_data["profissionaisComAcessoRemovidos"])) {
                this.profissionaisComAcessoRemovidos = [] as any;
                for (let item of _data["profissionaisComAcessoRemovidos"])
                    this.profissionaisComAcessoRemovidos.push(ProfissionalAcessoPacienteVipDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClinicaMedicaPacienteVipDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClinicaMedicaPacienteVipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalResponsavelId"] = this.profissionalResponsavelId;
        data["pacienteId"] = this.pacienteId;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        if (Array.isArray(this.profissionaisComAcesso)) {
            data["profissionaisComAcesso"] = [];
            for (let item of this.profissionaisComAcesso)
                data["profissionaisComAcesso"].push(item.toJSON());
        }
        if (Array.isArray(this.novosProfissionaisComAcesso)) {
            data["novosProfissionaisComAcesso"] = [];
            for (let item of this.novosProfissionaisComAcesso)
                data["novosProfissionaisComAcesso"].push(item.toJSON());
        }
        if (Array.isArray(this.profissionaisComAcessoRemovidos)) {
            data["profissionaisComAcessoRemovidos"] = [];
            for (let item of this.profissionaisComAcessoRemovidos)
                data["profissionaisComAcessoRemovidos"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateClinicaMedicaPacienteVipDto {
        const json = this.toJSON();
        let result = new UpdateClinicaMedicaPacienteVipDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateClinicaMedicaPacienteVipDto {
    profissionalResponsavelId: string | undefined;
    pacienteId: string;
    clinicaMedicaId: string;
    profissionaisComAcesso: ProfissionalAcessoPacienteVipDto[] | undefined;
    novosProfissionaisComAcesso: ProfissionalAcessoPacienteVipDto[] | undefined;
    profissionaisComAcessoRemovidos: ProfissionalAcessoPacienteVipDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export enum StatusConsultaEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum SexoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PacienteGroupDto implements IPacienteGroupDto {
    id: string;
    nome: string | undefined;
    hasCadastroCompleto: boolean;
    nomeSocial: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    urlFotoPerfil: string | undefined;
    dataNascimento: moment.Moment | undefined;
    readonly idade: number;
    sexo: SexoEnum;
    responsavelLegalId: string | undefined;
    readonly sexoDescricao: string | undefined;

    constructor(data?: IPacienteGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nome = _data["nome"];
            this.hasCadastroCompleto = _data["hasCadastroCompleto"];
            this.nomeSocial = _data["nomeSocial"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.urlFotoPerfil = _data["urlFotoPerfil"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            (<any>this).idade = _data["idade"];
            this.sexo = _data["sexo"];
            this.responsavelLegalId = _data["responsavelLegalId"];
            (<any>this).sexoDescricao = _data["sexoDescricao"];
        }
    }

    static fromJS(data: any): PacienteGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nome"] = this.nome;
        data["hasCadastroCompleto"] = this.hasCadastroCompleto;
        data["nomeSocial"] = this.nomeSocial;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["urlFotoPerfil"] = this.urlFotoPerfil;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["idade"] = this.idade;
        data["sexo"] = this.sexo;
        data["responsavelLegalId"] = this.responsavelLegalId;
        data["sexoDescricao"] = this.sexoDescricao;
        return data;
    }

    clone(): PacienteGroupDto {
        const json = this.toJSON();
        let result = new PacienteGroupDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteGroupDto {
    id: string;
    nome: string | undefined;
    hasCadastroCompleto: boolean;
    nomeSocial: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    urlFotoPerfil: string | undefined;
    dataNascimento: moment.Moment | undefined;
    idade: number;
    sexo: SexoEnum;
    responsavelLegalId: string | undefined;
    sexoDescricao: string | undefined;
}

export class RegistroClasseDto implements IRegistroClasseDto {
    nome: string | undefined;
    id: string;

    constructor(data?: IRegistroClasseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegistroClasseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistroClasseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["id"] = this.id;
        return data;
    }

    clone(): RegistroClasseDto {
        const json = this.toJSON();
        let result = new RegistroClasseDto();
        result.init(json);
        return result;
    }
}

export interface IRegistroClasseDto {
    nome: string | undefined;
    id: string;
}

export class RQEDto implements IRQEDto {
    nomeEspecializacao: string | undefined;
    codigo: string | undefined;
    uf: string | undefined;

    constructor(data?: IRQEDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomeEspecializacao = _data["nomeEspecializacao"];
            this.codigo = _data["codigo"];
            this.uf = _data["uf"];
        }
    }

    static fromJS(data: any): RQEDto {
        data = typeof data === 'object' ? data : {};
        let result = new RQEDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeEspecializacao"] = this.nomeEspecializacao;
        data["codigo"] = this.codigo;
        data["uf"] = this.uf;
        return data;
    }

    clone(): RQEDto {
        const json = this.toJSON();
        let result = new RQEDto();
        result.init(json);
        return result;
    }
}

export interface IRQEDto {
    nomeEspecializacao: string | undefined;
    codigo: string | undefined;
    uf: string | undefined;
}

export class ProfissionalSaudePacienteDto implements IProfissionalSaudePacienteDto {
    profissionalSaudeId: string;
    pacienteId: string;
    token: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalSaudePacienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.pacienteId = _data["pacienteId"];
            this.token = _data["token"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalSaudePacienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudePacienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["pacienteId"] = this.pacienteId;
        data["token"] = this.token;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalSaudePacienteDto {
        const json = this.toJSON();
        let result = new ProfissionalSaudePacienteDto();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudePacienteDto {
    profissionalSaudeId: string;
    pacienteId: string;
    token: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum RespostaProfissionalEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class EmailProfissionalClinicaDto implements IEmailProfissionalClinicaDto {
    profissionalClinicaId: string;
    email: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEmailProfissionalClinicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalClinicaId = _data["profissionalClinicaId"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmailProfissionalClinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailProfissionalClinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalClinicaId"] = this.profissionalClinicaId;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): EmailProfissionalClinicaDto {
        const json = this.toJSON();
        let result = new EmailProfissionalClinicaDto();
        result.init(json);
        return result;
    }
}

export interface IEmailProfissionalClinicaDto {
    profissionalClinicaId: string;
    email: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class TelefoneProfissionalClinicaDto implements ITelefoneProfissionalClinicaDto {
    profissionalClinicaId: string;
    telefone: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ITelefoneProfissionalClinicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalClinicaId = _data["profissionalClinicaId"];
            this.telefone = _data["telefone"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TelefoneProfissionalClinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelefoneProfissionalClinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalClinicaId"] = this.profissionalClinicaId;
        data["telefone"] = this.telefone;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TelefoneProfissionalClinicaDto {
        const json = this.toJSON();
        let result = new TelefoneProfissionalClinicaDto();
        result.init(json);
        return result;
    }
}

export interface ITelefoneProfissionalClinicaDto {
    profissionalClinicaId: string;
    telefone: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProfissionalSaudeClinicaMedicaDto implements IProfissionalSaudeClinicaMedicaDto {
    clinicaMedicaId: string;
    nomeFantasia: string | undefined;
    razaoSocial: string | undefined;
    telefoneClinica: string | undefined;
    profissionalSaudeId: string;
    isActive: boolean;
    resposta: RespostaProfissionalEnum;
    readonly respostaString: string | undefined;
    emailProfissionalClinicas: EmailProfissionalClinicaDto[] | undefined;
    telefoneProfissionalClinicas: TelefoneProfissionalClinicaDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalSaudeClinicaMedicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.razaoSocial = _data["razaoSocial"];
            this.telefoneClinica = _data["telefoneClinica"];
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.isActive = _data["isActive"];
            this.resposta = _data["resposta"];
            (<any>this).respostaString = _data["respostaString"];
            if (Array.isArray(_data["emailProfissionalClinicas"])) {
                this.emailProfissionalClinicas = [] as any;
                for (let item of _data["emailProfissionalClinicas"])
                    this.emailProfissionalClinicas.push(EmailProfissionalClinicaDto.fromJS(item));
            }
            if (Array.isArray(_data["telefoneProfissionalClinicas"])) {
                this.telefoneProfissionalClinicas = [] as any;
                for (let item of _data["telefoneProfissionalClinicas"])
                    this.telefoneProfissionalClinicas.push(TelefoneProfissionalClinicaDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalSaudeClinicaMedicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudeClinicaMedicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["nomeFantasia"] = this.nomeFantasia;
        data["razaoSocial"] = this.razaoSocial;
        data["telefoneClinica"] = this.telefoneClinica;
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["isActive"] = this.isActive;
        data["resposta"] = this.resposta;
        data["respostaString"] = this.respostaString;
        if (Array.isArray(this.emailProfissionalClinicas)) {
            data["emailProfissionalClinicas"] = [];
            for (let item of this.emailProfissionalClinicas)
                data["emailProfissionalClinicas"].push(item.toJSON());
        }
        if (Array.isArray(this.telefoneProfissionalClinicas)) {
            data["telefoneProfissionalClinicas"] = [];
            for (let item of this.telefoneProfissionalClinicas)
                data["telefoneProfissionalClinicas"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalSaudeClinicaMedicaDto {
        const json = this.toJSON();
        let result = new ProfissionalSaudeClinicaMedicaDto();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudeClinicaMedicaDto {
    clinicaMedicaId: string;
    nomeFantasia: string | undefined;
    razaoSocial: string | undefined;
    telefoneClinica: string | undefined;
    profissionalSaudeId: string;
    isActive: boolean;
    resposta: RespostaProfissionalEnum;
    respostaString: string | undefined;
    emailProfissionalClinicas: EmailProfissionalClinicaDto[] | undefined;
    telefoneProfissionalClinicas: TelefoneProfissionalClinicaDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProfissionalSaudeDto implements IProfissionalSaudeDto {
    nome: string | undefined;
    assinaturaMedico: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    numeroRegistroClasse: string | undefined;
    registroEspecialidade: string | undefined;
    registroClasse: RegistroClasseDto;
    registroClasseId: string;
    endereco: EnderecoDto;
    enderecoId: string | undefined;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    assinatura: AssinaturaDto;
    nomeAssinatura: string | undefined;
    userId: number;
    ufRegistro: string | undefined;
    certificado: string | undefined;
    nomeCertificado: string | undefined;
    senhaCertificado: string | undefined;
    hasBond: boolean;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    permitirAssinaturaDigital: boolean;
    especializacoes: RQEDto[] | undefined;
    exibirNaListagemDeNovaConsulta: boolean;
    pacientes: ProfissionalSaudePacienteDto[] | undefined;
    clinicasMedicas: ProfissionalSaudeClinicaMedicaDto[] | undefined;
    id: string;

    constructor(data?: IProfissionalSaudeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.assinaturaMedico = _data["assinaturaMedico"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.numeroRegistroClasse = _data["numeroRegistroClasse"];
            this.registroEspecialidade = _data["registroEspecialidade"];
            this.registroClasse = _data["registroClasse"] ? RegistroClasseDto.fromJS(_data["registroClasse"]) : <any>undefined;
            this.registroClasseId = _data["registroClasseId"];
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.enderecoId = _data["enderecoId"];
            this.rg = _data["rg"];
            this.cns = _data["cns"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.assinatura = _data["assinatura"] ? AssinaturaDto.fromJS(_data["assinatura"]) : <any>undefined;
            this.nomeAssinatura = _data["nomeAssinatura"];
            this.userId = _data["userId"];
            this.ufRegistro = _data["ufRegistro"];
            this.certificado = _data["certificado"];
            this.nomeCertificado = _data["nomeCertificado"];
            this.senhaCertificado = _data["senhaCertificado"];
            this.hasBond = _data["hasBond"];
            this.avatar = _data["avatar"];
            this.nomeAvatar = _data["nomeAvatar"];
            this.permitirAssinaturaDigital = _data["permitirAssinaturaDigital"];
            if (Array.isArray(_data["especializacoes"])) {
                this.especializacoes = [] as any;
                for (let item of _data["especializacoes"])
                    this.especializacoes.push(RQEDto.fromJS(item));
            }
            this.exibirNaListagemDeNovaConsulta = _data["exibirNaListagemDeNovaConsulta"];
            if (Array.isArray(_data["pacientes"])) {
                this.pacientes = [] as any;
                for (let item of _data["pacientes"])
                    this.pacientes.push(ProfissionalSaudePacienteDto.fromJS(item));
            }
            if (Array.isArray(_data["clinicasMedicas"])) {
                this.clinicasMedicas = [] as any;
                for (let item of _data["clinicasMedicas"])
                    this.clinicasMedicas.push(ProfissionalSaudeClinicaMedicaDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalSaudeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["assinaturaMedico"] = this.assinaturaMedico;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["numeroRegistroClasse"] = this.numeroRegistroClasse;
        data["registroEspecialidade"] = this.registroEspecialidade;
        data["registroClasse"] = this.registroClasse ? this.registroClasse.toJSON() : <any>undefined;
        data["registroClasseId"] = this.registroClasseId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["enderecoId"] = this.enderecoId;
        data["rg"] = this.rg;
        data["cns"] = this.cns;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["assinatura"] = this.assinatura ? this.assinatura.toJSON() : <any>undefined;
        data["nomeAssinatura"] = this.nomeAssinatura;
        data["userId"] = this.userId;
        data["ufRegistro"] = this.ufRegistro;
        data["certificado"] = this.certificado;
        data["nomeCertificado"] = this.nomeCertificado;
        data["senhaCertificado"] = this.senhaCertificado;
        data["hasBond"] = this.hasBond;
        data["avatar"] = this.avatar;
        data["nomeAvatar"] = this.nomeAvatar;
        data["permitirAssinaturaDigital"] = this.permitirAssinaturaDigital;
        if (Array.isArray(this.especializacoes)) {
            data["especializacoes"] = [];
            for (let item of this.especializacoes)
                data["especializacoes"].push(item.toJSON());
        }
        data["exibirNaListagemDeNovaConsulta"] = this.exibirNaListagemDeNovaConsulta;
        if (Array.isArray(this.pacientes)) {
            data["pacientes"] = [];
            for (let item of this.pacientes)
                data["pacientes"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicasMedicas)) {
            data["clinicasMedicas"] = [];
            for (let item of this.clinicasMedicas)
                data["clinicasMedicas"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalSaudeDto {
        const json = this.toJSON();
        let result = new ProfissionalSaudeDto();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudeDto {
    nome: string | undefined;
    assinaturaMedico: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    numeroRegistroClasse: string | undefined;
    registroEspecialidade: string | undefined;
    registroClasse: RegistroClasseDto;
    registroClasseId: string;
    endereco: EnderecoDto;
    enderecoId: string | undefined;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    assinatura: AssinaturaDto;
    nomeAssinatura: string | undefined;
    userId: number;
    ufRegistro: string | undefined;
    certificado: string | undefined;
    nomeCertificado: string | undefined;
    senhaCertificado: string | undefined;
    hasBond: boolean;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    permitirAssinaturaDigital: boolean;
    especializacoes: RQEDto[] | undefined;
    exibirNaListagemDeNovaConsulta: boolean;
    pacientes: ProfissionalSaudePacienteDto[] | undefined;
    clinicasMedicas: ProfissionalSaudeClinicaMedicaDto[] | undefined;
    id: string;
}

export enum TipoConsultaEnum {
    _0 = 0,
    _1 = 1,
}

export enum TipoArquivoProntuarioEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum TipoUsuarioEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class AnexoConsultaDto implements IAnexoConsultaDto {
    consultaId: string;
    aquivoId: string;
    arquivo: ArquivoDto;
    tipoArquivoProntuario: TipoArquivoProntuarioEnum;
    readonly tipoArquivoProntuarioEnum: string | undefined;
    tipoUsuario: TipoUsuarioEnum;
    readonly tipoUsuarioString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAnexoConsultaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultaId = _data["consultaId"];
            this.aquivoId = _data["aquivoId"];
            this.arquivo = _data["arquivo"] ? ArquivoDto.fromJS(_data["arquivo"]) : <any>undefined;
            this.tipoArquivoProntuario = _data["tipoArquivoProntuario"];
            (<any>this).tipoArquivoProntuarioEnum = _data["tipoArquivoProntuarioEnum"];
            this.tipoUsuario = _data["tipoUsuario"];
            (<any>this).tipoUsuarioString = _data["tipoUsuarioString"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AnexoConsultaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnexoConsultaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultaId"] = this.consultaId;
        data["aquivoId"] = this.aquivoId;
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        data["tipoArquivoProntuario"] = this.tipoArquivoProntuario;
        data["tipoArquivoProntuarioEnum"] = this.tipoArquivoProntuarioEnum;
        data["tipoUsuario"] = this.tipoUsuario;
        data["tipoUsuarioString"] = this.tipoUsuarioString;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): AnexoConsultaDto {
        const json = this.toJSON();
        let result = new AnexoConsultaDto();
        result.init(json);
        return result;
    }
}

export interface IAnexoConsultaDto {
    consultaId: string;
    aquivoId: string;
    arquivo: ArquivoDto;
    tipoArquivoProntuario: TipoArquivoProntuarioEnum;
    tipoArquivoProntuarioEnum: string | undefined;
    tipoUsuario: TipoUsuarioEnum;
    tipoUsuarioString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProfissionalSaudeConvenioDto implements IProfissionalSaudeConvenioDto {
    profissionalSaudeId: string;
    convenioId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalSaudeConvenioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.convenioId = _data["convenioId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalSaudeConvenioDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudeConvenioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["convenioId"] = this.convenioId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalSaudeConvenioDto {
        const json = this.toJSON();
        let result = new ProfissionalSaudeConvenioDto();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudeConvenioDto {
    profissionalSaudeId: string;
    convenioId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ConvenioDto implements IConvenioDto {
    registroAns: string | undefined;
    cnpj: string | undefined;
    razaoSocial: string | undefined;
    nomeFantasia: string | undefined;
    autoGestao: boolean;
    ddd: string | undefined;
    telefone: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    representante: string | undefined;
    cargoRepresentante: string | undefined;
    dataRegistroAns: moment.Moment | undefined;
    ativo: boolean;
    enderecoId: string;
    endereco: EnderecoDto;
    profissionalSaudeConvenio: ProfissionalSaudeConvenioDto[] | undefined;
    clinicaMedicaConvenio: ClinicaMedicaConvenioDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IConvenioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registroAns = _data["registroAns"];
            this.cnpj = _data["cnpj"];
            this.razaoSocial = _data["razaoSocial"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.autoGestao = _data["autoGestao"];
            this.ddd = _data["ddd"];
            this.telefone = _data["telefone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.representante = _data["representante"];
            this.cargoRepresentante = _data["cargoRepresentante"];
            this.dataRegistroAns = _data["dataRegistroAns"] ? moment(_data["dataRegistroAns"].toString()) : <any>undefined;
            this.ativo = _data["ativo"];
            this.enderecoId = _data["enderecoId"];
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            if (Array.isArray(_data["profissionalSaudeConvenio"])) {
                this.profissionalSaudeConvenio = [] as any;
                for (let item of _data["profissionalSaudeConvenio"])
                    this.profissionalSaudeConvenio.push(ProfissionalSaudeConvenioDto.fromJS(item));
            }
            if (Array.isArray(_data["clinicaMedicaConvenio"])) {
                this.clinicaMedicaConvenio = [] as any;
                for (let item of _data["clinicaMedicaConvenio"])
                    this.clinicaMedicaConvenio.push(ClinicaMedicaConvenioDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConvenioDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvenioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registroAns"] = this.registroAns;
        data["cnpj"] = this.cnpj;
        data["razaoSocial"] = this.razaoSocial;
        data["nomeFantasia"] = this.nomeFantasia;
        data["autoGestao"] = this.autoGestao;
        data["ddd"] = this.ddd;
        data["telefone"] = this.telefone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["representante"] = this.representante;
        data["cargoRepresentante"] = this.cargoRepresentante;
        data["dataRegistroAns"] = this.dataRegistroAns ? this.dataRegistroAns.toISOString() : <any>undefined;
        data["ativo"] = this.ativo;
        data["enderecoId"] = this.enderecoId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        if (Array.isArray(this.profissionalSaudeConvenio)) {
            data["profissionalSaudeConvenio"] = [];
            for (let item of this.profissionalSaudeConvenio)
                data["profissionalSaudeConvenio"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicaMedicaConvenio)) {
            data["clinicaMedicaConvenio"] = [];
            for (let item of this.clinicaMedicaConvenio)
                data["clinicaMedicaConvenio"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConvenioDto {
        const json = this.toJSON();
        let result = new ConvenioDto();
        result.init(json);
        return result;
    }
}

export interface IConvenioDto {
    registroAns: string | undefined;
    cnpj: string | undefined;
    razaoSocial: string | undefined;
    nomeFantasia: string | undefined;
    autoGestao: boolean;
    ddd: string | undefined;
    telefone: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    representante: string | undefined;
    cargoRepresentante: string | undefined;
    dataRegistroAns: moment.Moment | undefined;
    ativo: boolean;
    enderecoId: string;
    endereco: EnderecoDto;
    profissionalSaudeConvenio: ProfissionalSaudeConvenioDto[] | undefined;
    clinicaMedicaConvenio: ClinicaMedicaConvenioDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum TipoPedidoEnum {
    _0 = 0,
    _1 = 1,
}

export class PedidoDto implements IPedidoDto {
    consultaId: string;
    nome: string | undefined;
    ext: string | undefined;
    urlArquivo: string | undefined;
    tipo: TipoPedidoEnum;
    dataSolicitacao: moment.Moment | undefined;
    dataEnvio: moment.Moment | undefined;
    id: string;

    constructor(data?: IPedidoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultaId = _data["consultaId"];
            this.nome = _data["nome"];
            this.ext = _data["ext"];
            this.urlArquivo = _data["urlArquivo"];
            this.tipo = _data["tipo"];
            this.dataSolicitacao = _data["dataSolicitacao"] ? moment(_data["dataSolicitacao"].toString()) : <any>undefined;
            this.dataEnvio = _data["dataEnvio"] ? moment(_data["dataEnvio"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PedidoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PedidoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultaId"] = this.consultaId;
        data["nome"] = this.nome;
        data["ext"] = this.ext;
        data["urlArquivo"] = this.urlArquivo;
        data["tipo"] = this.tipo;
        data["dataSolicitacao"] = this.dataSolicitacao ? this.dataSolicitacao.toISOString() : <any>undefined;
        data["dataEnvio"] = this.dataEnvio ? this.dataEnvio.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): PedidoDto {
        const json = this.toJSON();
        let result = new PedidoDto();
        result.init(json);
        return result;
    }
}

export interface IPedidoDto {
    consultaId: string;
    nome: string | undefined;
    ext: string | undefined;
    urlArquivo: string | undefined;
    tipo: TipoPedidoEnum;
    dataSolicitacao: moment.Moment | undefined;
    dataEnvio: moment.Moment | undefined;
    id: string;
}

export class ConsultaDto implements IConsultaDto {
    descricao: string | undefined;
    pacienteId: string;
    paciente: PacienteGroupDto;
    profissionalId: string;
    profissionalSaude: ProfissionalSaudeDto;
    clinicaMedicaId: string | undefined;
    clinciaMedica: ClinicaMedicaDto;
    dataConsulta: moment.Moment;
    linkTeleconsulta: string | undefined;
    observacoes: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    readonly tipoConsultaString: string | undefined;
    statusConsulta: StatusConsultaEnum;
    readonly statusConsultaString: string | undefined;
    anexos: AnexoConsultaDto[] | undefined;
    pastaId: string | undefined;
    eventoId: string;
    agendaId: string;
    convenioId: string | undefined;
    convenio: ConvenioDto;
    observacaoPaciente: string | undefined;
    observacaoProfissional: string | undefined;
    endereco: EnderecoDto;
    pedidos: PedidoDto[] | undefined;
    hasPedidosPendentes: boolean;
    isDependente: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IConsultaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? PacienteGroupDto.fromJS(_data["paciente"]) : <any>undefined;
            this.profissionalId = _data["profissionalId"];
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaudeDto.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.clinciaMedica = _data["clinciaMedica"] ? ClinicaMedicaDto.fromJS(_data["clinciaMedica"]) : <any>undefined;
            this.dataConsulta = _data["dataConsulta"] ? moment(_data["dataConsulta"].toString()) : <any>undefined;
            this.linkTeleconsulta = _data["linkTeleconsulta"];
            this.observacoes = _data["observacoes"];
            this.tipoConsulta = _data["tipoConsulta"];
            (<any>this).tipoConsultaString = _data["tipoConsultaString"];
            this.statusConsulta = _data["statusConsulta"];
            (<any>this).statusConsultaString = _data["statusConsultaString"];
            if (Array.isArray(_data["anexos"])) {
                this.anexos = [] as any;
                for (let item of _data["anexos"])
                    this.anexos.push(AnexoConsultaDto.fromJS(item));
            }
            this.pastaId = _data["pastaId"];
            this.eventoId = _data["eventoId"];
            this.agendaId = _data["agendaId"];
            this.convenioId = _data["convenioId"];
            this.convenio = _data["convenio"] ? ConvenioDto.fromJS(_data["convenio"]) : <any>undefined;
            this.observacaoPaciente = _data["observacaoPaciente"];
            this.observacaoProfissional = _data["observacaoProfissional"];
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            if (Array.isArray(_data["pedidos"])) {
                this.pedidos = [] as any;
                for (let item of _data["pedidos"])
                    this.pedidos.push(PedidoDto.fromJS(item));
            }
            this.hasPedidosPendentes = _data["hasPedidosPendentes"];
            this.isDependente = _data["isDependente"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConsultaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["profissionalId"] = this.profissionalId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["clinciaMedica"] = this.clinciaMedica ? this.clinciaMedica.toJSON() : <any>undefined;
        data["dataConsulta"] = this.dataConsulta ? this.dataConsulta.toISOString() : <any>undefined;
        data["linkTeleconsulta"] = this.linkTeleconsulta;
        data["observacoes"] = this.observacoes;
        data["tipoConsulta"] = this.tipoConsulta;
        data["tipoConsultaString"] = this.tipoConsultaString;
        data["statusConsulta"] = this.statusConsulta;
        data["statusConsultaString"] = this.statusConsultaString;
        if (Array.isArray(this.anexos)) {
            data["anexos"] = [];
            for (let item of this.anexos)
                data["anexos"].push(item.toJSON());
        }
        data["pastaId"] = this.pastaId;
        data["eventoId"] = this.eventoId;
        data["agendaId"] = this.agendaId;
        data["convenioId"] = this.convenioId;
        data["convenio"] = this.convenio ? this.convenio.toJSON() : <any>undefined;
        data["observacaoPaciente"] = this.observacaoPaciente;
        data["observacaoProfissional"] = this.observacaoProfissional;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        if (Array.isArray(this.pedidos)) {
            data["pedidos"] = [];
            for (let item of this.pedidos)
                data["pedidos"].push(item.toJSON());
        }
        data["hasPedidosPendentes"] = this.hasPedidosPendentes;
        data["isDependente"] = this.isDependente;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConsultaDto {
        const json = this.toJSON();
        let result = new ConsultaDto();
        result.init(json);
        return result;
    }
}

export interface IConsultaDto {
    descricao: string | undefined;
    pacienteId: string;
    paciente: PacienteGroupDto;
    profissionalId: string;
    profissionalSaude: ProfissionalSaudeDto;
    clinicaMedicaId: string | undefined;
    clinciaMedica: ClinicaMedicaDto;
    dataConsulta: moment.Moment;
    linkTeleconsulta: string | undefined;
    observacoes: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    tipoConsultaString: string | undefined;
    statusConsulta: StatusConsultaEnum;
    statusConsultaString: string | undefined;
    anexos: AnexoConsultaDto[] | undefined;
    pastaId: string | undefined;
    eventoId: string;
    agendaId: string;
    convenioId: string | undefined;
    convenio: ConvenioDto;
    observacaoPaciente: string | undefined;
    observacaoProfissional: string | undefined;
    endereco: EnderecoDto;
    pedidos: PedidoDto[] | undefined;
    hasPedidosPendentes: boolean;
    isDependente: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateSimplePacienteDto implements ICreateSimplePacienteDto {
    nome: string;
    cpf: string;
    email: string | undefined;
    celular: string | undefined;
    clinicaMedicaId: string | undefined;
    profissionalId: string | undefined;

    constructor(data?: ICreateSimplePacienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.profissionalId = _data["profissionalId"];
        }
    }

    static fromJS(data: any): CreateSimplePacienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSimplePacienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["profissionalId"] = this.profissionalId;
        return data;
    }

    clone(): CreateSimplePacienteDto {
        const json = this.toJSON();
        let result = new CreateSimplePacienteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSimplePacienteDto {
    nome: string;
    cpf: string;
    email: string | undefined;
    celular: string | undefined;
    clinicaMedicaId: string | undefined;
    profissionalId: string | undefined;
}

export class CreateConsultaDto implements ICreateConsultaDto {
    descricao: string;
    pacienteId: string | undefined;
    profissionalId: string;
    clinicaMedicaId: string | undefined;
    dataConsulta: moment.Moment;
    linkTeleconsulta: string | undefined;
    observacoes: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    statusConsulta: StatusConsultaEnum;
    agendaId: string;
    convenioId: string | undefined;
    anexos: AnexoConsultaDto[] | undefined;
    novoPaciente: CreateSimplePacienteDto;

    constructor(data?: ICreateConsultaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.pacienteId = _data["pacienteId"];
            this.profissionalId = _data["profissionalId"];
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.dataConsulta = _data["dataConsulta"] ? moment(_data["dataConsulta"].toString()) : <any>undefined;
            this.linkTeleconsulta = _data["linkTeleconsulta"];
            this.observacoes = _data["observacoes"];
            this.tipoConsulta = _data["tipoConsulta"];
            this.statusConsulta = _data["statusConsulta"];
            this.agendaId = _data["agendaId"];
            this.convenioId = _data["convenioId"];
            if (Array.isArray(_data["anexos"])) {
                this.anexos = [] as any;
                for (let item of _data["anexos"])
                    this.anexos.push(AnexoConsultaDto.fromJS(item));
            }
            this.novoPaciente = _data["novoPaciente"] ? CreateSimplePacienteDto.fromJS(_data["novoPaciente"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateConsultaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConsultaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["pacienteId"] = this.pacienteId;
        data["profissionalId"] = this.profissionalId;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["dataConsulta"] = this.dataConsulta ? this.dataConsulta.toISOString() : <any>undefined;
        data["linkTeleconsulta"] = this.linkTeleconsulta;
        data["observacoes"] = this.observacoes;
        data["tipoConsulta"] = this.tipoConsulta;
        data["statusConsulta"] = this.statusConsulta;
        data["agendaId"] = this.agendaId;
        data["convenioId"] = this.convenioId;
        if (Array.isArray(this.anexos)) {
            data["anexos"] = [];
            for (let item of this.anexos)
                data["anexos"].push(item.toJSON());
        }
        data["novoPaciente"] = this.novoPaciente ? this.novoPaciente.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateConsultaDto {
        const json = this.toJSON();
        let result = new CreateConsultaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateConsultaDto {
    descricao: string;
    pacienteId: string | undefined;
    profissionalId: string;
    clinicaMedicaId: string | undefined;
    dataConsulta: moment.Moment;
    linkTeleconsulta: string | undefined;
    observacoes: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    statusConsulta: StatusConsultaEnum;
    agendaId: string;
    convenioId: string | undefined;
    anexos: AnexoConsultaDto[] | undefined;
    novoPaciente: CreateSimplePacienteDto;
}

export enum FiltroConsultaEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ConsultaDtoPagedResultDto implements IConsultaDtoPagedResultDto {
    totalCount: number;
    items: ConsultaDto[] | undefined;

    constructor(data?: IConsultaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ConsultaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsultaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConsultaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ConsultaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IConsultaDtoPagedResultDto {
    totalCount: number;
    items: ConsultaDto[] | undefined;
}

export class UpdateConsultaDto implements IUpdateConsultaDto {
    descricao: string;
    pacienteId: string;
    paciente: PacienteGroupDto;
    profissionalId: string;
    profissionalSaude: EssentialProfisisonalSaudeDto;
    clinicaMedicaId: string | undefined;
    dataConsulta: moment.Moment;
    linkTeleconsulta: string | undefined;
    observacoes: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    readonly tipoConsultaString: string | undefined;
    statusConsulta: StatusConsultaEnum;
    readonly statusConsultaString: string | undefined;
    anexos: AnexoConsultaDto[] | undefined;
    novosAnexos: AnexoConsultaDto[] | undefined;
    anexosRemovidos: AnexoConsultaDto[] | undefined;
    pastaId: string | undefined;
    eventoId: string;
    agendaId: string;
    convenioId: string | undefined;
    observacaoPaciente: string | undefined;
    observacaoProfissional: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdateConsultaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? PacienteGroupDto.fromJS(_data["paciente"]) : <any>undefined;
            this.profissionalId = _data["profissionalId"];
            this.profissionalSaude = _data["profissionalSaude"] ? EssentialProfisisonalSaudeDto.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.dataConsulta = _data["dataConsulta"] ? moment(_data["dataConsulta"].toString()) : <any>undefined;
            this.linkTeleconsulta = _data["linkTeleconsulta"];
            this.observacoes = _data["observacoes"];
            this.tipoConsulta = _data["tipoConsulta"];
            (<any>this).tipoConsultaString = _data["tipoConsultaString"];
            this.statusConsulta = _data["statusConsulta"];
            (<any>this).statusConsultaString = _data["statusConsultaString"];
            if (Array.isArray(_data["anexos"])) {
                this.anexos = [] as any;
                for (let item of _data["anexos"])
                    this.anexos.push(AnexoConsultaDto.fromJS(item));
            }
            if (Array.isArray(_data["novosAnexos"])) {
                this.novosAnexos = [] as any;
                for (let item of _data["novosAnexos"])
                    this.novosAnexos.push(AnexoConsultaDto.fromJS(item));
            }
            if (Array.isArray(_data["anexosRemovidos"])) {
                this.anexosRemovidos = [] as any;
                for (let item of _data["anexosRemovidos"])
                    this.anexosRemovidos.push(AnexoConsultaDto.fromJS(item));
            }
            this.pastaId = _data["pastaId"];
            this.eventoId = _data["eventoId"];
            this.agendaId = _data["agendaId"];
            this.convenioId = _data["convenioId"];
            this.observacaoPaciente = _data["observacaoPaciente"];
            this.observacaoProfissional = _data["observacaoProfissional"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateConsultaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConsultaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["profissionalId"] = this.profissionalId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["dataConsulta"] = this.dataConsulta ? this.dataConsulta.toISOString() : <any>undefined;
        data["linkTeleconsulta"] = this.linkTeleconsulta;
        data["observacoes"] = this.observacoes;
        data["tipoConsulta"] = this.tipoConsulta;
        data["tipoConsultaString"] = this.tipoConsultaString;
        data["statusConsulta"] = this.statusConsulta;
        data["statusConsultaString"] = this.statusConsultaString;
        if (Array.isArray(this.anexos)) {
            data["anexos"] = [];
            for (let item of this.anexos)
                data["anexos"].push(item.toJSON());
        }
        if (Array.isArray(this.novosAnexos)) {
            data["novosAnexos"] = [];
            for (let item of this.novosAnexos)
                data["novosAnexos"].push(item.toJSON());
        }
        if (Array.isArray(this.anexosRemovidos)) {
            data["anexosRemovidos"] = [];
            for (let item of this.anexosRemovidos)
                data["anexosRemovidos"].push(item.toJSON());
        }
        data["pastaId"] = this.pastaId;
        data["eventoId"] = this.eventoId;
        data["agendaId"] = this.agendaId;
        data["convenioId"] = this.convenioId;
        data["observacaoPaciente"] = this.observacaoPaciente;
        data["observacaoProfissional"] = this.observacaoProfissional;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateConsultaDto {
        const json = this.toJSON();
        let result = new UpdateConsultaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateConsultaDto {
    descricao: string;
    pacienteId: string;
    paciente: PacienteGroupDto;
    profissionalId: string;
    profissionalSaude: EssentialProfisisonalSaudeDto;
    clinicaMedicaId: string | undefined;
    dataConsulta: moment.Moment;
    linkTeleconsulta: string | undefined;
    observacoes: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    tipoConsultaString: string | undefined;
    statusConsulta: StatusConsultaEnum;
    statusConsultaString: string | undefined;
    anexos: AnexoConsultaDto[] | undefined;
    novosAnexos: AnexoConsultaDto[] | undefined;
    anexosRemovidos: AnexoConsultaDto[] | undefined;
    pastaId: string | undefined;
    eventoId: string;
    agendaId: string;
    convenioId: string | undefined;
    observacaoPaciente: string | undefined;
    observacaoProfissional: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class VideoSessionDto implements IVideoSessionDto {
    sessionId: string | undefined;
    token: string | undefined;
    applicationId: string | undefined;

    constructor(data?: IVideoSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.token = _data["token"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): VideoSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["token"] = this.token;
        data["applicationId"] = this.applicationId;
        return data;
    }

    clone(): VideoSessionDto {
        const json = this.toJSON();
        let result = new VideoSessionDto();
        result.init(json);
        return result;
    }
}

export interface IVideoSessionDto {
    sessionId: string | undefined;
    token: string | undefined;
    applicationId: string | undefined;
}

export class PagedConsultasResultRequestDto implements IPagedConsultasResultRequestDto {
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    nomeProfissional: string | undefined;
    nomePaciente: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    statusConsulta: StatusConsultaEnum;
    pacienteId: string | undefined;
    profissionalId: string | undefined;
    clinicaId: string | undefined;
    proximasConsultas: boolean;
    filtro: FiltroConsultaEnum;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IPagedConsultasResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.nomeProfissional = _data["nomeProfissional"];
            this.nomePaciente = _data["nomePaciente"];
            this.tipoConsulta = _data["tipoConsulta"];
            this.statusConsulta = _data["statusConsulta"];
            this.pacienteId = _data["pacienteId"];
            this.profissionalId = _data["profissionalId"];
            this.clinicaId = _data["clinicaId"];
            this.proximasConsultas = _data["proximasConsultas"];
            this.filtro = _data["filtro"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): PagedConsultasResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedConsultasResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["nomeProfissional"] = this.nomeProfissional;
        data["nomePaciente"] = this.nomePaciente;
        data["tipoConsulta"] = this.tipoConsulta;
        data["statusConsulta"] = this.statusConsulta;
        data["pacienteId"] = this.pacienteId;
        data["profissionalId"] = this.profissionalId;
        data["clinicaId"] = this.clinicaId;
        data["proximasConsultas"] = this.proximasConsultas;
        data["filtro"] = this.filtro;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }

    clone(): PagedConsultasResultRequestDto {
        const json = this.toJSON();
        let result = new PagedConsultasResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedConsultasResultRequestDto {
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    nomeProfissional: string | undefined;
    nomePaciente: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    statusConsulta: StatusConsultaEnum;
    pacienteId: string | undefined;
    profissionalId: string | undefined;
    clinicaId: string | undefined;
    proximasConsultas: boolean;
    filtro: FiltroConsultaEnum;
    skipCount: number;
    maxResultCount: number;
}

export class UpdateObservacaoDto implements IUpdateObservacaoDto {
    consultaId: string;
    observacaoProfissional: string | undefined;
    observacaoPaciente: string | undefined;
    id: string;

    constructor(data?: IUpdateObservacaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultaId = _data["consultaId"];
            this.observacaoProfissional = _data["observacaoProfissional"];
            this.observacaoPaciente = _data["observacaoPaciente"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateObservacaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateObservacaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultaId"] = this.consultaId;
        data["observacaoProfissional"] = this.observacaoProfissional;
        data["observacaoPaciente"] = this.observacaoPaciente;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateObservacaoDto {
        const json = this.toJSON();
        let result = new UpdateObservacaoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateObservacaoDto {
    consultaId: string;
    observacaoProfissional: string | undefined;
    observacaoPaciente: string | undefined;
    id: string;
}

export class ObservacaoDto implements IObservacaoDto {
    consultaId: string;
    observacaoProfissional: string | undefined;
    observacaoPaciente: string | undefined;
    dataConsulta: moment.Moment;

    constructor(data?: IObservacaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultaId = _data["consultaId"];
            this.observacaoProfissional = _data["observacaoProfissional"];
            this.observacaoPaciente = _data["observacaoPaciente"];
            this.dataConsulta = _data["dataConsulta"] ? moment(_data["dataConsulta"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ObservacaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservacaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultaId"] = this.consultaId;
        data["observacaoProfissional"] = this.observacaoProfissional;
        data["observacaoPaciente"] = this.observacaoPaciente;
        data["dataConsulta"] = this.dataConsulta ? this.dataConsulta.toISOString() : <any>undefined;
        return data;
    }

    clone(): ObservacaoDto {
        const json = this.toJSON();
        let result = new ObservacaoDto();
        result.init(json);
        return result;
    }
}

export interface IObservacaoDto {
    consultaId: string;
    observacaoProfissional: string | undefined;
    observacaoPaciente: string | undefined;
    dataConsulta: moment.Moment;
}

export class SolicitarExameDto implements ISolicitarExameDto {
    consultaId: string;
    nome: string | undefined;

    constructor(data?: ISolicitarExameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultaId = _data["consultaId"];
            this.nome = _data["nome"];
        }
    }

    static fromJS(data: any): SolicitarExameDto {
        data = typeof data === 'object' ? data : {};
        let result = new SolicitarExameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultaId"] = this.consultaId;
        data["nome"] = this.nome;
        return data;
    }

    clone(): SolicitarExameDto {
        const json = this.toJSON();
        let result = new SolicitarExameDto();
        result.init(json);
        return result;
    }
}

export interface ISolicitarExameDto {
    consultaId: string;
    nome: string | undefined;
}

export class AnexarExameDto implements IAnexarExameDto {
    solicitacaoId: string | undefined;
    consultaId: string;
    base64File: string | undefined;
    fileNameWithOutExtension: string | undefined;
    extension: string | undefined;
    tipoArquivo: string | undefined;
    tamanhoArquivo: number;

    constructor(data?: IAnexarExameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solicitacaoId = _data["solicitacaoId"];
            this.consultaId = _data["consultaId"];
            this.base64File = _data["base64File"];
            this.fileNameWithOutExtension = _data["fileNameWithOutExtension"];
            this.extension = _data["extension"];
            this.tipoArquivo = _data["tipoArquivo"];
            this.tamanhoArquivo = _data["tamanhoArquivo"];
        }
    }

    static fromJS(data: any): AnexarExameDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnexarExameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solicitacaoId"] = this.solicitacaoId;
        data["consultaId"] = this.consultaId;
        data["base64File"] = this.base64File;
        data["fileNameWithOutExtension"] = this.fileNameWithOutExtension;
        data["extension"] = this.extension;
        data["tipoArquivo"] = this.tipoArquivo;
        data["tamanhoArquivo"] = this.tamanhoArquivo;
        return data;
    }

    clone(): AnexarExameDto {
        const json = this.toJSON();
        let result = new AnexarExameDto();
        result.init(json);
        return result;
    }
}

export interface IAnexarExameDto {
    solicitacaoId: string | undefined;
    consultaId: string;
    base64File: string | undefined;
    fileNameWithOutExtension: string | undefined;
    extension: string | undefined;
    tipoArquivo: string | undefined;
    tamanhoArquivo: number;
}

export class AnexarPrescricaoDto implements IAnexarPrescricaoDto {
    consultaId: string;
    base64File: string | undefined;
    fileNameWithOutExtension: string | undefined;
    extension: string | undefined;
    tipoArquivo: string | undefined;
    tamanhoArquivo: number;

    constructor(data?: IAnexarPrescricaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultaId = _data["consultaId"];
            this.base64File = _data["base64File"];
            this.fileNameWithOutExtension = _data["fileNameWithOutExtension"];
            this.extension = _data["extension"];
            this.tipoArquivo = _data["tipoArquivo"];
            this.tamanhoArquivo = _data["tamanhoArquivo"];
        }
    }

    static fromJS(data: any): AnexarPrescricaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnexarPrescricaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultaId"] = this.consultaId;
        data["base64File"] = this.base64File;
        data["fileNameWithOutExtension"] = this.fileNameWithOutExtension;
        data["extension"] = this.extension;
        data["tipoArquivo"] = this.tipoArquivo;
        data["tamanhoArquivo"] = this.tamanhoArquivo;
        return data;
    }

    clone(): AnexarPrescricaoDto {
        const json = this.toJSON();
        let result = new AnexarPrescricaoDto();
        result.init(json);
        return result;
    }
}

export interface IAnexarPrescricaoDto {
    consultaId: string;
    base64File: string | undefined;
    fileNameWithOutExtension: string | undefined;
    extension: string | undefined;
    tipoArquivo: string | undefined;
    tamanhoArquivo: number;
}

export class CreateConvenioDto implements ICreateConvenioDto {
    registroAns: string | undefined;
    cnpj: string;
    razaoSocial: string;
    nomeFantasia: string | undefined;
    autoGestao: boolean;
    ddd: string | undefined;
    telefone: string | undefined;
    fax: string | undefined;
    email: string;
    representante: string;
    cargoRepresentante: string;
    dataRegistroAns: moment.Moment | undefined;
    endereco: CreateEnderecoDto;

    constructor(data?: ICreateConvenioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registroAns = _data["registroAns"];
            this.cnpj = _data["cnpj"];
            this.razaoSocial = _data["razaoSocial"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.autoGestao = _data["autoGestao"];
            this.ddd = _data["ddd"];
            this.telefone = _data["telefone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.representante = _data["representante"];
            this.cargoRepresentante = _data["cargoRepresentante"];
            this.dataRegistroAns = _data["dataRegistroAns"] ? moment(_data["dataRegistroAns"].toString()) : <any>undefined;
            this.endereco = _data["endereco"] ? CreateEnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateConvenioDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConvenioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registroAns"] = this.registroAns;
        data["cnpj"] = this.cnpj;
        data["razaoSocial"] = this.razaoSocial;
        data["nomeFantasia"] = this.nomeFantasia;
        data["autoGestao"] = this.autoGestao;
        data["ddd"] = this.ddd;
        data["telefone"] = this.telefone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["representante"] = this.representante;
        data["cargoRepresentante"] = this.cargoRepresentante;
        data["dataRegistroAns"] = this.dataRegistroAns ? this.dataRegistroAns.toISOString() : <any>undefined;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateConvenioDto {
        const json = this.toJSON();
        let result = new CreateConvenioDto();
        result.init(json);
        return result;
    }
}

export interface ICreateConvenioDto {
    registroAns: string | undefined;
    cnpj: string;
    razaoSocial: string;
    nomeFantasia: string | undefined;
    autoGestao: boolean;
    ddd: string | undefined;
    telefone: string | undefined;
    fax: string | undefined;
    email: string;
    representante: string;
    cargoRepresentante: string;
    dataRegistroAns: moment.Moment | undefined;
    endereco: CreateEnderecoDto;
}

export class ConvenioDtoPagedResultDto implements IConvenioDtoPagedResultDto {
    totalCount: number;
    items: ConvenioDto[] | undefined;

    constructor(data?: IConvenioDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ConvenioDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConvenioDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvenioDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConvenioDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ConvenioDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IConvenioDtoPagedResultDto {
    totalCount: number;
    items: ConvenioDto[] | undefined;
}

export class UpdateConvenioDto implements IUpdateConvenioDto {
    registroAns: string | undefined;
    cnpj: string;
    razaoSocial: string;
    nomeFantasia: string | undefined;
    autoGestao: boolean;
    ddd: string | undefined;
    telefone: string | undefined;
    fax: string | undefined;
    email: string;
    representante: string;
    cargoRepresentante: string;
    dataRegistroAns: moment.Moment | undefined;
    enderecoId: string;
    endereco: UpdateEnderecoDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdateConvenioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registroAns = _data["registroAns"];
            this.cnpj = _data["cnpj"];
            this.razaoSocial = _data["razaoSocial"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.autoGestao = _data["autoGestao"];
            this.ddd = _data["ddd"];
            this.telefone = _data["telefone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.representante = _data["representante"];
            this.cargoRepresentante = _data["cargoRepresentante"];
            this.dataRegistroAns = _data["dataRegistroAns"] ? moment(_data["dataRegistroAns"].toString()) : <any>undefined;
            this.enderecoId = _data["enderecoId"];
            this.endereco = _data["endereco"] ? UpdateEnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateConvenioDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConvenioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registroAns"] = this.registroAns;
        data["cnpj"] = this.cnpj;
        data["razaoSocial"] = this.razaoSocial;
        data["nomeFantasia"] = this.nomeFantasia;
        data["autoGestao"] = this.autoGestao;
        data["ddd"] = this.ddd;
        data["telefone"] = this.telefone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["representante"] = this.representante;
        data["cargoRepresentante"] = this.cargoRepresentante;
        data["dataRegistroAns"] = this.dataRegistroAns ? this.dataRegistroAns.toISOString() : <any>undefined;
        data["enderecoId"] = this.enderecoId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateConvenioDto {
        const json = this.toJSON();
        let result = new UpdateConvenioDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateConvenioDto {
    registroAns: string | undefined;
    cnpj: string;
    razaoSocial: string;
    nomeFantasia: string | undefined;
    autoGestao: boolean;
    ddd: string | undefined;
    telefone: string | undefined;
    fax: string | undefined;
    email: string;
    representante: string;
    cargoRepresentante: string;
    dataRegistroAns: moment.Moment | undefined;
    enderecoId: string;
    endereco: UpdateEnderecoDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class DadosEmpresaDto implements IDadosEmpresaDto {
    nomeFantasia: string | undefined;
    razaoSocial: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    ddd: string | undefined;

    constructor(data?: IDadosEmpresaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomeFantasia = _data["nomeFantasia"];
            this.razaoSocial = _data["razaoSocial"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.ddd = _data["ddd"];
        }
    }

    static fromJS(data: any): DadosEmpresaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DadosEmpresaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeFantasia"] = this.nomeFantasia;
        data["razaoSocial"] = this.razaoSocial;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["ddd"] = this.ddd;
        return data;
    }

    clone(): DadosEmpresaDto {
        const json = this.toJSON();
        let result = new DadosEmpresaDto();
        result.init(json);
        return result;
    }
}

export interface IDadosEmpresaDto {
    nomeFantasia: string | undefined;
    razaoSocial: string | undefined;
    email: string | undefined;
    telefone: string | undefined;
    ddd: string | undefined;
}

export class CreatePagamentoCustoAdicionalDto implements ICreatePagamentoCustoAdicionalDto {
    custoAdicionalId: string;
    tipoPagamento: TipoPagamentoEnum;
    cartaoCredito: CartaoCreditoDto;
    ehAnual: boolean;
    endereco: EnderecoAssinaturaDto;

    constructor(data?: ICreatePagamentoCustoAdicionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.custoAdicionalId = _data["custoAdicionalId"];
            this.tipoPagamento = _data["tipoPagamento"];
            this.cartaoCredito = _data["cartaoCredito"] ? CartaoCreditoDto.fromJS(_data["cartaoCredito"]) : <any>undefined;
            this.ehAnual = _data["ehAnual"];
            this.endereco = _data["endereco"] ? EnderecoAssinaturaDto.fromJS(_data["endereco"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePagamentoCustoAdicionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePagamentoCustoAdicionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["custoAdicionalId"] = this.custoAdicionalId;
        data["tipoPagamento"] = this.tipoPagamento;
        data["cartaoCredito"] = this.cartaoCredito ? this.cartaoCredito.toJSON() : <any>undefined;
        data["ehAnual"] = this.ehAnual;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatePagamentoCustoAdicionalDto {
        const json = this.toJSON();
        let result = new CreatePagamentoCustoAdicionalDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePagamentoCustoAdicionalDto {
    custoAdicionalId: string;
    tipoPagamento: TipoPagamentoEnum;
    cartaoCredito: CartaoCreditoDto;
    ehAnual: boolean;
    endereco: EnderecoAssinaturaDto;
}

export class CustoAdicionalMensalDto implements ICustoAdicionalMensalDto {
    valor: number;
    dataInicio: moment.Moment;
    dataFim: moment.Moment;
    userId: number;
    status: string | undefined;
    mercadoPagoId: string | undefined;
    pago: boolean;
    qrCode: string | undefined;
    qrCodeBase64: string | undefined;
    boletoUrl: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICustoAdicionalMensalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valor = _data["valor"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.mercadoPagoId = _data["mercadoPagoId"];
            this.pago = _data["pago"];
            this.qrCode = _data["qrCode"];
            this.qrCodeBase64 = _data["qrCodeBase64"];
            this.boletoUrl = _data["boletoUrl"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustoAdicionalMensalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustoAdicionalMensalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valor"] = this.valor;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["mercadoPagoId"] = this.mercadoPagoId;
        data["pago"] = this.pago;
        data["qrCode"] = this.qrCode;
        data["qrCodeBase64"] = this.qrCodeBase64;
        data["boletoUrl"] = this.boletoUrl;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CustoAdicionalMensalDto {
        const json = this.toJSON();
        let result = new CustoAdicionalMensalDto();
        result.init(json);
        return result;
    }
}

export interface ICustoAdicionalMensalDto {
    valor: number;
    dataInicio: moment.Moment;
    dataFim: moment.Moment;
    userId: number;
    status: string | undefined;
    mercadoPagoId: string | undefined;
    pago: boolean;
    qrCode: string | undefined;
    qrCodeBase64: string | undefined;
    boletoUrl: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CustoAdicionalMensalDtoPagedResultDto implements ICustoAdicionalMensalDtoPagedResultDto {
    totalCount: number;
    items: CustoAdicionalMensalDto[] | undefined;

    constructor(data?: ICustoAdicionalMensalDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustoAdicionalMensalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustoAdicionalMensalDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustoAdicionalMensalDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustoAdicionalMensalDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustoAdicionalMensalDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustoAdicionalMensalDtoPagedResultDto {
    totalCount: number;
    items: CustoAdicionalMensalDto[] | undefined;
}

export enum NivelDorEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CreateDorArticularDto implements ICreateDorArticularDto {
    ondeOcorre: string;
    nivelDor: number;
    tipoDor: NivelDorEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateDorArticularDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ondeOcorre = _data["ondeOcorre"];
            this.nivelDor = _data["nivelDor"];
            this.tipoDor = _data["tipoDor"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateDorArticularDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDorArticularDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ondeOcorre"] = this.ondeOcorre;
        data["nivelDor"] = this.nivelDor;
        data["tipoDor"] = this.tipoDor;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateDorArticularDto {
        const json = this.toJSON();
        let result = new CreateDorArticularDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDorArticularDto {
    ondeOcorre: string;
    nivelDor: number;
    tipoDor: NivelDorEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class DorArticularDto implements IDorArticularDto {
    ondeOcorre: string;
    nivelDor: number;
    tipoDor: NivelDorEnum;
    readonly tipoDorString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IDorArticularDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ondeOcorre = _data["ondeOcorre"];
            this.nivelDor = _data["nivelDor"];
            this.tipoDor = _data["tipoDor"];
            (<any>this).tipoDorString = _data["tipoDorString"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DorArticularDto {
        data = typeof data === 'object' ? data : {};
        let result = new DorArticularDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ondeOcorre"] = this.ondeOcorre;
        data["nivelDor"] = this.nivelDor;
        data["tipoDor"] = this.tipoDor;
        data["tipoDorString"] = this.tipoDorString;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): DorArticularDto {
        const json = this.toJSON();
        let result = new DorArticularDto();
        result.init(json);
        return result;
    }
}

export interface IDorArticularDto {
    ondeOcorre: string;
    nivelDor: number;
    tipoDor: NivelDorEnum;
    tipoDorString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class UpdateDorArticularDto implements IUpdateDorArticularDto {
    ondeOcorre: string;
    nivelDor: number;
    tipoDor: NivelDorEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateDorArticularDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ondeOcorre = _data["ondeOcorre"];
            this.nivelDor = _data["nivelDor"];
            this.tipoDor = _data["tipoDor"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateDorArticularDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDorArticularDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ondeOcorre"] = this.ondeOcorre;
        data["nivelDor"] = this.nivelDor;
        data["tipoDor"] = this.tipoDor;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateDorArticularDto {
        const json = this.toJSON();
        let result = new UpdateDorArticularDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDorArticularDto {
    ondeOcorre: string;
    nivelDor: number;
    tipoDor: NivelDorEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class DorArticularDtoPagedResultDto implements IDorArticularDtoPagedResultDto {
    totalCount: number;
    items: DorArticularDto[] | undefined;

    constructor(data?: IDorArticularDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DorArticularDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DorArticularDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DorArticularDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): DorArticularDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DorArticularDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDorArticularDtoPagedResultDto {
    totalCount: number;
    items: DorArticularDto[] | undefined;
}

export class EnumDto implements IEnumDto {
    value: number;
    name: string | undefined;

    constructor(data?: IEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }

    clone(): EnumDto {
        const json = this.toJSON();
        let result = new EnumDto();
        result.init(json);
        return result;
    }
}

export interface IEnumDto {
    value: number;
    name: string | undefined;
}

export class EnumDtoListResultDto implements IEnumDtoListResultDto {
    items: EnumDto[] | undefined;

    constructor(data?: IEnumDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EnumDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnumDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): EnumDtoListResultDto {
        const json = this.toJSON();
        let result = new EnumDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IEnumDtoListResultDto {
    items: EnumDto[] | undefined;
}

export class CreateEquipeClinicaDto implements ICreateEquipeClinicaDto {
    clinicaMedicaId: string;
    nome: string;
    descricao: string;
    especialidade: string | undefined;
    ativo: boolean;
    liderId: string;
    profissionais: string[] | undefined;

    constructor(data?: ICreateEquipeClinicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.nome = _data["nome"];
            this.descricao = _data["descricao"];
            this.especialidade = _data["especialidade"];
            this.ativo = _data["ativo"];
            this.liderId = _data["liderId"];
            if (Array.isArray(_data["profissionais"])) {
                this.profissionais = [] as any;
                for (let item of _data["profissionais"])
                    this.profissionais.push(item);
            }
        }
    }

    static fromJS(data: any): CreateEquipeClinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEquipeClinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["nome"] = this.nome;
        data["descricao"] = this.descricao;
        data["especialidade"] = this.especialidade;
        data["ativo"] = this.ativo;
        data["liderId"] = this.liderId;
        if (Array.isArray(this.profissionais)) {
            data["profissionais"] = [];
            for (let item of this.profissionais)
                data["profissionais"].push(item);
        }
        return data;
    }

    clone(): CreateEquipeClinicaDto {
        const json = this.toJSON();
        let result = new CreateEquipeClinicaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEquipeClinicaDto {
    clinicaMedicaId: string;
    nome: string;
    descricao: string;
    especialidade: string | undefined;
    ativo: boolean;
    liderId: string;
    profissionais: string[] | undefined;
}

export class EquipeClinicaDtoPagedResultDto implements IEquipeClinicaDtoPagedResultDto {
    totalCount: number;
    items: EquipeClinicaDto[] | undefined;

    constructor(data?: IEquipeClinicaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EquipeClinicaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EquipeClinicaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipeClinicaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): EquipeClinicaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EquipeClinicaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEquipeClinicaDtoPagedResultDto {
    totalCount: number;
    items: EquipeClinicaDto[] | undefined;
}

export class UpdateEquipeClinicaDto implements IUpdateEquipeClinicaDto {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedicaDto;
    nome: string;
    descricao: string;
    especialidade: string | undefined;
    ativo: boolean;
    liderId: string;
    novosProfissionais: EquipeProfissionalDto[] | undefined;
    profissionaisRemovidos: EquipeProfissionalDto[] | undefined;
    profissionais: EquipeProfissionalDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdateEquipeClinicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.clinicaMedica = _data["clinicaMedica"] ? ClinicaMedicaDto.fromJS(_data["clinicaMedica"]) : <any>undefined;
            this.nome = _data["nome"];
            this.descricao = _data["descricao"];
            this.especialidade = _data["especialidade"];
            this.ativo = _data["ativo"];
            this.liderId = _data["liderId"];
            if (Array.isArray(_data["novosProfissionais"])) {
                this.novosProfissionais = [] as any;
                for (let item of _data["novosProfissionais"])
                    this.novosProfissionais.push(EquipeProfissionalDto.fromJS(item));
            }
            if (Array.isArray(_data["profissionaisRemovidos"])) {
                this.profissionaisRemovidos = [] as any;
                for (let item of _data["profissionaisRemovidos"])
                    this.profissionaisRemovidos.push(EquipeProfissionalDto.fromJS(item));
            }
            if (Array.isArray(_data["profissionais"])) {
                this.profissionais = [] as any;
                for (let item of _data["profissionais"])
                    this.profissionais.push(EquipeProfissionalDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEquipeClinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEquipeClinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["clinicaMedica"] = this.clinicaMedica ? this.clinicaMedica.toJSON() : <any>undefined;
        data["nome"] = this.nome;
        data["descricao"] = this.descricao;
        data["especialidade"] = this.especialidade;
        data["ativo"] = this.ativo;
        data["liderId"] = this.liderId;
        if (Array.isArray(this.novosProfissionais)) {
            data["novosProfissionais"] = [];
            for (let item of this.novosProfissionais)
                data["novosProfissionais"].push(item.toJSON());
        }
        if (Array.isArray(this.profissionaisRemovidos)) {
            data["profissionaisRemovidos"] = [];
            for (let item of this.profissionaisRemovidos)
                data["profissionaisRemovidos"].push(item.toJSON());
        }
        if (Array.isArray(this.profissionais)) {
            data["profissionais"] = [];
            for (let item of this.profissionais)
                data["profissionais"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateEquipeClinicaDto {
        const json = this.toJSON();
        let result = new UpdateEquipeClinicaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEquipeClinicaDto {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedicaDto;
    nome: string;
    descricao: string;
    especialidade: string | undefined;
    ativo: boolean;
    liderId: string;
    novosProfissionais: EquipeProfissionalDto[] | undefined;
    profissionaisRemovidos: EquipeProfissionalDto[] | undefined;
    profissionais: EquipeProfissionalDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum TipoEvento {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class EventoDto implements IEventoDto {
    titulo: string | undefined;
    descricao: string | undefined;
    clinicaId: string | undefined;
    profissionalId: string | undefined;
    recorrenciaId: string | undefined;
    ehRecorrente: boolean;
    inicio: moment.Moment;
    fim: moment.Moment;
    tipo: TipoEvento;
    criadoAutomaticamente: boolean;
    consulta: ConsultaDto;
    id: string;

    constructor(data?: IEventoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titulo = _data["titulo"];
            this.descricao = _data["descricao"];
            this.clinicaId = _data["clinicaId"];
            this.profissionalId = _data["profissionalId"];
            this.recorrenciaId = _data["recorrenciaId"];
            this.ehRecorrente = _data["ehRecorrente"];
            this.inicio = _data["inicio"] ? moment(_data["inicio"].toString()) : <any>undefined;
            this.fim = _data["fim"] ? moment(_data["fim"].toString()) : <any>undefined;
            this.tipo = _data["tipo"];
            this.criadoAutomaticamente = _data["criadoAutomaticamente"];
            this.consulta = _data["consulta"] ? ConsultaDto.fromJS(_data["consulta"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titulo"] = this.titulo;
        data["descricao"] = this.descricao;
        data["clinicaId"] = this.clinicaId;
        data["profissionalId"] = this.profissionalId;
        data["recorrenciaId"] = this.recorrenciaId;
        data["ehRecorrente"] = this.ehRecorrente;
        data["inicio"] = this.inicio ? this.inicio.toISOString() : <any>undefined;
        data["fim"] = this.fim ? this.fim.toISOString() : <any>undefined;
        data["tipo"] = this.tipo;
        data["criadoAutomaticamente"] = this.criadoAutomaticamente;
        data["consulta"] = this.consulta ? this.consulta.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): EventoDto {
        const json = this.toJSON();
        let result = new EventoDto();
        result.init(json);
        return result;
    }
}

export interface IEventoDto {
    titulo: string | undefined;
    descricao: string | undefined;
    clinicaId: string | undefined;
    profissionalId: string | undefined;
    recorrenciaId: string | undefined;
    ehRecorrente: boolean;
    inicio: moment.Moment;
    fim: moment.Moment;
    tipo: TipoEvento;
    criadoAutomaticamente: boolean;
    consulta: ConsultaDto;
    id: string;
}

export class EventoDtoPagedResultDto implements IEventoDtoPagedResultDto {
    totalCount: number;
    items: EventoDto[] | undefined;

    constructor(data?: IEventoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EventoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): EventoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EventoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEventoDtoPagedResultDto {
    totalCount: number;
    items: EventoDto[] | undefined;
}

export enum TipoRecorrencia {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class CreateEventoDto implements ICreateEventoDto {
    agendaId: string;
    clinicaId: string | undefined;
    profissionalId: string | undefined;
    pacienteId: string | undefined;
    titulo: string | undefined;
    descricao: string | undefined;
    inicio: moment.Moment;
    fim: moment.Moment;
    tipo: TipoEvento;
    ehRecorrente: boolean;
    tipoRecorrencia: TipoRecorrencia;
    diasDaSemana: DayOfWeek[] | undefined;
    dataFimRecorrencia: moment.Moment | undefined;
    ignorarEventosExistentes: boolean;

    constructor(data?: ICreateEventoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agendaId = _data["agendaId"];
            this.clinicaId = _data["clinicaId"];
            this.profissionalId = _data["profissionalId"];
            this.pacienteId = _data["pacienteId"];
            this.titulo = _data["titulo"];
            this.descricao = _data["descricao"];
            this.inicio = _data["inicio"] ? moment(_data["inicio"].toString()) : <any>undefined;
            this.fim = _data["fim"] ? moment(_data["fim"].toString()) : <any>undefined;
            this.tipo = _data["tipo"];
            this.ehRecorrente = _data["ehRecorrente"];
            this.tipoRecorrencia = _data["tipoRecorrencia"];
            if (Array.isArray(_data["diasDaSemana"])) {
                this.diasDaSemana = [] as any;
                for (let item of _data["diasDaSemana"])
                    this.diasDaSemana.push(item);
            }
            this.dataFimRecorrencia = _data["dataFimRecorrencia"] ? moment(_data["dataFimRecorrencia"].toString()) : <any>undefined;
            this.ignorarEventosExistentes = _data["ignorarEventosExistentes"];
        }
    }

    static fromJS(data: any): CreateEventoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agendaId"] = this.agendaId;
        data["clinicaId"] = this.clinicaId;
        data["profissionalId"] = this.profissionalId;
        data["pacienteId"] = this.pacienteId;
        data["titulo"] = this.titulo;
        data["descricao"] = this.descricao;
        data["inicio"] = this.inicio ? this.inicio.toISOString() : <any>undefined;
        data["fim"] = this.fim ? this.fim.toISOString() : <any>undefined;
        data["tipo"] = this.tipo;
        data["ehRecorrente"] = this.ehRecorrente;
        data["tipoRecorrencia"] = this.tipoRecorrencia;
        if (Array.isArray(this.diasDaSemana)) {
            data["diasDaSemana"] = [];
            for (let item of this.diasDaSemana)
                data["diasDaSemana"].push(item);
        }
        data["dataFimRecorrencia"] = this.dataFimRecorrencia ? this.dataFimRecorrencia.toISOString() : <any>undefined;
        data["ignorarEventosExistentes"] = this.ignorarEventosExistentes;
        return data;
    }

    clone(): CreateEventoDto {
        const json = this.toJSON();
        let result = new CreateEventoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEventoDto {
    agendaId: string;
    clinicaId: string | undefined;
    profissionalId: string | undefined;
    pacienteId: string | undefined;
    titulo: string | undefined;
    descricao: string | undefined;
    inicio: moment.Moment;
    fim: moment.Moment;
    tipo: TipoEvento;
    ehRecorrente: boolean;
    tipoRecorrencia: TipoRecorrencia;
    diasDaSemana: DayOfWeek[] | undefined;
    dataFimRecorrencia: moment.Moment | undefined;
    ignorarEventosExistentes: boolean;
}

export class UpdateEventoDto implements IUpdateEventoDto {
    titulo: string | undefined;
    descricao: string | undefined;
    inicio: moment.Moment;
    fim: moment.Moment;
    tipo: TipoEvento;
    ehRecorrente: boolean;
    tipoRecorrencia: TipoRecorrencia;
    diasDaSemana: DayOfWeek[] | undefined;
    dataFimRecorrencia: moment.Moment | undefined;
    id: string;

    constructor(data?: IUpdateEventoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titulo = _data["titulo"];
            this.descricao = _data["descricao"];
            this.inicio = _data["inicio"] ? moment(_data["inicio"].toString()) : <any>undefined;
            this.fim = _data["fim"] ? moment(_data["fim"].toString()) : <any>undefined;
            this.tipo = _data["tipo"];
            this.ehRecorrente = _data["ehRecorrente"];
            this.tipoRecorrencia = _data["tipoRecorrencia"];
            if (Array.isArray(_data["diasDaSemana"])) {
                this.diasDaSemana = [] as any;
                for (let item of _data["diasDaSemana"])
                    this.diasDaSemana.push(item);
            }
            this.dataFimRecorrencia = _data["dataFimRecorrencia"] ? moment(_data["dataFimRecorrencia"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEventoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titulo"] = this.titulo;
        data["descricao"] = this.descricao;
        data["inicio"] = this.inicio ? this.inicio.toISOString() : <any>undefined;
        data["fim"] = this.fim ? this.fim.toISOString() : <any>undefined;
        data["tipo"] = this.tipo;
        data["ehRecorrente"] = this.ehRecorrente;
        data["tipoRecorrencia"] = this.tipoRecorrencia;
        if (Array.isArray(this.diasDaSemana)) {
            data["diasDaSemana"] = [];
            for (let item of this.diasDaSemana)
                data["diasDaSemana"].push(item);
        }
        data["dataFimRecorrencia"] = this.dataFimRecorrencia ? this.dataFimRecorrencia.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateEventoDto {
        const json = this.toJSON();
        let result = new UpdateEventoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEventoDto {
    titulo: string | undefined;
    descricao: string | undefined;
    inicio: moment.Moment;
    fim: moment.Moment;
    tipo: TipoEvento;
    ehRecorrente: boolean;
    tipoRecorrencia: TipoRecorrencia;
    diasDaSemana: DayOfWeek[] | undefined;
    dataFimRecorrencia: moment.Moment | undefined;
    id: string;
}

export class HorarioLivreDto implements IHorarioLivreDto {
    data: moment.Moment;
    horaInicio: string | undefined;
    horaFim: string | undefined;
    agendaId: string;
    nomeSala: string | undefined;

    constructor(data?: IHorarioLivreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? moment(_data["data"].toString()) : <any>undefined;
            this.horaInicio = _data["horaInicio"];
            this.horaFim = _data["horaFim"];
            this.agendaId = _data["agendaId"];
            this.nomeSala = _data["nomeSala"];
        }
    }

    static fromJS(data: any): HorarioLivreDto {
        data = typeof data === 'object' ? data : {};
        let result = new HorarioLivreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toISOString() : <any>undefined;
        data["horaInicio"] = this.horaInicio;
        data["horaFim"] = this.horaFim;
        data["agendaId"] = this.agendaId;
        data["nomeSala"] = this.nomeSala;
        return data;
    }

    clone(): HorarioLivreDto {
        const json = this.toJSON();
        let result = new HorarioLivreDto();
        result.init(json);
        return result;
    }
}

export interface IHorarioLivreDto {
    data: moment.Moment;
    horaInicio: string | undefined;
    horaFim: string | undefined;
    agendaId: string;
    nomeSala: string | undefined;
}

export class DiaLivreDto implements IDiaLivreDto {
    agendaId: string;
    nomeSala: string | undefined;
    data: moment.Moment;
    horarios: HorarioLivreDto[] | undefined;

    constructor(data?: IDiaLivreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agendaId = _data["agendaId"];
            this.nomeSala = _data["nomeSala"];
            this.data = _data["data"] ? moment(_data["data"].toString()) : <any>undefined;
            if (Array.isArray(_data["horarios"])) {
                this.horarios = [] as any;
                for (let item of _data["horarios"])
                    this.horarios.push(HorarioLivreDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiaLivreDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiaLivreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agendaId"] = this.agendaId;
        data["nomeSala"] = this.nomeSala;
        data["data"] = this.data ? this.data.toISOString() : <any>undefined;
        if (Array.isArray(this.horarios)) {
            data["horarios"] = [];
            for (let item of this.horarios)
                data["horarios"].push(item.toJSON());
        }
        return data;
    }

    clone(): DiaLivreDto {
        const json = this.toJSON();
        let result = new DiaLivreDto();
        result.init(json);
        return result;
    }
}

export interface IDiaLivreDto {
    agendaId: string;
    nomeSala: string | undefined;
    data: moment.Moment;
    horarios: HorarioLivreDto[] | undefined;
}

export class EventoAgendaDto implements IEventoAgendaDto {
    id: string;
    inicio: moment.Moment;
    fim: moment.Moment;
    ehRecorrente: boolean;
    recorrenciaId: string | undefined;
    criadoAutomaticamente: boolean;
    profissionalId: string | undefined;
    profissionalNome: string | undefined;

    constructor(data?: IEventoAgendaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inicio = _data["inicio"] ? moment(_data["inicio"].toString()) : <any>undefined;
            this.fim = _data["fim"] ? moment(_data["fim"].toString()) : <any>undefined;
            this.ehRecorrente = _data["ehRecorrente"];
            this.recorrenciaId = _data["recorrenciaId"];
            this.criadoAutomaticamente = _data["criadoAutomaticamente"];
            this.profissionalId = _data["profissionalId"];
            this.profissionalNome = _data["profissionalNome"];
        }
    }

    static fromJS(data: any): EventoAgendaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventoAgendaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inicio"] = this.inicio ? this.inicio.toISOString() : <any>undefined;
        data["fim"] = this.fim ? this.fim.toISOString() : <any>undefined;
        data["ehRecorrente"] = this.ehRecorrente;
        data["recorrenciaId"] = this.recorrenciaId;
        data["criadoAutomaticamente"] = this.criadoAutomaticamente;
        data["profissionalId"] = this.profissionalId;
        data["profissionalNome"] = this.profissionalNome;
        return data;
    }

    clone(): EventoAgendaDto {
        const json = this.toJSON();
        let result = new EventoAgendaDto();
        result.init(json);
        return result;
    }
}

export interface IEventoAgendaDto {
    id: string;
    inicio: moment.Moment;
    fim: moment.Moment;
    ehRecorrente: boolean;
    recorrenciaId: string | undefined;
    criadoAutomaticamente: boolean;
    profissionalId: string | undefined;
    profissionalNome: string | undefined;
}

export class CriarEventoAgendaInputDto implements ICriarEventoAgendaInputDto {
    agendaId: string;
    profissionalId: string | undefined;
    clinicaId: string | undefined;
    inicio: moment.Moment;
    fim: moment.Moment;
    ehRecorrente: boolean;
    dataFimRecorrencia: moment.Moment | undefined;

    constructor(data?: ICriarEventoAgendaInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agendaId = _data["agendaId"];
            this.profissionalId = _data["profissionalId"];
            this.clinicaId = _data["clinicaId"];
            this.inicio = _data["inicio"] ? moment(_data["inicio"].toString()) : <any>undefined;
            this.fim = _data["fim"] ? moment(_data["fim"].toString()) : <any>undefined;
            this.ehRecorrente = _data["ehRecorrente"];
            this.dataFimRecorrencia = _data["dataFimRecorrencia"] ? moment(_data["dataFimRecorrencia"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CriarEventoAgendaInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CriarEventoAgendaInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agendaId"] = this.agendaId;
        data["profissionalId"] = this.profissionalId;
        data["clinicaId"] = this.clinicaId;
        data["inicio"] = this.inicio ? this.inicio.toISOString() : <any>undefined;
        data["fim"] = this.fim ? this.fim.toISOString() : <any>undefined;
        data["ehRecorrente"] = this.ehRecorrente;
        data["dataFimRecorrencia"] = this.dataFimRecorrencia ? this.dataFimRecorrencia.toISOString() : <any>undefined;
        return data;
    }

    clone(): CriarEventoAgendaInputDto {
        const json = this.toJSON();
        let result = new CriarEventoAgendaInputDto();
        result.init(json);
        return result;
    }
}

export interface ICriarEventoAgendaInputDto {
    agendaId: string;
    profissionalId: string | undefined;
    clinicaId: string | undefined;
    inicio: moment.Moment;
    fim: moment.Moment;
    ehRecorrente: boolean;
    dataFimRecorrencia: moment.Moment | undefined;
}

export class ExcluirEventoAgendaInputDto implements IExcluirEventoAgendaInputDto {
    eventoId: string;
    excluirRecorrentes: boolean;
    dataReferencia: moment.Moment | undefined;

    constructor(data?: IExcluirEventoAgendaInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventoId = _data["eventoId"];
            this.excluirRecorrentes = _data["excluirRecorrentes"];
            this.dataReferencia = _data["dataReferencia"] ? moment(_data["dataReferencia"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExcluirEventoAgendaInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcluirEventoAgendaInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventoId"] = this.eventoId;
        data["excluirRecorrentes"] = this.excluirRecorrentes;
        data["dataReferencia"] = this.dataReferencia ? this.dataReferencia.toISOString() : <any>undefined;
        return data;
    }

    clone(): ExcluirEventoAgendaInputDto {
        const json = this.toJSON();
        let result = new ExcluirEventoAgendaInputDto();
        result.init(json);
        return result;
    }
}

export interface IExcluirEventoAgendaInputDto {
    eventoId: string;
    excluirRecorrentes: boolean;
    dataReferencia: moment.Moment | undefined;
}

export class ExcluirDiaAgendaInputDto implements IExcluirDiaAgendaInputDto {
    agendaId: string;
    profissionalId: string | undefined;
    data: moment.Moment;
    excluirProximosEquivalentes: boolean;

    constructor(data?: IExcluirDiaAgendaInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agendaId = _data["agendaId"];
            this.profissionalId = _data["profissionalId"];
            this.data = _data["data"] ? moment(_data["data"].toString()) : <any>undefined;
            this.excluirProximosEquivalentes = _data["excluirProximosEquivalentes"];
        }
    }

    static fromJS(data: any): ExcluirDiaAgendaInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcluirDiaAgendaInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agendaId"] = this.agendaId;
        data["profissionalId"] = this.profissionalId;
        data["data"] = this.data ? this.data.toISOString() : <any>undefined;
        data["excluirProximosEquivalentes"] = this.excluirProximosEquivalentes;
        return data;
    }

    clone(): ExcluirDiaAgendaInputDto {
        const json = this.toJSON();
        let result = new ExcluirDiaAgendaInputDto();
        result.init(json);
        return result;
    }
}

export interface IExcluirDiaAgendaInputDto {
    agendaId: string;
    profissionalId: string | undefined;
    data: moment.Moment;
    excluirProximosEquivalentes: boolean;
}

export class AlterarProfissionalEventoAgendaInputDto implements IAlterarProfissionalEventoAgendaInputDto {
    eventoId: string;
    profissionalId: string | undefined;

    constructor(data?: IAlterarProfissionalEventoAgendaInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventoId = _data["eventoId"];
            this.profissionalId = _data["profissionalId"];
        }
    }

    static fromJS(data: any): AlterarProfissionalEventoAgendaInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlterarProfissionalEventoAgendaInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventoId"] = this.eventoId;
        data["profissionalId"] = this.profissionalId;
        return data;
    }

    clone(): AlterarProfissionalEventoAgendaInputDto {
        const json = this.toJSON();
        let result = new AlterarProfissionalEventoAgendaInputDto();
        result.init(json);
        return result;
    }
}

export interface IAlterarProfissionalEventoAgendaInputDto {
    eventoId: string;
    profissionalId: string | undefined;
}

export class CreateFrequenciaRespiratoriaDto implements ICreateFrequenciaRespiratoriaDto {
    valorRpm: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateFrequenciaRespiratoriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorRpm = _data["valorRpm"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateFrequenciaRespiratoriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFrequenciaRespiratoriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorRpm"] = this.valorRpm;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateFrequenciaRespiratoriaDto {
        const json = this.toJSON();
        let result = new CreateFrequenciaRespiratoriaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFrequenciaRespiratoriaDto {
    valorRpm: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class FrequenciaRespiratoriaDto implements IFrequenciaRespiratoriaDto {
    valorRpm: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IFrequenciaRespiratoriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorRpm = _data["valorRpm"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FrequenciaRespiratoriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrequenciaRespiratoriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorRpm"] = this.valorRpm;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): FrequenciaRespiratoriaDto {
        const json = this.toJSON();
        let result = new FrequenciaRespiratoriaDto();
        result.init(json);
        return result;
    }
}

export interface IFrequenciaRespiratoriaDto {
    valorRpm: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class UpdateFrequenciaRespiratoriaDto implements IUpdateFrequenciaRespiratoriaDto {
    valorRpm: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateFrequenciaRespiratoriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorRpm = _data["valorRpm"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFrequenciaRespiratoriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFrequenciaRespiratoriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorRpm"] = this.valorRpm;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateFrequenciaRespiratoriaDto {
        const json = this.toJSON();
        let result = new UpdateFrequenciaRespiratoriaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFrequenciaRespiratoriaDto {
    valorRpm: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class FrequenciaRespiratoriaDtoPagedResultDto implements IFrequenciaRespiratoriaDtoPagedResultDto {
    totalCount: number;
    items: FrequenciaRespiratoriaDto[] | undefined;

    constructor(data?: IFrequenciaRespiratoriaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FrequenciaRespiratoriaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FrequenciaRespiratoriaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrequenciaRespiratoriaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): FrequenciaRespiratoriaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FrequenciaRespiratoriaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFrequenciaRespiratoriaDtoPagedResultDto {
    totalCount: number;
    items: FrequenciaRespiratoriaDto[] | undefined;
}

export class Endereco implements IEndereco {
    cep: string;
    logradouro: string;
    numero: string | undefined;
    bairro: string;
    cidade: string;
    estado: string;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEndereco) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cep = _data["cep"];
            this.logradouro = _data["logradouro"];
            this.numero = _data["numero"];
            this.bairro = _data["bairro"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.complemento = _data["complemento"];
            this.referencia = _data["referencia"];
            this.codigoIbge = _data["codigoIbge"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Endereco {
        data = typeof data === 'object' ? data : {};
        let result = new Endereco();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cep"] = this.cep;
        data["logradouro"] = this.logradouro;
        data["numero"] = this.numero;
        data["bairro"] = this.bairro;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["complemento"] = this.complemento;
        data["referencia"] = this.referencia;
        data["codigoIbge"] = this.codigoIbge;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Endereco {
        const json = this.toJSON();
        let result = new Endereco();
        result.init(json);
        return result;
    }
}

export interface IEndereco {
    cep: string;
    logradouro: string;
    numero: string | undefined;
    bairro: string;
    cidade: string;
    estado: string;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class RegistroClasse implements IRegistroClasse {
    nome: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRegistroClasse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegistroClasse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistroClasse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RegistroClasse {
        const json = this.toJSON();
        let result = new RegistroClasse();
        result.init(json);
        return result;
    }
}

export interface IRegistroClasse {
    nome: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class RQE implements IRQE {
    profissionalSaude: ProfissionalSaude;
    profissionalSaudeId: string;
    nomeEspecializacao: string | undefined;
    codigo: string | undefined;
    uf: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRQE) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.nomeEspecializacao = _data["nomeEspecializacao"];
            this.codigo = _data["codigo"];
            this.uf = _data["uf"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RQE {
        data = typeof data === 'object' ? data : {};
        let result = new RQE();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["nomeEspecializacao"] = this.nomeEspecializacao;
        data["codigo"] = this.codigo;
        data["uf"] = this.uf;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RQE {
        const json = this.toJSON();
        let result = new RQE();
        result.init(json);
        return result;
    }
}

export interface IRQE {
    profissionalSaude: ProfissionalSaude;
    profissionalSaudeId: string;
    nomeEspecializacao: string | undefined;
    codigo: string | undefined;
    uf: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class EmailProfissionalClinica implements IEmailProfissionalClinica {
    profissionalClinicaId: string;
    profissionalClinica: ProfissionalSaudeClinicaMedica;
    email: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEmailProfissionalClinica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalClinicaId = _data["profissionalClinicaId"];
            this.profissionalClinica = _data["profissionalClinica"] ? ProfissionalSaudeClinicaMedica.fromJS(_data["profissionalClinica"]) : <any>undefined;
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmailProfissionalClinica {
        data = typeof data === 'object' ? data : {};
        let result = new EmailProfissionalClinica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalClinicaId"] = this.profissionalClinicaId;
        data["profissionalClinica"] = this.profissionalClinica ? this.profissionalClinica.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): EmailProfissionalClinica {
        const json = this.toJSON();
        let result = new EmailProfissionalClinica();
        result.init(json);
        return result;
    }
}

export interface IEmailProfissionalClinica {
    profissionalClinicaId: string;
    profissionalClinica: ProfissionalSaudeClinicaMedica;
    email: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class TelefoneProfissionalClinica implements ITelefoneProfissionalClinica {
    profissionalClinicaId: string;
    profissionalClinica: ProfissionalSaudeClinicaMedica;
    telefone: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ITelefoneProfissionalClinica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalClinicaId = _data["profissionalClinicaId"];
            this.profissionalClinica = _data["profissionalClinica"] ? ProfissionalSaudeClinicaMedica.fromJS(_data["profissionalClinica"]) : <any>undefined;
            this.telefone = _data["telefone"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TelefoneProfissionalClinica {
        data = typeof data === 'object' ? data : {};
        let result = new TelefoneProfissionalClinica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalClinicaId"] = this.profissionalClinicaId;
        data["profissionalClinica"] = this.profissionalClinica ? this.profissionalClinica.toJSON() : <any>undefined;
        data["telefone"] = this.telefone;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TelefoneProfissionalClinica {
        const json = this.toJSON();
        let result = new TelefoneProfissionalClinica();
        result.init(json);
        return result;
    }
}

export interface ITelefoneProfissionalClinica {
    profissionalClinicaId: string;
    profissionalClinica: ProfissionalSaudeClinicaMedica;
    telefone: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProfissionalSaudeClinicaMedica implements IProfissionalSaudeClinicaMedica {
    clinicaMedica: ClinicaMedica;
    clinicaMedicaId: string;
    profissionalSaude: ProfissionalSaude;
    profissionalSaudeId: string;
    isActive: boolean;
    resposta: RespostaProfissionalEnum;
    readonly respostaString: string | undefined;
    emailProfissionalClinicas: EmailProfissionalClinica[] | undefined;
    telefoneProfissionalClinicas: TelefoneProfissionalClinica[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalSaudeClinicaMedica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedica = _data["clinicaMedica"] ? ClinicaMedica.fromJS(_data["clinicaMedica"]) : <any>undefined;
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.isActive = _data["isActive"];
            this.resposta = _data["resposta"];
            (<any>this).respostaString = _data["respostaString"];
            if (Array.isArray(_data["emailProfissionalClinicas"])) {
                this.emailProfissionalClinicas = [] as any;
                for (let item of _data["emailProfissionalClinicas"])
                    this.emailProfissionalClinicas.push(EmailProfissionalClinica.fromJS(item));
            }
            if (Array.isArray(_data["telefoneProfissionalClinicas"])) {
                this.telefoneProfissionalClinicas = [] as any;
                for (let item of _data["telefoneProfissionalClinicas"])
                    this.telefoneProfissionalClinicas.push(TelefoneProfissionalClinica.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalSaudeClinicaMedica {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudeClinicaMedica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedica"] = this.clinicaMedica ? this.clinicaMedica.toJSON() : <any>undefined;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["isActive"] = this.isActive;
        data["resposta"] = this.resposta;
        data["respostaString"] = this.respostaString;
        if (Array.isArray(this.emailProfissionalClinicas)) {
            data["emailProfissionalClinicas"] = [];
            for (let item of this.emailProfissionalClinicas)
                data["emailProfissionalClinicas"].push(item.toJSON());
        }
        if (Array.isArray(this.telefoneProfissionalClinicas)) {
            data["telefoneProfissionalClinicas"] = [];
            for (let item of this.telefoneProfissionalClinicas)
                data["telefoneProfissionalClinicas"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalSaudeClinicaMedica {
        const json = this.toJSON();
        let result = new ProfissionalSaudeClinicaMedica();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudeClinicaMedica {
    clinicaMedica: ClinicaMedica;
    clinicaMedicaId: string;
    profissionalSaude: ProfissionalSaude;
    profissionalSaudeId: string;
    isActive: boolean;
    resposta: RespostaProfissionalEnum;
    respostaString: string | undefined;
    emailProfissionalClinicas: EmailProfissionalClinica[] | undefined;
    telefoneProfissionalClinicas: TelefoneProfissionalClinica[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum TipoSanguineoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export enum EstadoCivilEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum CorEtniaEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ProfissionalAcessoPacienteVip implements IProfissionalAcessoPacienteVip {
    clinicaMedicaPacienteVipId: string;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVip;
    profissionalSaudeId: string;
    profissionalSaude: ProfissionalSaude;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalAcessoPacienteVip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaPacienteVipId = _data["clinicaMedicaPacienteVipId"];
            this.clinicaMedicaPacienteVip = _data["clinicaMedicaPacienteVip"] ? ClinicaMedicaPacienteVip.fromJS(_data["clinicaMedicaPacienteVip"]) : <any>undefined;
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalAcessoPacienteVip {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalAcessoPacienteVip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaPacienteVipId"] = this.clinicaMedicaPacienteVipId;
        data["clinicaMedicaPacienteVip"] = this.clinicaMedicaPacienteVip ? this.clinicaMedicaPacienteVip.toJSON() : <any>undefined;
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalAcessoPacienteVip {
        const json = this.toJSON();
        let result = new ProfissionalAcessoPacienteVip();
        result.init(json);
        return result;
    }
}

export interface IProfissionalAcessoPacienteVip {
    clinicaMedicaPacienteVipId: string;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVip;
    profissionalSaudeId: string;
    profissionalSaude: ProfissionalSaude;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class TimeSpan implements ITimeSpan {
    readonly ticks: number;
    readonly days: number;
    readonly hours: number;
    readonly milliseconds: number;
    readonly minutes: number;
    readonly seconds: number;
    readonly totalDays: number;
    readonly totalHours: number;
    readonly totalMilliseconds: number;
    readonly totalMinutes: number;
    readonly totalSeconds: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }

    clone(): TimeSpan {
        const json = this.toJSON();
        let result = new TimeSpan();
        result.init(json);
        return result;
    }
}

export interface ITimeSpan {
    ticks: number;
    days: number;
    hours: number;
    milliseconds: number;
    minutes: number;
    seconds: number;
    totalDays: number;
    totalHours: number;
    totalMilliseconds: number;
    totalMinutes: number;
    totalSeconds: number;
}

export class AgendaProfissional implements IAgendaProfissional {
    agenda: Agenda;
    agendaId: string;
    profissionalSaude: ProfissionalSaude;
    profissionalSaudeId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAgendaProfissional) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agenda = _data["agenda"] ? Agenda.fromJS(_data["agenda"]) : <any>undefined;
            this.agendaId = _data["agendaId"];
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AgendaProfissional {
        data = typeof data === 'object' ? data : {};
        let result = new AgendaProfissional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agenda"] = this.agenda ? this.agenda.toJSON() : <any>undefined;
        data["agendaId"] = this.agendaId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): AgendaProfissional {
        const json = this.toJSON();
        let result = new AgendaProfissional();
        result.init(json);
        return result;
    }
}

export interface IAgendaProfissional {
    agenda: Agenda;
    agendaId: string;
    profissionalSaude: ProfissionalSaude;
    profissionalSaudeId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class HorarioDisponivel implements IHorarioDisponivel {
    agendaId: string;
    agenda: Agenda;
    diaDaSemana: DayOfWeek;
    inicio: TimeSpan;
    fim: TimeSpan;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IHorarioDisponivel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.inicio = new TimeSpan();
            this.fim = new TimeSpan();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agendaId = _data["agendaId"];
            this.agenda = _data["agenda"] ? Agenda.fromJS(_data["agenda"]) : <any>undefined;
            this.diaDaSemana = _data["diaDaSemana"];
            this.inicio = _data["inicio"] ? TimeSpan.fromJS(_data["inicio"]) : new TimeSpan();
            this.fim = _data["fim"] ? TimeSpan.fromJS(_data["fim"]) : new TimeSpan();
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HorarioDisponivel {
        data = typeof data === 'object' ? data : {};
        let result = new HorarioDisponivel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agendaId"] = this.agendaId;
        data["agenda"] = this.agenda ? this.agenda.toJSON() : <any>undefined;
        data["diaDaSemana"] = this.diaDaSemana;
        data["inicio"] = this.inicio ? this.inicio.toJSON() : <any>undefined;
        data["fim"] = this.fim ? this.fim.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): HorarioDisponivel {
        const json = this.toJSON();
        let result = new HorarioDisponivel();
        result.init(json);
        return result;
    }
}

export interface IHorarioDisponivel {
    agendaId: string;
    agenda: Agenda;
    diaDaSemana: DayOfWeek;
    inicio: TimeSpan;
    fim: TimeSpan;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Agenda implements IAgenda {
    clinicaId: string | undefined;
    clinica: ClinicaMedica;
    nomeSala: string | undefined;
    horarioInicio: TimeSpan;
    horarioFim: TimeSpan;
    duracaoConsulta: number;
    tipoSala: TipoSala;
    suspenso: boolean;
    profissionais: AgendaProfissional[] | undefined;
    horariosDisponiveis: HorarioDisponivel[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAgenda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaId = _data["clinicaId"];
            this.clinica = _data["clinica"] ? ClinicaMedica.fromJS(_data["clinica"]) : <any>undefined;
            this.nomeSala = _data["nomeSala"];
            this.horarioInicio = _data["horarioInicio"] ? TimeSpan.fromJS(_data["horarioInicio"]) : <any>undefined;
            this.horarioFim = _data["horarioFim"] ? TimeSpan.fromJS(_data["horarioFim"]) : <any>undefined;
            this.duracaoConsulta = _data["duracaoConsulta"];
            this.tipoSala = _data["tipoSala"];
            this.suspenso = _data["suspenso"];
            if (Array.isArray(_data["profissionais"])) {
                this.profissionais = [] as any;
                for (let item of _data["profissionais"])
                    this.profissionais.push(AgendaProfissional.fromJS(item));
            }
            if (Array.isArray(_data["horariosDisponiveis"])) {
                this.horariosDisponiveis = [] as any;
                for (let item of _data["horariosDisponiveis"])
                    this.horariosDisponiveis.push(HorarioDisponivel.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Agenda {
        data = typeof data === 'object' ? data : {};
        let result = new Agenda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaId"] = this.clinicaId;
        data["clinica"] = this.clinica ? this.clinica.toJSON() : <any>undefined;
        data["nomeSala"] = this.nomeSala;
        data["horarioInicio"] = this.horarioInicio ? this.horarioInicio.toJSON() : <any>undefined;
        data["horarioFim"] = this.horarioFim ? this.horarioFim.toJSON() : <any>undefined;
        data["duracaoConsulta"] = this.duracaoConsulta;
        data["tipoSala"] = this.tipoSala;
        data["suspenso"] = this.suspenso;
        if (Array.isArray(this.profissionais)) {
            data["profissionais"] = [];
            for (let item of this.profissionais)
                data["profissionais"].push(item.toJSON());
        }
        if (Array.isArray(this.horariosDisponiveis)) {
            data["horariosDisponiveis"] = [];
            for (let item of this.horariosDisponiveis)
                data["horariosDisponiveis"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Agenda {
        const json = this.toJSON();
        let result = new Agenda();
        result.init(json);
        return result;
    }
}

export interface IAgenda {
    clinicaId: string | undefined;
    clinica: ClinicaMedica;
    nomeSala: string | undefined;
    horarioInicio: TimeSpan;
    horarioFim: TimeSpan;
    duracaoConsulta: number;
    tipoSala: TipoSala;
    suspenso: boolean;
    profissionais: AgendaProfissional[] | undefined;
    horariosDisponiveis: HorarioDisponivel[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Evento implements IEvento {
    agendaId: string;
    agenda: Agenda;
    titulo: string;
    descricao: string | undefined;
    clinicaId: string | undefined;
    clinica: ClinicaMedica;
    profissionalId: string | undefined;
    profissional: ProfissionalSaude;
    pacienteId: string | undefined;
    paciente: Paciente;
    recorrenciaId: string | undefined;
    ehRecorrente: boolean;
    inicio: moment.Moment;
    fim: moment.Moment;
    tipo: TipoEvento;
    criadoAutomaticamente: boolean;
    consulta: Consulta;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEvento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agendaId = _data["agendaId"];
            this.agenda = _data["agenda"] ? Agenda.fromJS(_data["agenda"]) : <any>undefined;
            this.titulo = _data["titulo"];
            this.descricao = _data["descricao"];
            this.clinicaId = _data["clinicaId"];
            this.clinica = _data["clinica"] ? ClinicaMedica.fromJS(_data["clinica"]) : <any>undefined;
            this.profissionalId = _data["profissionalId"];
            this.profissional = _data["profissional"] ? ProfissionalSaude.fromJS(_data["profissional"]) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.recorrenciaId = _data["recorrenciaId"];
            this.ehRecorrente = _data["ehRecorrente"];
            this.inicio = _data["inicio"] ? moment(_data["inicio"].toString()) : <any>undefined;
            this.fim = _data["fim"] ? moment(_data["fim"].toString()) : <any>undefined;
            this.tipo = _data["tipo"];
            this.criadoAutomaticamente = _data["criadoAutomaticamente"];
            this.consulta = _data["consulta"] ? Consulta.fromJS(_data["consulta"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Evento {
        data = typeof data === 'object' ? data : {};
        let result = new Evento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agendaId"] = this.agendaId;
        data["agenda"] = this.agenda ? this.agenda.toJSON() : <any>undefined;
        data["titulo"] = this.titulo;
        data["descricao"] = this.descricao;
        data["clinicaId"] = this.clinicaId;
        data["clinica"] = this.clinica ? this.clinica.toJSON() : <any>undefined;
        data["profissionalId"] = this.profissionalId;
        data["profissional"] = this.profissional ? this.profissional.toJSON() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["recorrenciaId"] = this.recorrenciaId;
        data["ehRecorrente"] = this.ehRecorrente;
        data["inicio"] = this.inicio ? this.inicio.toISOString() : <any>undefined;
        data["fim"] = this.fim ? this.fim.toISOString() : <any>undefined;
        data["tipo"] = this.tipo;
        data["criadoAutomaticamente"] = this.criadoAutomaticamente;
        data["consulta"] = this.consulta ? this.consulta.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Evento {
        const json = this.toJSON();
        let result = new Evento();
        result.init(json);
        return result;
    }
}

export interface IEvento {
    agendaId: string;
    agenda: Agenda;
    titulo: string;
    descricao: string | undefined;
    clinicaId: string | undefined;
    clinica: ClinicaMedica;
    profissionalId: string | undefined;
    profissional: ProfissionalSaude;
    pacienteId: string | undefined;
    paciente: Paciente;
    recorrenciaId: string | undefined;
    ehRecorrente: boolean;
    inicio: moment.Moment;
    fim: moment.Moment;
    tipo: TipoEvento;
    criadoAutomaticamente: boolean;
    consulta: Consulta;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProfissionalSaudeConvenio implements IProfissionalSaudeConvenio {
    profissionalSaudeId: string;
    profissionalSaude: ProfissionalSaude;
    convenioId: string;
    convenio: Convenio;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalSaudeConvenio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.convenioId = _data["convenioId"];
            this.convenio = _data["convenio"] ? Convenio.fromJS(_data["convenio"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalSaudeConvenio {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudeConvenio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["convenioId"] = this.convenioId;
        data["convenio"] = this.convenio ? this.convenio.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalSaudeConvenio {
        const json = this.toJSON();
        let result = new ProfissionalSaudeConvenio();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudeConvenio {
    profissionalSaudeId: string;
    profissionalSaude: ProfissionalSaude;
    convenioId: string;
    convenio: Convenio;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ClinicaMedicaConvenio implements IClinicaMedicaConvenio {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedica;
    convenioId: string;
    convenio: Convenio;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IClinicaMedicaConvenio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.clinicaMedica = _data["clinicaMedica"] ? ClinicaMedica.fromJS(_data["clinicaMedica"]) : <any>undefined;
            this.convenioId = _data["convenioId"];
            this.convenio = _data["convenio"] ? Convenio.fromJS(_data["convenio"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClinicaMedicaConvenio {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicaMedicaConvenio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["clinicaMedica"] = this.clinicaMedica ? this.clinicaMedica.toJSON() : <any>undefined;
        data["convenioId"] = this.convenioId;
        data["convenio"] = this.convenio ? this.convenio.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ClinicaMedicaConvenio {
        const json = this.toJSON();
        let result = new ClinicaMedicaConvenio();
        result.init(json);
        return result;
    }
}

export interface IClinicaMedicaConvenio {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedica;
    convenioId: string;
    convenio: Convenio;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PacienteConvenio implements IPacienteConvenio {
    pacienteId: string;
    paciente: Paciente;
    convenioId: string;
    convenio: Convenio;
    plano: string | undefined;
    numeroCarteira: string | undefined;
    validade: moment.Moment | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPacienteConvenio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.convenioId = _data["convenioId"];
            this.convenio = _data["convenio"] ? Convenio.fromJS(_data["convenio"]) : <any>undefined;
            this.plano = _data["plano"];
            this.numeroCarteira = _data["numeroCarteira"];
            this.validade = _data["validade"] ? moment(_data["validade"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteConvenio {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteConvenio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["convenioId"] = this.convenioId;
        data["convenio"] = this.convenio ? this.convenio.toJSON() : <any>undefined;
        data["plano"] = this.plano;
        data["numeroCarteira"] = this.numeroCarteira;
        data["validade"] = this.validade ? this.validade.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteConvenio {
        const json = this.toJSON();
        let result = new PacienteConvenio();
        result.init(json);
        return result;
    }
}

export interface IPacienteConvenio {
    pacienteId: string;
    paciente: Paciente;
    convenioId: string;
    convenio: Convenio;
    plano: string | undefined;
    numeroCarteira: string | undefined;
    validade: moment.Moment | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Convenio implements IConvenio {
    registroAns: string | undefined;
    cnpj: string;
    razaoSocial: string;
    nomeFantasia: string | undefined;
    autoGestao: boolean;
    ddd: string | undefined;
    telefone: string | undefined;
    fax: string | undefined;
    email: string;
    representante: string;
    cargoRepresentante: string;
    dataRegistroAns: moment.Moment | undefined;
    ativo: boolean;
    enderecoId: string;
    endereco: Endereco;
    profissionalSaudeConvenio: ProfissionalSaudeConvenio[] | undefined;
    clinicaMedicaConvenio: ClinicaMedicaConvenio[] | undefined;
    pacienteConvenio: PacienteConvenio[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IConvenio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registroAns = _data["registroAns"];
            this.cnpj = _data["cnpj"];
            this.razaoSocial = _data["razaoSocial"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.autoGestao = _data["autoGestao"];
            this.ddd = _data["ddd"];
            this.telefone = _data["telefone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.representante = _data["representante"];
            this.cargoRepresentante = _data["cargoRepresentante"];
            this.dataRegistroAns = _data["dataRegistroAns"] ? moment(_data["dataRegistroAns"].toString()) : <any>undefined;
            this.ativo = _data["ativo"];
            this.enderecoId = _data["enderecoId"];
            this.endereco = _data["endereco"] ? Endereco.fromJS(_data["endereco"]) : <any>undefined;
            if (Array.isArray(_data["profissionalSaudeConvenio"])) {
                this.profissionalSaudeConvenio = [] as any;
                for (let item of _data["profissionalSaudeConvenio"])
                    this.profissionalSaudeConvenio.push(ProfissionalSaudeConvenio.fromJS(item));
            }
            if (Array.isArray(_data["clinicaMedicaConvenio"])) {
                this.clinicaMedicaConvenio = [] as any;
                for (let item of _data["clinicaMedicaConvenio"])
                    this.clinicaMedicaConvenio.push(ClinicaMedicaConvenio.fromJS(item));
            }
            if (Array.isArray(_data["pacienteConvenio"])) {
                this.pacienteConvenio = [] as any;
                for (let item of _data["pacienteConvenio"])
                    this.pacienteConvenio.push(PacienteConvenio.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Convenio {
        data = typeof data === 'object' ? data : {};
        let result = new Convenio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registroAns"] = this.registroAns;
        data["cnpj"] = this.cnpj;
        data["razaoSocial"] = this.razaoSocial;
        data["nomeFantasia"] = this.nomeFantasia;
        data["autoGestao"] = this.autoGestao;
        data["ddd"] = this.ddd;
        data["telefone"] = this.telefone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["representante"] = this.representante;
        data["cargoRepresentante"] = this.cargoRepresentante;
        data["dataRegistroAns"] = this.dataRegistroAns ? this.dataRegistroAns.toISOString() : <any>undefined;
        data["ativo"] = this.ativo;
        data["enderecoId"] = this.enderecoId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        if (Array.isArray(this.profissionalSaudeConvenio)) {
            data["profissionalSaudeConvenio"] = [];
            for (let item of this.profissionalSaudeConvenio)
                data["profissionalSaudeConvenio"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicaMedicaConvenio)) {
            data["clinicaMedicaConvenio"] = [];
            for (let item of this.clinicaMedicaConvenio)
                data["clinicaMedicaConvenio"].push(item.toJSON());
        }
        if (Array.isArray(this.pacienteConvenio)) {
            data["pacienteConvenio"] = [];
            for (let item of this.pacienteConvenio)
                data["pacienteConvenio"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Convenio {
        const json = this.toJSON();
        let result = new Convenio();
        result.init(json);
        return result;
    }
}

export interface IConvenio {
    registroAns: string | undefined;
    cnpj: string;
    razaoSocial: string;
    nomeFantasia: string | undefined;
    autoGestao: boolean;
    ddd: string | undefined;
    telefone: string | undefined;
    fax: string | undefined;
    email: string;
    representante: string;
    cargoRepresentante: string;
    dataRegistroAns: moment.Moment | undefined;
    ativo: boolean;
    enderecoId: string;
    endereco: Endereco;
    profissionalSaudeConvenio: ProfissionalSaudeConvenio[] | undefined;
    clinicaMedicaConvenio: ClinicaMedicaConvenio[] | undefined;
    pacienteConvenio: PacienteConvenio[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Pedido implements IPedido {
    consultaId: string;
    nome: string | undefined;
    ext: string | undefined;
    urlArquivo: string | undefined;
    tipo: TipoPedidoEnum;
    dataSolicitacao: moment.Moment | undefined;
    dataEnvio: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPedido) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultaId = _data["consultaId"];
            this.nome = _data["nome"];
            this.ext = _data["ext"];
            this.urlArquivo = _data["urlArquivo"];
            this.tipo = _data["tipo"];
            this.dataSolicitacao = _data["dataSolicitacao"] ? moment(_data["dataSolicitacao"].toString()) : <any>undefined;
            this.dataEnvio = _data["dataEnvio"] ? moment(_data["dataEnvio"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Pedido {
        data = typeof data === 'object' ? data : {};
        let result = new Pedido();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultaId"] = this.consultaId;
        data["nome"] = this.nome;
        data["ext"] = this.ext;
        data["urlArquivo"] = this.urlArquivo;
        data["tipo"] = this.tipo;
        data["dataSolicitacao"] = this.dataSolicitacao ? this.dataSolicitacao.toISOString() : <any>undefined;
        data["dataEnvio"] = this.dataEnvio ? this.dataEnvio.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Pedido {
        const json = this.toJSON();
        let result = new Pedido();
        result.init(json);
        return result;
    }
}

export interface IPedido {
    consultaId: string;
    nome: string | undefined;
    ext: string | undefined;
    urlArquivo: string | undefined;
    tipo: TipoPedidoEnum;
    dataSolicitacao: moment.Moment | undefined;
    dataEnvio: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Consulta implements IConsulta {
    descricao: string;
    pacienteId: string;
    paciente: Paciente;
    profissionalId: string;
    profissionalSaude: ProfissionalSaude;
    clinicaMedicaId: string | undefined;
    clinciaMedica: ClinicaMedica;
    dataConsulta: moment.Moment;
    sessaoTeleConsulta: string | undefined;
    linkTeleconsulta: string | undefined;
    observacoes: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    readonly tipoConsultaString: string | undefined;
    statusConsulta: StatusConsultaEnum;
    readonly statusConsultaString: string | undefined;
    anexos: AnexoConsulta[] | undefined;
    pastaId: string | undefined;
    eventoId: string;
    evento: Evento;
    convenioId: string | undefined;
    convenio: Convenio;
    pedidos: Pedido[] | undefined;
    observacaoPaciente: string | undefined;
    observacaoProfissional: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IConsulta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.profissionalId = _data["profissionalId"];
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.clinciaMedica = _data["clinciaMedica"] ? ClinicaMedica.fromJS(_data["clinciaMedica"]) : <any>undefined;
            this.dataConsulta = _data["dataConsulta"] ? moment(_data["dataConsulta"].toString()) : <any>undefined;
            this.sessaoTeleConsulta = _data["sessaoTeleConsulta"];
            this.linkTeleconsulta = _data["linkTeleconsulta"];
            this.observacoes = _data["observacoes"];
            this.tipoConsulta = _data["tipoConsulta"];
            (<any>this).tipoConsultaString = _data["tipoConsultaString"];
            this.statusConsulta = _data["statusConsulta"];
            (<any>this).statusConsultaString = _data["statusConsultaString"];
            if (Array.isArray(_data["anexos"])) {
                this.anexos = [] as any;
                for (let item of _data["anexos"])
                    this.anexos.push(AnexoConsulta.fromJS(item));
            }
            this.pastaId = _data["pastaId"];
            this.eventoId = _data["eventoId"];
            this.evento = _data["evento"] ? Evento.fromJS(_data["evento"]) : <any>undefined;
            this.convenioId = _data["convenioId"];
            this.convenio = _data["convenio"] ? Convenio.fromJS(_data["convenio"]) : <any>undefined;
            if (Array.isArray(_data["pedidos"])) {
                this.pedidos = [] as any;
                for (let item of _data["pedidos"])
                    this.pedidos.push(Pedido.fromJS(item));
            }
            this.observacaoPaciente = _data["observacaoPaciente"];
            this.observacaoProfissional = _data["observacaoProfissional"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Consulta {
        data = typeof data === 'object' ? data : {};
        let result = new Consulta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["profissionalId"] = this.profissionalId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["clinciaMedica"] = this.clinciaMedica ? this.clinciaMedica.toJSON() : <any>undefined;
        data["dataConsulta"] = this.dataConsulta ? this.dataConsulta.toISOString() : <any>undefined;
        data["sessaoTeleConsulta"] = this.sessaoTeleConsulta;
        data["linkTeleconsulta"] = this.linkTeleconsulta;
        data["observacoes"] = this.observacoes;
        data["tipoConsulta"] = this.tipoConsulta;
        data["tipoConsultaString"] = this.tipoConsultaString;
        data["statusConsulta"] = this.statusConsulta;
        data["statusConsultaString"] = this.statusConsultaString;
        if (Array.isArray(this.anexos)) {
            data["anexos"] = [];
            for (let item of this.anexos)
                data["anexos"].push(item.toJSON());
        }
        data["pastaId"] = this.pastaId;
        data["eventoId"] = this.eventoId;
        data["evento"] = this.evento ? this.evento.toJSON() : <any>undefined;
        data["convenioId"] = this.convenioId;
        data["convenio"] = this.convenio ? this.convenio.toJSON() : <any>undefined;
        if (Array.isArray(this.pedidos)) {
            data["pedidos"] = [];
            for (let item of this.pedidos)
                data["pedidos"].push(item.toJSON());
        }
        data["observacaoPaciente"] = this.observacaoPaciente;
        data["observacaoProfissional"] = this.observacaoProfissional;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Consulta {
        const json = this.toJSON();
        let result = new Consulta();
        result.init(json);
        return result;
    }
}

export interface IConsulta {
    descricao: string;
    pacienteId: string;
    paciente: Paciente;
    profissionalId: string;
    profissionalSaude: ProfissionalSaude;
    clinicaMedicaId: string | undefined;
    clinciaMedica: ClinicaMedica;
    dataConsulta: moment.Moment;
    sessaoTeleConsulta: string | undefined;
    linkTeleconsulta: string | undefined;
    observacoes: string | undefined;
    tipoConsulta: TipoConsultaEnum;
    tipoConsultaString: string | undefined;
    statusConsulta: StatusConsultaEnum;
    statusConsultaString: string | undefined;
    anexos: AnexoConsulta[] | undefined;
    pastaId: string | undefined;
    eventoId: string;
    evento: Evento;
    convenioId: string | undefined;
    convenio: Convenio;
    pedidos: Pedido[] | undefined;
    observacaoPaciente: string | undefined;
    observacaoProfissional: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class AnexoConsulta implements IAnexoConsulta {
    consultaId: string;
    consulta: Consulta;
    aquivoId: string;
    arquivo: Arquivo;
    tipoArquivoProntuario: TipoArquivoProntuarioEnum;
    readonly tipoArquivoProntuarioString: string | undefined;
    tipoUsuario: TipoUsuarioEnum;
    readonly tipoUsuarioString: string | undefined;
    dataSolicitacao: moment.Moment | undefined;
    dataEnvio: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAnexoConsulta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultaId = _data["consultaId"];
            this.consulta = _data["consulta"] ? Consulta.fromJS(_data["consulta"]) : <any>undefined;
            this.aquivoId = _data["aquivoId"];
            this.arquivo = _data["arquivo"] ? Arquivo.fromJS(_data["arquivo"]) : <any>undefined;
            this.tipoArquivoProntuario = _data["tipoArquivoProntuario"];
            (<any>this).tipoArquivoProntuarioString = _data["tipoArquivoProntuarioString"];
            this.tipoUsuario = _data["tipoUsuario"];
            (<any>this).tipoUsuarioString = _data["tipoUsuarioString"];
            this.dataSolicitacao = _data["dataSolicitacao"] ? moment(_data["dataSolicitacao"].toString()) : <any>undefined;
            this.dataEnvio = _data["dataEnvio"] ? moment(_data["dataEnvio"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AnexoConsulta {
        data = typeof data === 'object' ? data : {};
        let result = new AnexoConsulta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultaId"] = this.consultaId;
        data["consulta"] = this.consulta ? this.consulta.toJSON() : <any>undefined;
        data["aquivoId"] = this.aquivoId;
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        data["tipoArquivoProntuario"] = this.tipoArquivoProntuario;
        data["tipoArquivoProntuarioString"] = this.tipoArquivoProntuarioString;
        data["tipoUsuario"] = this.tipoUsuario;
        data["tipoUsuarioString"] = this.tipoUsuarioString;
        data["dataSolicitacao"] = this.dataSolicitacao ? this.dataSolicitacao.toISOString() : <any>undefined;
        data["dataEnvio"] = this.dataEnvio ? this.dataEnvio.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): AnexoConsulta {
        const json = this.toJSON();
        let result = new AnexoConsulta();
        result.init(json);
        return result;
    }
}

export interface IAnexoConsulta {
    consultaId: string;
    consulta: Consulta;
    aquivoId: string;
    arquivo: Arquivo;
    tipoArquivoProntuario: TipoArquivoProntuarioEnum;
    tipoArquivoProntuarioString: string | undefined;
    tipoUsuario: TipoUsuarioEnum;
    tipoUsuarioString: string | undefined;
    dataSolicitacao: moment.Moment | undefined;
    dataEnvio: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Cid implements ICid {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    arquivosCids: ArquivoCid[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.observacoes = _data["observacoes"];
            if (Array.isArray(_data["arquivosCids"])) {
                this.arquivosCids = [] as any;
                for (let item of _data["arquivosCids"])
                    this.arquivosCids.push(ArquivoCid.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Cid {
        data = typeof data === 'object' ? data : {};
        let result = new Cid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["observacoes"] = this.observacoes;
        if (Array.isArray(this.arquivosCids)) {
            data["arquivosCids"] = [];
            for (let item of this.arquivosCids)
                data["arquivosCids"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Cid {
        const json = this.toJSON();
        let result = new Cid();
        result.init(json);
        return result;
    }
}

export interface ICid {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    arquivosCids: ArquivoCid[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ArquivoCid implements IArquivoCid {
    arquivoId: string;
    arquivo: Arquivo;
    cidId: string;
    cid: Cid;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IArquivoCid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoId = _data["arquivoId"];
            this.arquivo = _data["arquivo"] ? Arquivo.fromJS(_data["arquivo"]) : <any>undefined;
            this.cidId = _data["cidId"];
            this.cid = _data["cid"] ? Cid.fromJS(_data["cid"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ArquivoCid {
        data = typeof data === 'object' ? data : {};
        let result = new ArquivoCid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoId"] = this.arquivoId;
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        data["cidId"] = this.cidId;
        data["cid"] = this.cid ? this.cid.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ArquivoCid {
        const json = this.toJSON();
        let result = new ArquivoCid();
        result.init(json);
        return result;
    }
}

export interface IArquivoCid {
    arquivoId: string;
    arquivo: Arquivo;
    cidId: string;
    cid: Cid;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProcedimentoSigtap implements IProcedimentoSigtap {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    observacoes: string | undefined;
    arquivoProcedimentoSigtaps: ArquivoProcedimentoSigtap[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProcedimentoSigtap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.grupo = _data["grupo"];
            this.subgrupo = _data["subgrupo"];
            this.observacoes = _data["observacoes"];
            if (Array.isArray(_data["arquivoProcedimentoSigtaps"])) {
                this.arquivoProcedimentoSigtaps = [] as any;
                for (let item of _data["arquivoProcedimentoSigtaps"])
                    this.arquivoProcedimentoSigtaps.push(ArquivoProcedimentoSigtap.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProcedimentoSigtap {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedimentoSigtap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["grupo"] = this.grupo;
        data["subgrupo"] = this.subgrupo;
        data["observacoes"] = this.observacoes;
        if (Array.isArray(this.arquivoProcedimentoSigtaps)) {
            data["arquivoProcedimentoSigtaps"] = [];
            for (let item of this.arquivoProcedimentoSigtaps)
                data["arquivoProcedimentoSigtaps"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProcedimentoSigtap {
        const json = this.toJSON();
        let result = new ProcedimentoSigtap();
        result.init(json);
        return result;
    }
}

export interface IProcedimentoSigtap {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    observacoes: string | undefined;
    arquivoProcedimentoSigtaps: ArquivoProcedimentoSigtap[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ArquivoProcedimentoSigtap implements IArquivoProcedimentoSigtap {
    arquivoId: string;
    arquivo: Arquivo;
    procedimentoSigtapId: string;
    procedimento: ProcedimentoSigtap;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IArquivoProcedimentoSigtap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoId = _data["arquivoId"];
            this.arquivo = _data["arquivo"] ? Arquivo.fromJS(_data["arquivo"]) : <any>undefined;
            this.procedimentoSigtapId = _data["procedimentoSigtapId"];
            this.procedimento = _data["procedimento"] ? ProcedimentoSigtap.fromJS(_data["procedimento"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ArquivoProcedimentoSigtap {
        data = typeof data === 'object' ? data : {};
        let result = new ArquivoProcedimentoSigtap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoId"] = this.arquivoId;
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        data["procedimentoSigtapId"] = this.procedimentoSigtapId;
        data["procedimento"] = this.procedimento ? this.procedimento.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ArquivoProcedimentoSigtap {
        const json = this.toJSON();
        let result = new ArquivoProcedimentoSigtap();
        result.init(json);
        return result;
    }
}

export interface IArquivoProcedimentoSigtap {
    arquivoId: string;
    arquivo: Arquivo;
    procedimentoSigtapId: string;
    procedimento: ProcedimentoSigtap;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProcedimentoTuss implements IProcedimentoTuss {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    arquivoPocedimentosTuss: ArquivoProcedimentoTuss[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProcedimentoTuss) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.observacoes = _data["observacoes"];
            if (Array.isArray(_data["arquivoPocedimentosTuss"])) {
                this.arquivoPocedimentosTuss = [] as any;
                for (let item of _data["arquivoPocedimentosTuss"])
                    this.arquivoPocedimentosTuss.push(ArquivoProcedimentoTuss.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProcedimentoTuss {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedimentoTuss();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["observacoes"] = this.observacoes;
        if (Array.isArray(this.arquivoPocedimentosTuss)) {
            data["arquivoPocedimentosTuss"] = [];
            for (let item of this.arquivoPocedimentosTuss)
                data["arquivoPocedimentosTuss"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProcedimentoTuss {
        const json = this.toJSON();
        let result = new ProcedimentoTuss();
        result.init(json);
        return result;
    }
}

export interface IProcedimentoTuss {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    arquivoPocedimentosTuss: ArquivoProcedimentoTuss[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ArquivoProcedimentoTuss implements IArquivoProcedimentoTuss {
    arquivoId: string;
    arquivo: Arquivo;
    procedimentoTussId: string;
    procedimento: ProcedimentoTuss;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IArquivoProcedimentoTuss) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoId = _data["arquivoId"];
            this.arquivo = _data["arquivo"] ? Arquivo.fromJS(_data["arquivo"]) : <any>undefined;
            this.procedimentoTussId = _data["procedimentoTussId"];
            this.procedimento = _data["procedimento"] ? ProcedimentoTuss.fromJS(_data["procedimento"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ArquivoProcedimentoTuss {
        data = typeof data === 'object' ? data : {};
        let result = new ArquivoProcedimentoTuss();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoId"] = this.arquivoId;
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        data["procedimentoTussId"] = this.procedimentoTussId;
        data["procedimento"] = this.procedimento ? this.procedimento.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ArquivoProcedimentoTuss {
        const json = this.toJSON();
        let result = new ArquivoProcedimentoTuss();
        result.init(json);
        return result;
    }
}

export interface IArquivoProcedimentoTuss {
    arquivoId: string;
    arquivo: Arquivo;
    procedimentoTussId: string;
    procedimento: ProcedimentoTuss;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class MedicamentoSigtap implements IMedicamentoSigtap {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    organizacao: string | undefined;
    observacoes: string | undefined;
    arquivosMedicamentosSigtap: ArquivoMedicamentoSigtap[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IMedicamentoSigtap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.grupo = _data["grupo"];
            this.subgrupo = _data["subgrupo"];
            this.organizacao = _data["organizacao"];
            this.observacoes = _data["observacoes"];
            if (Array.isArray(_data["arquivosMedicamentosSigtap"])) {
                this.arquivosMedicamentosSigtap = [] as any;
                for (let item of _data["arquivosMedicamentosSigtap"])
                    this.arquivosMedicamentosSigtap.push(ArquivoMedicamentoSigtap.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicamentoSigtap {
        data = typeof data === 'object' ? data : {};
        let result = new MedicamentoSigtap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["grupo"] = this.grupo;
        data["subgrupo"] = this.subgrupo;
        data["organizacao"] = this.organizacao;
        data["observacoes"] = this.observacoes;
        if (Array.isArray(this.arquivosMedicamentosSigtap)) {
            data["arquivosMedicamentosSigtap"] = [];
            for (let item of this.arquivosMedicamentosSigtap)
                data["arquivosMedicamentosSigtap"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): MedicamentoSigtap {
        const json = this.toJSON();
        let result = new MedicamentoSigtap();
        result.init(json);
        return result;
    }
}

export interface IMedicamentoSigtap {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    organizacao: string | undefined;
    observacoes: string | undefined;
    arquivosMedicamentosSigtap: ArquivoMedicamentoSigtap[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ArquivoMedicamentoSigtap implements IArquivoMedicamentoSigtap {
    arquivoId: string;
    arquivo: Arquivo;
    medicamentoSigtapId: string;
    medicamento: MedicamentoSigtap;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IArquivoMedicamentoSigtap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoId = _data["arquivoId"];
            this.arquivo = _data["arquivo"] ? Arquivo.fromJS(_data["arquivo"]) : <any>undefined;
            this.medicamentoSigtapId = _data["medicamentoSigtapId"];
            this.medicamento = _data["medicamento"] ? MedicamentoSigtap.fromJS(_data["medicamento"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ArquivoMedicamentoSigtap {
        data = typeof data === 'object' ? data : {};
        let result = new ArquivoMedicamentoSigtap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoId"] = this.arquivoId;
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        data["medicamentoSigtapId"] = this.medicamentoSigtapId;
        data["medicamento"] = this.medicamento ? this.medicamento.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ArquivoMedicamentoSigtap {
        const json = this.toJSON();
        let result = new ArquivoMedicamentoSigtap();
        result.init(json);
        return result;
    }
}

export interface IArquivoMedicamentoSigtap {
    arquivoId: string;
    arquivo: Arquivo;
    medicamentoSigtapId: string;
    medicamento: MedicamentoSigtap;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class MedicamentoTiss implements IMedicamentoTiss {
    codigo: string | undefined;
    descricao: string | undefined;
    principioAtivo: string | undefined;
    generico: string | undefined;
    grupoFarmacologico: string | undefined;
    classeFarmacologica: string | undefined;
    formaFarmaceutica: string | undefined;
    unidMinFracao: string | undefined;
    detentordoRegistronaAnvisa: string | undefined;
    registroANVISA: string | undefined;
    tipodeProduto: string | undefined;
    tipodeCodificacao: string | undefined;
    codTISSBrasindice: string | undefined;
    observacoes: string | undefined;
    arquivoMedicamentoTisses: ArquivoMedicamentoTiss[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IMedicamentoTiss) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.principioAtivo = _data["principioAtivo"];
            this.generico = _data["generico"];
            this.grupoFarmacologico = _data["grupoFarmacologico"];
            this.classeFarmacologica = _data["classeFarmacologica"];
            this.formaFarmaceutica = _data["formaFarmaceutica"];
            this.unidMinFracao = _data["unidMinFracao"];
            this.detentordoRegistronaAnvisa = _data["detentordoRegistronaAnvisa"];
            this.registroANVISA = _data["registroANVISA"];
            this.tipodeProduto = _data["tipodeProduto"];
            this.tipodeCodificacao = _data["tipodeCodificacao"];
            this.codTISSBrasindice = _data["codTISSBrasindice"];
            this.observacoes = _data["observacoes"];
            if (Array.isArray(_data["arquivoMedicamentoTisses"])) {
                this.arquivoMedicamentoTisses = [] as any;
                for (let item of _data["arquivoMedicamentoTisses"])
                    this.arquivoMedicamentoTisses.push(ArquivoMedicamentoTiss.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicamentoTiss {
        data = typeof data === 'object' ? data : {};
        let result = new MedicamentoTiss();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["principioAtivo"] = this.principioAtivo;
        data["generico"] = this.generico;
        data["grupoFarmacologico"] = this.grupoFarmacologico;
        data["classeFarmacologica"] = this.classeFarmacologica;
        data["formaFarmaceutica"] = this.formaFarmaceutica;
        data["unidMinFracao"] = this.unidMinFracao;
        data["detentordoRegistronaAnvisa"] = this.detentordoRegistronaAnvisa;
        data["registroANVISA"] = this.registroANVISA;
        data["tipodeProduto"] = this.tipodeProduto;
        data["tipodeCodificacao"] = this.tipodeCodificacao;
        data["codTISSBrasindice"] = this.codTISSBrasindice;
        data["observacoes"] = this.observacoes;
        if (Array.isArray(this.arquivoMedicamentoTisses)) {
            data["arquivoMedicamentoTisses"] = [];
            for (let item of this.arquivoMedicamentoTisses)
                data["arquivoMedicamentoTisses"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): MedicamentoTiss {
        const json = this.toJSON();
        let result = new MedicamentoTiss();
        result.init(json);
        return result;
    }
}

export interface IMedicamentoTiss {
    codigo: string | undefined;
    descricao: string | undefined;
    principioAtivo: string | undefined;
    generico: string | undefined;
    grupoFarmacologico: string | undefined;
    classeFarmacologica: string | undefined;
    formaFarmaceutica: string | undefined;
    unidMinFracao: string | undefined;
    detentordoRegistronaAnvisa: string | undefined;
    registroANVISA: string | undefined;
    tipodeProduto: string | undefined;
    tipodeCodificacao: string | undefined;
    codTISSBrasindice: string | undefined;
    observacoes: string | undefined;
    arquivoMedicamentoTisses: ArquivoMedicamentoTiss[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ArquivoMedicamentoTiss implements IArquivoMedicamentoTiss {
    arquivoId: string;
    arquivo: Arquivo;
    medicamentoTissId: string;
    medicamento: MedicamentoTiss;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IArquivoMedicamentoTiss) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoId = _data["arquivoId"];
            this.arquivo = _data["arquivo"] ? Arquivo.fromJS(_data["arquivo"]) : <any>undefined;
            this.medicamentoTissId = _data["medicamentoTissId"];
            this.medicamento = _data["medicamento"] ? MedicamentoTiss.fromJS(_data["medicamento"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ArquivoMedicamentoTiss {
        data = typeof data === 'object' ? data : {};
        let result = new ArquivoMedicamentoTiss();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoId"] = this.arquivoId;
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        data["medicamentoTissId"] = this.medicamentoTissId;
        data["medicamento"] = this.medicamento ? this.medicamento.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ArquivoMedicamentoTiss {
        const json = this.toJSON();
        let result = new ArquivoMedicamentoTiss();
        result.init(json);
        return result;
    }
}

export interface IArquivoMedicamentoTiss {
    arquivoId: string;
    arquivo: Arquivo;
    medicamentoTissId: string;
    medicamento: MedicamentoTiss;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Historico implements IHistorico {
    dataHora: moment.Moment;
    descricao: string | undefined;
    pacienteId: string;
    arquivoId: string | undefined;
    arquivo: Arquivo;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IHistorico) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.descricao = _data["descricao"];
            this.pacienteId = _data["pacienteId"];
            this.arquivoId = _data["arquivoId"];
            this.arquivo = _data["arquivo"] ? Arquivo.fromJS(_data["arquivo"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Historico {
        data = typeof data === 'object' ? data : {};
        let result = new Historico();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["descricao"] = this.descricao;
        data["pacienteId"] = this.pacienteId;
        data["arquivoId"] = this.arquivoId;
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Historico {
        const json = this.toJSON();
        let result = new Historico();
        result.init(json);
        return result;
    }
}

export interface IHistorico {
    dataHora: moment.Moment;
    descricao: string | undefined;
    pacienteId: string;
    arquivoId: string | undefined;
    arquivo: Arquivo;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Arquivo implements IArquivo {
    nome: string;
    extensaoArquivo: string | undefined;
    ehPasta: boolean;
    tamanho: number;
    arquivoPaiId: string | undefined;
    pacienteId: string;
    clinicaId: string | undefined;
    urlArquivo: string | undefined;
    ultimaAlteracao: moment.Moment;
    tipoArquivo: string | undefined;
    template: string | undefined;
    codigo: string | undefined;
    codigoValidacaoIti: string | undefined;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    observacao: string | undefined;
    localizacao: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    darBaixa: boolean | undefined;
    vip: boolean;
    isDefault: boolean;
    anexosConsultas: AnexoConsulta;
    arquivosCids: ArquivoCid[] | undefined;
    arquivosProcedimentosSigtap: ArquivoProcedimentoSigtap[] | undefined;
    arquivosProcedimentosTuss: ArquivoProcedimentoTuss[] | undefined;
    arquivosMedicamentosSigtap: ArquivoMedicamentoSigtap[] | undefined;
    arquivosMedicamentosTiss: ArquivoMedicamentoTiss[] | undefined;
    historico: Historico[] | undefined;
    statusProntuario: StatusProntuarioEnum;
    readonly statusProntuarioString: string | undefined;
    clinicaMedicaPacienteVipId: string | undefined;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVip;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IArquivo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.ehPasta = _data["ehPasta"];
            this.tamanho = _data["tamanho"];
            this.arquivoPaiId = _data["arquivoPaiId"];
            this.pacienteId = _data["pacienteId"];
            this.clinicaId = _data["clinicaId"];
            this.urlArquivo = _data["urlArquivo"];
            this.ultimaAlteracao = _data["ultimaAlteracao"] ? moment(_data["ultimaAlteracao"].toString()) : <any>undefined;
            this.tipoArquivo = _data["tipoArquivo"];
            this.template = _data["template"];
            this.codigo = _data["codigo"];
            this.codigoValidacaoIti = _data["codigoValidacaoIti"];
            this.ordemProfissionalSaude = _data["ordemProfissionalSaude"];
            this.ordemPaciente = _data["ordemPaciente"];
            this.observacao = _data["observacao"];
            this.localizacao = _data["localizacao"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.darBaixa = _data["darBaixa"];
            this.vip = _data["vip"];
            this.isDefault = _data["isDefault"];
            this.anexosConsultas = _data["anexosConsultas"] ? AnexoConsulta.fromJS(_data["anexosConsultas"]) : <any>undefined;
            if (Array.isArray(_data["arquivosCids"])) {
                this.arquivosCids = [] as any;
                for (let item of _data["arquivosCids"])
                    this.arquivosCids.push(ArquivoCid.fromJS(item));
            }
            if (Array.isArray(_data["arquivosProcedimentosSigtap"])) {
                this.arquivosProcedimentosSigtap = [] as any;
                for (let item of _data["arquivosProcedimentosSigtap"])
                    this.arquivosProcedimentosSigtap.push(ArquivoProcedimentoSigtap.fromJS(item));
            }
            if (Array.isArray(_data["arquivosProcedimentosTuss"])) {
                this.arquivosProcedimentosTuss = [] as any;
                for (let item of _data["arquivosProcedimentosTuss"])
                    this.arquivosProcedimentosTuss.push(ArquivoProcedimentoTuss.fromJS(item));
            }
            if (Array.isArray(_data["arquivosMedicamentosSigtap"])) {
                this.arquivosMedicamentosSigtap = [] as any;
                for (let item of _data["arquivosMedicamentosSigtap"])
                    this.arquivosMedicamentosSigtap.push(ArquivoMedicamentoSigtap.fromJS(item));
            }
            if (Array.isArray(_data["arquivosMedicamentosTiss"])) {
                this.arquivosMedicamentosTiss = [] as any;
                for (let item of _data["arquivosMedicamentosTiss"])
                    this.arquivosMedicamentosTiss.push(ArquivoMedicamentoTiss.fromJS(item));
            }
            if (Array.isArray(_data["historico"])) {
                this.historico = [] as any;
                for (let item of _data["historico"])
                    this.historico.push(Historico.fromJS(item));
            }
            this.statusProntuario = _data["statusProntuario"];
            (<any>this).statusProntuarioString = _data["statusProntuarioString"];
            this.clinicaMedicaPacienteVipId = _data["clinicaMedicaPacienteVipId"];
            this.clinicaMedicaPacienteVip = _data["clinicaMedicaPacienteVip"] ? ClinicaMedicaPacienteVip.fromJS(_data["clinicaMedicaPacienteVip"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Arquivo {
        data = typeof data === 'object' ? data : {};
        let result = new Arquivo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["ehPasta"] = this.ehPasta;
        data["tamanho"] = this.tamanho;
        data["arquivoPaiId"] = this.arquivoPaiId;
        data["pacienteId"] = this.pacienteId;
        data["clinicaId"] = this.clinicaId;
        data["urlArquivo"] = this.urlArquivo;
        data["ultimaAlteracao"] = this.ultimaAlteracao ? this.ultimaAlteracao.toISOString() : <any>undefined;
        data["tipoArquivo"] = this.tipoArquivo;
        data["template"] = this.template;
        data["codigo"] = this.codigo;
        data["codigoValidacaoIti"] = this.codigoValidacaoIti;
        data["ordemProfissionalSaude"] = this.ordemProfissionalSaude;
        data["ordemPaciente"] = this.ordemPaciente;
        data["observacao"] = this.observacao;
        data["localizacao"] = this.localizacao;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["darBaixa"] = this.darBaixa;
        data["vip"] = this.vip;
        data["isDefault"] = this.isDefault;
        data["anexosConsultas"] = this.anexosConsultas ? this.anexosConsultas.toJSON() : <any>undefined;
        if (Array.isArray(this.arquivosCids)) {
            data["arquivosCids"] = [];
            for (let item of this.arquivosCids)
                data["arquivosCids"].push(item.toJSON());
        }
        if (Array.isArray(this.arquivosProcedimentosSigtap)) {
            data["arquivosProcedimentosSigtap"] = [];
            for (let item of this.arquivosProcedimentosSigtap)
                data["arquivosProcedimentosSigtap"].push(item.toJSON());
        }
        if (Array.isArray(this.arquivosProcedimentosTuss)) {
            data["arquivosProcedimentosTuss"] = [];
            for (let item of this.arquivosProcedimentosTuss)
                data["arquivosProcedimentosTuss"].push(item.toJSON());
        }
        if (Array.isArray(this.arquivosMedicamentosSigtap)) {
            data["arquivosMedicamentosSigtap"] = [];
            for (let item of this.arquivosMedicamentosSigtap)
                data["arquivosMedicamentosSigtap"].push(item.toJSON());
        }
        if (Array.isArray(this.arquivosMedicamentosTiss)) {
            data["arquivosMedicamentosTiss"] = [];
            for (let item of this.arquivosMedicamentosTiss)
                data["arquivosMedicamentosTiss"].push(item.toJSON());
        }
        if (Array.isArray(this.historico)) {
            data["historico"] = [];
            for (let item of this.historico)
                data["historico"].push(item.toJSON());
        }
        data["statusProntuario"] = this.statusProntuario;
        data["statusProntuarioString"] = this.statusProntuarioString;
        data["clinicaMedicaPacienteVipId"] = this.clinicaMedicaPacienteVipId;
        data["clinicaMedicaPacienteVip"] = this.clinicaMedicaPacienteVip ? this.clinicaMedicaPacienteVip.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Arquivo {
        const json = this.toJSON();
        let result = new Arquivo();
        result.init(json);
        return result;
    }
}

export interface IArquivo {
    nome: string;
    extensaoArquivo: string | undefined;
    ehPasta: boolean;
    tamanho: number;
    arquivoPaiId: string | undefined;
    pacienteId: string;
    clinicaId: string | undefined;
    urlArquivo: string | undefined;
    ultimaAlteracao: moment.Moment;
    tipoArquivo: string | undefined;
    template: string | undefined;
    codigo: string | undefined;
    codigoValidacaoIti: string | undefined;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    observacao: string | undefined;
    localizacao: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    darBaixa: boolean | undefined;
    vip: boolean;
    isDefault: boolean;
    anexosConsultas: AnexoConsulta;
    arquivosCids: ArquivoCid[] | undefined;
    arquivosProcedimentosSigtap: ArquivoProcedimentoSigtap[] | undefined;
    arquivosProcedimentosTuss: ArquivoProcedimentoTuss[] | undefined;
    arquivosMedicamentosSigtap: ArquivoMedicamentoSigtap[] | undefined;
    arquivosMedicamentosTiss: ArquivoMedicamentoTiss[] | undefined;
    historico: Historico[] | undefined;
    statusProntuario: StatusProntuarioEnum;
    statusProntuarioString: string | undefined;
    clinicaMedicaPacienteVipId: string | undefined;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVip;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ClinicaMedicaPacienteVip implements IClinicaMedicaPacienteVip {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedica;
    pacienteId: string;
    paciente: Paciente;
    profissionalResponsavelId: string | undefined;
    profissionaisComAcesso: ProfissionalAcessoPacienteVip[] | undefined;
    arquivosVips: Arquivo[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IClinicaMedicaPacienteVip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.clinicaMedica = _data["clinicaMedica"] ? ClinicaMedica.fromJS(_data["clinicaMedica"]) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.profissionalResponsavelId = _data["profissionalResponsavelId"];
            if (Array.isArray(_data["profissionaisComAcesso"])) {
                this.profissionaisComAcesso = [] as any;
                for (let item of _data["profissionaisComAcesso"])
                    this.profissionaisComAcesso.push(ProfissionalAcessoPacienteVip.fromJS(item));
            }
            if (Array.isArray(_data["arquivosVips"])) {
                this.arquivosVips = [] as any;
                for (let item of _data["arquivosVips"])
                    this.arquivosVips.push(Arquivo.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClinicaMedicaPacienteVip {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicaMedicaPacienteVip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["clinicaMedica"] = this.clinicaMedica ? this.clinicaMedica.toJSON() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["profissionalResponsavelId"] = this.profissionalResponsavelId;
        if (Array.isArray(this.profissionaisComAcesso)) {
            data["profissionaisComAcesso"] = [];
            for (let item of this.profissionaisComAcesso)
                data["profissionaisComAcesso"].push(item.toJSON());
        }
        if (Array.isArray(this.arquivosVips)) {
            data["arquivosVips"] = [];
            for (let item of this.arquivosVips)
                data["arquivosVips"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ClinicaMedicaPacienteVip {
        const json = this.toJSON();
        let result = new ClinicaMedicaPacienteVip();
        result.init(json);
        return result;
    }
}

export interface IClinicaMedicaPacienteVip {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedica;
    pacienteId: string;
    paciente: Paciente;
    profissionalResponsavelId: string | undefined;
    profissionaisComAcesso: ProfissionalAcessoPacienteVip[] | undefined;
    arquivosVips: Arquivo[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class EmailAlternativo implements IEmailAlternativo {
    pacienteId: string;
    paciente: Paciente;
    email: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEmailAlternativo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmailAlternativo {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAlternativo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): EmailAlternativo {
        const json = this.toJSON();
        let result = new EmailAlternativo();
        result.init(json);
        return result;
    }
}

export interface IEmailAlternativo {
    pacienteId: string;
    paciente: Paciente;
    email: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Altura implements IAltura {
    valorAltura: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAltura) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorAltura = _data["valorAltura"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Altura {
        data = typeof data === 'object' ? data : {};
        let result = new Altura();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorAltura"] = this.valorAltura;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Altura {
        const json = this.toJSON();
        let result = new Altura();
        result.init(json);
        return result;
    }
}

export interface IAltura {
    valorAltura: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class BatimentosCardiacos implements IBatimentosCardiacos {
    valorBps: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IBatimentosCardiacos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorBps = _data["valorBps"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BatimentosCardiacos {
        data = typeof data === 'object' ? data : {};
        let result = new BatimentosCardiacos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorBps"] = this.valorBps;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): BatimentosCardiacos {
        const json = this.toJSON();
        let result = new BatimentosCardiacos();
        result.init(json);
        return result;
    }
}

export interface IBatimentosCardiacos {
    valorBps: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class DorArticular implements IDorArticular {
    ondeOcorre: string;
    nivelDor: number;
    tipoDor: NivelDorEnum;
    readonly tipoDorString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IDorArticular) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ondeOcorre = _data["ondeOcorre"];
            this.nivelDor = _data["nivelDor"];
            this.tipoDor = _data["tipoDor"];
            (<any>this).tipoDorString = _data["tipoDorString"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DorArticular {
        data = typeof data === 'object' ? data : {};
        let result = new DorArticular();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ondeOcorre"] = this.ondeOcorre;
        data["nivelDor"] = this.nivelDor;
        data["tipoDor"] = this.tipoDor;
        data["tipoDorString"] = this.tipoDorString;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): DorArticular {
        const json = this.toJSON();
        let result = new DorArticular();
        result.init(json);
        return result;
    }
}

export interface IDorArticular {
    ondeOcorre: string;
    nivelDor: number;
    tipoDor: NivelDorEnum;
    tipoDorString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class FrequenciaRespiratoria implements IFrequenciaRespiratoria {
    valorRpm: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IFrequenciaRespiratoria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorRpm = _data["valorRpm"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FrequenciaRespiratoria {
        data = typeof data === 'object' ? data : {};
        let result = new FrequenciaRespiratoria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorRpm"] = this.valorRpm;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): FrequenciaRespiratoria {
        const json = this.toJSON();
        let result = new FrequenciaRespiratoria();
        result.init(json);
        return result;
    }
}

export interface IFrequenciaRespiratoria {
    valorRpm: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum TipoMedicaoGlicoseEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class Glicose implements IGlicose {
    valorGlicose: number;
    tipoMedicao: TipoMedicaoGlicoseEnum;
    readonly tipoMedicaoString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IGlicose) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorGlicose = _data["valorGlicose"];
            this.tipoMedicao = _data["tipoMedicao"];
            (<any>this).tipoMedicaoString = _data["tipoMedicaoString"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Glicose {
        data = typeof data === 'object' ? data : {};
        let result = new Glicose();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorGlicose"] = this.valorGlicose;
        data["tipoMedicao"] = this.tipoMedicao;
        data["tipoMedicaoString"] = this.tipoMedicaoString;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Glicose {
        const json = this.toJSON();
        let result = new Glicose();
        result.init(json);
        return result;
    }
}

export interface IGlicose {
    valorGlicose: number;
    tipoMedicao: TipoMedicaoGlicoseEnum;
    tipoMedicaoString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum HumorEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class Humor implements IHumor {
    tipoHumor: HumorEnum;
    readonly tipoHumorString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IHumor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoHumor = _data["tipoHumor"];
            (<any>this).tipoHumorString = _data["tipoHumorString"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Humor {
        data = typeof data === 'object' ? data : {};
        let result = new Humor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoHumor"] = this.tipoHumor;
        data["tipoHumorString"] = this.tipoHumorString;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Humor {
        const json = this.toJSON();
        let result = new Humor();
        result.init(json);
        return result;
    }
}

export interface IHumor {
    tipoHumor: HumorEnum;
    tipoHumorString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ObjetivoImc implements IObjetivoImc {
    objetivo: number;
    pacienteId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IObjetivoImc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objetivo = _data["objetivo"];
            this.pacienteId = _data["pacienteId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ObjetivoImc {
        data = typeof data === 'object' ? data : {};
        let result = new ObjetivoImc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objetivo"] = this.objetivo;
        data["pacienteId"] = this.pacienteId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ObjetivoImc {
        const json = this.toJSON();
        let result = new ObjetivoImc();
        result.init(json);
        return result;
    }
}

export interface IObjetivoImc {
    objetivo: number;
    pacienteId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Oximetria implements IOximetria {
    valorOximetria: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IOximetria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorOximetria = _data["valorOximetria"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Oximetria {
        data = typeof data === 'object' ? data : {};
        let result = new Oximetria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorOximetria"] = this.valorOximetria;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Oximetria {
        const json = this.toJSON();
        let result = new Oximetria();
        result.init(json);
        return result;
    }
}

export interface IOximetria {
    valorOximetria: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Peso implements IPeso {
    valorPeso: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    objetivo: boolean;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPeso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorPeso = _data["valorPeso"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.objetivo = _data["objetivo"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Peso {
        data = typeof data === 'object' ? data : {};
        let result = new Peso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorPeso"] = this.valorPeso;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["objetivo"] = this.objetivo;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Peso {
        const json = this.toJSON();
        let result = new Peso();
        result.init(json);
        return result;
    }
}

export interface IPeso {
    valorPeso: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    objetivo: boolean;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PressaoArterial implements IPressaoArterial {
    valorSistolica: number;
    valorDiastolica: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPressaoArterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorSistolica = _data["valorSistolica"];
            this.valorDiastolica = _data["valorDiastolica"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PressaoArterial {
        data = typeof data === 'object' ? data : {};
        let result = new PressaoArterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorSistolica"] = this.valorSistolica;
        data["valorDiastolica"] = this.valorDiastolica;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PressaoArterial {
        const json = this.toJSON();
        let result = new PressaoArterial();
        result.init(json);
        return result;
    }
}

export interface IPressaoArterial {
    valorSistolica: number;
    valorDiastolica: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum QualidadeSonoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class QualidadeSono implements IQualidadeSono {
    duracaoSono: string;
    qualidadeSonoEnum: QualidadeSonoEnum;
    readonly qualidadeSonoString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IQualidadeSono) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duracaoSono = _data["duracaoSono"];
            this.qualidadeSonoEnum = _data["qualidadeSonoEnum"];
            (<any>this).qualidadeSonoString = _data["qualidadeSonoString"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QualidadeSono {
        data = typeof data === 'object' ? data : {};
        let result = new QualidadeSono();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duracaoSono"] = this.duracaoSono;
        data["qualidadeSonoEnum"] = this.qualidadeSonoEnum;
        data["qualidadeSonoString"] = this.qualidadeSonoString;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): QualidadeSono {
        const json = this.toJSON();
        let result = new QualidadeSono();
        result.init(json);
        return result;
    }
}

export interface IQualidadeSono {
    duracaoSono: string;
    qualidadeSonoEnum: QualidadeSonoEnum;
    qualidadeSonoString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Temperatura implements ITemperatura {
    valorTemperatura: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ITemperatura) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorTemperatura = _data["valorTemperatura"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Temperatura {
        data = typeof data === 'object' ? data : {};
        let result = new Temperatura();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorTemperatura"] = this.valorTemperatura;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Temperatura {
        const json = this.toJSON();
        let result = new Temperatura();
        result.init(json);
        return result;
    }
}

export interface ITemperatura {
    valorTemperatura: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    isProfissionalSaude: boolean;
    alerta: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PacienteClinicaMedica implements IPacienteClinicaMedica {
    clinicaMedica: ClinicaMedica;
    clinicaMedicaId: string;
    paciente: Paciente;
    pacienteId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPacienteClinicaMedica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedica = _data["clinicaMedica"] ? ClinicaMedica.fromJS(_data["clinicaMedica"]) : <any>undefined;
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteClinicaMedica {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteClinicaMedica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedica"] = this.clinicaMedica ? this.clinicaMedica.toJSON() : <any>undefined;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteClinicaMedica {
        const json = this.toJSON();
        let result = new PacienteClinicaMedica();
        result.init(json);
        return result;
    }
}

export interface IPacienteClinicaMedica {
    clinicaMedica: ClinicaMedica;
    clinicaMedicaId: string;
    paciente: Paciente;
    pacienteId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class RegistroRespostaPacienteClinica implements IRegistroRespostaPacienteClinica {
    remetenteId: string;
    paciente: Paciente;
    pacienteId: string;
    notificacaoId: string;
    aceito: boolean;
    isClinica: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRegistroRespostaPacienteClinica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remetenteId = _data["remetenteId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.notificacaoId = _data["notificacaoId"];
            this.aceito = _data["aceito"];
            this.isClinica = _data["isClinica"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegistroRespostaPacienteClinica {
        data = typeof data === 'object' ? data : {};
        let result = new RegistroRespostaPacienteClinica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remetenteId"] = this.remetenteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["notificacaoId"] = this.notificacaoId;
        data["aceito"] = this.aceito;
        data["isClinica"] = this.isClinica;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RegistroRespostaPacienteClinica {
        const json = this.toJSON();
        let result = new RegistroRespostaPacienteClinica();
        result.init(json);
        return result;
    }
}

export interface IRegistroRespostaPacienteClinica {
    remetenteId: string;
    paciente: Paciente;
    pacienteId: string;
    notificacaoId: string;
    aceito: boolean;
    isClinica: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum GraficoMonitoramentoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export class GraficoMonitoramento implements IGraficoMonitoramento {
    grupoMonitoramentoId: string;
    grupoMonitoramento: GrupoMonitoramento;
    valorMaximo: number | undefined;
    valorMinimo: number | undefined;
    valorMaximoAlternativo: number | undefined;
    valorMinimoAlternativo: number | undefined;
    grafico: GraficoMonitoramentoEnum;
    readonly graficoString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IGraficoMonitoramento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grupoMonitoramentoId = _data["grupoMonitoramentoId"];
            this.grupoMonitoramento = _data["grupoMonitoramento"] ? GrupoMonitoramento.fromJS(_data["grupoMonitoramento"]) : <any>undefined;
            this.valorMaximo = _data["valorMaximo"];
            this.valorMinimo = _data["valorMinimo"];
            this.valorMaximoAlternativo = _data["valorMaximoAlternativo"];
            this.valorMinimoAlternativo = _data["valorMinimoAlternativo"];
            this.grafico = _data["grafico"];
            (<any>this).graficoString = _data["graficoString"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GraficoMonitoramento {
        data = typeof data === 'object' ? data : {};
        let result = new GraficoMonitoramento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grupoMonitoramentoId"] = this.grupoMonitoramentoId;
        data["grupoMonitoramento"] = this.grupoMonitoramento ? this.grupoMonitoramento.toJSON() : <any>undefined;
        data["valorMaximo"] = this.valorMaximo;
        data["valorMinimo"] = this.valorMinimo;
        data["valorMaximoAlternativo"] = this.valorMaximoAlternativo;
        data["valorMinimoAlternativo"] = this.valorMinimoAlternativo;
        data["grafico"] = this.grafico;
        data["graficoString"] = this.graficoString;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): GraficoMonitoramento {
        const json = this.toJSON();
        let result = new GraficoMonitoramento();
        result.init(json);
        return result;
    }
}

export interface IGraficoMonitoramento {
    grupoMonitoramentoId: string;
    grupoMonitoramento: GrupoMonitoramento;
    valorMaximo: number | undefined;
    valorMinimo: number | undefined;
    valorMaximoAlternativo: number | undefined;
    valorMinimoAlternativo: number | undefined;
    grafico: GraficoMonitoramentoEnum;
    graficoString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class GrupoMonitoramento implements IGrupoMonitoramento {
    nome: string;
    descricao: string;
    profissionalId: string;
    profissional: ProfissionalSaude;
    clinicaId: string | undefined;
    clinica: ClinicaMedica;
    ativo: boolean;
    grupoPacientes: PacienteGrupoMonitoramento[] | undefined;
    graficos: GraficoMonitoramento[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IGrupoMonitoramento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.descricao = _data["descricao"];
            this.profissionalId = _data["profissionalId"];
            this.profissional = _data["profissional"] ? ProfissionalSaude.fromJS(_data["profissional"]) : <any>undefined;
            this.clinicaId = _data["clinicaId"];
            this.clinica = _data["clinica"] ? ClinicaMedica.fromJS(_data["clinica"]) : <any>undefined;
            this.ativo = _data["ativo"];
            if (Array.isArray(_data["grupoPacientes"])) {
                this.grupoPacientes = [] as any;
                for (let item of _data["grupoPacientes"])
                    this.grupoPacientes.push(PacienteGrupoMonitoramento.fromJS(item));
            }
            if (Array.isArray(_data["graficos"])) {
                this.graficos = [] as any;
                for (let item of _data["graficos"])
                    this.graficos.push(GraficoMonitoramento.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GrupoMonitoramento {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoMonitoramento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["descricao"] = this.descricao;
        data["profissionalId"] = this.profissionalId;
        data["profissional"] = this.profissional ? this.profissional.toJSON() : <any>undefined;
        data["clinicaId"] = this.clinicaId;
        data["clinica"] = this.clinica ? this.clinica.toJSON() : <any>undefined;
        data["ativo"] = this.ativo;
        if (Array.isArray(this.grupoPacientes)) {
            data["grupoPacientes"] = [];
            for (let item of this.grupoPacientes)
                data["grupoPacientes"].push(item.toJSON());
        }
        if (Array.isArray(this.graficos)) {
            data["graficos"] = [];
            for (let item of this.graficos)
                data["graficos"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): GrupoMonitoramento {
        const json = this.toJSON();
        let result = new GrupoMonitoramento();
        result.init(json);
        return result;
    }
}

export interface IGrupoMonitoramento {
    nome: string;
    descricao: string;
    profissionalId: string;
    profissional: ProfissionalSaude;
    clinicaId: string | undefined;
    clinica: ClinicaMedica;
    ativo: boolean;
    grupoPacientes: PacienteGrupoMonitoramento[] | undefined;
    graficos: GraficoMonitoramento[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PacienteGrupoMonitoramento implements IPacienteGrupoMonitoramento {
    grupoId: string;
    grupo: GrupoMonitoramento;
    pacienteId: string;
    paciente: Paciente;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPacienteGrupoMonitoramento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grupoId = _data["grupoId"];
            this.grupo = _data["grupo"] ? GrupoMonitoramento.fromJS(_data["grupo"]) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteGrupoMonitoramento {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteGrupoMonitoramento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grupoId"] = this.grupoId;
        data["grupo"] = this.grupo ? this.grupo.toJSON() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteGrupoMonitoramento {
        const json = this.toJSON();
        let result = new PacienteGrupoMonitoramento();
        result.init(json);
        return result;
    }
}

export interface IPacienteGrupoMonitoramento {
    grupoId: string;
    grupo: GrupoMonitoramento;
    pacienteId: string;
    paciente: Paciente;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PacienteAlergia implements IPacienteAlergia {
    pacienteId: string;
    paciente: Paciente;
    substancia: string;
    tipoAlergia: TipoAlergiaEnum;
    readonly tipoAlergiaString: string | undefined;
    observacao: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPacienteAlergia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.substancia = _data["substancia"];
            this.tipoAlergia = _data["tipoAlergia"];
            (<any>this).tipoAlergiaString = _data["tipoAlergiaString"];
            this.observacao = _data["observacao"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteAlergia {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteAlergia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["substancia"] = this.substancia;
        data["tipoAlergia"] = this.tipoAlergia;
        data["tipoAlergiaString"] = this.tipoAlergiaString;
        data["observacao"] = this.observacao;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteAlergia {
        const json = this.toJSON();
        let result = new PacienteAlergia();
        result.init(json);
        return result;
    }
}

export interface IPacienteAlergia {
    pacienteId: string;
    paciente: Paciente;
    substancia: string;
    tipoAlergia: TipoAlergiaEnum;
    tipoAlergiaString: string | undefined;
    observacao: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Paciente implements IPaciente {
    nome: string;
    nomeSocial: string | undefined;
    cpf: string | undefined;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    nomeMae: string | undefined;
    peso: string | undefined;
    altura: string | undefined;
    email: string | undefined;
    objetivoPeso: number | undefined;
    hasCadastroCompleto: boolean;
    tipoSanguineo: TipoSanguineoEnum;
    readonly tipoSanguineoString: string | undefined;
    estadoCivil: EstadoCivilEnum;
    readonly estadoCivilString: string | undefined;
    corEtnia: CorEtniaEnum;
    readonly corEtniaString: string | undefined;
    profissao: string | undefined;
    religiao: string | undefined;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVip[] | undefined;
    emailAlternativo: EmailAlternativo[] | undefined;
    dadosAltura: Altura[] | undefined;
    dadosBatimentosCardiacos: BatimentosCardiacos[] | undefined;
    dadosDorArticular: DorArticular[] | undefined;
    dadosFrequenciaRespiratoria: FrequenciaRespiratoria[] | undefined;
    dadosGlicose: Glicose[] | undefined;
    dadosHumor: Humor[] | undefined;
    dadosObjetivoImc: ObjetivoImc[] | undefined;
    dadosOximetria: Oximetria[] | undefined;
    dadosPeso: Peso[] | undefined;
    dadosPressaoArterial: PressaoArterial[] | undefined;
    dadosQualidadeSono: QualidadeSono[] | undefined;
    dadosTemperatura: Temperatura[] | undefined;
    clinicasMedicas: PacienteClinicaMedica[] | undefined;
    medicos: ProfissionalSaudePaciente[] | undefined;
    registroRespostaPacienteClinicas: RegistroRespostaPacienteClinica[] | undefined;
    grupos: PacienteGrupoMonitoramento[] | undefined;
    pacienteAlergias: PacienteAlergia[] | undefined;
    pacienteConvenio: PacienteConvenio[] | undefined;
    celular: string | undefined;
    user: User;
    userId: number | undefined;
    endereco: Endereco;
    enderecoId: string | undefined;
    responsavelLegalId: string | undefined;
    responsavelLegal: Paciente;
    prontuarioId: string | undefined;
    readonly sexoString: string;
    readonly grauParentescoString: string;
    numeroPassaporte: string | undefined;
    ehEstrangeiro: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPaciente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.nomeSocial = _data["nomeSocial"];
            this.cpf = _data["cpf"];
            this.rg = _data["rg"];
            this.cns = _data["cns"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.nomeMae = _data["nomeMae"];
            this.peso = _data["peso"];
            this.altura = _data["altura"];
            this.email = _data["email"];
            this.objetivoPeso = _data["objetivoPeso"];
            this.hasCadastroCompleto = _data["hasCadastroCompleto"];
            this.tipoSanguineo = _data["tipoSanguineo"];
            (<any>this).tipoSanguineoString = _data["tipoSanguineoString"];
            this.estadoCivil = _data["estadoCivil"];
            (<any>this).estadoCivilString = _data["estadoCivilString"];
            this.corEtnia = _data["corEtnia"];
            (<any>this).corEtniaString = _data["corEtniaString"];
            this.profissao = _data["profissao"];
            this.religiao = _data["religiao"];
            if (Array.isArray(_data["clinicaMedicaPacienteVip"])) {
                this.clinicaMedicaPacienteVip = [] as any;
                for (let item of _data["clinicaMedicaPacienteVip"])
                    this.clinicaMedicaPacienteVip.push(ClinicaMedicaPacienteVip.fromJS(item));
            }
            if (Array.isArray(_data["emailAlternativo"])) {
                this.emailAlternativo = [] as any;
                for (let item of _data["emailAlternativo"])
                    this.emailAlternativo.push(EmailAlternativo.fromJS(item));
            }
            if (Array.isArray(_data["dadosAltura"])) {
                this.dadosAltura = [] as any;
                for (let item of _data["dadosAltura"])
                    this.dadosAltura.push(Altura.fromJS(item));
            }
            if (Array.isArray(_data["dadosBatimentosCardiacos"])) {
                this.dadosBatimentosCardiacos = [] as any;
                for (let item of _data["dadosBatimentosCardiacos"])
                    this.dadosBatimentosCardiacos.push(BatimentosCardiacos.fromJS(item));
            }
            if (Array.isArray(_data["dadosDorArticular"])) {
                this.dadosDorArticular = [] as any;
                for (let item of _data["dadosDorArticular"])
                    this.dadosDorArticular.push(DorArticular.fromJS(item));
            }
            if (Array.isArray(_data["dadosFrequenciaRespiratoria"])) {
                this.dadosFrequenciaRespiratoria = [] as any;
                for (let item of _data["dadosFrequenciaRespiratoria"])
                    this.dadosFrequenciaRespiratoria.push(FrequenciaRespiratoria.fromJS(item));
            }
            if (Array.isArray(_data["dadosGlicose"])) {
                this.dadosGlicose = [] as any;
                for (let item of _data["dadosGlicose"])
                    this.dadosGlicose.push(Glicose.fromJS(item));
            }
            if (Array.isArray(_data["dadosHumor"])) {
                this.dadosHumor = [] as any;
                for (let item of _data["dadosHumor"])
                    this.dadosHumor.push(Humor.fromJS(item));
            }
            if (Array.isArray(_data["dadosObjetivoImc"])) {
                this.dadosObjetivoImc = [] as any;
                for (let item of _data["dadosObjetivoImc"])
                    this.dadosObjetivoImc.push(ObjetivoImc.fromJS(item));
            }
            if (Array.isArray(_data["dadosOximetria"])) {
                this.dadosOximetria = [] as any;
                for (let item of _data["dadosOximetria"])
                    this.dadosOximetria.push(Oximetria.fromJS(item));
            }
            if (Array.isArray(_data["dadosPeso"])) {
                this.dadosPeso = [] as any;
                for (let item of _data["dadosPeso"])
                    this.dadosPeso.push(Peso.fromJS(item));
            }
            if (Array.isArray(_data["dadosPressaoArterial"])) {
                this.dadosPressaoArterial = [] as any;
                for (let item of _data["dadosPressaoArterial"])
                    this.dadosPressaoArterial.push(PressaoArterial.fromJS(item));
            }
            if (Array.isArray(_data["dadosQualidadeSono"])) {
                this.dadosQualidadeSono = [] as any;
                for (let item of _data["dadosQualidadeSono"])
                    this.dadosQualidadeSono.push(QualidadeSono.fromJS(item));
            }
            if (Array.isArray(_data["dadosTemperatura"])) {
                this.dadosTemperatura = [] as any;
                for (let item of _data["dadosTemperatura"])
                    this.dadosTemperatura.push(Temperatura.fromJS(item));
            }
            if (Array.isArray(_data["clinicasMedicas"])) {
                this.clinicasMedicas = [] as any;
                for (let item of _data["clinicasMedicas"])
                    this.clinicasMedicas.push(PacienteClinicaMedica.fromJS(item));
            }
            if (Array.isArray(_data["medicos"])) {
                this.medicos = [] as any;
                for (let item of _data["medicos"])
                    this.medicos.push(ProfissionalSaudePaciente.fromJS(item));
            }
            if (Array.isArray(_data["registroRespostaPacienteClinicas"])) {
                this.registroRespostaPacienteClinicas = [] as any;
                for (let item of _data["registroRespostaPacienteClinicas"])
                    this.registroRespostaPacienteClinicas.push(RegistroRespostaPacienteClinica.fromJS(item));
            }
            if (Array.isArray(_data["grupos"])) {
                this.grupos = [] as any;
                for (let item of _data["grupos"])
                    this.grupos.push(PacienteGrupoMonitoramento.fromJS(item));
            }
            if (Array.isArray(_data["pacienteAlergias"])) {
                this.pacienteAlergias = [] as any;
                for (let item of _data["pacienteAlergias"])
                    this.pacienteAlergias.push(PacienteAlergia.fromJS(item));
            }
            if (Array.isArray(_data["pacienteConvenio"])) {
                this.pacienteConvenio = [] as any;
                for (let item of _data["pacienteConvenio"])
                    this.pacienteConvenio.push(PacienteConvenio.fromJS(item));
            }
            this.celular = _data["celular"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.endereco = _data["endereco"] ? Endereco.fromJS(_data["endereco"]) : <any>undefined;
            this.enderecoId = _data["enderecoId"];
            this.responsavelLegalId = _data["responsavelLegalId"];
            this.responsavelLegal = _data["responsavelLegal"] ? Paciente.fromJS(_data["responsavelLegal"]) : <any>undefined;
            this.prontuarioId = _data["prontuarioId"];
            (<any>this).sexoString = _data["sexoString"];
            (<any>this).grauParentescoString = _data["grauParentescoString"];
            this.numeroPassaporte = _data["numeroPassaporte"];
            this.ehEstrangeiro = _data["ehEstrangeiro"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Paciente {
        data = typeof data === 'object' ? data : {};
        let result = new Paciente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["nomeSocial"] = this.nomeSocial;
        data["cpf"] = this.cpf;
        data["rg"] = this.rg;
        data["cns"] = this.cns;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["nomeMae"] = this.nomeMae;
        data["peso"] = this.peso;
        data["altura"] = this.altura;
        data["email"] = this.email;
        data["objetivoPeso"] = this.objetivoPeso;
        data["hasCadastroCompleto"] = this.hasCadastroCompleto;
        data["tipoSanguineo"] = this.tipoSanguineo;
        data["tipoSanguineoString"] = this.tipoSanguineoString;
        data["estadoCivil"] = this.estadoCivil;
        data["estadoCivilString"] = this.estadoCivilString;
        data["corEtnia"] = this.corEtnia;
        data["corEtniaString"] = this.corEtniaString;
        data["profissao"] = this.profissao;
        data["religiao"] = this.religiao;
        if (Array.isArray(this.clinicaMedicaPacienteVip)) {
            data["clinicaMedicaPacienteVip"] = [];
            for (let item of this.clinicaMedicaPacienteVip)
                data["clinicaMedicaPacienteVip"].push(item.toJSON());
        }
        if (Array.isArray(this.emailAlternativo)) {
            data["emailAlternativo"] = [];
            for (let item of this.emailAlternativo)
                data["emailAlternativo"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosAltura)) {
            data["dadosAltura"] = [];
            for (let item of this.dadosAltura)
                data["dadosAltura"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosBatimentosCardiacos)) {
            data["dadosBatimentosCardiacos"] = [];
            for (let item of this.dadosBatimentosCardiacos)
                data["dadosBatimentosCardiacos"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosDorArticular)) {
            data["dadosDorArticular"] = [];
            for (let item of this.dadosDorArticular)
                data["dadosDorArticular"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosFrequenciaRespiratoria)) {
            data["dadosFrequenciaRespiratoria"] = [];
            for (let item of this.dadosFrequenciaRespiratoria)
                data["dadosFrequenciaRespiratoria"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosGlicose)) {
            data["dadosGlicose"] = [];
            for (let item of this.dadosGlicose)
                data["dadosGlicose"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosHumor)) {
            data["dadosHumor"] = [];
            for (let item of this.dadosHumor)
                data["dadosHumor"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosObjetivoImc)) {
            data["dadosObjetivoImc"] = [];
            for (let item of this.dadosObjetivoImc)
                data["dadosObjetivoImc"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosOximetria)) {
            data["dadosOximetria"] = [];
            for (let item of this.dadosOximetria)
                data["dadosOximetria"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosPeso)) {
            data["dadosPeso"] = [];
            for (let item of this.dadosPeso)
                data["dadosPeso"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosPressaoArterial)) {
            data["dadosPressaoArterial"] = [];
            for (let item of this.dadosPressaoArterial)
                data["dadosPressaoArterial"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosQualidadeSono)) {
            data["dadosQualidadeSono"] = [];
            for (let item of this.dadosQualidadeSono)
                data["dadosQualidadeSono"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosTemperatura)) {
            data["dadosTemperatura"] = [];
            for (let item of this.dadosTemperatura)
                data["dadosTemperatura"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicasMedicas)) {
            data["clinicasMedicas"] = [];
            for (let item of this.clinicasMedicas)
                data["clinicasMedicas"].push(item.toJSON());
        }
        if (Array.isArray(this.medicos)) {
            data["medicos"] = [];
            for (let item of this.medicos)
                data["medicos"].push(item.toJSON());
        }
        if (Array.isArray(this.registroRespostaPacienteClinicas)) {
            data["registroRespostaPacienteClinicas"] = [];
            for (let item of this.registroRespostaPacienteClinicas)
                data["registroRespostaPacienteClinicas"].push(item.toJSON());
        }
        if (Array.isArray(this.grupos)) {
            data["grupos"] = [];
            for (let item of this.grupos)
                data["grupos"].push(item.toJSON());
        }
        if (Array.isArray(this.pacienteAlergias)) {
            data["pacienteAlergias"] = [];
            for (let item of this.pacienteAlergias)
                data["pacienteAlergias"].push(item.toJSON());
        }
        if (Array.isArray(this.pacienteConvenio)) {
            data["pacienteConvenio"] = [];
            for (let item of this.pacienteConvenio)
                data["pacienteConvenio"].push(item.toJSON());
        }
        data["celular"] = this.celular;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["enderecoId"] = this.enderecoId;
        data["responsavelLegalId"] = this.responsavelLegalId;
        data["responsavelLegal"] = this.responsavelLegal ? this.responsavelLegal.toJSON() : <any>undefined;
        data["prontuarioId"] = this.prontuarioId;
        data["sexoString"] = this.sexoString;
        data["grauParentescoString"] = this.grauParentescoString;
        data["numeroPassaporte"] = this.numeroPassaporte;
        data["ehEstrangeiro"] = this.ehEstrangeiro;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Paciente {
        const json = this.toJSON();
        let result = new Paciente();
        result.init(json);
        return result;
    }
}

export interface IPaciente {
    nome: string;
    nomeSocial: string | undefined;
    cpf: string | undefined;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    nomeMae: string | undefined;
    peso: string | undefined;
    altura: string | undefined;
    email: string | undefined;
    objetivoPeso: number | undefined;
    hasCadastroCompleto: boolean;
    tipoSanguineo: TipoSanguineoEnum;
    tipoSanguineoString: string | undefined;
    estadoCivil: EstadoCivilEnum;
    estadoCivilString: string | undefined;
    corEtnia: CorEtniaEnum;
    corEtniaString: string | undefined;
    profissao: string | undefined;
    religiao: string | undefined;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVip[] | undefined;
    emailAlternativo: EmailAlternativo[] | undefined;
    dadosAltura: Altura[] | undefined;
    dadosBatimentosCardiacos: BatimentosCardiacos[] | undefined;
    dadosDorArticular: DorArticular[] | undefined;
    dadosFrequenciaRespiratoria: FrequenciaRespiratoria[] | undefined;
    dadosGlicose: Glicose[] | undefined;
    dadosHumor: Humor[] | undefined;
    dadosObjetivoImc: ObjetivoImc[] | undefined;
    dadosOximetria: Oximetria[] | undefined;
    dadosPeso: Peso[] | undefined;
    dadosPressaoArterial: PressaoArterial[] | undefined;
    dadosQualidadeSono: QualidadeSono[] | undefined;
    dadosTemperatura: Temperatura[] | undefined;
    clinicasMedicas: PacienteClinicaMedica[] | undefined;
    medicos: ProfissionalSaudePaciente[] | undefined;
    registroRespostaPacienteClinicas: RegistroRespostaPacienteClinica[] | undefined;
    grupos: PacienteGrupoMonitoramento[] | undefined;
    pacienteAlergias: PacienteAlergia[] | undefined;
    pacienteConvenio: PacienteConvenio[] | undefined;
    celular: string | undefined;
    user: User;
    userId: number | undefined;
    endereco: Endereco;
    enderecoId: string | undefined;
    responsavelLegalId: string | undefined;
    responsavelLegal: Paciente;
    prontuarioId: string | undefined;
    sexoString: string;
    grauParentescoString: string;
    numeroPassaporte: string | undefined;
    ehEstrangeiro: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProfissionalSaudePaciente implements IProfissionalSaudePaciente {
    profissionalSaude: ProfissionalSaude;
    profissionalSaudeId: string;
    paciente: Paciente;
    pacienteId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalSaudePaciente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalSaudePaciente {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudePaciente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalSaudePaciente {
        const json = this.toJSON();
        let result = new ProfissionalSaudePaciente();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudePaciente {
    profissionalSaude: ProfissionalSaude;
    profissionalSaudeId: string;
    paciente: Paciente;
    pacienteId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class EquipeProfissional implements IEquipeProfissional {
    profissionalId: string;
    profissionalSaude: ProfissionalSaude;
    equipeId: string;
    equipeClinica: EquipeClinica;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEquipeProfissional) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profissionalId = _data["profissionalId"];
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.equipeId = _data["equipeId"];
            this.equipeClinica = _data["equipeClinica"] ? EquipeClinica.fromJS(_data["equipeClinica"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EquipeProfissional {
        data = typeof data === 'object' ? data : {};
        let result = new EquipeProfissional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profissionalId"] = this.profissionalId;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["equipeId"] = this.equipeId;
        data["equipeClinica"] = this.equipeClinica ? this.equipeClinica.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): EquipeProfissional {
        const json = this.toJSON();
        let result = new EquipeProfissional();
        result.init(json);
        return result;
    }
}

export interface IEquipeProfissional {
    profissionalId: string;
    profissionalSaude: ProfissionalSaude;
    equipeId: string;
    equipeClinica: EquipeClinica;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProfissionalSaude implements IProfissionalSaude {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    numeroRegistroClasse: string;
    registroEspecialidade: string | undefined;
    registroClasse: RegistroClasse;
    registroClasseId: string;
    assinaturaMedico: string | undefined;
    nomeAssinatura: string | undefined;
    certificado: string | undefined;
    senhaCertificado: string | undefined;
    nomeCertificado: string | undefined;
    user: User;
    userId: number;
    endereco: Endereco;
    enderecoId: string | undefined;
    ufRegistro: string;
    dataNascimento: moment.Moment | undefined;
    permitirAssinaturaDigital: boolean;
    especializacoes: RQE[] | undefined;
    exibirNaListagemDeNovaConsulta: boolean;
    clinicasMedicas: ProfissionalSaudeClinicaMedica[] | undefined;
    pacientes: ProfissionalSaudePaciente[] | undefined;
    equipeProfissionais: EquipeProfissional[] | undefined;
    grupoMonitoramentos: GrupoMonitoramento[] | undefined;
    profissionalAcessoPacienteVips: ProfissionalAcessoPacienteVip[] | undefined;
    profissionalSaudeConvenio: ProfissionalSaudeConvenio[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProfissionalSaude) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.numeroRegistroClasse = _data["numeroRegistroClasse"];
            this.registroEspecialidade = _data["registroEspecialidade"];
            this.registroClasse = _data["registroClasse"] ? RegistroClasse.fromJS(_data["registroClasse"]) : <any>undefined;
            this.registroClasseId = _data["registroClasseId"];
            this.assinaturaMedico = _data["assinaturaMedico"];
            this.nomeAssinatura = _data["nomeAssinatura"];
            this.certificado = _data["certificado"];
            this.senhaCertificado = _data["senhaCertificado"];
            this.nomeCertificado = _data["nomeCertificado"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.endereco = _data["endereco"] ? Endereco.fromJS(_data["endereco"]) : <any>undefined;
            this.enderecoId = _data["enderecoId"];
            this.ufRegistro = _data["ufRegistro"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.permitirAssinaturaDigital = _data["permitirAssinaturaDigital"];
            if (Array.isArray(_data["especializacoes"])) {
                this.especializacoes = [] as any;
                for (let item of _data["especializacoes"])
                    this.especializacoes.push(RQE.fromJS(item));
            }
            this.exibirNaListagemDeNovaConsulta = _data["exibirNaListagemDeNovaConsulta"];
            if (Array.isArray(_data["clinicasMedicas"])) {
                this.clinicasMedicas = [] as any;
                for (let item of _data["clinicasMedicas"])
                    this.clinicasMedicas.push(ProfissionalSaudeClinicaMedica.fromJS(item));
            }
            if (Array.isArray(_data["pacientes"])) {
                this.pacientes = [] as any;
                for (let item of _data["pacientes"])
                    this.pacientes.push(ProfissionalSaudePaciente.fromJS(item));
            }
            if (Array.isArray(_data["equipeProfissionais"])) {
                this.equipeProfissionais = [] as any;
                for (let item of _data["equipeProfissionais"])
                    this.equipeProfissionais.push(EquipeProfissional.fromJS(item));
            }
            if (Array.isArray(_data["grupoMonitoramentos"])) {
                this.grupoMonitoramentos = [] as any;
                for (let item of _data["grupoMonitoramentos"])
                    this.grupoMonitoramentos.push(GrupoMonitoramento.fromJS(item));
            }
            if (Array.isArray(_data["profissionalAcessoPacienteVips"])) {
                this.profissionalAcessoPacienteVips = [] as any;
                for (let item of _data["profissionalAcessoPacienteVips"])
                    this.profissionalAcessoPacienteVips.push(ProfissionalAcessoPacienteVip.fromJS(item));
            }
            if (Array.isArray(_data["profissionalSaudeConvenio"])) {
                this.profissionalSaudeConvenio = [] as any;
                for (let item of _data["profissionalSaudeConvenio"])
                    this.profissionalSaudeConvenio.push(ProfissionalSaudeConvenio.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfissionalSaude {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaude();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["numeroRegistroClasse"] = this.numeroRegistroClasse;
        data["registroEspecialidade"] = this.registroEspecialidade;
        data["registroClasse"] = this.registroClasse ? this.registroClasse.toJSON() : <any>undefined;
        data["registroClasseId"] = this.registroClasseId;
        data["assinaturaMedico"] = this.assinaturaMedico;
        data["nomeAssinatura"] = this.nomeAssinatura;
        data["certificado"] = this.certificado;
        data["senhaCertificado"] = this.senhaCertificado;
        data["nomeCertificado"] = this.nomeCertificado;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["enderecoId"] = this.enderecoId;
        data["ufRegistro"] = this.ufRegistro;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["permitirAssinaturaDigital"] = this.permitirAssinaturaDigital;
        if (Array.isArray(this.especializacoes)) {
            data["especializacoes"] = [];
            for (let item of this.especializacoes)
                data["especializacoes"].push(item.toJSON());
        }
        data["exibirNaListagemDeNovaConsulta"] = this.exibirNaListagemDeNovaConsulta;
        if (Array.isArray(this.clinicasMedicas)) {
            data["clinicasMedicas"] = [];
            for (let item of this.clinicasMedicas)
                data["clinicasMedicas"].push(item.toJSON());
        }
        if (Array.isArray(this.pacientes)) {
            data["pacientes"] = [];
            for (let item of this.pacientes)
                data["pacientes"].push(item.toJSON());
        }
        if (Array.isArray(this.equipeProfissionais)) {
            data["equipeProfissionais"] = [];
            for (let item of this.equipeProfissionais)
                data["equipeProfissionais"].push(item.toJSON());
        }
        if (Array.isArray(this.grupoMonitoramentos)) {
            data["grupoMonitoramentos"] = [];
            for (let item of this.grupoMonitoramentos)
                data["grupoMonitoramentos"].push(item.toJSON());
        }
        if (Array.isArray(this.profissionalAcessoPacienteVips)) {
            data["profissionalAcessoPacienteVips"] = [];
            for (let item of this.profissionalAcessoPacienteVips)
                data["profissionalAcessoPacienteVips"].push(item.toJSON());
        }
        if (Array.isArray(this.profissionalSaudeConvenio)) {
            data["profissionalSaudeConvenio"] = [];
            for (let item of this.profissionalSaudeConvenio)
                data["profissionalSaudeConvenio"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProfissionalSaude {
        const json = this.toJSON();
        let result = new ProfissionalSaude();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaude {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    numeroRegistroClasse: string;
    registroEspecialidade: string | undefined;
    registroClasse: RegistroClasse;
    registroClasseId: string;
    assinaturaMedico: string | undefined;
    nomeAssinatura: string | undefined;
    certificado: string | undefined;
    senhaCertificado: string | undefined;
    nomeCertificado: string | undefined;
    user: User;
    userId: number;
    endereco: Endereco;
    enderecoId: string | undefined;
    ufRegistro: string;
    dataNascimento: moment.Moment | undefined;
    permitirAssinaturaDigital: boolean;
    especializacoes: RQE[] | undefined;
    exibirNaListagemDeNovaConsulta: boolean;
    clinicasMedicas: ProfissionalSaudeClinicaMedica[] | undefined;
    pacientes: ProfissionalSaudePaciente[] | undefined;
    equipeProfissionais: EquipeProfissional[] | undefined;
    grupoMonitoramentos: GrupoMonitoramento[] | undefined;
    profissionalAcessoPacienteVips: ProfissionalAcessoPacienteVip[] | undefined;
    profissionalSaudeConvenio: ProfissionalSaudeConvenio[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class DestinatarioChatMensagem implements IDestinatarioChatMensagem {
    destinatarioId: number;
    destinatario: User;
    chatMensagem: ChatMensagem;
    chatMensagemId: string;
    visto: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IDestinatarioChatMensagem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinatarioId = _data["destinatarioId"];
            this.destinatario = _data["destinatario"] ? User.fromJS(_data["destinatario"]) : <any>undefined;
            this.chatMensagem = _data["chatMensagem"] ? ChatMensagem.fromJS(_data["chatMensagem"]) : <any>undefined;
            this.chatMensagemId = _data["chatMensagemId"];
            this.visto = _data["visto"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DestinatarioChatMensagem {
        data = typeof data === 'object' ? data : {};
        let result = new DestinatarioChatMensagem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinatarioId"] = this.destinatarioId;
        data["destinatario"] = this.destinatario ? this.destinatario.toJSON() : <any>undefined;
        data["chatMensagem"] = this.chatMensagem ? this.chatMensagem.toJSON() : <any>undefined;
        data["chatMensagemId"] = this.chatMensagemId;
        data["visto"] = this.visto;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): DestinatarioChatMensagem {
        const json = this.toJSON();
        let result = new DestinatarioChatMensagem();
        result.init(json);
        return result;
    }
}

export interface IDestinatarioChatMensagem {
    destinatarioId: number;
    destinatario: User;
    chatMensagem: ChatMensagem;
    chatMensagemId: string;
    visto: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ChatMensagem implements IChatMensagem {
    mensagem: string | undefined;
    url: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    remetenteId: number;
    equipeId: string | undefined;
    equipe: EquipeClinica;
    dataHoraEnvio: moment.Moment;
    destinatarios: DestinatarioChatMensagem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IChatMensagem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mensagem = _data["mensagem"];
            this.url = _data["url"];
            this.nomeArquivo = _data["nomeArquivo"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.remetenteId = _data["remetenteId"];
            this.equipeId = _data["equipeId"];
            this.equipe = _data["equipe"] ? EquipeClinica.fromJS(_data["equipe"]) : <any>undefined;
            this.dataHoraEnvio = _data["dataHoraEnvio"] ? moment(_data["dataHoraEnvio"].toString()) : <any>undefined;
            if (Array.isArray(_data["destinatarios"])) {
                this.destinatarios = [] as any;
                for (let item of _data["destinatarios"])
                    this.destinatarios.push(DestinatarioChatMensagem.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMensagem {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMensagem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mensagem"] = this.mensagem;
        data["url"] = this.url;
        data["nomeArquivo"] = this.nomeArquivo;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["remetenteId"] = this.remetenteId;
        data["equipeId"] = this.equipeId;
        data["equipe"] = this.equipe ? this.equipe.toJSON() : <any>undefined;
        data["dataHoraEnvio"] = this.dataHoraEnvio ? this.dataHoraEnvio.toISOString() : <any>undefined;
        if (Array.isArray(this.destinatarios)) {
            data["destinatarios"] = [];
            for (let item of this.destinatarios)
                data["destinatarios"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ChatMensagem {
        const json = this.toJSON();
        let result = new ChatMensagem();
        result.init(json);
        return result;
    }
}

export interface IChatMensagem {
    mensagem: string | undefined;
    url: string | undefined;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    remetenteId: number;
    equipeId: string | undefined;
    equipe: EquipeClinica;
    dataHoraEnvio: moment.Moment;
    destinatarios: DestinatarioChatMensagem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class EquipeClinica implements IEquipeClinica {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedica;
    nome: string;
    descricao: string;
    especialidade: string | undefined;
    ativo: boolean;
    liderId: string;
    lider: ProfissionalSaude;
    equipeProfissionais: EquipeProfissional[] | undefined;
    chatMensagensEquipe: ChatMensagem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IEquipeClinica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.clinicaMedica = _data["clinicaMedica"] ? ClinicaMedica.fromJS(_data["clinicaMedica"]) : <any>undefined;
            this.nome = _data["nome"];
            this.descricao = _data["descricao"];
            this.especialidade = _data["especialidade"];
            this.ativo = _data["ativo"];
            this.liderId = _data["liderId"];
            this.lider = _data["lider"] ? ProfissionalSaude.fromJS(_data["lider"]) : <any>undefined;
            if (Array.isArray(_data["equipeProfissionais"])) {
                this.equipeProfissionais = [] as any;
                for (let item of _data["equipeProfissionais"])
                    this.equipeProfissionais.push(EquipeProfissional.fromJS(item));
            }
            if (Array.isArray(_data["chatMensagensEquipe"])) {
                this.chatMensagensEquipe = [] as any;
                for (let item of _data["chatMensagensEquipe"])
                    this.chatMensagensEquipe.push(ChatMensagem.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EquipeClinica {
        data = typeof data === 'object' ? data : {};
        let result = new EquipeClinica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["clinicaMedica"] = this.clinicaMedica ? this.clinicaMedica.toJSON() : <any>undefined;
        data["nome"] = this.nome;
        data["descricao"] = this.descricao;
        data["especialidade"] = this.especialidade;
        data["ativo"] = this.ativo;
        data["liderId"] = this.liderId;
        data["lider"] = this.lider ? this.lider.toJSON() : <any>undefined;
        if (Array.isArray(this.equipeProfissionais)) {
            data["equipeProfissionais"] = [];
            for (let item of this.equipeProfissionais)
                data["equipeProfissionais"].push(item.toJSON());
        }
        if (Array.isArray(this.chatMensagensEquipe)) {
            data["chatMensagensEquipe"] = [];
            for (let item of this.chatMensagensEquipe)
                data["chatMensagensEquipe"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): EquipeClinica {
        const json = this.toJSON();
        let result = new EquipeClinica();
        result.init(json);
        return result;
    }
}

export interface IEquipeClinica {
    clinicaMedicaId: string;
    clinicaMedica: ClinicaMedica;
    nome: string;
    descricao: string;
    especialidade: string | undefined;
    ativo: boolean;
    liderId: string;
    lider: ProfissionalSaude;
    equipeProfissionais: EquipeProfissional[] | undefined;
    chatMensagensEquipe: ChatMensagem[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ClinicaMedica implements IClinicaMedica {
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    cnes: string;
    logomarca: string;
    email: string;
    telefone: string;
    celular: string;
    numeroRegistroConselho: string;
    tenancyName: string;
    endereco: Endereco;
    enderecoId: string;
    prontuarioId: number;
    equipeClinicas: EquipeClinica[] | undefined;
    grupoMonitoramentos: GrupoMonitoramento[] | undefined;
    consultas: Consulta[] | undefined;
    clinicaMedicaPacienteVips: ClinicaMedicaPacienteVip[] | undefined;
    pacienteClinicaMedicas: PacienteClinicaMedica[] | undefined;
    profissionalSaudeClinicaMedicas: ProfissionalSaudeClinicaMedica[] | undefined;
    clinicaMedicaConvenio: ClinicaMedicaConvenio[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IClinicaMedica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.razaoSocial = _data["razaoSocial"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.cnpj = _data["cnpj"];
            this.cnes = _data["cnes"];
            this.logomarca = _data["logomarca"];
            this.email = _data["email"];
            this.telefone = _data["telefone"];
            this.celular = _data["celular"];
            this.numeroRegistroConselho = _data["numeroRegistroConselho"];
            this.tenancyName = _data["tenancyName"];
            this.endereco = _data["endereco"] ? Endereco.fromJS(_data["endereco"]) : <any>undefined;
            this.enderecoId = _data["enderecoId"];
            this.prontuarioId = _data["prontuarioId"];
            if (Array.isArray(_data["equipeClinicas"])) {
                this.equipeClinicas = [] as any;
                for (let item of _data["equipeClinicas"])
                    this.equipeClinicas.push(EquipeClinica.fromJS(item));
            }
            if (Array.isArray(_data["grupoMonitoramentos"])) {
                this.grupoMonitoramentos = [] as any;
                for (let item of _data["grupoMonitoramentos"])
                    this.grupoMonitoramentos.push(GrupoMonitoramento.fromJS(item));
            }
            if (Array.isArray(_data["consultas"])) {
                this.consultas = [] as any;
                for (let item of _data["consultas"])
                    this.consultas.push(Consulta.fromJS(item));
            }
            if (Array.isArray(_data["clinicaMedicaPacienteVips"])) {
                this.clinicaMedicaPacienteVips = [] as any;
                for (let item of _data["clinicaMedicaPacienteVips"])
                    this.clinicaMedicaPacienteVips.push(ClinicaMedicaPacienteVip.fromJS(item));
            }
            if (Array.isArray(_data["pacienteClinicaMedicas"])) {
                this.pacienteClinicaMedicas = [] as any;
                for (let item of _data["pacienteClinicaMedicas"])
                    this.pacienteClinicaMedicas.push(PacienteClinicaMedica.fromJS(item));
            }
            if (Array.isArray(_data["profissionalSaudeClinicaMedicas"])) {
                this.profissionalSaudeClinicaMedicas = [] as any;
                for (let item of _data["profissionalSaudeClinicaMedicas"])
                    this.profissionalSaudeClinicaMedicas.push(ProfissionalSaudeClinicaMedica.fromJS(item));
            }
            if (Array.isArray(_data["clinicaMedicaConvenio"])) {
                this.clinicaMedicaConvenio = [] as any;
                for (let item of _data["clinicaMedicaConvenio"])
                    this.clinicaMedicaConvenio.push(ClinicaMedicaConvenio.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClinicaMedica {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicaMedica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["razaoSocial"] = this.razaoSocial;
        data["nomeFantasia"] = this.nomeFantasia;
        data["cnpj"] = this.cnpj;
        data["cnes"] = this.cnes;
        data["logomarca"] = this.logomarca;
        data["email"] = this.email;
        data["telefone"] = this.telefone;
        data["celular"] = this.celular;
        data["numeroRegistroConselho"] = this.numeroRegistroConselho;
        data["tenancyName"] = this.tenancyName;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["enderecoId"] = this.enderecoId;
        data["prontuarioId"] = this.prontuarioId;
        if (Array.isArray(this.equipeClinicas)) {
            data["equipeClinicas"] = [];
            for (let item of this.equipeClinicas)
                data["equipeClinicas"].push(item.toJSON());
        }
        if (Array.isArray(this.grupoMonitoramentos)) {
            data["grupoMonitoramentos"] = [];
            for (let item of this.grupoMonitoramentos)
                data["grupoMonitoramentos"].push(item.toJSON());
        }
        if (Array.isArray(this.consultas)) {
            data["consultas"] = [];
            for (let item of this.consultas)
                data["consultas"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicaMedicaPacienteVips)) {
            data["clinicaMedicaPacienteVips"] = [];
            for (let item of this.clinicaMedicaPacienteVips)
                data["clinicaMedicaPacienteVips"].push(item.toJSON());
        }
        if (Array.isArray(this.pacienteClinicaMedicas)) {
            data["pacienteClinicaMedicas"] = [];
            for (let item of this.pacienteClinicaMedicas)
                data["pacienteClinicaMedicas"].push(item.toJSON());
        }
        if (Array.isArray(this.profissionalSaudeClinicaMedicas)) {
            data["profissionalSaudeClinicaMedicas"] = [];
            for (let item of this.profissionalSaudeClinicaMedicas)
                data["profissionalSaudeClinicaMedicas"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicaMedicaConvenio)) {
            data["clinicaMedicaConvenio"] = [];
            for (let item of this.clinicaMedicaConvenio)
                data["clinicaMedicaConvenio"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ClinicaMedica {
        const json = this.toJSON();
        let result = new ClinicaMedica();
        result.init(json);
        return result;
    }
}

export interface IClinicaMedica {
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    cnes: string;
    logomarca: string;
    email: string;
    telefone: string;
    celular: string;
    numeroRegistroConselho: string;
    tenancyName: string;
    endereco: Endereco;
    enderecoId: string;
    prontuarioId: number;
    equipeClinicas: EquipeClinica[] | undefined;
    grupoMonitoramentos: GrupoMonitoramento[] | undefined;
    consultas: Consulta[] | undefined;
    clinicaMedicaPacienteVips: ClinicaMedicaPacienteVip[] | undefined;
    pacienteClinicaMedicas: PacienteClinicaMedica[] | undefined;
    profissionalSaudeClinicaMedicas: ProfissionalSaudeClinicaMedica[] | undefined;
    clinicaMedicaConvenio: ClinicaMedicaConvenio[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class FuncionarioClinicaMedica implements IFuncionarioClinicaMedica {
    clinicaMedica: ClinicaMedica;
    clinicaMedicaId: string;
    funcionario: Funcionario;
    funcionarioId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IFuncionarioClinicaMedica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedica = _data["clinicaMedica"] ? ClinicaMedica.fromJS(_data["clinicaMedica"]) : <any>undefined;
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.funcionario = _data["funcionario"] ? Funcionario.fromJS(_data["funcionario"]) : <any>undefined;
            this.funcionarioId = _data["funcionarioId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FuncionarioClinicaMedica {
        data = typeof data === 'object' ? data : {};
        let result = new FuncionarioClinicaMedica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedica"] = this.clinicaMedica ? this.clinicaMedica.toJSON() : <any>undefined;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["funcionario"] = this.funcionario ? this.funcionario.toJSON() : <any>undefined;
        data["funcionarioId"] = this.funcionarioId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): FuncionarioClinicaMedica {
        const json = this.toJSON();
        let result = new FuncionarioClinicaMedica();
        result.init(json);
        return result;
    }
}

export interface IFuncionarioClinicaMedica {
    clinicaMedica: ClinicaMedica;
    clinicaMedicaId: string;
    funcionario: Funcionario;
    funcionarioId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class Funcionario implements IFuncionario {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    dataNascimento: moment.Moment | undefined;
    cns: string | undefined;
    user: User;
    userId: number;
    clinicasMedicas: FuncionarioClinicaMedica[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IFuncionario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.cns = _data["cns"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            if (Array.isArray(_data["clinicasMedicas"])) {
                this.clinicasMedicas = [] as any;
                for (let item of _data["clinicasMedicas"])
                    this.clinicasMedicas.push(FuncionarioClinicaMedica.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Funcionario {
        data = typeof data === 'object' ? data : {};
        let result = new Funcionario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["cns"] = this.cns;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        if (Array.isArray(this.clinicasMedicas)) {
            data["clinicasMedicas"] = [];
            for (let item of this.clinicasMedicas)
                data["clinicasMedicas"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Funcionario {
        const json = this.toJSON();
        let result = new Funcionario();
        result.init(json);
        return result;
    }
}

export interface IFuncionario {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    dataNascimento: moment.Moment | undefined;
    cns: string | undefined;
    user: User;
    userId: number;
    clinicasMedicas: FuncionarioClinicaMedica[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    readonly tipoUsuario: string;
    passwordResetCodeExpireDate: moment.Moment | undefined;
    clinicaMedicaGestao: ClinicaMedica;
    clinicaMedicaGestaoId: string | undefined;
    nomeFotoPerfil: string | undefined;
    funcionario: Funcionario;
    paciente: Paciente;
    profissionalSaude: ProfissionalSaude;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).tipoUsuario = _data["tipoUsuario"];
            this.passwordResetCodeExpireDate = _data["passwordResetCodeExpireDate"] ? moment(_data["passwordResetCodeExpireDate"].toString()) : <any>undefined;
            this.clinicaMedicaGestao = _data["clinicaMedicaGestao"] ? ClinicaMedica.fromJS(_data["clinicaMedicaGestao"]) : <any>undefined;
            this.clinicaMedicaGestaoId = _data["clinicaMedicaGestaoId"];
            this.nomeFotoPerfil = _data["nomeFotoPerfil"];
            this.funcionario = _data["funcionario"] ? Funcionario.fromJS(_data["funcionario"]) : <any>undefined;
            this.paciente = _data["paciente"] ? Paciente.fromJS(_data["paciente"]) : <any>undefined;
            this.profissionalSaude = _data["profissionalSaude"] ? ProfissionalSaude.fromJS(_data["profissionalSaude"]) : <any>undefined;
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoUsuario"] = this.tipoUsuario;
        data["passwordResetCodeExpireDate"] = this.passwordResetCodeExpireDate ? this.passwordResetCodeExpireDate.toISOString() : <any>undefined;
        data["clinicaMedicaGestao"] = this.clinicaMedicaGestao ? this.clinicaMedicaGestao.toJSON() : <any>undefined;
        data["clinicaMedicaGestaoId"] = this.clinicaMedicaGestaoId;
        data["nomeFotoPerfil"] = this.nomeFotoPerfil;
        data["funcionario"] = this.funcionario ? this.funcionario.toJSON() : <any>undefined;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["profissionalSaude"] = this.profissionalSaude ? this.profissionalSaude.toJSON() : <any>undefined;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    tipoUsuario: string;
    passwordResetCodeExpireDate: moment.Moment | undefined;
    clinicaMedicaGestao: ClinicaMedica;
    clinicaMedicaGestaoId: string | undefined;
    nomeFotoPerfil: string | undefined;
    funcionario: Funcionario;
    paciente: Paciente;
    profissionalSaude: ProfissionalSaude;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateFuncionarioDto implements ICreateFuncionarioDto {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    dataNascimento: moment.Moment | undefined;
    cns: string | undefined;
    senha: string | undefined;
    user: User;
    userId: number;

    constructor(data?: ICreateFuncionarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.cns = _data["cns"];
            this.senha = _data["senha"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreateFuncionarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFuncionarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["cns"] = this.cns;
        data["senha"] = this.senha;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }

    clone(): CreateFuncionarioDto {
        const json = this.toJSON();
        let result = new CreateFuncionarioDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFuncionarioDto {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    dataNascimento: moment.Moment | undefined;
    cns: string | undefined;
    senha: string | undefined;
    user: User;
    userId: number;
}

export class FuncionarioDto implements IFuncionarioDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    dataNascimento: moment.Moment | undefined;
    cns: string | undefined;
    userId: number;
    id: string;

    constructor(data?: IFuncionarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.cns = _data["cns"];
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FuncionarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuncionarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["cns"] = this.cns;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }

    clone(): FuncionarioDto {
        const json = this.toJSON();
        let result = new FuncionarioDto();
        result.init(json);
        return result;
    }
}

export interface IFuncionarioDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    dataNascimento: moment.Moment | undefined;
    cns: string | undefined;
    userId: number;
    id: string;
}

export class UpdateFuncionarioDto implements IUpdateFuncionarioDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    dataNascimento: moment.Moment | undefined;
    cns: string | undefined;
    userId: number;
    id: string;

    constructor(data?: IUpdateFuncionarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.cns = _data["cns"];
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFuncionarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFuncionarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["cns"] = this.cns;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateFuncionarioDto {
        const json = this.toJSON();
        let result = new UpdateFuncionarioDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFuncionarioDto {
    nome: string | undefined;
    cpf: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    dataNascimento: moment.Moment | undefined;
    cns: string | undefined;
    userId: number;
    id: string;
}

export class FuncionarioDtoPagedResultDto implements IFuncionarioDtoPagedResultDto {
    totalCount: number;
    items: FuncionarioDto[] | undefined;

    constructor(data?: IFuncionarioDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FuncionarioDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FuncionarioDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuncionarioDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): FuncionarioDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FuncionarioDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFuncionarioDtoPagedResultDto {
    totalCount: number;
    items: FuncionarioDto[] | undefined;
}

export class CreateGlicoseDto implements ICreateGlicoseDto {
    valorGlicose: number;
    tipoMedicao: TipoMedicaoGlicoseEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateGlicoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorGlicose = _data["valorGlicose"];
            this.tipoMedicao = _data["tipoMedicao"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateGlicoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGlicoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorGlicose"] = this.valorGlicose;
        data["tipoMedicao"] = this.tipoMedicao;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateGlicoseDto {
        const json = this.toJSON();
        let result = new CreateGlicoseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateGlicoseDto {
    valorGlicose: number;
    tipoMedicao: TipoMedicaoGlicoseEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class GlicoseDto implements IGlicoseDto {
    valorGlicose: number;
    tipoMedicao: TipoMedicaoGlicoseEnum;
    readonly tipoMedicaoString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IGlicoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorGlicose = _data["valorGlicose"];
            this.tipoMedicao = _data["tipoMedicao"];
            (<any>this).tipoMedicaoString = _data["tipoMedicaoString"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GlicoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlicoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorGlicose"] = this.valorGlicose;
        data["tipoMedicao"] = this.tipoMedicao;
        data["tipoMedicaoString"] = this.tipoMedicaoString;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): GlicoseDto {
        const json = this.toJSON();
        let result = new GlicoseDto();
        result.init(json);
        return result;
    }
}

export interface IGlicoseDto {
    valorGlicose: number;
    tipoMedicao: TipoMedicaoGlicoseEnum;
    tipoMedicaoString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class UpdateGlicoseDto implements IUpdateGlicoseDto {
    valorGlicose: number;
    tipoMedicao: TipoMedicaoGlicoseEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateGlicoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorGlicose = _data["valorGlicose"];
            this.tipoMedicao = _data["tipoMedicao"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGlicoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGlicoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorGlicose"] = this.valorGlicose;
        data["tipoMedicao"] = this.tipoMedicao;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateGlicoseDto {
        const json = this.toJSON();
        let result = new UpdateGlicoseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateGlicoseDto {
    valorGlicose: number;
    tipoMedicao: TipoMedicaoGlicoseEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class GlicoseDtoPagedResultDto implements IGlicoseDtoPagedResultDto {
    totalCount: number;
    items: GlicoseDto[] | undefined;

    constructor(data?: IGlicoseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GlicoseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlicoseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlicoseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): GlicoseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GlicoseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGlicoseDtoPagedResultDto {
    totalCount: number;
    items: GlicoseDto[] | undefined;
}

export class PacienteGrupoMonitoramentoDto implements IPacienteGrupoMonitoramentoDto {
    grupoId: string;
    pacienteId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPacienteGrupoMonitoramentoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grupoId = _data["grupoId"];
            this.pacienteId = _data["pacienteId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteGrupoMonitoramentoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteGrupoMonitoramentoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grupoId"] = this.grupoId;
        data["pacienteId"] = this.pacienteId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteGrupoMonitoramentoDto {
        const json = this.toJSON();
        let result = new PacienteGrupoMonitoramentoDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteGrupoMonitoramentoDto {
    grupoId: string;
    pacienteId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class GraficoMonitoramentoDto implements IGraficoMonitoramentoDto {
    grupoMonitoramentoId: string;
    valorMaximo: number | undefined;
    valorMinimo: number | undefined;
    valorMaximoAlternativo: number | undefined;
    valorMinimoAlternativo: number | undefined;
    grafico: GraficoMonitoramentoEnum;
    readonly graficoString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IGraficoMonitoramentoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grupoMonitoramentoId = _data["grupoMonitoramentoId"];
            this.valorMaximo = _data["valorMaximo"];
            this.valorMinimo = _data["valorMinimo"];
            this.valorMaximoAlternativo = _data["valorMaximoAlternativo"];
            this.valorMinimoAlternativo = _data["valorMinimoAlternativo"];
            this.grafico = _data["grafico"];
            (<any>this).graficoString = _data["graficoString"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GraficoMonitoramentoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GraficoMonitoramentoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grupoMonitoramentoId"] = this.grupoMonitoramentoId;
        data["valorMaximo"] = this.valorMaximo;
        data["valorMinimo"] = this.valorMinimo;
        data["valorMaximoAlternativo"] = this.valorMaximoAlternativo;
        data["valorMinimoAlternativo"] = this.valorMinimoAlternativo;
        data["grafico"] = this.grafico;
        data["graficoString"] = this.graficoString;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): GraficoMonitoramentoDto {
        const json = this.toJSON();
        let result = new GraficoMonitoramentoDto();
        result.init(json);
        return result;
    }
}

export interface IGraficoMonitoramentoDto {
    grupoMonitoramentoId: string;
    valorMaximo: number | undefined;
    valorMinimo: number | undefined;
    valorMaximoAlternativo: number | undefined;
    valorMinimoAlternativo: number | undefined;
    grafico: GraficoMonitoramentoEnum;
    graficoString: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateGrupoMonitoramentoDto implements ICreateGrupoMonitoramentoDto {
    nome: string;
    descricao: string;
    profissionalId: string;
    clinicaId: string | undefined;
    grupoPacientes: PacienteGrupoMonitoramentoDto[] | undefined;
    graficos: GraficoMonitoramentoDto[] | undefined;

    constructor(data?: ICreateGrupoMonitoramentoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.descricao = _data["descricao"];
            this.profissionalId = _data["profissionalId"];
            this.clinicaId = _data["clinicaId"];
            if (Array.isArray(_data["grupoPacientes"])) {
                this.grupoPacientes = [] as any;
                for (let item of _data["grupoPacientes"])
                    this.grupoPacientes.push(PacienteGrupoMonitoramentoDto.fromJS(item));
            }
            if (Array.isArray(_data["graficos"])) {
                this.graficos = [] as any;
                for (let item of _data["graficos"])
                    this.graficos.push(GraficoMonitoramentoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateGrupoMonitoramentoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGrupoMonitoramentoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["descricao"] = this.descricao;
        data["profissionalId"] = this.profissionalId;
        data["clinicaId"] = this.clinicaId;
        if (Array.isArray(this.grupoPacientes)) {
            data["grupoPacientes"] = [];
            for (let item of this.grupoPacientes)
                data["grupoPacientes"].push(item.toJSON());
        }
        if (Array.isArray(this.graficos)) {
            data["graficos"] = [];
            for (let item of this.graficos)
                data["graficos"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateGrupoMonitoramentoDto {
        const json = this.toJSON();
        let result = new CreateGrupoMonitoramentoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateGrupoMonitoramentoDto {
    nome: string;
    descricao: string;
    profissionalId: string;
    clinicaId: string | undefined;
    grupoPacientes: PacienteGrupoMonitoramentoDto[] | undefined;
    graficos: GraficoMonitoramentoDto[] | undefined;
}

export class GrupoMonitoramentoDto implements IGrupoMonitoramentoDto {
    nome: string | undefined;
    descricao: string | undefined;
    profissionalId: string;
    profissional: ProfissionalSaudeDto;
    clinicaId: string | undefined;
    clinica: ClinicaMedicaDto;
    ativo: boolean;
    nomePacientes: string | undefined;
    nomeGraficos: string | undefined;
    alerta: boolean;
    grupoPacientes: PacienteGrupoMonitoramentoDto[] | undefined;
    graficos: GraficoMonitoramentoDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IGrupoMonitoramentoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.descricao = _data["descricao"];
            this.profissionalId = _data["profissionalId"];
            this.profissional = _data["profissional"] ? ProfissionalSaudeDto.fromJS(_data["profissional"]) : <any>undefined;
            this.clinicaId = _data["clinicaId"];
            this.clinica = _data["clinica"] ? ClinicaMedicaDto.fromJS(_data["clinica"]) : <any>undefined;
            this.ativo = _data["ativo"];
            this.nomePacientes = _data["nomePacientes"];
            this.nomeGraficos = _data["nomeGraficos"];
            this.alerta = _data["alerta"];
            if (Array.isArray(_data["grupoPacientes"])) {
                this.grupoPacientes = [] as any;
                for (let item of _data["grupoPacientes"])
                    this.grupoPacientes.push(PacienteGrupoMonitoramentoDto.fromJS(item));
            }
            if (Array.isArray(_data["graficos"])) {
                this.graficos = [] as any;
                for (let item of _data["graficos"])
                    this.graficos.push(GraficoMonitoramentoDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GrupoMonitoramentoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoMonitoramentoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["descricao"] = this.descricao;
        data["profissionalId"] = this.profissionalId;
        data["profissional"] = this.profissional ? this.profissional.toJSON() : <any>undefined;
        data["clinicaId"] = this.clinicaId;
        data["clinica"] = this.clinica ? this.clinica.toJSON() : <any>undefined;
        data["ativo"] = this.ativo;
        data["nomePacientes"] = this.nomePacientes;
        data["nomeGraficos"] = this.nomeGraficos;
        data["alerta"] = this.alerta;
        if (Array.isArray(this.grupoPacientes)) {
            data["grupoPacientes"] = [];
            for (let item of this.grupoPacientes)
                data["grupoPacientes"].push(item.toJSON());
        }
        if (Array.isArray(this.graficos)) {
            data["graficos"] = [];
            for (let item of this.graficos)
                data["graficos"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): GrupoMonitoramentoDto {
        const json = this.toJSON();
        let result = new GrupoMonitoramentoDto();
        result.init(json);
        return result;
    }
}

export interface IGrupoMonitoramentoDto {
    nome: string | undefined;
    descricao: string | undefined;
    profissionalId: string;
    profissional: ProfissionalSaudeDto;
    clinicaId: string | undefined;
    clinica: ClinicaMedicaDto;
    ativo: boolean;
    nomePacientes: string | undefined;
    nomeGraficos: string | undefined;
    alerta: boolean;
    grupoPacientes: PacienteGrupoMonitoramentoDto[] | undefined;
    graficos: GraficoMonitoramentoDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class GrupoMonitoramentoDtoPagedResultDto implements IGrupoMonitoramentoDtoPagedResultDto {
    totalCount: number;
    items: GrupoMonitoramentoDto[] | undefined;

    constructor(data?: IGrupoMonitoramentoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GrupoMonitoramentoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrupoMonitoramentoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoMonitoramentoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): GrupoMonitoramentoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GrupoMonitoramentoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGrupoMonitoramentoDtoPagedResultDto {
    totalCount: number;
    items: GrupoMonitoramentoDto[] | undefined;
}

export class UpdateGrupoMonitoramentoDto implements IUpdateGrupoMonitoramentoDto {
    nome: string;
    descricao: string;
    profissionalId: string;
    clinicaId: string | undefined;
    grupoPacientes: PacienteGrupoMonitoramentoDto[] | undefined;
    novosPacientes: PacienteGrupoMonitoramentoDto[] | undefined;
    pacientesRemovidos: PacienteGrupoMonitoramentoDto[] | undefined;
    graficos: GraficoMonitoramentoDto[] | undefined;
    novosGraficos: GraficoMonitoramentoDto[] | undefined;
    graficosRemovidos: GraficoMonitoramentoDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdateGrupoMonitoramentoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.descricao = _data["descricao"];
            this.profissionalId = _data["profissionalId"];
            this.clinicaId = _data["clinicaId"];
            if (Array.isArray(_data["grupoPacientes"])) {
                this.grupoPacientes = [] as any;
                for (let item of _data["grupoPacientes"])
                    this.grupoPacientes.push(PacienteGrupoMonitoramentoDto.fromJS(item));
            }
            if (Array.isArray(_data["novosPacientes"])) {
                this.novosPacientes = [] as any;
                for (let item of _data["novosPacientes"])
                    this.novosPacientes.push(PacienteGrupoMonitoramentoDto.fromJS(item));
            }
            if (Array.isArray(_data["pacientesRemovidos"])) {
                this.pacientesRemovidos = [] as any;
                for (let item of _data["pacientesRemovidos"])
                    this.pacientesRemovidos.push(PacienteGrupoMonitoramentoDto.fromJS(item));
            }
            if (Array.isArray(_data["graficos"])) {
                this.graficos = [] as any;
                for (let item of _data["graficos"])
                    this.graficos.push(GraficoMonitoramentoDto.fromJS(item));
            }
            if (Array.isArray(_data["novosGraficos"])) {
                this.novosGraficos = [] as any;
                for (let item of _data["novosGraficos"])
                    this.novosGraficos.push(GraficoMonitoramentoDto.fromJS(item));
            }
            if (Array.isArray(_data["graficosRemovidos"])) {
                this.graficosRemovidos = [] as any;
                for (let item of _data["graficosRemovidos"])
                    this.graficosRemovidos.push(GraficoMonitoramentoDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGrupoMonitoramentoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGrupoMonitoramentoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["descricao"] = this.descricao;
        data["profissionalId"] = this.profissionalId;
        data["clinicaId"] = this.clinicaId;
        if (Array.isArray(this.grupoPacientes)) {
            data["grupoPacientes"] = [];
            for (let item of this.grupoPacientes)
                data["grupoPacientes"].push(item.toJSON());
        }
        if (Array.isArray(this.novosPacientes)) {
            data["novosPacientes"] = [];
            for (let item of this.novosPacientes)
                data["novosPacientes"].push(item.toJSON());
        }
        if (Array.isArray(this.pacientesRemovidos)) {
            data["pacientesRemovidos"] = [];
            for (let item of this.pacientesRemovidos)
                data["pacientesRemovidos"].push(item.toJSON());
        }
        if (Array.isArray(this.graficos)) {
            data["graficos"] = [];
            for (let item of this.graficos)
                data["graficos"].push(item.toJSON());
        }
        if (Array.isArray(this.novosGraficos)) {
            data["novosGraficos"] = [];
            for (let item of this.novosGraficos)
                data["novosGraficos"].push(item.toJSON());
        }
        if (Array.isArray(this.graficosRemovidos)) {
            data["graficosRemovidos"] = [];
            for (let item of this.graficosRemovidos)
                data["graficosRemovidos"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateGrupoMonitoramentoDto {
        const json = this.toJSON();
        let result = new UpdateGrupoMonitoramentoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateGrupoMonitoramentoDto {
    nome: string;
    descricao: string;
    profissionalId: string;
    clinicaId: string | undefined;
    grupoPacientes: PacienteGrupoMonitoramentoDto[] | undefined;
    novosPacientes: PacienteGrupoMonitoramentoDto[] | undefined;
    pacientesRemovidos: PacienteGrupoMonitoramentoDto[] | undefined;
    graficos: GraficoMonitoramentoDto[] | undefined;
    novosGraficos: GraficoMonitoramentoDto[] | undefined;
    graficosRemovidos: GraficoMonitoramentoDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class HumorDto implements IHumorDto {
    tipoHumor: HumorEnum;
    readonly tipoHumorString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IHumorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoHumor = _data["tipoHumor"];
            (<any>this).tipoHumorString = _data["tipoHumorString"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HumorDto {
        data = typeof data === 'object' ? data : {};
        let result = new HumorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoHumor"] = this.tipoHumor;
        data["tipoHumorString"] = this.tipoHumorString;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): HumorDto {
        const json = this.toJSON();
        let result = new HumorDto();
        result.init(json);
        return result;
    }
}

export interface IHumorDto {
    tipoHumor: HumorEnum;
    tipoHumorString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export enum NivelImcEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ImcDto implements IImcDto {
    peso: number;
    altura: number;
    imc: number;
    nivelImc: NivelImcEnum;
    readonly nivelImcString: string | undefined;
    dataHora: moment.Moment;
    alerta: boolean;

    constructor(data?: IImcDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.peso = _data["peso"];
            this.altura = _data["altura"];
            this.imc = _data["imc"];
            this.nivelImc = _data["nivelImc"];
            (<any>this).nivelImcString = _data["nivelImcString"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.alerta = _data["alerta"];
        }
    }

    static fromJS(data: any): ImcDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["peso"] = this.peso;
        data["altura"] = this.altura;
        data["imc"] = this.imc;
        data["nivelImc"] = this.nivelImc;
        data["nivelImcString"] = this.nivelImcString;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["alerta"] = this.alerta;
        return data;
    }

    clone(): ImcDto {
        const json = this.toJSON();
        let result = new ImcDto();
        result.init(json);
        return result;
    }
}

export interface IImcDto {
    peso: number;
    altura: number;
    imc: number;
    nivelImc: NivelImcEnum;
    nivelImcString: string | undefined;
    dataHora: moment.Moment;
    alerta: boolean;
}

export class OximetriaDto implements IOximetriaDto {
    valorOximetria: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IOximetriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorOximetria = _data["valorOximetria"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OximetriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OximetriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorOximetria"] = this.valorOximetria;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): OximetriaDto {
        const json = this.toJSON();
        let result = new OximetriaDto();
        result.init(json);
        return result;
    }
}

export interface IOximetriaDto {
    valorOximetria: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class PesoDto implements IPesoDto {
    valorPeso: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    objetivo: boolean;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IPesoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorPeso = _data["valorPeso"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.objetivo = _data["objetivo"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PesoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PesoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorPeso"] = this.valorPeso;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["objetivo"] = this.objetivo;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): PesoDto {
        const json = this.toJSON();
        let result = new PesoDto();
        result.init(json);
        return result;
    }
}

export interface IPesoDto {
    valorPeso: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    objetivo: boolean;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class PressaoArterialDto implements IPressaoArterialDto {
    valorSistolica: number;
    valorDiastolica: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IPressaoArterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorSistolica = _data["valorSistolica"];
            this.valorDiastolica = _data["valorDiastolica"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PressaoArterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new PressaoArterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorSistolica"] = this.valorSistolica;
        data["valorDiastolica"] = this.valorDiastolica;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): PressaoArterialDto {
        const json = this.toJSON();
        let result = new PressaoArterialDto();
        result.init(json);
        return result;
    }
}

export interface IPressaoArterialDto {
    valorSistolica: number;
    valorDiastolica: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class QualidadeSonoDto implements IQualidadeSonoDto {
    duracaoSono: string;
    qualidadeSonoEnum: QualidadeSonoEnum;
    readonly qualidadeSonoString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: IQualidadeSonoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duracaoSono = _data["duracaoSono"];
            this.qualidadeSonoEnum = _data["qualidadeSonoEnum"];
            (<any>this).qualidadeSonoString = _data["qualidadeSonoString"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QualidadeSonoDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualidadeSonoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duracaoSono"] = this.duracaoSono;
        data["qualidadeSonoEnum"] = this.qualidadeSonoEnum;
        data["qualidadeSonoString"] = this.qualidadeSonoString;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): QualidadeSonoDto {
        const json = this.toJSON();
        let result = new QualidadeSonoDto();
        result.init(json);
        return result;
    }
}

export interface IQualidadeSonoDto {
    duracaoSono: string;
    qualidadeSonoEnum: QualidadeSonoEnum;
    qualidadeSonoString: string | undefined;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class TemperaturaDto implements ITemperaturaDto {
    valorTemperatura: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;

    constructor(data?: ITemperaturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorTemperatura = _data["valorTemperatura"];
            this.observacao = _data["observacao"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.pacienteId = _data["pacienteId"];
            this.creatorUserId = _data["creatorUserId"];
            this.isProfissionalSaude = _data["isProfissionalSaude"];
            this.alerta = _data["alerta"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TemperaturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperaturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorTemperatura"] = this.valorTemperatura;
        data["observacao"] = this.observacao;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["pacienteId"] = this.pacienteId;
        data["creatorUserId"] = this.creatorUserId;
        data["isProfissionalSaude"] = this.isProfissionalSaude;
        data["alerta"] = this.alerta;
        data["id"] = this.id;
        return data;
    }

    clone(): TemperaturaDto {
        const json = this.toJSON();
        let result = new TemperaturaDto();
        result.init(json);
        return result;
    }
}

export interface ITemperaturaDto {
    valorTemperatura: number;
    observacao: string | undefined;
    dataHora: moment.Moment;
    pacienteId: string;
    creatorUserId: number;
    isProfissionalSaude: boolean;
    alerta: boolean;
    id: string;
}

export class PacienteDadosGraficoDto implements IPacienteDadosGraficoDto {
    nome: string | undefined;
    nomeSocial: string | undefined;
    userId: number;
    dadosAltura: AlturaDto[] | undefined;
    dadosBatimentosCardiacos: BatimentosCardiacosDto[] | undefined;
    dadosDorArticular: DorArticularDto[] | undefined;
    dadosFrequenciaRespiratoria: FrequenciaRespiratoriaDto[] | undefined;
    dadosGlicose: GlicoseDto[] | undefined;
    dadosHumor: HumorDto[] | undefined;
    dadosImc: ImcDto[] | undefined;
    dadosOximetria: OximetriaDto[] | undefined;
    dadosPeso: PesoDto[] | undefined;
    dadosPressaoArterial: PressaoArterialDto[] | undefined;
    dadosQualidadeSono: QualidadeSonoDto[] | undefined;
    dadosTemperatura: TemperaturaDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPacienteDadosGraficoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.nomeSocial = _data["nomeSocial"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["dadosAltura"])) {
                this.dadosAltura = [] as any;
                for (let item of _data["dadosAltura"])
                    this.dadosAltura.push(AlturaDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosBatimentosCardiacos"])) {
                this.dadosBatimentosCardiacos = [] as any;
                for (let item of _data["dadosBatimentosCardiacos"])
                    this.dadosBatimentosCardiacos.push(BatimentosCardiacosDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosDorArticular"])) {
                this.dadosDorArticular = [] as any;
                for (let item of _data["dadosDorArticular"])
                    this.dadosDorArticular.push(DorArticularDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosFrequenciaRespiratoria"])) {
                this.dadosFrequenciaRespiratoria = [] as any;
                for (let item of _data["dadosFrequenciaRespiratoria"])
                    this.dadosFrequenciaRespiratoria.push(FrequenciaRespiratoriaDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosGlicose"])) {
                this.dadosGlicose = [] as any;
                for (let item of _data["dadosGlicose"])
                    this.dadosGlicose.push(GlicoseDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosHumor"])) {
                this.dadosHumor = [] as any;
                for (let item of _data["dadosHumor"])
                    this.dadosHumor.push(HumorDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosImc"])) {
                this.dadosImc = [] as any;
                for (let item of _data["dadosImc"])
                    this.dadosImc.push(ImcDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosOximetria"])) {
                this.dadosOximetria = [] as any;
                for (let item of _data["dadosOximetria"])
                    this.dadosOximetria.push(OximetriaDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosPeso"])) {
                this.dadosPeso = [] as any;
                for (let item of _data["dadosPeso"])
                    this.dadosPeso.push(PesoDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosPressaoArterial"])) {
                this.dadosPressaoArterial = [] as any;
                for (let item of _data["dadosPressaoArterial"])
                    this.dadosPressaoArterial.push(PressaoArterialDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosQualidadeSono"])) {
                this.dadosQualidadeSono = [] as any;
                for (let item of _data["dadosQualidadeSono"])
                    this.dadosQualidadeSono.push(QualidadeSonoDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosTemperatura"])) {
                this.dadosTemperatura = [] as any;
                for (let item of _data["dadosTemperatura"])
                    this.dadosTemperatura.push(TemperaturaDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteDadosGraficoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteDadosGraficoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["nomeSocial"] = this.nomeSocial;
        data["userId"] = this.userId;
        if (Array.isArray(this.dadosAltura)) {
            data["dadosAltura"] = [];
            for (let item of this.dadosAltura)
                data["dadosAltura"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosBatimentosCardiacos)) {
            data["dadosBatimentosCardiacos"] = [];
            for (let item of this.dadosBatimentosCardiacos)
                data["dadosBatimentosCardiacos"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosDorArticular)) {
            data["dadosDorArticular"] = [];
            for (let item of this.dadosDorArticular)
                data["dadosDorArticular"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosFrequenciaRespiratoria)) {
            data["dadosFrequenciaRespiratoria"] = [];
            for (let item of this.dadosFrequenciaRespiratoria)
                data["dadosFrequenciaRespiratoria"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosGlicose)) {
            data["dadosGlicose"] = [];
            for (let item of this.dadosGlicose)
                data["dadosGlicose"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosHumor)) {
            data["dadosHumor"] = [];
            for (let item of this.dadosHumor)
                data["dadosHumor"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosImc)) {
            data["dadosImc"] = [];
            for (let item of this.dadosImc)
                data["dadosImc"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosOximetria)) {
            data["dadosOximetria"] = [];
            for (let item of this.dadosOximetria)
                data["dadosOximetria"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosPeso)) {
            data["dadosPeso"] = [];
            for (let item of this.dadosPeso)
                data["dadosPeso"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosPressaoArterial)) {
            data["dadosPressaoArterial"] = [];
            for (let item of this.dadosPressaoArterial)
                data["dadosPressaoArterial"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosQualidadeSono)) {
            data["dadosQualidadeSono"] = [];
            for (let item of this.dadosQualidadeSono)
                data["dadosQualidadeSono"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosTemperatura)) {
            data["dadosTemperatura"] = [];
            for (let item of this.dadosTemperatura)
                data["dadosTemperatura"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteDadosGraficoDto {
        const json = this.toJSON();
        let result = new PacienteDadosGraficoDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteDadosGraficoDto {
    nome: string | undefined;
    nomeSocial: string | undefined;
    userId: number;
    dadosAltura: AlturaDto[] | undefined;
    dadosBatimentosCardiacos: BatimentosCardiacosDto[] | undefined;
    dadosDorArticular: DorArticularDto[] | undefined;
    dadosFrequenciaRespiratoria: FrequenciaRespiratoriaDto[] | undefined;
    dadosGlicose: GlicoseDto[] | undefined;
    dadosHumor: HumorDto[] | undefined;
    dadosImc: ImcDto[] | undefined;
    dadosOximetria: OximetriaDto[] | undefined;
    dadosPeso: PesoDto[] | undefined;
    dadosPressaoArterial: PressaoArterialDto[] | undefined;
    dadosQualidadeSono: QualidadeSonoDto[] | undefined;
    dadosTemperatura: TemperaturaDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateHumorDto implements ICreateHumorDto {
    tipoHumor: HumorEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateHumorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoHumor = _data["tipoHumor"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateHumorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHumorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoHumor"] = this.tipoHumor;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateHumorDto {
        const json = this.toJSON();
        let result = new CreateHumorDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHumorDto {
    tipoHumor: HumorEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class UpdateHumorDto implements IUpdateHumorDto {
    tipoHumor: HumorEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateHumorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoHumor = _data["tipoHumor"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateHumorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHumorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoHumor"] = this.tipoHumor;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateHumorDto {
        const json = this.toJSON();
        let result = new UpdateHumorDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHumorDto {
    tipoHumor: HumorEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class HumorDtoPagedResultDto implements IHumorDtoPagedResultDto {
    totalCount: number;
    items: HumorDto[] | undefined;

    constructor(data?: IHumorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HumorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HumorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HumorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): HumorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HumorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHumorDtoPagedResultDto {
    totalCount: number;
    items: HumorDto[] | undefined;
}

export class CreateObjetivoImcDto implements ICreateObjetivoImcDto {
    objetivo: number;
    pacienteId: string;

    constructor(data?: ICreateObjetivoImcDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objetivo = _data["objetivo"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateObjetivoImcDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateObjetivoImcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objetivo"] = this.objetivo;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateObjetivoImcDto {
        const json = this.toJSON();
        let result = new CreateObjetivoImcDto();
        result.init(json);
        return result;
    }
}

export interface ICreateObjetivoImcDto {
    objetivo: number;
    pacienteId: string;
}

export class ObjetivoImcDto implements IObjetivoImcDto {
    objetivo: number;
    pacienteId: string;
    id: string;

    constructor(data?: IObjetivoImcDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objetivo = _data["objetivo"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ObjetivoImcDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjetivoImcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objetivo"] = this.objetivo;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): ObjetivoImcDto {
        const json = this.toJSON();
        let result = new ObjetivoImcDto();
        result.init(json);
        return result;
    }
}

export interface IObjetivoImcDto {
    objetivo: number;
    pacienteId: string;
    id: string;
}

export class UpdateObjetivoImcDto implements IUpdateObjetivoImcDto {
    objetivo: number;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateObjetivoImcDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objetivo = _data["objetivo"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateObjetivoImcDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateObjetivoImcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objetivo"] = this.objetivo;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateObjetivoImcDto {
        const json = this.toJSON();
        let result = new UpdateObjetivoImcDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateObjetivoImcDto {
    objetivo: number;
    pacienteId: string;
    id: string;
}

export class ImcDtoPagedResultDto implements IImcDtoPagedResultDto {
    totalCount: number;
    items: ImcDto[] | undefined;

    constructor(data?: IImcDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ImcDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImcDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImcDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ImcDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ImcDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IImcDtoPagedResultDto {
    totalCount: number;
    items: ImcDto[] | undefined;
}

export class MedicamentoSigtapDto implements IMedicamentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    organizacao: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IMedicamentoSigtapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.grupo = _data["grupo"];
            this.subgrupo = _data["subgrupo"];
            this.organizacao = _data["organizacao"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicamentoSigtapDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicamentoSigtapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["grupo"] = this.grupo;
        data["subgrupo"] = this.subgrupo;
        data["organizacao"] = this.organizacao;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): MedicamentoSigtapDto {
        const json = this.toJSON();
        let result = new MedicamentoSigtapDto();
        result.init(json);
        return result;
    }
}

export interface IMedicamentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    organizacao: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class MedicamentoSigtapDtoPagedResultDto implements IMedicamentoSigtapDtoPagedResultDto {
    totalCount: number;
    items: MedicamentoSigtapDto[] | undefined;

    constructor(data?: IMedicamentoSigtapDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicamentoSigtapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicamentoSigtapDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicamentoSigtapDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): MedicamentoSigtapDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicamentoSigtapDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicamentoSigtapDtoPagedResultDto {
    totalCount: number;
    items: MedicamentoSigtapDto[] | undefined;
}

export class CreateMedicamentoSigtapDto implements ICreateMedicamentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    organizacao: string | undefined;

    constructor(data?: ICreateMedicamentoSigtapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.grupo = _data["grupo"];
            this.subgrupo = _data["subgrupo"];
            this.organizacao = _data["organizacao"];
        }
    }

    static fromJS(data: any): CreateMedicamentoSigtapDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicamentoSigtapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["grupo"] = this.grupo;
        data["subgrupo"] = this.subgrupo;
        data["organizacao"] = this.organizacao;
        return data;
    }

    clone(): CreateMedicamentoSigtapDto {
        const json = this.toJSON();
        let result = new CreateMedicamentoSigtapDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicamentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    organizacao: string | undefined;
}

export class UpdateMedicamentoSigtapDto implements IUpdateMedicamentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    organizacao: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IUpdateMedicamentoSigtapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.grupo = _data["grupo"];
            this.subgrupo = _data["subgrupo"];
            this.organizacao = _data["organizacao"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMedicamentoSigtapDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicamentoSigtapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["grupo"] = this.grupo;
        data["subgrupo"] = this.subgrupo;
        data["organizacao"] = this.organizacao;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateMedicamentoSigtapDto {
        const json = this.toJSON();
        let result = new UpdateMedicamentoSigtapDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicamentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    organizacao: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class MedicamentoTissDto implements IMedicamentoTissDto {
    codigo: string | undefined;
    descricao: string | undefined;
    principioAtivo: string | undefined;
    generico: string | undefined;
    grupoFarmacologico: string | undefined;
    classeFarmacologica: string | undefined;
    formaFarmaceutica: string | undefined;
    unidMinFracao: string | undefined;
    detentordoRegistronaAnvisa: string | undefined;
    registroANVISA: string | undefined;
    tipodeProduto: string | undefined;
    tipodeCodificacao: string | undefined;
    codTISSBrasindice: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IMedicamentoTissDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.principioAtivo = _data["principioAtivo"];
            this.generico = _data["generico"];
            this.grupoFarmacologico = _data["grupoFarmacologico"];
            this.classeFarmacologica = _data["classeFarmacologica"];
            this.formaFarmaceutica = _data["formaFarmaceutica"];
            this.unidMinFracao = _data["unidMinFracao"];
            this.detentordoRegistronaAnvisa = _data["detentordoRegistronaAnvisa"];
            this.registroANVISA = _data["registroANVISA"];
            this.tipodeProduto = _data["tipodeProduto"];
            this.tipodeCodificacao = _data["tipodeCodificacao"];
            this.codTISSBrasindice = _data["codTISSBrasindice"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedicamentoTissDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicamentoTissDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["principioAtivo"] = this.principioAtivo;
        data["generico"] = this.generico;
        data["grupoFarmacologico"] = this.grupoFarmacologico;
        data["classeFarmacologica"] = this.classeFarmacologica;
        data["formaFarmaceutica"] = this.formaFarmaceutica;
        data["unidMinFracao"] = this.unidMinFracao;
        data["detentordoRegistronaAnvisa"] = this.detentordoRegistronaAnvisa;
        data["registroANVISA"] = this.registroANVISA;
        data["tipodeProduto"] = this.tipodeProduto;
        data["tipodeCodificacao"] = this.tipodeCodificacao;
        data["codTISSBrasindice"] = this.codTISSBrasindice;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): MedicamentoTissDto {
        const json = this.toJSON();
        let result = new MedicamentoTissDto();
        result.init(json);
        return result;
    }
}

export interface IMedicamentoTissDto {
    codigo: string | undefined;
    descricao: string | undefined;
    principioAtivo: string | undefined;
    generico: string | undefined;
    grupoFarmacologico: string | undefined;
    classeFarmacologica: string | undefined;
    formaFarmaceutica: string | undefined;
    unidMinFracao: string | undefined;
    detentordoRegistronaAnvisa: string | undefined;
    registroANVISA: string | undefined;
    tipodeProduto: string | undefined;
    tipodeCodificacao: string | undefined;
    codTISSBrasindice: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class MedicamentoTissDtoPagedResultDto implements IMedicamentoTissDtoPagedResultDto {
    totalCount: number;
    items: MedicamentoTissDto[] | undefined;

    constructor(data?: IMedicamentoTissDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MedicamentoTissDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicamentoTissDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicamentoTissDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): MedicamentoTissDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicamentoTissDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicamentoTissDtoPagedResultDto {
    totalCount: number;
    items: MedicamentoTissDto[] | undefined;
}

export class CreateMedicamentoTissDto implements ICreateMedicamentoTissDto {
    codigo: string | undefined;
    descricao: string | undefined;
    principioAtivo: string | undefined;
    generico: string | undefined;
    grupoFarmacologico: string | undefined;
    classeFarmacologica: string | undefined;
    formaFarmaceutica: string | undefined;
    unidMinFracao: string | undefined;
    detentordoRegistronaAnvisa: string | undefined;
    registroANVISA: string | undefined;
    tipodeProduto: string | undefined;
    tipodeCodificacao: string | undefined;
    codTISSBrasindice: string | undefined;
    observacoes: string | undefined;

    constructor(data?: ICreateMedicamentoTissDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.principioAtivo = _data["principioAtivo"];
            this.generico = _data["generico"];
            this.grupoFarmacologico = _data["grupoFarmacologico"];
            this.classeFarmacologica = _data["classeFarmacologica"];
            this.formaFarmaceutica = _data["formaFarmaceutica"];
            this.unidMinFracao = _data["unidMinFracao"];
            this.detentordoRegistronaAnvisa = _data["detentordoRegistronaAnvisa"];
            this.registroANVISA = _data["registroANVISA"];
            this.tipodeProduto = _data["tipodeProduto"];
            this.tipodeCodificacao = _data["tipodeCodificacao"];
            this.codTISSBrasindice = _data["codTISSBrasindice"];
            this.observacoes = _data["observacoes"];
        }
    }

    static fromJS(data: any): CreateMedicamentoTissDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicamentoTissDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["principioAtivo"] = this.principioAtivo;
        data["generico"] = this.generico;
        data["grupoFarmacologico"] = this.grupoFarmacologico;
        data["classeFarmacologica"] = this.classeFarmacologica;
        data["formaFarmaceutica"] = this.formaFarmaceutica;
        data["unidMinFracao"] = this.unidMinFracao;
        data["detentordoRegistronaAnvisa"] = this.detentordoRegistronaAnvisa;
        data["registroANVISA"] = this.registroANVISA;
        data["tipodeProduto"] = this.tipodeProduto;
        data["tipodeCodificacao"] = this.tipodeCodificacao;
        data["codTISSBrasindice"] = this.codTISSBrasindice;
        data["observacoes"] = this.observacoes;
        return data;
    }

    clone(): CreateMedicamentoTissDto {
        const json = this.toJSON();
        let result = new CreateMedicamentoTissDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicamentoTissDto {
    codigo: string | undefined;
    descricao: string | undefined;
    principioAtivo: string | undefined;
    generico: string | undefined;
    grupoFarmacologico: string | undefined;
    classeFarmacologica: string | undefined;
    formaFarmaceutica: string | undefined;
    unidMinFracao: string | undefined;
    detentordoRegistronaAnvisa: string | undefined;
    registroANVISA: string | undefined;
    tipodeProduto: string | undefined;
    tipodeCodificacao: string | undefined;
    codTISSBrasindice: string | undefined;
    observacoes: string | undefined;
}

export class UpdateMedicamentoTissDto implements IUpdateMedicamentoTissDto {
    codigo: string | undefined;
    descricao: string | undefined;
    principioAtivo: string | undefined;
    generico: string | undefined;
    grupoFarmacologico: string | undefined;
    classeFarmacologica: string | undefined;
    formaFarmaceutica: string | undefined;
    unidMinFracao: string | undefined;
    detentordoRegistronaAnvisa: string | undefined;
    registroANVISA: string | undefined;
    tipodeProduto: string | undefined;
    tipodeCodificacao: string | undefined;
    codTISSBrasindice: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IUpdateMedicamentoTissDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.principioAtivo = _data["principioAtivo"];
            this.generico = _data["generico"];
            this.grupoFarmacologico = _data["grupoFarmacologico"];
            this.classeFarmacologica = _data["classeFarmacologica"];
            this.formaFarmaceutica = _data["formaFarmaceutica"];
            this.unidMinFracao = _data["unidMinFracao"];
            this.detentordoRegistronaAnvisa = _data["detentordoRegistronaAnvisa"];
            this.registroANVISA = _data["registroANVISA"];
            this.tipodeProduto = _data["tipodeProduto"];
            this.tipodeCodificacao = _data["tipodeCodificacao"];
            this.codTISSBrasindice = _data["codTISSBrasindice"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMedicamentoTissDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicamentoTissDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["principioAtivo"] = this.principioAtivo;
        data["generico"] = this.generico;
        data["grupoFarmacologico"] = this.grupoFarmacologico;
        data["classeFarmacologica"] = this.classeFarmacologica;
        data["formaFarmaceutica"] = this.formaFarmaceutica;
        data["unidMinFracao"] = this.unidMinFracao;
        data["detentordoRegistronaAnvisa"] = this.detentordoRegistronaAnvisa;
        data["registroANVISA"] = this.registroANVISA;
        data["tipodeProduto"] = this.tipodeProduto;
        data["tipodeCodificacao"] = this.tipodeCodificacao;
        data["codTISSBrasindice"] = this.codTISSBrasindice;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateMedicamentoTissDto {
        const json = this.toJSON();
        let result = new UpdateMedicamentoTissDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicamentoTissDto {
    codigo: string | undefined;
    descricao: string | undefined;
    principioAtivo: string | undefined;
    generico: string | undefined;
    grupoFarmacologico: string | undefined;
    classeFarmacologica: string | undefined;
    formaFarmaceutica: string | undefined;
    unidMinFracao: string | undefined;
    detentordoRegistronaAnvisa: string | undefined;
    registroANVISA: string | undefined;
    tipodeProduto: string | undefined;
    tipodeCodificacao: string | undefined;
    codTISSBrasindice: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class MotorizacaoDto implements IMotorizacaoDto {
    valor: number;
    dataHora: moment.Moment;

    constructor(data?: IMotorizacaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valor = _data["valor"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MotorizacaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotorizacaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valor"] = this.valor;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        return data;
    }

    clone(): MotorizacaoDto {
        const json = this.toJSON();
        let result = new MotorizacaoDto();
        result.init(json);
        return result;
    }
}

export interface IMotorizacaoDto {
    valor: number;
    dataHora: moment.Moment;
}

export class NotificacaoDto implements INotificacaoDto {
    pacienteId: string;
    remetenteId: string | undefined;
    responsavelLegalId: string | undefined;
    terminoToken: moment.Moment | undefined;
    titulo: string;
    mensagem: string;
    token: string | undefined;
    hasResposta: boolean | undefined;
    mensagemPreview: string | undefined;
    isClinica: boolean | undefined;
    lida: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: INotificacaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.remetenteId = _data["remetenteId"];
            this.responsavelLegalId = _data["responsavelLegalId"];
            this.terminoToken = _data["terminoToken"] ? moment(_data["terminoToken"].toString()) : <any>undefined;
            this.titulo = _data["titulo"];
            this.mensagem = _data["mensagem"];
            this.token = _data["token"];
            this.hasResposta = _data["hasResposta"];
            this.mensagemPreview = _data["mensagemPreview"];
            this.isClinica = _data["isClinica"];
            this.lida = _data["lida"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NotificacaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificacaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["remetenteId"] = this.remetenteId;
        data["responsavelLegalId"] = this.responsavelLegalId;
        data["terminoToken"] = this.terminoToken ? this.terminoToken.toISOString() : <any>undefined;
        data["titulo"] = this.titulo;
        data["mensagem"] = this.mensagem;
        data["token"] = this.token;
        data["hasResposta"] = this.hasResposta;
        data["mensagemPreview"] = this.mensagemPreview;
        data["isClinica"] = this.isClinica;
        data["lida"] = this.lida;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): NotificacaoDto {
        const json = this.toJSON();
        let result = new NotificacaoDto();
        result.init(json);
        return result;
    }
}

export interface INotificacaoDto {
    pacienteId: string;
    remetenteId: string | undefined;
    responsavelLegalId: string | undefined;
    terminoToken: moment.Moment | undefined;
    titulo: string;
    mensagem: string;
    token: string | undefined;
    hasResposta: boolean | undefined;
    mensagemPreview: string | undefined;
    isClinica: boolean | undefined;
    lida: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateNotificacaoDto implements ICreateNotificacaoDto {
    pacienteId: string;
    remetenteId: string | undefined;
    responsavelLegalId: string | undefined;
    terminoToken: moment.Moment | undefined;
    titulo: string;
    mensagem: string;
    token: string | undefined;
    mensagemPreview: string | undefined;
    isClinica: boolean | undefined;

    constructor(data?: ICreateNotificacaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.remetenteId = _data["remetenteId"];
            this.responsavelLegalId = _data["responsavelLegalId"];
            this.terminoToken = _data["terminoToken"] ? moment(_data["terminoToken"].toString()) : <any>undefined;
            this.titulo = _data["titulo"];
            this.mensagem = _data["mensagem"];
            this.token = _data["token"];
            this.mensagemPreview = _data["mensagemPreview"];
            this.isClinica = _data["isClinica"];
        }
    }

    static fromJS(data: any): CreateNotificacaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotificacaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["remetenteId"] = this.remetenteId;
        data["responsavelLegalId"] = this.responsavelLegalId;
        data["terminoToken"] = this.terminoToken ? this.terminoToken.toISOString() : <any>undefined;
        data["titulo"] = this.titulo;
        data["mensagem"] = this.mensagem;
        data["token"] = this.token;
        data["mensagemPreview"] = this.mensagemPreview;
        data["isClinica"] = this.isClinica;
        return data;
    }

    clone(): CreateNotificacaoDto {
        const json = this.toJSON();
        let result = new CreateNotificacaoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNotificacaoDto {
    pacienteId: string;
    remetenteId: string | undefined;
    responsavelLegalId: string | undefined;
    terminoToken: moment.Moment | undefined;
    titulo: string;
    mensagem: string;
    token: string | undefined;
    mensagemPreview: string | undefined;
    isClinica: boolean | undefined;
}

export class PushNotificationConfigDto implements IPushNotificationConfigDto {
    apiKey: string | undefined;
    appId: string | undefined;
    messagingSenderId: string | undefined;
    projectId: string | undefined;

    constructor(data?: IPushNotificationConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.appId = _data["appId"];
            this.messagingSenderId = _data["messagingSenderId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): PushNotificationConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["appId"] = this.appId;
        data["messagingSenderId"] = this.messagingSenderId;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): PushNotificationConfigDto {
        const json = this.toJSON();
        let result = new PushNotificationConfigDto();
        result.init(json);
        return result;
    }
}

export interface IPushNotificationConfigDto {
    apiKey: string | undefined;
    appId: string | undefined;
    messagingSenderId: string | undefined;
    projectId: string | undefined;
}

export class CreateOximentriaDto implements ICreateOximentriaDto {
    valorOximetria: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateOximentriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorOximetria = _data["valorOximetria"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateOximentriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOximentriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorOximetria"] = this.valorOximetria;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateOximentriaDto {
        const json = this.toJSON();
        let result = new CreateOximentriaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOximentriaDto {
    valorOximetria: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class UpdateOximetriaDto implements IUpdateOximetriaDto {
    valorOximetria: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateOximetriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorOximetria = _data["valorOximetria"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateOximetriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOximetriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorOximetria"] = this.valorOximetria;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateOximetriaDto {
        const json = this.toJSON();
        let result = new UpdateOximetriaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOximetriaDto {
    valorOximetria: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class OximetriaDtoPagedResultDto implements IOximetriaDtoPagedResultDto {
    totalCount: number;
    items: OximetriaDto[] | undefined;

    constructor(data?: IOximetriaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OximetriaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OximetriaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OximetriaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): OximetriaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OximetriaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOximetriaDtoPagedResultDto {
    totalCount: number;
    items: OximetriaDto[] | undefined;
}

export class PacienteAlergiaDto implements IPacienteAlergiaDto {
    pacienteId: string;
    alergiaId: string;
    substancia: string | undefined;
    tipoAlergia: TipoAlergiaEnum;
    readonly tipoAlergiaString: string | undefined;
    observacao: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPacienteAlergiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.alergiaId = _data["alergiaId"];
            this.substancia = _data["substancia"];
            this.tipoAlergia = _data["tipoAlergia"];
            (<any>this).tipoAlergiaString = _data["tipoAlergiaString"];
            this.observacao = _data["observacao"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteAlergiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteAlergiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["alergiaId"] = this.alergiaId;
        data["substancia"] = this.substancia;
        data["tipoAlergia"] = this.tipoAlergia;
        data["tipoAlergiaString"] = this.tipoAlergiaString;
        data["observacao"] = this.observacao;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteAlergiaDto {
        const json = this.toJSON();
        let result = new PacienteAlergiaDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteAlergiaDto {
    pacienteId: string;
    alergiaId: string;
    substancia: string | undefined;
    tipoAlergia: TipoAlergiaEnum;
    tipoAlergiaString: string | undefined;
    observacao: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class EmailAlternativoDto implements IEmailAlternativoDto {
    idPaciente: string;
    email: string | undefined;
    id: string;

    constructor(data?: IEmailAlternativoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPaciente = _data["idPaciente"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmailAlternativoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAlternativoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPaciente"] = this.idPaciente;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }

    clone(): EmailAlternativoDto {
        const json = this.toJSON();
        let result = new EmailAlternativoDto();
        result.init(json);
        return result;
    }
}

export interface IEmailAlternativoDto {
    idPaciente: string;
    email: string | undefined;
    id: string;
}

export class PacienteClincaMedicaDto implements IPacienteClincaMedicaDto {
    clinicaMedicaId: string;
    pacienteId: string;
    token: string | undefined;

    constructor(data?: IPacienteClincaMedicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.pacienteId = _data["pacienteId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): PacienteClincaMedicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteClincaMedicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["pacienteId"] = this.pacienteId;
        data["token"] = this.token;
        return data;
    }

    clone(): PacienteClincaMedicaDto {
        const json = this.toJSON();
        let result = new PacienteClincaMedicaDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteClincaMedicaDto {
    clinicaMedicaId: string;
    pacienteId: string;
    token: string | undefined;
}

export class PacienteDto implements IPacienteDto {
    nome: string | undefined;
    nomeSocial: string | undefined;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    cpf: string | undefined;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    nomeMae: string | undefined;
    peso: string | undefined;
    objetivoPeso: number | undefined;
    altura: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    userId: number | undefined;
    user: UserDto;
    endereco: EnderecoDto;
    enderecoId: string | undefined;
    prontuarioId: string | undefined;
    responsavelLegalId: string | undefined;
    readonly isDependente: boolean;
    isPacienteClinica: boolean;
    vip: boolean;
    hasCadastroCompleto: boolean;
    tipoSanguineo: TipoSanguineoEnum;
    readonly tipoSanguineoString: string | undefined;
    estadoCivil: EstadoCivilEnum;
    readonly estadoCivilString: string | undefined;
    corEtnia: CorEtniaEnum;
    readonly corEtniaString: string | undefined;
    profissao: string | undefined;
    religiao: string | undefined;
    ehEstrangeiro: boolean;
    assinatura: AssinaturaDto;
    pacienteAlergias: PacienteAlergiaDto[] | undefined;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVipDto[] | undefined;
    emailAlternativo: EmailAlternativoDto[] | undefined;
    dadosAltura: AlturaDto[] | undefined;
    dadosBatimentosCardiacos: BatimentosCardiacosDto[] | undefined;
    dadosDorArticular: DorArticularDto[] | undefined;
    dadosFrequenciaRespiratoria: FrequenciaRespiratoriaDto[] | undefined;
    dadosGlicose: GlicoseDto[] | undefined;
    dadosHumor: HumorDto[] | undefined;
    dadosObjetivoImc: ObjetivoImcDto[] | undefined;
    dadosOximetria: OximetriaDto[] | undefined;
    dadosPeso: PesoDto[] | undefined;
    dadosPressaoArterial: PressaoArterialDto[] | undefined;
    dadosQualidadeSono: QualidadeSonoDto[] | undefined;
    dadosTemperatura: TemperaturaDto[] | undefined;
    clinicasMedicas: PacienteClincaMedicaDto[] | undefined;
    medicos: ProfissionalSaudePacienteDto[] | undefined;
    sexo: SexoEnum;
    readonly sexoDescricao: string | undefined;
    readonly idade: number;
    numeroPassaporte: string | undefined;
    id: string;

    constructor(data?: IPacienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.nomeSocial = _data["nomeSocial"];
            this.avatar = _data["avatar"];
            this.nomeAvatar = _data["nomeAvatar"];
            this.cpf = _data["cpf"];
            this.rg = _data["rg"];
            this.cns = _data["cns"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.nomeMae = _data["nomeMae"];
            this.peso = _data["peso"];
            this.objetivoPeso = _data["objetivoPeso"];
            this.altura = _data["altura"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.enderecoId = _data["enderecoId"];
            this.prontuarioId = _data["prontuarioId"];
            this.responsavelLegalId = _data["responsavelLegalId"];
            (<any>this).isDependente = _data["isDependente"];
            this.isPacienteClinica = _data["isPacienteClinica"];
            this.vip = _data["vip"];
            this.hasCadastroCompleto = _data["hasCadastroCompleto"];
            this.tipoSanguineo = _data["tipoSanguineo"];
            (<any>this).tipoSanguineoString = _data["tipoSanguineoString"];
            this.estadoCivil = _data["estadoCivil"];
            (<any>this).estadoCivilString = _data["estadoCivilString"];
            this.corEtnia = _data["corEtnia"];
            (<any>this).corEtniaString = _data["corEtniaString"];
            this.profissao = _data["profissao"];
            this.religiao = _data["religiao"];
            this.ehEstrangeiro = _data["ehEstrangeiro"];
            this.assinatura = _data["assinatura"] ? AssinaturaDto.fromJS(_data["assinatura"]) : <any>undefined;
            if (Array.isArray(_data["pacienteAlergias"])) {
                this.pacienteAlergias = [] as any;
                for (let item of _data["pacienteAlergias"])
                    this.pacienteAlergias.push(PacienteAlergiaDto.fromJS(item));
            }
            if (Array.isArray(_data["clinicaMedicaPacienteVip"])) {
                this.clinicaMedicaPacienteVip = [] as any;
                for (let item of _data["clinicaMedicaPacienteVip"])
                    this.clinicaMedicaPacienteVip.push(ClinicaMedicaPacienteVipDto.fromJS(item));
            }
            if (Array.isArray(_data["emailAlternativo"])) {
                this.emailAlternativo = [] as any;
                for (let item of _data["emailAlternativo"])
                    this.emailAlternativo.push(EmailAlternativoDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosAltura"])) {
                this.dadosAltura = [] as any;
                for (let item of _data["dadosAltura"])
                    this.dadosAltura.push(AlturaDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosBatimentosCardiacos"])) {
                this.dadosBatimentosCardiacos = [] as any;
                for (let item of _data["dadosBatimentosCardiacos"])
                    this.dadosBatimentosCardiacos.push(BatimentosCardiacosDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosDorArticular"])) {
                this.dadosDorArticular = [] as any;
                for (let item of _data["dadosDorArticular"])
                    this.dadosDorArticular.push(DorArticularDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosFrequenciaRespiratoria"])) {
                this.dadosFrequenciaRespiratoria = [] as any;
                for (let item of _data["dadosFrequenciaRespiratoria"])
                    this.dadosFrequenciaRespiratoria.push(FrequenciaRespiratoriaDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosGlicose"])) {
                this.dadosGlicose = [] as any;
                for (let item of _data["dadosGlicose"])
                    this.dadosGlicose.push(GlicoseDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosHumor"])) {
                this.dadosHumor = [] as any;
                for (let item of _data["dadosHumor"])
                    this.dadosHumor.push(HumorDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosObjetivoImc"])) {
                this.dadosObjetivoImc = [] as any;
                for (let item of _data["dadosObjetivoImc"])
                    this.dadosObjetivoImc.push(ObjetivoImcDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosOximetria"])) {
                this.dadosOximetria = [] as any;
                for (let item of _data["dadosOximetria"])
                    this.dadosOximetria.push(OximetriaDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosPeso"])) {
                this.dadosPeso = [] as any;
                for (let item of _data["dadosPeso"])
                    this.dadosPeso.push(PesoDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosPressaoArterial"])) {
                this.dadosPressaoArterial = [] as any;
                for (let item of _data["dadosPressaoArterial"])
                    this.dadosPressaoArterial.push(PressaoArterialDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosQualidadeSono"])) {
                this.dadosQualidadeSono = [] as any;
                for (let item of _data["dadosQualidadeSono"])
                    this.dadosQualidadeSono.push(QualidadeSonoDto.fromJS(item));
            }
            if (Array.isArray(_data["dadosTemperatura"])) {
                this.dadosTemperatura = [] as any;
                for (let item of _data["dadosTemperatura"])
                    this.dadosTemperatura.push(TemperaturaDto.fromJS(item));
            }
            if (Array.isArray(_data["clinicasMedicas"])) {
                this.clinicasMedicas = [] as any;
                for (let item of _data["clinicasMedicas"])
                    this.clinicasMedicas.push(PacienteClincaMedicaDto.fromJS(item));
            }
            if (Array.isArray(_data["medicos"])) {
                this.medicos = [] as any;
                for (let item of _data["medicos"])
                    this.medicos.push(ProfissionalSaudePacienteDto.fromJS(item));
            }
            this.sexo = _data["sexo"];
            (<any>this).sexoDescricao = _data["sexoDescricao"];
            (<any>this).idade = _data["idade"];
            this.numeroPassaporte = _data["numeroPassaporte"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["nomeSocial"] = this.nomeSocial;
        data["avatar"] = this.avatar;
        data["nomeAvatar"] = this.nomeAvatar;
        data["cpf"] = this.cpf;
        data["rg"] = this.rg;
        data["cns"] = this.cns;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["nomeMae"] = this.nomeMae;
        data["peso"] = this.peso;
        data["objetivoPeso"] = this.objetivoPeso;
        data["altura"] = this.altura;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["enderecoId"] = this.enderecoId;
        data["prontuarioId"] = this.prontuarioId;
        data["responsavelLegalId"] = this.responsavelLegalId;
        data["isDependente"] = this.isDependente;
        data["isPacienteClinica"] = this.isPacienteClinica;
        data["vip"] = this.vip;
        data["hasCadastroCompleto"] = this.hasCadastroCompleto;
        data["tipoSanguineo"] = this.tipoSanguineo;
        data["tipoSanguineoString"] = this.tipoSanguineoString;
        data["estadoCivil"] = this.estadoCivil;
        data["estadoCivilString"] = this.estadoCivilString;
        data["corEtnia"] = this.corEtnia;
        data["corEtniaString"] = this.corEtniaString;
        data["profissao"] = this.profissao;
        data["religiao"] = this.religiao;
        data["ehEstrangeiro"] = this.ehEstrangeiro;
        data["assinatura"] = this.assinatura ? this.assinatura.toJSON() : <any>undefined;
        if (Array.isArray(this.pacienteAlergias)) {
            data["pacienteAlergias"] = [];
            for (let item of this.pacienteAlergias)
                data["pacienteAlergias"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicaMedicaPacienteVip)) {
            data["clinicaMedicaPacienteVip"] = [];
            for (let item of this.clinicaMedicaPacienteVip)
                data["clinicaMedicaPacienteVip"].push(item.toJSON());
        }
        if (Array.isArray(this.emailAlternativo)) {
            data["emailAlternativo"] = [];
            for (let item of this.emailAlternativo)
                data["emailAlternativo"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosAltura)) {
            data["dadosAltura"] = [];
            for (let item of this.dadosAltura)
                data["dadosAltura"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosBatimentosCardiacos)) {
            data["dadosBatimentosCardiacos"] = [];
            for (let item of this.dadosBatimentosCardiacos)
                data["dadosBatimentosCardiacos"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosDorArticular)) {
            data["dadosDorArticular"] = [];
            for (let item of this.dadosDorArticular)
                data["dadosDorArticular"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosFrequenciaRespiratoria)) {
            data["dadosFrequenciaRespiratoria"] = [];
            for (let item of this.dadosFrequenciaRespiratoria)
                data["dadosFrequenciaRespiratoria"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosGlicose)) {
            data["dadosGlicose"] = [];
            for (let item of this.dadosGlicose)
                data["dadosGlicose"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosHumor)) {
            data["dadosHumor"] = [];
            for (let item of this.dadosHumor)
                data["dadosHumor"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosObjetivoImc)) {
            data["dadosObjetivoImc"] = [];
            for (let item of this.dadosObjetivoImc)
                data["dadosObjetivoImc"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosOximetria)) {
            data["dadosOximetria"] = [];
            for (let item of this.dadosOximetria)
                data["dadosOximetria"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosPeso)) {
            data["dadosPeso"] = [];
            for (let item of this.dadosPeso)
                data["dadosPeso"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosPressaoArterial)) {
            data["dadosPressaoArterial"] = [];
            for (let item of this.dadosPressaoArterial)
                data["dadosPressaoArterial"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosQualidadeSono)) {
            data["dadosQualidadeSono"] = [];
            for (let item of this.dadosQualidadeSono)
                data["dadosQualidadeSono"].push(item.toJSON());
        }
        if (Array.isArray(this.dadosTemperatura)) {
            data["dadosTemperatura"] = [];
            for (let item of this.dadosTemperatura)
                data["dadosTemperatura"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicasMedicas)) {
            data["clinicasMedicas"] = [];
            for (let item of this.clinicasMedicas)
                data["clinicasMedicas"].push(item.toJSON());
        }
        if (Array.isArray(this.medicos)) {
            data["medicos"] = [];
            for (let item of this.medicos)
                data["medicos"].push(item.toJSON());
        }
        data["sexo"] = this.sexo;
        data["sexoDescricao"] = this.sexoDescricao;
        data["idade"] = this.idade;
        data["numeroPassaporte"] = this.numeroPassaporte;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteDto {
        const json = this.toJSON();
        let result = new PacienteDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteDto {
    nome: string | undefined;
    nomeSocial: string | undefined;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    cpf: string | undefined;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    nomeMae: string | undefined;
    peso: string | undefined;
    objetivoPeso: number | undefined;
    altura: string | undefined;
    email: string | undefined;
    celular: string | undefined;
    userId: number | undefined;
    user: UserDto;
    endereco: EnderecoDto;
    enderecoId: string | undefined;
    prontuarioId: string | undefined;
    responsavelLegalId: string | undefined;
    isDependente: boolean;
    isPacienteClinica: boolean;
    vip: boolean;
    hasCadastroCompleto: boolean;
    tipoSanguineo: TipoSanguineoEnum;
    tipoSanguineoString: string | undefined;
    estadoCivil: EstadoCivilEnum;
    estadoCivilString: string | undefined;
    corEtnia: CorEtniaEnum;
    corEtniaString: string | undefined;
    profissao: string | undefined;
    religiao: string | undefined;
    ehEstrangeiro: boolean;
    assinatura: AssinaturaDto;
    pacienteAlergias: PacienteAlergiaDto[] | undefined;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVipDto[] | undefined;
    emailAlternativo: EmailAlternativoDto[] | undefined;
    dadosAltura: AlturaDto[] | undefined;
    dadosBatimentosCardiacos: BatimentosCardiacosDto[] | undefined;
    dadosDorArticular: DorArticularDto[] | undefined;
    dadosFrequenciaRespiratoria: FrequenciaRespiratoriaDto[] | undefined;
    dadosGlicose: GlicoseDto[] | undefined;
    dadosHumor: HumorDto[] | undefined;
    dadosObjetivoImc: ObjetivoImcDto[] | undefined;
    dadosOximetria: OximetriaDto[] | undefined;
    dadosPeso: PesoDto[] | undefined;
    dadosPressaoArterial: PressaoArterialDto[] | undefined;
    dadosQualidadeSono: QualidadeSonoDto[] | undefined;
    dadosTemperatura: TemperaturaDto[] | undefined;
    clinicasMedicas: PacienteClincaMedicaDto[] | undefined;
    medicos: ProfissionalSaudePacienteDto[] | undefined;
    sexo: SexoEnum;
    sexoDescricao: string | undefined;
    idade: number;
    numeroPassaporte: string | undefined;
    id: string;
}

export enum GrauParentescoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class CreatePacienteDto implements ICreatePacienteDto {
    nome: string;
    nomeSocial: string | undefined;
    cpf: string | undefined;
    avatarBase64: string | undefined;
    nomeAvatar: string | undefined;
    sexo: SexoEnum;
    tipoSanguineo: TipoSanguineoEnum;
    estadoCivil: EstadoCivilEnum;
    corEtnia: CorEtniaEnum;
    profissao: string | undefined;
    religiao: string | undefined;
    nomeMae: string | undefined;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    email: string | undefined;
    emailAlternativo: EmailAlternativoDto[] | undefined;
    celular: string;
    senha: string | undefined;
    isDependente: boolean;
    responsavelLogado: boolean;
    responsavelLegalId: string | undefined;
    responsavelLegalNome: string | undefined;
    responsavelLegalCpf: string | undefined;
    responsavelLegalCelular: string | undefined;
    responsavelLegalNomeSocial: string | undefined;
    responsavelLegalEmail: string | undefined;
    responsavelLegalProfissao: string | undefined;
    responsavelLegalReligiao: string | undefined;
    responsavelLegalNomeMae: string | undefined;
    responsavelLegalNumeroPassaporte: string | undefined;
    responsavelLegaDataNascimento: moment.Moment | undefined;
    responsavelLegalEmailAlternativo: EmailAlternativoDto[] | undefined;
    enderecoAssinatura: EnderecoAssinaturaDto;
    responsavelLegalSenha: string | undefined;
    grauParentesco: GrauParentescoEnum;
    clinicaMedicaId: string | undefined;
    profissionalSaudeId: string | undefined;
    numeroPassaporte: string | undefined;
    ehEstrangeiro: boolean;

    constructor(data?: ICreatePacienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.nomeSocial = _data["nomeSocial"];
            this.cpf = _data["cpf"];
            this.avatarBase64 = _data["avatarBase64"];
            this.nomeAvatar = _data["nomeAvatar"];
            this.sexo = _data["sexo"];
            this.tipoSanguineo = _data["tipoSanguineo"];
            this.estadoCivil = _data["estadoCivil"];
            this.corEtnia = _data["corEtnia"];
            this.profissao = _data["profissao"];
            this.religiao = _data["religiao"];
            this.nomeMae = _data["nomeMae"];
            this.rg = _data["rg"];
            this.cns = _data["cns"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.email = _data["email"];
            if (Array.isArray(_data["emailAlternativo"])) {
                this.emailAlternativo = [] as any;
                for (let item of _data["emailAlternativo"])
                    this.emailAlternativo.push(EmailAlternativoDto.fromJS(item));
            }
            this.celular = _data["celular"];
            this.senha = _data["senha"];
            this.isDependente = _data["isDependente"];
            this.responsavelLogado = _data["responsavelLogado"];
            this.responsavelLegalId = _data["responsavelLegalId"];
            this.responsavelLegalNome = _data["responsavelLegalNome"];
            this.responsavelLegalCpf = _data["responsavelLegalCpf"];
            this.responsavelLegalCelular = _data["responsavelLegalCelular"];
            this.responsavelLegalNomeSocial = _data["responsavelLegalNomeSocial"];
            this.responsavelLegalEmail = _data["responsavelLegalEmail"];
            this.responsavelLegalProfissao = _data["responsavelLegalProfissao"];
            this.responsavelLegalReligiao = _data["responsavelLegalReligiao"];
            this.responsavelLegalNomeMae = _data["responsavelLegalNomeMae"];
            this.responsavelLegalNumeroPassaporte = _data["responsavelLegalNumeroPassaporte"];
            this.responsavelLegaDataNascimento = _data["responsavelLegaDataNascimento"] ? moment(_data["responsavelLegaDataNascimento"].toString()) : <any>undefined;
            if (Array.isArray(_data["responsavelLegalEmailAlternativo"])) {
                this.responsavelLegalEmailAlternativo = [] as any;
                for (let item of _data["responsavelLegalEmailAlternativo"])
                    this.responsavelLegalEmailAlternativo.push(EmailAlternativoDto.fromJS(item));
            }
            this.enderecoAssinatura = _data["enderecoAssinatura"] ? EnderecoAssinaturaDto.fromJS(_data["enderecoAssinatura"]) : <any>undefined;
            this.responsavelLegalSenha = _data["responsavelLegalSenha"];
            this.grauParentesco = _data["grauParentesco"];
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.profissionalSaudeId = _data["profissionalSaudeId"];
            this.numeroPassaporte = _data["numeroPassaporte"];
            this.ehEstrangeiro = _data["ehEstrangeiro"];
        }
    }

    static fromJS(data: any): CreatePacienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePacienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["nomeSocial"] = this.nomeSocial;
        data["cpf"] = this.cpf;
        data["avatarBase64"] = this.avatarBase64;
        data["nomeAvatar"] = this.nomeAvatar;
        data["sexo"] = this.sexo;
        data["tipoSanguineo"] = this.tipoSanguineo;
        data["estadoCivil"] = this.estadoCivil;
        data["corEtnia"] = this.corEtnia;
        data["profissao"] = this.profissao;
        data["religiao"] = this.religiao;
        data["nomeMae"] = this.nomeMae;
        data["rg"] = this.rg;
        data["cns"] = this.cns;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["email"] = this.email;
        if (Array.isArray(this.emailAlternativo)) {
            data["emailAlternativo"] = [];
            for (let item of this.emailAlternativo)
                data["emailAlternativo"].push(item.toJSON());
        }
        data["celular"] = this.celular;
        data["senha"] = this.senha;
        data["isDependente"] = this.isDependente;
        data["responsavelLogado"] = this.responsavelLogado;
        data["responsavelLegalId"] = this.responsavelLegalId;
        data["responsavelLegalNome"] = this.responsavelLegalNome;
        data["responsavelLegalCpf"] = this.responsavelLegalCpf;
        data["responsavelLegalCelular"] = this.responsavelLegalCelular;
        data["responsavelLegalNomeSocial"] = this.responsavelLegalNomeSocial;
        data["responsavelLegalEmail"] = this.responsavelLegalEmail;
        data["responsavelLegalProfissao"] = this.responsavelLegalProfissao;
        data["responsavelLegalReligiao"] = this.responsavelLegalReligiao;
        data["responsavelLegalNomeMae"] = this.responsavelLegalNomeMae;
        data["responsavelLegalNumeroPassaporte"] = this.responsavelLegalNumeroPassaporte;
        data["responsavelLegaDataNascimento"] = this.responsavelLegaDataNascimento ? this.responsavelLegaDataNascimento.toISOString() : <any>undefined;
        if (Array.isArray(this.responsavelLegalEmailAlternativo)) {
            data["responsavelLegalEmailAlternativo"] = [];
            for (let item of this.responsavelLegalEmailAlternativo)
                data["responsavelLegalEmailAlternativo"].push(item.toJSON());
        }
        data["enderecoAssinatura"] = this.enderecoAssinatura ? this.enderecoAssinatura.toJSON() : <any>undefined;
        data["responsavelLegalSenha"] = this.responsavelLegalSenha;
        data["grauParentesco"] = this.grauParentesco;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["profissionalSaudeId"] = this.profissionalSaudeId;
        data["numeroPassaporte"] = this.numeroPassaporte;
        data["ehEstrangeiro"] = this.ehEstrangeiro;
        return data;
    }

    clone(): CreatePacienteDto {
        const json = this.toJSON();
        let result = new CreatePacienteDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePacienteDto {
    nome: string;
    nomeSocial: string | undefined;
    cpf: string | undefined;
    avatarBase64: string | undefined;
    nomeAvatar: string | undefined;
    sexo: SexoEnum;
    tipoSanguineo: TipoSanguineoEnum;
    estadoCivil: EstadoCivilEnum;
    corEtnia: CorEtniaEnum;
    profissao: string | undefined;
    religiao: string | undefined;
    nomeMae: string | undefined;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    email: string | undefined;
    emailAlternativo: EmailAlternativoDto[] | undefined;
    celular: string;
    senha: string | undefined;
    isDependente: boolean;
    responsavelLogado: boolean;
    responsavelLegalId: string | undefined;
    responsavelLegalNome: string | undefined;
    responsavelLegalCpf: string | undefined;
    responsavelLegalCelular: string | undefined;
    responsavelLegalNomeSocial: string | undefined;
    responsavelLegalEmail: string | undefined;
    responsavelLegalProfissao: string | undefined;
    responsavelLegalReligiao: string | undefined;
    responsavelLegalNomeMae: string | undefined;
    responsavelLegalNumeroPassaporte: string | undefined;
    responsavelLegaDataNascimento: moment.Moment | undefined;
    responsavelLegalEmailAlternativo: EmailAlternativoDto[] | undefined;
    enderecoAssinatura: EnderecoAssinaturaDto;
    responsavelLegalSenha: string | undefined;
    grauParentesco: GrauParentescoEnum;
    clinicaMedicaId: string | undefined;
    profissionalSaudeId: string | undefined;
    numeroPassaporte: string | undefined;
    ehEstrangeiro: boolean;
}

export class UpdatePacienteDto implements IUpdatePacienteDto {
    nome: string;
    nomeSocial: string | undefined;
    cpf: string | undefined;
    avatar: string | undefined;
    atualizarAvatar: boolean;
    nomeAvatar: string | undefined;
    sexo: SexoEnum;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    email: string | undefined;
    tipoSanguineo: TipoSanguineoEnum;
    estadoCivil: EstadoCivilEnum;
    corEtnia: CorEtniaEnum;
    profissao: string | undefined;
    religiao: string | undefined;
    nomeMae: string | undefined;
    celular: string;
    hasCadastroCompleto: boolean;
    isDependente: boolean;
    enderecoAtualizado: UpdateEnderecoDto;
    enderecoAtualizadoId: string | undefined;
    responsavelLegalId: string | undefined;
    emailAlternativo: EmailAlternativoDto[] | undefined;
    numeroPassaporte: string | undefined;
    ehEstrangeiro: boolean;
    id: string;

    constructor(data?: IUpdatePacienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.nomeSocial = _data["nomeSocial"];
            this.cpf = _data["cpf"];
            this.avatar = _data["avatar"];
            this.atualizarAvatar = _data["atualizarAvatar"];
            this.nomeAvatar = _data["nomeAvatar"];
            this.sexo = _data["sexo"];
            this.rg = _data["rg"];
            this.cns = _data["cns"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.tipoSanguineo = _data["tipoSanguineo"];
            this.estadoCivil = _data["estadoCivil"];
            this.corEtnia = _data["corEtnia"];
            this.profissao = _data["profissao"];
            this.religiao = _data["religiao"];
            this.nomeMae = _data["nomeMae"];
            this.celular = _data["celular"];
            this.hasCadastroCompleto = _data["hasCadastroCompleto"];
            this.isDependente = _data["isDependente"];
            this.enderecoAtualizado = _data["enderecoAtualizado"] ? UpdateEnderecoDto.fromJS(_data["enderecoAtualizado"]) : <any>undefined;
            this.enderecoAtualizadoId = _data["enderecoAtualizadoId"];
            this.responsavelLegalId = _data["responsavelLegalId"];
            if (Array.isArray(_data["emailAlternativo"])) {
                this.emailAlternativo = [] as any;
                for (let item of _data["emailAlternativo"])
                    this.emailAlternativo.push(EmailAlternativoDto.fromJS(item));
            }
            this.numeroPassaporte = _data["numeroPassaporte"];
            this.ehEstrangeiro = _data["ehEstrangeiro"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePacienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePacienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["nomeSocial"] = this.nomeSocial;
        data["cpf"] = this.cpf;
        data["avatar"] = this.avatar;
        data["atualizarAvatar"] = this.atualizarAvatar;
        data["nomeAvatar"] = this.nomeAvatar;
        data["sexo"] = this.sexo;
        data["rg"] = this.rg;
        data["cns"] = this.cns;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["tipoSanguineo"] = this.tipoSanguineo;
        data["estadoCivil"] = this.estadoCivil;
        data["corEtnia"] = this.corEtnia;
        data["profissao"] = this.profissao;
        data["religiao"] = this.religiao;
        data["nomeMae"] = this.nomeMae;
        data["celular"] = this.celular;
        data["hasCadastroCompleto"] = this.hasCadastroCompleto;
        data["isDependente"] = this.isDependente;
        data["enderecoAtualizado"] = this.enderecoAtualizado ? this.enderecoAtualizado.toJSON() : <any>undefined;
        data["enderecoAtualizadoId"] = this.enderecoAtualizadoId;
        data["responsavelLegalId"] = this.responsavelLegalId;
        if (Array.isArray(this.emailAlternativo)) {
            data["emailAlternativo"] = [];
            for (let item of this.emailAlternativo)
                data["emailAlternativo"].push(item.toJSON());
        }
        data["numeroPassaporte"] = this.numeroPassaporte;
        data["ehEstrangeiro"] = this.ehEstrangeiro;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdatePacienteDto {
        const json = this.toJSON();
        let result = new UpdatePacienteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePacienteDto {
    nome: string;
    nomeSocial: string | undefined;
    cpf: string | undefined;
    avatar: string | undefined;
    atualizarAvatar: boolean;
    nomeAvatar: string | undefined;
    sexo: SexoEnum;
    rg: string | undefined;
    cns: string | undefined;
    dataNascimento: moment.Moment | undefined;
    email: string | undefined;
    tipoSanguineo: TipoSanguineoEnum;
    estadoCivil: EstadoCivilEnum;
    corEtnia: CorEtniaEnum;
    profissao: string | undefined;
    religiao: string | undefined;
    nomeMae: string | undefined;
    celular: string;
    hasCadastroCompleto: boolean;
    isDependente: boolean;
    enderecoAtualizado: UpdateEnderecoDto;
    enderecoAtualizadoId: string | undefined;
    responsavelLegalId: string | undefined;
    emailAlternativo: EmailAlternativoDto[] | undefined;
    numeroPassaporte: string | undefined;
    ehEstrangeiro: boolean;
    id: string;
}

export class UpdateAvatarDto implements IUpdateAvatarDto {
    id: string;
    avatar: string | undefined;
    nomeAvatar: string | undefined;

    constructor(data?: IUpdateAvatarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.avatar = _data["avatar"];
            this.nomeAvatar = _data["nomeAvatar"];
        }
    }

    static fromJS(data: any): UpdateAvatarDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAvatarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        data["nomeAvatar"] = this.nomeAvatar;
        return data;
    }

    clone(): UpdateAvatarDto {
        const json = this.toJSON();
        let result = new UpdateAvatarDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAvatarDto {
    id: string;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
}

export class AlterarResponsavelLegalDto implements IAlterarResponsavelLegalDto {
    pacienteId: string;
    responsavelLegalId: string;

    constructor(data?: IAlterarResponsavelLegalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.responsavelLegalId = _data["responsavelLegalId"];
        }
    }

    static fromJS(data: any): AlterarResponsavelLegalDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlterarResponsavelLegalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["responsavelLegalId"] = this.responsavelLegalId;
        return data;
    }

    clone(): AlterarResponsavelLegalDto {
        const json = this.toJSON();
        let result = new AlterarResponsavelLegalDto();
        result.init(json);
        return result;
    }
}

export interface IAlterarResponsavelLegalDto {
    pacienteId: string;
    responsavelLegalId: string;
}

export class PacienteDtoPagedResultDto implements IPacienteDtoPagedResultDto {
    totalCount: number;
    items: PacienteDto[] | undefined;

    constructor(data?: IPacienteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PacienteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PacienteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PacienteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PacienteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteDtoPagedResultDto {
    totalCount: number;
    items: PacienteDto[] | undefined;
}

export class GerarFichaPacienteDto implements IGerarFichaPacienteDto {
    pacienteId: string;
    hasMedicamento: boolean;
    hasAlergia: boolean;
    graficos: GraficoMonitoramentoEnum[] | undefined;

    constructor(data?: IGerarFichaPacienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.hasMedicamento = _data["hasMedicamento"];
            this.hasAlergia = _data["hasAlergia"];
            if (Array.isArray(_data["graficos"])) {
                this.graficos = [] as any;
                for (let item of _data["graficos"])
                    this.graficos.push(item);
            }
        }
    }

    static fromJS(data: any): GerarFichaPacienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new GerarFichaPacienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["hasMedicamento"] = this.hasMedicamento;
        data["hasAlergia"] = this.hasAlergia;
        if (Array.isArray(this.graficos)) {
            data["graficos"] = [];
            for (let item of this.graficos)
                data["graficos"].push(item);
        }
        return data;
    }

    clone(): GerarFichaPacienteDto {
        const json = this.toJSON();
        let result = new GerarFichaPacienteDto();
        result.init(json);
        return result;
    }
}

export interface IGerarFichaPacienteDto {
    pacienteId: string;
    hasMedicamento: boolean;
    hasAlergia: boolean;
    graficos: GraficoMonitoramentoEnum[] | undefined;
}

export class CreateEnderecoPacienteDto implements ICreateEnderecoPacienteDto {
    pacienteId: string;
    cep: string | undefined;
    logradouro: string | undefined;
    numero: string | undefined;
    bairro: string | undefined;
    cidade: string | undefined;
    estado: string | undefined;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string | undefined;

    constructor(data?: ICreateEnderecoPacienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.cep = _data["cep"];
            this.logradouro = _data["logradouro"];
            this.numero = _data["numero"];
            this.bairro = _data["bairro"];
            this.cidade = _data["cidade"];
            this.estado = _data["estado"];
            this.complemento = _data["complemento"];
            this.referencia = _data["referencia"];
            this.codigoIbge = _data["codigoIbge"];
        }
    }

    static fromJS(data: any): CreateEnderecoPacienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEnderecoPacienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["cep"] = this.cep;
        data["logradouro"] = this.logradouro;
        data["numero"] = this.numero;
        data["bairro"] = this.bairro;
        data["cidade"] = this.cidade;
        data["estado"] = this.estado;
        data["complemento"] = this.complemento;
        data["referencia"] = this.referencia;
        data["codigoIbge"] = this.codigoIbge;
        return data;
    }

    clone(): CreateEnderecoPacienteDto {
        const json = this.toJSON();
        let result = new CreateEnderecoPacienteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEnderecoPacienteDto {
    pacienteId: string;
    cep: string | undefined;
    logradouro: string | undefined;
    numero: string | undefined;
    bairro: string | undefined;
    cidade: string | undefined;
    estado: string | undefined;
    complemento: string | undefined;
    referencia: string | undefined;
    codigoIbge: string | undefined;
}

export class HistoricoDto implements IHistoricoDto {
    dataHora: moment.Moment;
    descricao: string | undefined;
    arquivoId: string;
    id: string;

    constructor(data?: IHistoricoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.descricao = _data["descricao"];
            this.arquivoId = _data["arquivoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HistoricoDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["descricao"] = this.descricao;
        data["arquivoId"] = this.arquivoId;
        data["id"] = this.id;
        return data;
    }

    clone(): HistoricoDto {
        const json = this.toJSON();
        let result = new HistoricoDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricoDto {
    dataHora: moment.Moment;
    descricao: string | undefined;
    arquivoId: string;
    id: string;
}

export class TokenDto implements ITokenDto {
    token: string | undefined;
    inicio: moment.Moment;
    termino: moment.Moment;
    tempoEmSegundos: number;

    constructor(data?: ITokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.inicio = _data["inicio"] ? moment(_data["inicio"].toString()) : <any>undefined;
            this.termino = _data["termino"] ? moment(_data["termino"].toString()) : <any>undefined;
            this.tempoEmSegundos = _data["tempoEmSegundos"];
        }
    }

    static fromJS(data: any): TokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["inicio"] = this.inicio ? this.inicio.toISOString() : <any>undefined;
        data["termino"] = this.termino ? this.termino.toISOString() : <any>undefined;
        data["tempoEmSegundos"] = this.tempoEmSegundos;
        return data;
    }

    clone(): TokenDto {
        const json = this.toJSON();
        let result = new TokenDto();
        result.init(json);
        return result;
    }
}

export interface ITokenDto {
    token: string | undefined;
    inicio: moment.Moment;
    termino: moment.Moment;
    tempoEmSegundos: number;
}

export class VerificarResponsavelLegalDto implements IVerificarResponsavelLegalDto {
    success: boolean;
    isDependente: boolean;
    paciente: PacienteDto;
    message: string | undefined;

    constructor(data?: IVerificarResponsavelLegalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.isDependente = _data["isDependente"];
            this.paciente = _data["paciente"] ? PacienteDto.fromJS(_data["paciente"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): VerificarResponsavelLegalDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificarResponsavelLegalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["isDependente"] = this.isDependente;
        data["paciente"] = this.paciente ? this.paciente.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }

    clone(): VerificarResponsavelLegalDto {
        const json = this.toJSON();
        let result = new VerificarResponsavelLegalDto();
        result.init(json);
        return result;
    }
}

export interface IVerificarResponsavelLegalDto {
    success: boolean;
    isDependente: boolean;
    paciente: PacienteDto;
    message: string | undefined;
}

export class InformacoesHomePacienteDto implements IInformacoesHomePacienteDto {
    arquivos: number;
    consultas: number;
    exames: number;

    constructor(data?: IInformacoesHomePacienteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivos = _data["arquivos"];
            this.consultas = _data["consultas"];
            this.exames = _data["exames"];
        }
    }

    static fromJS(data: any): InformacoesHomePacienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformacoesHomePacienteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivos"] = this.arquivos;
        data["consultas"] = this.consultas;
        data["exames"] = this.exames;
        return data;
    }

    clone(): InformacoesHomePacienteDto {
        const json = this.toJSON();
        let result = new InformacoesHomePacienteDto();
        result.init(json);
        return result;
    }
}

export interface IInformacoesHomePacienteDto {
    arquivos: number;
    consultas: number;
    exames: number;
}

export class CreatePacienteAlergiaDto implements ICreatePacienteAlergiaDto {
    pacienteId: string;
    substancia: string;
    tipoAlergia: TipoAlergiaEnum;
    observacao: string | undefined;

    constructor(data?: ICreatePacienteAlergiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.substancia = _data["substancia"];
            this.tipoAlergia = _data["tipoAlergia"];
            this.observacao = _data["observacao"];
        }
    }

    static fromJS(data: any): CreatePacienteAlergiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePacienteAlergiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["substancia"] = this.substancia;
        data["tipoAlergia"] = this.tipoAlergia;
        data["observacao"] = this.observacao;
        return data;
    }

    clone(): CreatePacienteAlergiaDto {
        const json = this.toJSON();
        let result = new CreatePacienteAlergiaDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePacienteAlergiaDto {
    pacienteId: string;
    substancia: string;
    tipoAlergia: TipoAlergiaEnum;
    observacao: string | undefined;
}

export class PacienteAlergiaDtoPagedResultDto implements IPacienteAlergiaDtoPagedResultDto {
    totalCount: number;
    items: PacienteAlergiaDto[] | undefined;

    constructor(data?: IPacienteAlergiaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PacienteAlergiaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PacienteAlergiaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteAlergiaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PacienteAlergiaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PacienteAlergiaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteAlergiaDtoPagedResultDto {
    totalCount: number;
    items: PacienteAlergiaDto[] | undefined;
}

export class UpdatePacienteAlergiaDto implements IUpdatePacienteAlergiaDto {
    pacienteId: string;
    substancia: string;
    tipoAlergia: TipoAlergiaEnum;
    observacao: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdatePacienteAlergiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.substancia = _data["substancia"];
            this.tipoAlergia = _data["tipoAlergia"];
            this.observacao = _data["observacao"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePacienteAlergiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePacienteAlergiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["substancia"] = this.substancia;
        data["tipoAlergia"] = this.tipoAlergia;
        data["observacao"] = this.observacao;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdatePacienteAlergiaDto {
        const json = this.toJSON();
        let result = new UpdatePacienteAlergiaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePacienteAlergiaDto {
    pacienteId: string;
    substancia: string;
    tipoAlergia: TipoAlergiaEnum;
    observacao: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PacienteConvenioDto implements IPacienteConvenioDto {
    pacienteId: string;
    convenioId: string;
    convenio: ConvenioDto;
    plano: string | undefined;
    numeroCarteira: string | undefined;
    validade: moment.Moment | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPacienteConvenioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.convenioId = _data["convenioId"];
            this.convenio = _data["convenio"] ? ConvenioDto.fromJS(_data["convenio"]) : <any>undefined;
            this.plano = _data["plano"];
            this.numeroCarteira = _data["numeroCarteira"];
            this.validade = _data["validade"] ? moment(_data["validade"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PacienteConvenioDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteConvenioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["convenioId"] = this.convenioId;
        data["convenio"] = this.convenio ? this.convenio.toJSON() : <any>undefined;
        data["plano"] = this.plano;
        data["numeroCarteira"] = this.numeroCarteira;
        data["validade"] = this.validade ? this.validade.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PacienteConvenioDto {
        const json = this.toJSON();
        let result = new PacienteConvenioDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteConvenioDto {
    pacienteId: string;
    convenioId: string;
    convenio: ConvenioDto;
    plano: string | undefined;
    numeroCarteira: string | undefined;
    validade: moment.Moment | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PacienteConvenioDtoPagedResultDto implements IPacienteConvenioDtoPagedResultDto {
    totalCount: number;
    items: PacienteConvenioDto[] | undefined;

    constructor(data?: IPacienteConvenioDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PacienteConvenioDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PacienteConvenioDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PacienteConvenioDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PacienteConvenioDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PacienteConvenioDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPacienteConvenioDtoPagedResultDto {
    totalCount: number;
    items: PacienteConvenioDto[] | undefined;
}

export class CreatePesoDto implements ICreatePesoDto {
    valorPeso: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    objetivo: boolean;

    constructor(data?: ICreatePesoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorPeso = _data["valorPeso"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.objetivo = _data["objetivo"];
        }
    }

    static fromJS(data: any): CreatePesoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePesoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorPeso"] = this.valorPeso;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["objetivo"] = this.objetivo;
        return data;
    }

    clone(): CreatePesoDto {
        const json = this.toJSON();
        let result = new CreatePesoDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePesoDto {
    valorPeso: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    objetivo: boolean;
}

export class UpdatePesoDto implements IUpdatePesoDto {
    valorPeso: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    objetivo: boolean;
    id: string;

    constructor(data?: IUpdatePesoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorPeso = _data["valorPeso"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.objetivo = _data["objetivo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePesoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePesoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorPeso"] = this.valorPeso;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["objetivo"] = this.objetivo;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdatePesoDto {
        const json = this.toJSON();
        let result = new UpdatePesoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePesoDto {
    valorPeso: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    objetivo: boolean;
    id: string;
}

export class ObjetivoPeso implements IObjetivoPeso {
    valorPeso: number;
    pacienteId: string;

    constructor(data?: IObjetivoPeso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorPeso = _data["valorPeso"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): ObjetivoPeso {
        data = typeof data === 'object' ? data : {};
        let result = new ObjetivoPeso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorPeso"] = this.valorPeso;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): ObjetivoPeso {
        const json = this.toJSON();
        let result = new ObjetivoPeso();
        result.init(json);
        return result;
    }
}

export interface IObjetivoPeso {
    valorPeso: number;
    pacienteId: string;
}

export class PesoDtoPagedResultDto implements IPesoDtoPagedResultDto {
    totalCount: number;
    items: PesoDto[] | undefined;

    constructor(data?: IPesoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PesoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PesoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PesoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PesoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PesoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPesoDtoPagedResultDto {
    totalCount: number;
    items: PesoDto[] | undefined;
}

export class CreatePlanoBeneficiosDto implements ICreatePlanoBeneficiosDto {
    descricao: string | undefined;
    planoId: string;

    constructor(data?: ICreatePlanoBeneficiosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.planoId = _data["planoId"];
        }
    }

    static fromJS(data: any): CreatePlanoBeneficiosDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlanoBeneficiosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["planoId"] = this.planoId;
        return data;
    }

    clone(): CreatePlanoBeneficiosDto {
        const json = this.toJSON();
        let result = new CreatePlanoBeneficiosDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePlanoBeneficiosDto {
    descricao: string | undefined;
    planoId: string;
}

export class CreatePlanoDto implements ICreatePlanoDto {
    nome: string;
    valorAnual: number;
    valorMensal: number;
    limiteMb: number;
    temLimitePacientes: boolean;
    temCustoAdicionalPacientes: boolean;
    limitePacientes: number | undefined;
    valorCustoAdicionalPacientes: number | undefined;
    descricao: string | undefined;
    idAppleAnual: string | undefined;
    idAppleMensal: string | undefined;
    suspenso: boolean;
    publicoAlvo: PublicoAlvoEnum;
    planoBeneficios: CreatePlanoBeneficiosDto[] | undefined;
    free: boolean;
    isTryout: boolean;
    onlyAdmins: boolean;
    duracaoTryout: number | undefined;

    constructor(data?: ICreatePlanoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.valorAnual = _data["valorAnual"];
            this.valorMensal = _data["valorMensal"];
            this.limiteMb = _data["limiteMb"];
            this.temLimitePacientes = _data["temLimitePacientes"];
            this.temCustoAdicionalPacientes = _data["temCustoAdicionalPacientes"];
            this.limitePacientes = _data["limitePacientes"];
            this.valorCustoAdicionalPacientes = _data["valorCustoAdicionalPacientes"];
            this.descricao = _data["descricao"];
            this.idAppleAnual = _data["idAppleAnual"];
            this.idAppleMensal = _data["idAppleMensal"];
            this.suspenso = _data["suspenso"];
            this.publicoAlvo = _data["publicoAlvo"];
            if (Array.isArray(_data["planoBeneficios"])) {
                this.planoBeneficios = [] as any;
                for (let item of _data["planoBeneficios"])
                    this.planoBeneficios.push(CreatePlanoBeneficiosDto.fromJS(item));
            }
            this.free = _data["free"];
            this.isTryout = _data["isTryout"];
            this.onlyAdmins = _data["onlyAdmins"];
            this.duracaoTryout = _data["duracaoTryout"];
        }
    }

    static fromJS(data: any): CreatePlanoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlanoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["valorAnual"] = this.valorAnual;
        data["valorMensal"] = this.valorMensal;
        data["limiteMb"] = this.limiteMb;
        data["temLimitePacientes"] = this.temLimitePacientes;
        data["temCustoAdicionalPacientes"] = this.temCustoAdicionalPacientes;
        data["limitePacientes"] = this.limitePacientes;
        data["valorCustoAdicionalPacientes"] = this.valorCustoAdicionalPacientes;
        data["descricao"] = this.descricao;
        data["idAppleAnual"] = this.idAppleAnual;
        data["idAppleMensal"] = this.idAppleMensal;
        data["suspenso"] = this.suspenso;
        data["publicoAlvo"] = this.publicoAlvo;
        if (Array.isArray(this.planoBeneficios)) {
            data["planoBeneficios"] = [];
            for (let item of this.planoBeneficios)
                data["planoBeneficios"].push(item.toJSON());
        }
        data["free"] = this.free;
        data["isTryout"] = this.isTryout;
        data["onlyAdmins"] = this.onlyAdmins;
        data["duracaoTryout"] = this.duracaoTryout;
        return data;
    }

    clone(): CreatePlanoDto {
        const json = this.toJSON();
        let result = new CreatePlanoDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePlanoDto {
    nome: string;
    valorAnual: number;
    valorMensal: number;
    limiteMb: number;
    temLimitePacientes: boolean;
    temCustoAdicionalPacientes: boolean;
    limitePacientes: number | undefined;
    valorCustoAdicionalPacientes: number | undefined;
    descricao: string | undefined;
    idAppleAnual: string | undefined;
    idAppleMensal: string | undefined;
    suspenso: boolean;
    publicoAlvo: PublicoAlvoEnum;
    planoBeneficios: CreatePlanoBeneficiosDto[] | undefined;
    free: boolean;
    isTryout: boolean;
    onlyAdmins: boolean;
    duracaoTryout: number | undefined;
}

export class PlanoDtoPagedResultDto implements IPlanoDtoPagedResultDto {
    totalCount: number;
    items: PlanoDto[] | undefined;

    constructor(data?: IPlanoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PlanoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PlanoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PlanoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPlanoDtoPagedResultDto {
    totalCount: number;
    items: PlanoDto[] | undefined;
}

export class UpdatePlanoDto implements IUpdatePlanoDto {
    nome: string;
    valorAnual: number;
    valorMensal: number;
    limiteMb: number;
    temLimitePacientes: boolean;
    temCustoAdicionalPacientes: boolean;
    limitePacientes: number | undefined;
    valorCustoAdicionalPacientes: number | undefined;
    descricao: string | undefined;
    idAppleAnual: string | undefined;
    idAppleMensal: string | undefined;
    suspenso: boolean;
    free: boolean;
    isTryout: boolean;
    onlyAdmins: boolean;
    duracaoTryout: number | undefined;
    isDefault: boolean;
    publicoAlvo: PublicoAlvoEnum;
    novosBeneficios: PlanoBeneficiosDto[] | undefined;
    beneficiosRemovidos: PlanoBeneficiosDto[] | undefined;
    planoBeneficios: PlanoBeneficiosDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUpdatePlanoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.valorAnual = _data["valorAnual"];
            this.valorMensal = _data["valorMensal"];
            this.limiteMb = _data["limiteMb"];
            this.temLimitePacientes = _data["temLimitePacientes"];
            this.temCustoAdicionalPacientes = _data["temCustoAdicionalPacientes"];
            this.limitePacientes = _data["limitePacientes"];
            this.valorCustoAdicionalPacientes = _data["valorCustoAdicionalPacientes"];
            this.descricao = _data["descricao"];
            this.idAppleAnual = _data["idAppleAnual"];
            this.idAppleMensal = _data["idAppleMensal"];
            this.suspenso = _data["suspenso"];
            this.free = _data["free"];
            this.isTryout = _data["isTryout"];
            this.onlyAdmins = _data["onlyAdmins"];
            this.duracaoTryout = _data["duracaoTryout"];
            this.isDefault = _data["isDefault"];
            this.publicoAlvo = _data["publicoAlvo"];
            if (Array.isArray(_data["novosBeneficios"])) {
                this.novosBeneficios = [] as any;
                for (let item of _data["novosBeneficios"])
                    this.novosBeneficios.push(PlanoBeneficiosDto.fromJS(item));
            }
            if (Array.isArray(_data["beneficiosRemovidos"])) {
                this.beneficiosRemovidos = [] as any;
                for (let item of _data["beneficiosRemovidos"])
                    this.beneficiosRemovidos.push(PlanoBeneficiosDto.fromJS(item));
            }
            if (Array.isArray(_data["planoBeneficios"])) {
                this.planoBeneficios = [] as any;
                for (let item of _data["planoBeneficios"])
                    this.planoBeneficios.push(PlanoBeneficiosDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePlanoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["valorAnual"] = this.valorAnual;
        data["valorMensal"] = this.valorMensal;
        data["limiteMb"] = this.limiteMb;
        data["temLimitePacientes"] = this.temLimitePacientes;
        data["temCustoAdicionalPacientes"] = this.temCustoAdicionalPacientes;
        data["limitePacientes"] = this.limitePacientes;
        data["valorCustoAdicionalPacientes"] = this.valorCustoAdicionalPacientes;
        data["descricao"] = this.descricao;
        data["idAppleAnual"] = this.idAppleAnual;
        data["idAppleMensal"] = this.idAppleMensal;
        data["suspenso"] = this.suspenso;
        data["free"] = this.free;
        data["isTryout"] = this.isTryout;
        data["onlyAdmins"] = this.onlyAdmins;
        data["duracaoTryout"] = this.duracaoTryout;
        data["isDefault"] = this.isDefault;
        data["publicoAlvo"] = this.publicoAlvo;
        if (Array.isArray(this.novosBeneficios)) {
            data["novosBeneficios"] = [];
            for (let item of this.novosBeneficios)
                data["novosBeneficios"].push(item.toJSON());
        }
        if (Array.isArray(this.beneficiosRemovidos)) {
            data["beneficiosRemovidos"] = [];
            for (let item of this.beneficiosRemovidos)
                data["beneficiosRemovidos"].push(item.toJSON());
        }
        if (Array.isArray(this.planoBeneficios)) {
            data["planoBeneficios"] = [];
            for (let item of this.planoBeneficios)
                data["planoBeneficios"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdatePlanoDto {
        const json = this.toJSON();
        let result = new UpdatePlanoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlanoDto {
    nome: string;
    valorAnual: number;
    valorMensal: number;
    limiteMb: number;
    temLimitePacientes: boolean;
    temCustoAdicionalPacientes: boolean;
    limitePacientes: number | undefined;
    valorCustoAdicionalPacientes: number | undefined;
    descricao: string | undefined;
    idAppleAnual: string | undefined;
    idAppleMensal: string | undefined;
    suspenso: boolean;
    free: boolean;
    isTryout: boolean;
    onlyAdmins: boolean;
    duracaoTryout: number | undefined;
    isDefault: boolean;
    publicoAlvo: PublicoAlvoEnum;
    novosBeneficios: PlanoBeneficiosDto[] | undefined;
    beneficiosRemovidos: PlanoBeneficiosDto[] | undefined;
    planoBeneficios: PlanoBeneficiosDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PrescricaoDto implements IPrescricaoDto {
    id: string;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    urlArquivo: string | undefined;
    cids: string | undefined;
    procedimentoTuss: string | undefined;
    procedimentoSigtap: string | undefined;
    medicamentoTiss: string | undefined;
    medicamentoSigtap: string | undefined;
    nomeResponsavel: string | undefined;
    nomePaciente: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IPrescricaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nomeArquivo = _data["nomeArquivo"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.urlArquivo = _data["urlArquivo"];
            this.cids = _data["cids"];
            this.procedimentoTuss = _data["procedimentoTuss"];
            this.procedimentoSigtap = _data["procedimentoSigtap"];
            this.medicamentoTiss = _data["medicamentoTiss"];
            this.medicamentoSigtap = _data["medicamentoSigtap"];
            this.nomeResponsavel = _data["nomeResponsavel"];
            this.nomePaciente = _data["nomePaciente"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PrescricaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescricaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nomeArquivo"] = this.nomeArquivo;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["urlArquivo"] = this.urlArquivo;
        data["cids"] = this.cids;
        data["procedimentoTuss"] = this.procedimentoTuss;
        data["procedimentoSigtap"] = this.procedimentoSigtap;
        data["medicamentoTiss"] = this.medicamentoTiss;
        data["medicamentoSigtap"] = this.medicamentoSigtap;
        data["nomeResponsavel"] = this.nomeResponsavel;
        data["nomePaciente"] = this.nomePaciente;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): PrescricaoDto {
        const json = this.toJSON();
        let result = new PrescricaoDto();
        result.init(json);
        return result;
    }
}

export interface IPrescricaoDto {
    id: string;
    nomeArquivo: string | undefined;
    extensaoArquivo: string | undefined;
    urlArquivo: string | undefined;
    cids: string | undefined;
    procedimentoTuss: string | undefined;
    procedimentoSigtap: string | undefined;
    medicamentoTiss: string | undefined;
    medicamentoSigtap: string | undefined;
    nomeResponsavel: string | undefined;
    nomePaciente: string | undefined;
    creationTime: moment.Moment;
}

export class PrescricaoDtoPagedResultDto implements IPrescricaoDtoPagedResultDto {
    totalCount: number;
    items: PrescricaoDto[] | undefined;

    constructor(data?: IPrescricaoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PrescricaoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrescricaoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescricaoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PrescricaoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PrescricaoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPrescricaoDtoPagedResultDto {
    totalCount: number;
    items: PrescricaoDto[] | undefined;
}

export enum TipoPrescricaoEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class TipoPrescricaoDto implements ITipoPrescricaoDto {
    id: string;
    nome: string | undefined;
    tipo: TipoPrescricaoEnum;

    constructor(data?: ITipoPrescricaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nome = _data["nome"];
            this.tipo = _data["tipo"];
        }
    }

    static fromJS(data: any): TipoPrescricaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipoPrescricaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nome"] = this.nome;
        data["tipo"] = this.tipo;
        return data;
    }

    clone(): TipoPrescricaoDto {
        const json = this.toJSON();
        let result = new TipoPrescricaoDto();
        result.init(json);
        return result;
    }
}

export interface ITipoPrescricaoDto {
    id: string;
    nome: string | undefined;
    tipo: TipoPrescricaoEnum;
}

export class CreatePressaoArterialDto implements ICreatePressaoArterialDto {
    valorSistolica: number;
    valorDiastolica: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreatePressaoArterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorSistolica = _data["valorSistolica"];
            this.valorDiastolica = _data["valorDiastolica"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreatePressaoArterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePressaoArterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorSistolica"] = this.valorSistolica;
        data["valorDiastolica"] = this.valorDiastolica;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreatePressaoArterialDto {
        const json = this.toJSON();
        let result = new CreatePressaoArterialDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePressaoArterialDto {
    valorSistolica: number;
    valorDiastolica: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class UpdatePressaoArterialDto implements IUpdatePressaoArterialDto {
    valorSistolica: number;
    valorDiastolica: number;
    observacao: string | undefined;
    dataHoraString: string | undefined;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdatePressaoArterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorSistolica = _data["valorSistolica"];
            this.valorDiastolica = _data["valorDiastolica"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePressaoArterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePressaoArterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorSistolica"] = this.valorSistolica;
        data["valorDiastolica"] = this.valorDiastolica;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdatePressaoArterialDto {
        const json = this.toJSON();
        let result = new UpdatePressaoArterialDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePressaoArterialDto {
    valorSistolica: number;
    valorDiastolica: number;
    observacao: string | undefined;
    dataHoraString: string | undefined;
    pacienteId: string;
    id: string;
}

export class PressaoArterialDtoPagedResultDto implements IPressaoArterialDtoPagedResultDto {
    totalCount: number;
    items: PressaoArterialDto[] | undefined;

    constructor(data?: IPressaoArterialDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PressaoArterialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PressaoArterialDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PressaoArterialDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PressaoArterialDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PressaoArterialDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPressaoArterialDtoPagedResultDto {
    totalCount: number;
    items: PressaoArterialDto[] | undefined;
}

export class ProcedimentoSigtapDto implements IProcedimentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IProcedimentoSigtapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.grupo = _data["grupo"];
            this.subgrupo = _data["subgrupo"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProcedimentoSigtapDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedimentoSigtapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["grupo"] = this.grupo;
        data["subgrupo"] = this.subgrupo;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): ProcedimentoSigtapDto {
        const json = this.toJSON();
        let result = new ProcedimentoSigtapDto();
        result.init(json);
        return result;
    }
}

export interface IProcedimentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class ProcedimentoSigtapDtoPagedResultDto implements IProcedimentoSigtapDtoPagedResultDto {
    totalCount: number;
    items: ProcedimentoSigtapDto[] | undefined;

    constructor(data?: IProcedimentoSigtapDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProcedimentoSigtapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcedimentoSigtapDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedimentoSigtapDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProcedimentoSigtapDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProcedimentoSigtapDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProcedimentoSigtapDtoPagedResultDto {
    totalCount: number;
    items: ProcedimentoSigtapDto[] | undefined;
}

export class CreateProcedimentoSigtapDto implements ICreateProcedimentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;

    constructor(data?: ICreateProcedimentoSigtapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.grupo = _data["grupo"];
            this.subgrupo = _data["subgrupo"];
        }
    }

    static fromJS(data: any): CreateProcedimentoSigtapDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedimentoSigtapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["grupo"] = this.grupo;
        data["subgrupo"] = this.subgrupo;
        return data;
    }

    clone(): CreateProcedimentoSigtapDto {
        const json = this.toJSON();
        let result = new CreateProcedimentoSigtapDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcedimentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
}

export class UpdateProcedimentoSigtapDto implements IUpdateProcedimentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IUpdateProcedimentoSigtapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.grupo = _data["grupo"];
            this.subgrupo = _data["subgrupo"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProcedimentoSigtapDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedimentoSigtapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["grupo"] = this.grupo;
        data["subgrupo"] = this.subgrupo;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateProcedimentoSigtapDto {
        const json = this.toJSON();
        let result = new UpdateProcedimentoSigtapDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcedimentoSigtapDto {
    codigo: string | undefined;
    descricao: string | undefined;
    grupo: string | undefined;
    subgrupo: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class ProcedimentoTussDto implements IProcedimentoTussDto {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IProcedimentoTussDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProcedimentoTussDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedimentoTussDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): ProcedimentoTussDto {
        const json = this.toJSON();
        let result = new ProcedimentoTussDto();
        result.init(json);
        return result;
    }
}

export interface IProcedimentoTussDto {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class ProcedimentoTussDtoPagedResultDto implements IProcedimentoTussDtoPagedResultDto {
    totalCount: number;
    items: ProcedimentoTussDto[] | undefined;

    constructor(data?: IProcedimentoTussDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProcedimentoTussDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcedimentoTussDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedimentoTussDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProcedimentoTussDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProcedimentoTussDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProcedimentoTussDtoPagedResultDto {
    totalCount: number;
    items: ProcedimentoTussDto[] | undefined;
}

export class CreateProcedimentoTussDto implements ICreateProcedimentoTussDto {
    codigo: string | undefined;
    descricao: string | undefined;

    constructor(data?: ICreateProcedimentoTussDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
        }
    }

    static fromJS(data: any): CreateProcedimentoTussDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProcedimentoTussDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        return data;
    }

    clone(): CreateProcedimentoTussDto {
        const json = this.toJSON();
        let result = new CreateProcedimentoTussDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProcedimentoTussDto {
    codigo: string | undefined;
    descricao: string | undefined;
}

export class UpdateProcedimentoTussDto implements IUpdateProcedimentoTussDto {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    id: string;

    constructor(data?: IUpdateProcedimentoTussDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descricao = _data["descricao"];
            this.observacoes = _data["observacoes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProcedimentoTussDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedimentoTussDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descricao"] = this.descricao;
        data["observacoes"] = this.observacoes;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateProcedimentoTussDto {
        const json = this.toJSON();
        let result = new UpdateProcedimentoTussDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProcedimentoTussDto {
    codigo: string | undefined;
    descricao: string | undefined;
    observacoes: string | undefined;
    id: string;
}

export class CreateProfissionalSaudeDto implements ICreateProfissionalSaudeDto {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    numeroRegistroClasse: string;
    senha: string;
    registroEspecialidade: string | undefined;
    tipoPagamento: TipoPagamentoEnum;
    cartaoCredito: CartaoCreditoDto;
    isAnual: boolean;
    planoId: string | undefined;
    registroClasseId: string;
    assinaturaMedico: string | undefined;
    nomeAssinatura: string | undefined;
    endereco: CreateEnderecoDto;
    incluirEndereco: boolean;
    validarSenha: boolean;
    rg: string | undefined;
    cns: string | undefined;
    especializacoes: RQEDto[] | undefined;
    dataNascimento: moment.Moment;
    ufRegistro: string;
    enderecoAssinatura: EnderecoAssinaturaDto;
    emailProfissionalClincas: EmailProfissionalClinicaDto[] | undefined;
    telefoneProfissionalClincas: TelefoneProfissionalClinicaDto[] | undefined;

    constructor(data?: ICreateProfissionalSaudeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.numeroRegistroClasse = _data["numeroRegistroClasse"];
            this.senha = _data["senha"];
            this.registroEspecialidade = _data["registroEspecialidade"];
            this.tipoPagamento = _data["tipoPagamento"];
            this.cartaoCredito = _data["cartaoCredito"] ? CartaoCreditoDto.fromJS(_data["cartaoCredito"]) : <any>undefined;
            this.isAnual = _data["isAnual"];
            this.planoId = _data["planoId"];
            this.registroClasseId = _data["registroClasseId"];
            this.assinaturaMedico = _data["assinaturaMedico"];
            this.nomeAssinatura = _data["nomeAssinatura"];
            this.endereco = _data["endereco"] ? CreateEnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.incluirEndereco = _data["incluirEndereco"];
            this.validarSenha = _data["validarSenha"];
            this.rg = _data["rg"];
            this.cns = _data["cns"];
            if (Array.isArray(_data["especializacoes"])) {
                this.especializacoes = [] as any;
                for (let item of _data["especializacoes"])
                    this.especializacoes.push(RQEDto.fromJS(item));
            }
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.ufRegistro = _data["ufRegistro"];
            this.enderecoAssinatura = _data["enderecoAssinatura"] ? EnderecoAssinaturaDto.fromJS(_data["enderecoAssinatura"]) : <any>undefined;
            if (Array.isArray(_data["emailProfissionalClincas"])) {
                this.emailProfissionalClincas = [] as any;
                for (let item of _data["emailProfissionalClincas"])
                    this.emailProfissionalClincas.push(EmailProfissionalClinicaDto.fromJS(item));
            }
            if (Array.isArray(_data["telefoneProfissionalClincas"])) {
                this.telefoneProfissionalClincas = [] as any;
                for (let item of _data["telefoneProfissionalClincas"])
                    this.telefoneProfissionalClincas.push(TelefoneProfissionalClinicaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProfissionalSaudeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfissionalSaudeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["numeroRegistroClasse"] = this.numeroRegistroClasse;
        data["senha"] = this.senha;
        data["registroEspecialidade"] = this.registroEspecialidade;
        data["tipoPagamento"] = this.tipoPagamento;
        data["cartaoCredito"] = this.cartaoCredito ? this.cartaoCredito.toJSON() : <any>undefined;
        data["isAnual"] = this.isAnual;
        data["planoId"] = this.planoId;
        data["registroClasseId"] = this.registroClasseId;
        data["assinaturaMedico"] = this.assinaturaMedico;
        data["nomeAssinatura"] = this.nomeAssinatura;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["incluirEndereco"] = this.incluirEndereco;
        data["validarSenha"] = this.validarSenha;
        data["rg"] = this.rg;
        data["cns"] = this.cns;
        if (Array.isArray(this.especializacoes)) {
            data["especializacoes"] = [];
            for (let item of this.especializacoes)
                data["especializacoes"].push(item.toJSON());
        }
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["ufRegistro"] = this.ufRegistro;
        data["enderecoAssinatura"] = this.enderecoAssinatura ? this.enderecoAssinatura.toJSON() : <any>undefined;
        if (Array.isArray(this.emailProfissionalClincas)) {
            data["emailProfissionalClincas"] = [];
            for (let item of this.emailProfissionalClincas)
                data["emailProfissionalClincas"].push(item.toJSON());
        }
        if (Array.isArray(this.telefoneProfissionalClincas)) {
            data["telefoneProfissionalClincas"] = [];
            for (let item of this.telefoneProfissionalClincas)
                data["telefoneProfissionalClincas"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateProfissionalSaudeDto {
        const json = this.toJSON();
        let result = new CreateProfissionalSaudeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProfissionalSaudeDto {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    numeroRegistroClasse: string;
    senha: string;
    registroEspecialidade: string | undefined;
    tipoPagamento: TipoPagamentoEnum;
    cartaoCredito: CartaoCreditoDto;
    isAnual: boolean;
    planoId: string | undefined;
    registroClasseId: string;
    assinaturaMedico: string | undefined;
    nomeAssinatura: string | undefined;
    endereco: CreateEnderecoDto;
    incluirEndereco: boolean;
    validarSenha: boolean;
    rg: string | undefined;
    cns: string | undefined;
    especializacoes: RQEDto[] | undefined;
    dataNascimento: moment.Moment;
    ufRegistro: string;
    enderecoAssinatura: EnderecoAssinaturaDto;
    emailProfissionalClincas: EmailProfissionalClinicaDto[] | undefined;
    telefoneProfissionalClincas: TelefoneProfissionalClinicaDto[] | undefined;
}

export class ProfissionalSaudeDtoPagedResultDto implements IProfissionalSaudeDtoPagedResultDto {
    totalCount: number;
    items: ProfissionalSaudeDto[] | undefined;

    constructor(data?: IProfissionalSaudeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProfissionalSaudeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfissionalSaudeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProfissionalSaudeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProfissionalSaudeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudeDtoPagedResultDto {
    totalCount: number;
    items: ProfissionalSaudeDto[] | undefined;
}

export class UpdateProfissionalSaudeDto implements IUpdateProfissionalSaudeDto {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    numeroRegistroClasse: string;
    registroEspecialidade: string | undefined;
    registroClasseId: string;
    assinaturaMedico: string | undefined;
    nomeAssinatura: string | undefined;
    atualizarAssinaturaMedico: boolean;
    endereco: UpdateEnderecoDto;
    incluirEndereco: boolean;
    rg: string | undefined;
    cns: string | undefined;
    certificado: string | undefined;
    atualizarCertificado: boolean;
    senhaCertificado: string | undefined;
    nomeCertificado: string | undefined;
    dataNascimento: moment.Moment;
    ufRegistro: string;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    especializacoes: RQEDto[] | undefined;
    id: string;

    constructor(data?: IUpdateProfissionalSaudeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.email = _data["email"];
            this.celular = _data["celular"];
            this.numeroRegistroClasse = _data["numeroRegistroClasse"];
            this.registroEspecialidade = _data["registroEspecialidade"];
            this.registroClasseId = _data["registroClasseId"];
            this.assinaturaMedico = _data["assinaturaMedico"];
            this.nomeAssinatura = _data["nomeAssinatura"];
            this.atualizarAssinaturaMedico = _data["atualizarAssinaturaMedico"];
            this.endereco = _data["endereco"] ? UpdateEnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
            this.incluirEndereco = _data["incluirEndereco"];
            this.rg = _data["rg"];
            this.cns = _data["cns"];
            this.certificado = _data["certificado"];
            this.atualizarCertificado = _data["atualizarCertificado"];
            this.senhaCertificado = _data["senhaCertificado"];
            this.nomeCertificado = _data["nomeCertificado"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.ufRegistro = _data["ufRegistro"];
            this.avatar = _data["avatar"];
            this.nomeAvatar = _data["nomeAvatar"];
            if (Array.isArray(_data["especializacoes"])) {
                this.especializacoes = [] as any;
                for (let item of _data["especializacoes"])
                    this.especializacoes.push(RQEDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProfissionalSaudeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfissionalSaudeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["email"] = this.email;
        data["celular"] = this.celular;
        data["numeroRegistroClasse"] = this.numeroRegistroClasse;
        data["registroEspecialidade"] = this.registroEspecialidade;
        data["registroClasseId"] = this.registroClasseId;
        data["assinaturaMedico"] = this.assinaturaMedico;
        data["nomeAssinatura"] = this.nomeAssinatura;
        data["atualizarAssinaturaMedico"] = this.atualizarAssinaturaMedico;
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        data["incluirEndereco"] = this.incluirEndereco;
        data["rg"] = this.rg;
        data["cns"] = this.cns;
        data["certificado"] = this.certificado;
        data["atualizarCertificado"] = this.atualizarCertificado;
        data["senhaCertificado"] = this.senhaCertificado;
        data["nomeCertificado"] = this.nomeCertificado;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["ufRegistro"] = this.ufRegistro;
        data["avatar"] = this.avatar;
        data["nomeAvatar"] = this.nomeAvatar;
        if (Array.isArray(this.especializacoes)) {
            data["especializacoes"] = [];
            for (let item of this.especializacoes)
                data["especializacoes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateProfissionalSaudeDto {
        const json = this.toJSON();
        let result = new UpdateProfissionalSaudeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProfissionalSaudeDto {
    nome: string;
    cpf: string;
    email: string;
    celular: string;
    numeroRegistroClasse: string;
    registroEspecialidade: string | undefined;
    registroClasseId: string;
    assinaturaMedico: string | undefined;
    nomeAssinatura: string | undefined;
    atualizarAssinaturaMedico: boolean;
    endereco: UpdateEnderecoDto;
    incluirEndereco: boolean;
    rg: string | undefined;
    cns: string | undefined;
    certificado: string | undefined;
    atualizarCertificado: boolean;
    senhaCertificado: string | undefined;
    nomeCertificado: string | undefined;
    dataNascimento: moment.Moment;
    ufRegistro: string;
    avatar: string | undefined;
    nomeAvatar: string | undefined;
    especializacoes: RQEDto[] | undefined;
    id: string;
}

export class PagedProfissionalSaudeResultRequestDto implements IPagedProfissionalSaudeResultRequestDto {
    keyword: string | undefined;
    clinicaId: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IPagedProfissionalSaudeResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.clinicaId = _data["clinicaId"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): PagedProfissionalSaudeResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedProfissionalSaudeResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["clinicaId"] = this.clinicaId;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }

    clone(): PagedProfissionalSaudeResultRequestDto {
        const json = this.toJSON();
        let result = new PagedProfissionalSaudeResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedProfissionalSaudeResultRequestDto {
    keyword: string | undefined;
    clinicaId: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class InformacoesHomeProfissionalDto implements IInformacoesHomeProfissionalDto {
    atendimentos: number;
    pacientes: number;
    exames: number;

    constructor(data?: IInformacoesHomeProfissionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atendimentos = _data["atendimentos"];
            this.pacientes = _data["pacientes"];
            this.exames = _data["exames"];
        }
    }

    static fromJS(data: any): InformacoesHomeProfissionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformacoesHomeProfissionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atendimentos"] = this.atendimentos;
        data["pacientes"] = this.pacientes;
        data["exames"] = this.exames;
        return data;
    }

    clone(): InformacoesHomeProfissionalDto {
        const json = this.toJSON();
        let result = new InformacoesHomeProfissionalDto();
        result.init(json);
        return result;
    }
}

export interface IInformacoesHomeProfissionalDto {
    atendimentos: number;
    pacientes: number;
    exames: number;
}

export class ProfissionalSaudeClinicaMedicaDtoPagedResultDto implements IProfissionalSaudeClinicaMedicaDtoPagedResultDto {
    totalCount: number;
    items: ProfissionalSaudeClinicaMedicaDto[] | undefined;

    constructor(data?: IProfissionalSaudeClinicaMedicaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProfissionalSaudeClinicaMedicaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfissionalSaudeClinicaMedicaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfissionalSaudeClinicaMedicaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProfissionalSaudeClinicaMedicaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProfissionalSaudeClinicaMedicaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProfissionalSaudeClinicaMedicaDtoPagedResultDto {
    totalCount: number;
    items: ProfissionalSaudeClinicaMedicaDto[] | undefined;
}

export class TemporaryLinkDto implements ITemporaryLinkDto {
    url: string[] | undefined;
    acessoProntuarioId: string | undefined;
    urlAtualizada: string[] | undefined;

    constructor(data?: ITemporaryLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["url"])) {
                this.url = [] as any;
                for (let item of _data["url"])
                    this.url.push(item);
            }
            this.acessoProntuarioId = _data["acessoProntuarioId"];
            if (Array.isArray(_data["urlAtualizada"])) {
                this.urlAtualizada = [] as any;
                for (let item of _data["urlAtualizada"])
                    this.urlAtualizada.push(item);
            }
        }
    }

    static fromJS(data: any): TemporaryLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemporaryLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.url)) {
            data["url"] = [];
            for (let item of this.url)
                data["url"].push(item);
        }
        data["acessoProntuarioId"] = this.acessoProntuarioId;
        if (Array.isArray(this.urlAtualizada)) {
            data["urlAtualizada"] = [];
            for (let item of this.urlAtualizada)
                data["urlAtualizada"].push(item);
        }
        return data;
    }

    clone(): TemporaryLinkDto {
        const json = this.toJSON();
        let result = new TemporaryLinkDto();
        result.init(json);
        return result;
    }
}

export interface ITemporaryLinkDto {
    url: string[] | undefined;
    acessoProntuarioId: string | undefined;
    urlAtualizada: string[] | undefined;
}

export class ValidarCertificadoDto implements IValidarCertificadoDto {
    id: string;
    template: string | undefined;
    codigo: string | undefined;
    darBaixa: boolean | undefined;
    nomePaciente: string | undefined;
    cpfPaciente: string | undefined;
    dataNascimento: moment.Moment | undefined;
    nomeProfissional: string | undefined;
    crmProfissional: string | undefined;
    especialidadeProfissional: string | undefined;
    dataCriacao: moment.Moment;
    emailProfissional: string | undefined;
    ufRegistro: string | undefined;
    endereco: string | undefined;

    constructor(data?: IValidarCertificadoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.template = _data["template"];
            this.codigo = _data["codigo"];
            this.darBaixa = _data["darBaixa"];
            this.nomePaciente = _data["nomePaciente"];
            this.cpfPaciente = _data["cpfPaciente"];
            this.dataNascimento = _data["dataNascimento"] ? moment(_data["dataNascimento"].toString()) : <any>undefined;
            this.nomeProfissional = _data["nomeProfissional"];
            this.crmProfissional = _data["crmProfissional"];
            this.especialidadeProfissional = _data["especialidadeProfissional"];
            this.dataCriacao = _data["dataCriacao"] ? moment(_data["dataCriacao"].toString()) : <any>undefined;
            this.emailProfissional = _data["emailProfissional"];
            this.ufRegistro = _data["ufRegistro"];
            this.endereco = _data["endereco"];
        }
    }

    static fromJS(data: any): ValidarCertificadoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidarCertificadoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["template"] = this.template;
        data["codigo"] = this.codigo;
        data["darBaixa"] = this.darBaixa;
        data["nomePaciente"] = this.nomePaciente;
        data["cpfPaciente"] = this.cpfPaciente;
        data["dataNascimento"] = this.dataNascimento ? this.dataNascimento.toISOString() : <any>undefined;
        data["nomeProfissional"] = this.nomeProfissional;
        data["crmProfissional"] = this.crmProfissional;
        data["especialidadeProfissional"] = this.especialidadeProfissional;
        data["dataCriacao"] = this.dataCriacao ? this.dataCriacao.toISOString() : <any>undefined;
        data["emailProfissional"] = this.emailProfissional;
        data["ufRegistro"] = this.ufRegistro;
        data["endereco"] = this.endereco;
        return data;
    }

    clone(): ValidarCertificadoDto {
        const json = this.toJSON();
        let result = new ValidarCertificadoDto();
        result.init(json);
        return result;
    }
}

export interface IValidarCertificadoDto {
    id: string;
    template: string | undefined;
    codigo: string | undefined;
    darBaixa: boolean | undefined;
    nomePaciente: string | undefined;
    cpfPaciente: string | undefined;
    dataNascimento: moment.Moment | undefined;
    nomeProfissional: string | undefined;
    crmProfissional: string | undefined;
    especialidadeProfissional: string | undefined;
    dataCriacao: moment.Moment;
    emailProfissional: string | undefined;
    ufRegistro: string | undefined;
    endereco: string | undefined;
}

export class AcessoProntuarioDto implements IAcessoProntuarioDto {
    cpfProfissional: string | undefined;
    nomeProfissional: string | undefined;
    registroClasseProfissionalId: string;
    numeroRegistroClasseProfissional: string | undefined;
    cpfPaciente: string | undefined;
    token: string | undefined;
    creationTime: moment.Moment;
    lastTimeInSeconds: number;
    id: string;

    constructor(data?: IAcessoProntuarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpfProfissional = _data["cpfProfissional"];
            this.nomeProfissional = _data["nomeProfissional"];
            this.registroClasseProfissionalId = _data["registroClasseProfissionalId"];
            this.numeroRegistroClasseProfissional = _data["numeroRegistroClasseProfissional"];
            this.cpfPaciente = _data["cpfPaciente"];
            this.token = _data["token"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastTimeInSeconds = _data["lastTimeInSeconds"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AcessoProntuarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcessoProntuarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpfProfissional"] = this.cpfProfissional;
        data["nomeProfissional"] = this.nomeProfissional;
        data["registroClasseProfissionalId"] = this.registroClasseProfissionalId;
        data["numeroRegistroClasseProfissional"] = this.numeroRegistroClasseProfissional;
        data["cpfPaciente"] = this.cpfPaciente;
        data["token"] = this.token;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastTimeInSeconds"] = this.lastTimeInSeconds;
        data["id"] = this.id;
        return data;
    }

    clone(): AcessoProntuarioDto {
        const json = this.toJSON();
        let result = new AcessoProntuarioDto();
        result.init(json);
        return result;
    }
}

export interface IAcessoProntuarioDto {
    cpfProfissional: string | undefined;
    nomeProfissional: string | undefined;
    registroClasseProfissionalId: string;
    numeroRegistroClasseProfissional: string | undefined;
    cpfPaciente: string | undefined;
    token: string | undefined;
    creationTime: moment.Moment;
    lastTimeInSeconds: number;
    id: string;
}

export class ProcedimentoSecundarioApacDto implements IProcedimentoSecundarioApacDto {
    codigo: string | undefined;
    nome: string | undefined;
    quantidade: string | undefined;

    constructor(data?: IProcedimentoSecundarioApacDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.nome = _data["nome"];
            this.quantidade = _data["quantidade"];
        }
    }

    static fromJS(data: any): ProcedimentoSecundarioApacDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedimentoSecundarioApacDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["nome"] = this.nome;
        data["quantidade"] = this.quantidade;
        return data;
    }

    clone(): ProcedimentoSecundarioApacDto {
        const json = this.toJSON();
        let result = new ProcedimentoSecundarioApacDto();
        result.init(json);
        return result;
    }
}

export interface IProcedimentoSecundarioApacDto {
    codigo: string | undefined;
    nome: string | undefined;
    quantidade: string | undefined;
}

export class SolicitacaoApacDto implements ISolicitacaoApacDto {
    nomeEstabelecimentoSolicitante: string | undefined;
    cnesSolicitante: string | undefined;
    nomePaciente: string | undefined;
    numeroProntuario: string | undefined;
    cns: string | undefined;
    dataNascimento: string | undefined;
    sexo: string | undefined;
    racaCor: string | undefined;
    nomeMae: string | undefined;
    telefoneCelular: string | undefined;
    nomeResponsavel: string | undefined;
    telefoneResponsavel: string | undefined;
    endereco: string | undefined;
    bairro: string | undefined;
    municipioResidencia: string | undefined;
    codigoIbgeMunicipio: string | undefined;
    uf: string | undefined;
    cep: string | undefined;
    codigoProcedimentoPrincipal: string | undefined;
    nomeProcedimentoPrincipal: string | undefined;
    quantidadePrincipal: string | undefined;
    procedimentosSecundarios: ProcedimentoSecundarioApacDto[] | undefined;
    descricaoDiagnostico: string | undefined;
    cid10Principal: string | undefined;
    cid10Secundario: string | undefined;
    cid10CausasAssociadas: string | undefined;
    observacoes: string | undefined;
    nomeProfissionalSolicitante: string | undefined;
    tipoDocumentoSolicitante: string | undefined;
    documentoProfissionalSolicitante: string | undefined;
    dataSolicitacao: string | undefined;
    nomeProfissionalAutorizador: string | undefined;
    cnsProfissionalAutorizador: string | undefined;
    codigoOrgaoEmissor: string | undefined;
    numeroAutorizacaoApac: string | undefined;
    dataAutorizacao: string | undefined;
    validadeInicio: string | undefined;
    validadeFim: string | undefined;
    nomeFantasiaExecutante: string | undefined;
    cnesExecutante: string | undefined;
    carimboEmitidoPor: string | undefined;

    constructor(data?: ISolicitacaoApacDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomeEstabelecimentoSolicitante = _data["nomeEstabelecimentoSolicitante"];
            this.cnesSolicitante = _data["cnesSolicitante"];
            this.nomePaciente = _data["nomePaciente"];
            this.numeroProntuario = _data["numeroProntuario"];
            this.cns = _data["cns"];
            this.dataNascimento = _data["dataNascimento"];
            this.sexo = _data["sexo"];
            this.racaCor = _data["racaCor"];
            this.nomeMae = _data["nomeMae"];
            this.telefoneCelular = _data["telefoneCelular"];
            this.nomeResponsavel = _data["nomeResponsavel"];
            this.telefoneResponsavel = _data["telefoneResponsavel"];
            this.endereco = _data["endereco"];
            this.bairro = _data["bairro"];
            this.municipioResidencia = _data["municipioResidencia"];
            this.codigoIbgeMunicipio = _data["codigoIbgeMunicipio"];
            this.uf = _data["uf"];
            this.cep = _data["cep"];
            this.codigoProcedimentoPrincipal = _data["codigoProcedimentoPrincipal"];
            this.nomeProcedimentoPrincipal = _data["nomeProcedimentoPrincipal"];
            this.quantidadePrincipal = _data["quantidadePrincipal"];
            if (Array.isArray(_data["procedimentosSecundarios"])) {
                this.procedimentosSecundarios = [] as any;
                for (let item of _data["procedimentosSecundarios"])
                    this.procedimentosSecundarios.push(ProcedimentoSecundarioApacDto.fromJS(item));
            }
            this.descricaoDiagnostico = _data["descricaoDiagnostico"];
            this.cid10Principal = _data["cid10Principal"];
            this.cid10Secundario = _data["cid10Secundario"];
            this.cid10CausasAssociadas = _data["cid10CausasAssociadas"];
            this.observacoes = _data["observacoes"];
            this.nomeProfissionalSolicitante = _data["nomeProfissionalSolicitante"];
            this.tipoDocumentoSolicitante = _data["tipoDocumentoSolicitante"];
            this.documentoProfissionalSolicitante = _data["documentoProfissionalSolicitante"];
            this.dataSolicitacao = _data["dataSolicitacao"];
            this.nomeProfissionalAutorizador = _data["nomeProfissionalAutorizador"];
            this.cnsProfissionalAutorizador = _data["cnsProfissionalAutorizador"];
            this.codigoOrgaoEmissor = _data["codigoOrgaoEmissor"];
            this.numeroAutorizacaoApac = _data["numeroAutorizacaoApac"];
            this.dataAutorizacao = _data["dataAutorizacao"];
            this.validadeInicio = _data["validadeInicio"];
            this.validadeFim = _data["validadeFim"];
            this.nomeFantasiaExecutante = _data["nomeFantasiaExecutante"];
            this.cnesExecutante = _data["cnesExecutante"];
            this.carimboEmitidoPor = _data["carimboEmitidoPor"];
        }
    }

    static fromJS(data: any): SolicitacaoApacDto {
        data = typeof data === 'object' ? data : {};
        let result = new SolicitacaoApacDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeEstabelecimentoSolicitante"] = this.nomeEstabelecimentoSolicitante;
        data["cnesSolicitante"] = this.cnesSolicitante;
        data["nomePaciente"] = this.nomePaciente;
        data["numeroProntuario"] = this.numeroProntuario;
        data["cns"] = this.cns;
        data["dataNascimento"] = this.dataNascimento;
        data["sexo"] = this.sexo;
        data["racaCor"] = this.racaCor;
        data["nomeMae"] = this.nomeMae;
        data["telefoneCelular"] = this.telefoneCelular;
        data["nomeResponsavel"] = this.nomeResponsavel;
        data["telefoneResponsavel"] = this.telefoneResponsavel;
        data["endereco"] = this.endereco;
        data["bairro"] = this.bairro;
        data["municipioResidencia"] = this.municipioResidencia;
        data["codigoIbgeMunicipio"] = this.codigoIbgeMunicipio;
        data["uf"] = this.uf;
        data["cep"] = this.cep;
        data["codigoProcedimentoPrincipal"] = this.codigoProcedimentoPrincipal;
        data["nomeProcedimentoPrincipal"] = this.nomeProcedimentoPrincipal;
        data["quantidadePrincipal"] = this.quantidadePrincipal;
        if (Array.isArray(this.procedimentosSecundarios)) {
            data["procedimentosSecundarios"] = [];
            for (let item of this.procedimentosSecundarios)
                data["procedimentosSecundarios"].push(item.toJSON());
        }
        data["descricaoDiagnostico"] = this.descricaoDiagnostico;
        data["cid10Principal"] = this.cid10Principal;
        data["cid10Secundario"] = this.cid10Secundario;
        data["cid10CausasAssociadas"] = this.cid10CausasAssociadas;
        data["observacoes"] = this.observacoes;
        data["nomeProfissionalSolicitante"] = this.nomeProfissionalSolicitante;
        data["tipoDocumentoSolicitante"] = this.tipoDocumentoSolicitante;
        data["documentoProfissionalSolicitante"] = this.documentoProfissionalSolicitante;
        data["dataSolicitacao"] = this.dataSolicitacao;
        data["nomeProfissionalAutorizador"] = this.nomeProfissionalAutorizador;
        data["cnsProfissionalAutorizador"] = this.cnsProfissionalAutorizador;
        data["codigoOrgaoEmissor"] = this.codigoOrgaoEmissor;
        data["numeroAutorizacaoApac"] = this.numeroAutorizacaoApac;
        data["dataAutorizacao"] = this.dataAutorizacao;
        data["validadeInicio"] = this.validadeInicio;
        data["validadeFim"] = this.validadeFim;
        data["nomeFantasiaExecutante"] = this.nomeFantasiaExecutante;
        data["cnesExecutante"] = this.cnesExecutante;
        data["carimboEmitidoPor"] = this.carimboEmitidoPor;
        return data;
    }

    clone(): SolicitacaoApacDto {
        const json = this.toJSON();
        let result = new SolicitacaoApacDto();
        result.init(json);
        return result;
    }
}

export interface ISolicitacaoApacDto {
    nomeEstabelecimentoSolicitante: string | undefined;
    cnesSolicitante: string | undefined;
    nomePaciente: string | undefined;
    numeroProntuario: string | undefined;
    cns: string | undefined;
    dataNascimento: string | undefined;
    sexo: string | undefined;
    racaCor: string | undefined;
    nomeMae: string | undefined;
    telefoneCelular: string | undefined;
    nomeResponsavel: string | undefined;
    telefoneResponsavel: string | undefined;
    endereco: string | undefined;
    bairro: string | undefined;
    municipioResidencia: string | undefined;
    codigoIbgeMunicipio: string | undefined;
    uf: string | undefined;
    cep: string | undefined;
    codigoProcedimentoPrincipal: string | undefined;
    nomeProcedimentoPrincipal: string | undefined;
    quantidadePrincipal: string | undefined;
    procedimentosSecundarios: ProcedimentoSecundarioApacDto[] | undefined;
    descricaoDiagnostico: string | undefined;
    cid10Principal: string | undefined;
    cid10Secundario: string | undefined;
    cid10CausasAssociadas: string | undefined;
    observacoes: string | undefined;
    nomeProfissionalSolicitante: string | undefined;
    tipoDocumentoSolicitante: string | undefined;
    documentoProfissionalSolicitante: string | undefined;
    dataSolicitacao: string | undefined;
    nomeProfissionalAutorizador: string | undefined;
    cnsProfissionalAutorizador: string | undefined;
    codigoOrgaoEmissor: string | undefined;
    numeroAutorizacaoApac: string | undefined;
    dataAutorizacao: string | undefined;
    validadeInicio: string | undefined;
    validadeFim: string | undefined;
    nomeFantasiaExecutante: string | undefined;
    cnesExecutante: string | undefined;
    carimboEmitidoPor: string | undefined;
}

export class ProntuarioMedicoDto implements IProntuarioMedicoDto {
    arquivoHtml: string | undefined;
    pacienteId: string | undefined;
    acessoProntuarioId: string | undefined;
    clinicaId: string | undefined;
    base64File: string | undefined;
    folderName: string | undefined;
    folderId: string | undefined;
    fileNameWithOutExtension: string | undefined;
    extension: string | undefined;
    tipoArquivo: string | undefined;
    tamanhoArquivo: number;
    codigo: string | undefined;
    codigoValidacaoIti: string | undefined;
    localizacao: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    darBaixa: boolean | undefined;
    vip: boolean;
    statusProntuario: StatusProntuarioEnum;
    readonly statusProntuarioString: string | undefined;
    cidIds: string[] | undefined;
    procedimentosTussIds: string[] | undefined;
    procedimentosSigtapIds: string[] | undefined;
    medicamentoTissIds: string[] | undefined;
    medicamentoSigtapIds: string[] | undefined;
    clinicaMedicaPacienteVipId: string | undefined;
    dadosApac: SolicitacaoApacDto;

    constructor(data?: IProntuarioMedicoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoHtml = _data["arquivoHtml"];
            this.pacienteId = _data["pacienteId"];
            this.acessoProntuarioId = _data["acessoProntuarioId"];
            this.clinicaId = _data["clinicaId"];
            this.base64File = _data["base64File"];
            this.folderName = _data["folderName"];
            this.folderId = _data["folderId"];
            this.fileNameWithOutExtension = _data["fileNameWithOutExtension"];
            this.extension = _data["extension"];
            this.tipoArquivo = _data["tipoArquivo"];
            this.tamanhoArquivo = _data["tamanhoArquivo"];
            this.codigo = _data["codigo"];
            this.codigoValidacaoIti = _data["codigoValidacaoIti"];
            this.localizacao = _data["localizacao"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.darBaixa = _data["darBaixa"];
            this.vip = _data["vip"];
            this.statusProntuario = _data["statusProntuario"];
            (<any>this).statusProntuarioString = _data["statusProntuarioString"];
            if (Array.isArray(_data["cidIds"])) {
                this.cidIds = [] as any;
                for (let item of _data["cidIds"])
                    this.cidIds.push(item);
            }
            if (Array.isArray(_data["procedimentosTussIds"])) {
                this.procedimentosTussIds = [] as any;
                for (let item of _data["procedimentosTussIds"])
                    this.procedimentosTussIds.push(item);
            }
            if (Array.isArray(_data["procedimentosSigtapIds"])) {
                this.procedimentosSigtapIds = [] as any;
                for (let item of _data["procedimentosSigtapIds"])
                    this.procedimentosSigtapIds.push(item);
            }
            if (Array.isArray(_data["medicamentoTissIds"])) {
                this.medicamentoTissIds = [] as any;
                for (let item of _data["medicamentoTissIds"])
                    this.medicamentoTissIds.push(item);
            }
            if (Array.isArray(_data["medicamentoSigtapIds"])) {
                this.medicamentoSigtapIds = [] as any;
                for (let item of _data["medicamentoSigtapIds"])
                    this.medicamentoSigtapIds.push(item);
            }
            this.clinicaMedicaPacienteVipId = _data["clinicaMedicaPacienteVipId"];
            this.dadosApac = _data["dadosApac"] ? SolicitacaoApacDto.fromJS(_data["dadosApac"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProntuarioMedicoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProntuarioMedicoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoHtml"] = this.arquivoHtml;
        data["pacienteId"] = this.pacienteId;
        data["acessoProntuarioId"] = this.acessoProntuarioId;
        data["clinicaId"] = this.clinicaId;
        data["base64File"] = this.base64File;
        data["folderName"] = this.folderName;
        data["folderId"] = this.folderId;
        data["fileNameWithOutExtension"] = this.fileNameWithOutExtension;
        data["extension"] = this.extension;
        data["tipoArquivo"] = this.tipoArquivo;
        data["tamanhoArquivo"] = this.tamanhoArquivo;
        data["codigo"] = this.codigo;
        data["codigoValidacaoIti"] = this.codigoValidacaoIti;
        data["localizacao"] = this.localizacao;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["darBaixa"] = this.darBaixa;
        data["vip"] = this.vip;
        data["statusProntuario"] = this.statusProntuario;
        data["statusProntuarioString"] = this.statusProntuarioString;
        if (Array.isArray(this.cidIds)) {
            data["cidIds"] = [];
            for (let item of this.cidIds)
                data["cidIds"].push(item);
        }
        if (Array.isArray(this.procedimentosTussIds)) {
            data["procedimentosTussIds"] = [];
            for (let item of this.procedimentosTussIds)
                data["procedimentosTussIds"].push(item);
        }
        if (Array.isArray(this.procedimentosSigtapIds)) {
            data["procedimentosSigtapIds"] = [];
            for (let item of this.procedimentosSigtapIds)
                data["procedimentosSigtapIds"].push(item);
        }
        if (Array.isArray(this.medicamentoTissIds)) {
            data["medicamentoTissIds"] = [];
            for (let item of this.medicamentoTissIds)
                data["medicamentoTissIds"].push(item);
        }
        if (Array.isArray(this.medicamentoSigtapIds)) {
            data["medicamentoSigtapIds"] = [];
            for (let item of this.medicamentoSigtapIds)
                data["medicamentoSigtapIds"].push(item);
        }
        data["clinicaMedicaPacienteVipId"] = this.clinicaMedicaPacienteVipId;
        data["dadosApac"] = this.dadosApac ? this.dadosApac.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProntuarioMedicoDto {
        const json = this.toJSON();
        let result = new ProntuarioMedicoDto();
        result.init(json);
        return result;
    }
}

export interface IProntuarioMedicoDto {
    arquivoHtml: string | undefined;
    pacienteId: string | undefined;
    acessoProntuarioId: string | undefined;
    clinicaId: string | undefined;
    base64File: string | undefined;
    folderName: string | undefined;
    folderId: string | undefined;
    fileNameWithOutExtension: string | undefined;
    extension: string | undefined;
    tipoArquivo: string | undefined;
    tamanhoArquivo: number;
    codigo: string | undefined;
    codigoValidacaoIti: string | undefined;
    localizacao: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    darBaixa: boolean | undefined;
    vip: boolean;
    statusProntuario: StatusProntuarioEnum;
    statusProntuarioString: string | undefined;
    cidIds: string[] | undefined;
    procedimentosTussIds: string[] | undefined;
    procedimentosSigtapIds: string[] | undefined;
    medicamentoTissIds: string[] | undefined;
    medicamentoSigtapIds: string[] | undefined;
    clinicaMedicaPacienteVipId: string | undefined;
    dadosApac: SolicitacaoApacDto;
}

export class ProntuarioArquivoDto implements IProntuarioArquivoDto {
    nome: string | undefined;
    extensaoArquivo: string | undefined;
    ehPasta: boolean;
    arquivoPaiId: string | undefined;
    pacienteId: string;
    urlArquivo: string | undefined;
    ultimaAlteracao: moment.Moment;
    tipoArquivo: string | undefined;
    arquivos: ProntuarioArquivoDto[] | undefined;
    isCollapsed: boolean;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    creationTime: moment.Moment;
    codigo: string | undefined;
    observacao: string | undefined;
    quantidadeArquivos: number;
    template: string | undefined;
    vip: boolean;
    isDefault: boolean;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVipDto;
    statusProntuario: StatusProntuarioEnum;
    readonly statusProntuarioString: string | undefined;
    clinicaMedicaPacienteVipId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProntuarioArquivoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.ehPasta = _data["ehPasta"];
            this.arquivoPaiId = _data["arquivoPaiId"];
            this.pacienteId = _data["pacienteId"];
            this.urlArquivo = _data["urlArquivo"];
            this.ultimaAlteracao = _data["ultimaAlteracao"] ? moment(_data["ultimaAlteracao"].toString()) : <any>undefined;
            this.tipoArquivo = _data["tipoArquivo"];
            if (Array.isArray(_data["arquivos"])) {
                this.arquivos = [] as any;
                for (let item of _data["arquivos"])
                    this.arquivos.push(ProntuarioArquivoDto.fromJS(item));
            }
            this.isCollapsed = _data["isCollapsed"];
            this.ordemProfissionalSaude = _data["ordemProfissionalSaude"];
            this.ordemPaciente = _data["ordemPaciente"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.codigo = _data["codigo"];
            this.observacao = _data["observacao"];
            this.quantidadeArquivos = _data["quantidadeArquivos"];
            this.template = _data["template"];
            this.vip = _data["vip"];
            this.isDefault = _data["isDefault"];
            this.clinicaMedicaPacienteVip = _data["clinicaMedicaPacienteVip"] ? ClinicaMedicaPacienteVipDto.fromJS(_data["clinicaMedicaPacienteVip"]) : <any>undefined;
            this.statusProntuario = _data["statusProntuario"];
            (<any>this).statusProntuarioString = _data["statusProntuarioString"];
            this.clinicaMedicaPacienteVipId = _data["clinicaMedicaPacienteVipId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProntuarioArquivoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProntuarioArquivoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["ehPasta"] = this.ehPasta;
        data["arquivoPaiId"] = this.arquivoPaiId;
        data["pacienteId"] = this.pacienteId;
        data["urlArquivo"] = this.urlArquivo;
        data["ultimaAlteracao"] = this.ultimaAlteracao ? this.ultimaAlteracao.toISOString() : <any>undefined;
        data["tipoArquivo"] = this.tipoArquivo;
        if (Array.isArray(this.arquivos)) {
            data["arquivos"] = [];
            for (let item of this.arquivos)
                data["arquivos"].push(item.toJSON());
        }
        data["isCollapsed"] = this.isCollapsed;
        data["ordemProfissionalSaude"] = this.ordemProfissionalSaude;
        data["ordemPaciente"] = this.ordemPaciente;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["codigo"] = this.codigo;
        data["observacao"] = this.observacao;
        data["quantidadeArquivos"] = this.quantidadeArquivos;
        data["template"] = this.template;
        data["vip"] = this.vip;
        data["isDefault"] = this.isDefault;
        data["clinicaMedicaPacienteVip"] = this.clinicaMedicaPacienteVip ? this.clinicaMedicaPacienteVip.toJSON() : <any>undefined;
        data["statusProntuario"] = this.statusProntuario;
        data["statusProntuarioString"] = this.statusProntuarioString;
        data["clinicaMedicaPacienteVipId"] = this.clinicaMedicaPacienteVipId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProntuarioArquivoDto {
        const json = this.toJSON();
        let result = new ProntuarioArquivoDto();
        result.init(json);
        return result;
    }
}

export interface IProntuarioArquivoDto {
    nome: string | undefined;
    extensaoArquivo: string | undefined;
    ehPasta: boolean;
    arquivoPaiId: string | undefined;
    pacienteId: string;
    urlArquivo: string | undefined;
    ultimaAlteracao: moment.Moment;
    tipoArquivo: string | undefined;
    arquivos: ProntuarioArquivoDto[] | undefined;
    isCollapsed: boolean;
    ordemProfissionalSaude: number | undefined;
    ordemPaciente: number | undefined;
    creationTime: moment.Moment;
    codigo: string | undefined;
    observacao: string | undefined;
    quantidadeArquivos: number;
    template: string | undefined;
    vip: boolean;
    isDefault: boolean;
    clinicaMedicaPacienteVip: ClinicaMedicaPacienteVipDto;
    statusProntuario: StatusProntuarioEnum;
    statusProntuarioString: string | undefined;
    clinicaMedicaPacienteVipId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUserId: number | undefined;
    id: string;
}

export class UltimosProntuariosCriadosDto implements IUltimosProntuariosCriadosDto {
    ultimosCriadosMedico: ProntuarioArquivoDto[] | undefined;
    ultimosGeral: ProntuarioArquivoDto[] | undefined;

    constructor(data?: IUltimosProntuariosCriadosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ultimosCriadosMedico"])) {
                this.ultimosCriadosMedico = [] as any;
                for (let item of _data["ultimosCriadosMedico"])
                    this.ultimosCriadosMedico.push(ProntuarioArquivoDto.fromJS(item));
            }
            if (Array.isArray(_data["ultimosGeral"])) {
                this.ultimosGeral = [] as any;
                for (let item of _data["ultimosGeral"])
                    this.ultimosGeral.push(ProntuarioArquivoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UltimosProntuariosCriadosDto {
        data = typeof data === 'object' ? data : {};
        let result = new UltimosProntuariosCriadosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ultimosCriadosMedico)) {
            data["ultimosCriadosMedico"] = [];
            for (let item of this.ultimosCriadosMedico)
                data["ultimosCriadosMedico"].push(item.toJSON());
        }
        if (Array.isArray(this.ultimosGeral)) {
            data["ultimosGeral"] = [];
            for (let item of this.ultimosGeral)
                data["ultimosGeral"].push(item.toJSON());
        }
        return data;
    }

    clone(): UltimosProntuariosCriadosDto {
        const json = this.toJSON();
        let result = new UltimosProntuariosCriadosDto();
        result.init(json);
        return result;
    }
}

export interface IUltimosProntuariosCriadosDto {
    ultimosCriadosMedico: ProntuarioArquivoDto[] | undefined;
    ultimosGeral: ProntuarioArquivoDto[] | undefined;
}

export class ProntuarioMedicoToSign implements IProntuarioMedicoToSign {
    arquivoId: string;
    arquivoBase64: string | undefined;
    codigoValidacaoIti: string | undefined;

    constructor(data?: IProntuarioMedicoToSign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivoId = _data["arquivoId"];
            this.arquivoBase64 = _data["arquivoBase64"];
            this.codigoValidacaoIti = _data["codigoValidacaoIti"];
        }
    }

    static fromJS(data: any): ProntuarioMedicoToSign {
        data = typeof data === 'object' ? data : {};
        let result = new ProntuarioMedicoToSign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivoId"] = this.arquivoId;
        data["arquivoBase64"] = this.arquivoBase64;
        data["codigoValidacaoIti"] = this.codigoValidacaoIti;
        return data;
    }

    clone(): ProntuarioMedicoToSign {
        const json = this.toJSON();
        let result = new ProntuarioMedicoToSign();
        result.init(json);
        return result;
    }
}

export interface IProntuarioMedicoToSign {
    arquivoId: string;
    arquivoBase64: string | undefined;
    codigoValidacaoIti: string | undefined;
}

export class ProntuarioArquivoDtoPagedResultDto implements IProntuarioArquivoDtoPagedResultDto {
    totalCount: number;
    items: ProntuarioArquivoDto[] | undefined;

    constructor(data?: IProntuarioArquivoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProntuarioArquivoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProntuarioArquivoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProntuarioArquivoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProntuarioArquivoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProntuarioArquivoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProntuarioArquivoDtoPagedResultDto {
    totalCount: number;
    items: ProntuarioArquivoDto[] | undefined;
}

export class ProntuarioHistoricoDto implements IProntuarioHistoricoDto {
    data: string | undefined;
    historicos: HistoricoDto[] | undefined;
    isCollapsed: boolean;

    constructor(data?: IProntuarioHistoricoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            if (Array.isArray(_data["historicos"])) {
                this.historicos = [] as any;
                for (let item of _data["historicos"])
                    this.historicos.push(HistoricoDto.fromJS(item));
            }
            this.isCollapsed = _data["isCollapsed"];
        }
    }

    static fromJS(data: any): ProntuarioHistoricoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProntuarioHistoricoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        if (Array.isArray(this.historicos)) {
            data["historicos"] = [];
            for (let item of this.historicos)
                data["historicos"].push(item.toJSON());
        }
        data["isCollapsed"] = this.isCollapsed;
        return data;
    }

    clone(): ProntuarioHistoricoDto {
        const json = this.toJSON();
        let result = new ProntuarioHistoricoDto();
        result.init(json);
        return result;
    }
}

export interface IProntuarioHistoricoDto {
    data: string | undefined;
    historicos: HistoricoDto[] | undefined;
    isCollapsed: boolean;
}

export class CreateAcessoProntuarioDto implements ICreateAcessoProntuarioDto {
    cpfProfissional: string;
    nomeProfissional: string;
    registroClasseProfissionalId: string;
    numeroRegistroClasseProfissional: string;
    cpfPaciente: string;
    token: string;

    constructor(data?: ICreateAcessoProntuarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpfProfissional = _data["cpfProfissional"];
            this.nomeProfissional = _data["nomeProfissional"];
            this.registroClasseProfissionalId = _data["registroClasseProfissionalId"];
            this.numeroRegistroClasseProfissional = _data["numeroRegistroClasseProfissional"];
            this.cpfPaciente = _data["cpfPaciente"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): CreateAcessoProntuarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAcessoProntuarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpfProfissional"] = this.cpfProfissional;
        data["nomeProfissional"] = this.nomeProfissional;
        data["registroClasseProfissionalId"] = this.registroClasseProfissionalId;
        data["numeroRegistroClasseProfissional"] = this.numeroRegistroClasseProfissional;
        data["cpfPaciente"] = this.cpfPaciente;
        data["token"] = this.token;
        return data;
    }

    clone(): CreateAcessoProntuarioDto {
        const json = this.toJSON();
        let result = new CreateAcessoProntuarioDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAcessoProntuarioDto {
    cpfProfissional: string;
    nomeProfissional: string;
    registroClasseProfissionalId: string;
    numeroRegistroClasseProfissional: string;
    cpfPaciente: string;
    token: string;
}

export class EnviarProntuarioDto implements IEnviarProntuarioDto {
    arquivo: ProntuarioMedicoDto;
    emails: string[] | undefined;
    nomePaciente: string | undefined;
    numeroPaciente: string | undefined;
    documento: ProntuarioArquivoDto;

    constructor(data?: IEnviarProntuarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arquivo = _data["arquivo"] ? ProntuarioMedicoDto.fromJS(_data["arquivo"]) : <any>undefined;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails.push(item);
            }
            this.nomePaciente = _data["nomePaciente"];
            this.numeroPaciente = _data["numeroPaciente"];
            this.documento = _data["documento"] ? ProntuarioArquivoDto.fromJS(_data["documento"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnviarProntuarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnviarProntuarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arquivo"] = this.arquivo ? this.arquivo.toJSON() : <any>undefined;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["nomePaciente"] = this.nomePaciente;
        data["numeroPaciente"] = this.numeroPaciente;
        data["documento"] = this.documento ? this.documento.toJSON() : <any>undefined;
        return data;
    }

    clone(): EnviarProntuarioDto {
        const json = this.toJSON();
        let result = new EnviarProntuarioDto();
        result.init(json);
        return result;
    }
}

export interface IEnviarProntuarioDto {
    arquivo: ProntuarioMedicoDto;
    emails: string[] | undefined;
    nomePaciente: string | undefined;
    numeroPaciente: string | undefined;
    documento: ProntuarioArquivoDto;
}

export class CreateFormularioMedicoDto implements ICreateFormularioMedicoDto {
    codigo: string | undefined;
    nome: string | undefined;
    extensaoArquivo: string | undefined;
    base64Arquivo: string | undefined;

    constructor(data?: ICreateFormularioMedicoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.nome = _data["nome"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.base64Arquivo = _data["base64Arquivo"];
        }
    }

    static fromJS(data: any): CreateFormularioMedicoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormularioMedicoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["nome"] = this.nome;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["base64Arquivo"] = this.base64Arquivo;
        return data;
    }

    clone(): CreateFormularioMedicoDto {
        const json = this.toJSON();
        let result = new CreateFormularioMedicoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFormularioMedicoDto {
    codigo: string | undefined;
    nome: string | undefined;
    extensaoArquivo: string | undefined;
    base64Arquivo: string | undefined;
}

export class FormularioMedicoDto implements IFormularioMedicoDto {
    codigo: string | undefined;
    nome: string | undefined;
    url: string | undefined;
    extensaoArquivo: string | undefined;
    dataAtualizacao: moment.Moment;
    template: string | undefined;
    id: string;

    constructor(data?: IFormularioMedicoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.nome = _data["nome"];
            this.url = _data["url"];
            this.extensaoArquivo = _data["extensaoArquivo"];
            this.dataAtualizacao = _data["dataAtualizacao"] ? moment(_data["dataAtualizacao"].toString()) : <any>undefined;
            this.template = _data["template"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FormularioMedicoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormularioMedicoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["nome"] = this.nome;
        data["url"] = this.url;
        data["extensaoArquivo"] = this.extensaoArquivo;
        data["dataAtualizacao"] = this.dataAtualizacao ? this.dataAtualizacao.toISOString() : <any>undefined;
        data["template"] = this.template;
        data["id"] = this.id;
        return data;
    }

    clone(): FormularioMedicoDto {
        const json = this.toJSON();
        let result = new FormularioMedicoDto();
        result.init(json);
        return result;
    }
}

export interface IFormularioMedicoDto {
    codigo: string | undefined;
    nome: string | undefined;
    url: string | undefined;
    extensaoArquivo: string | undefined;
    dataAtualizacao: moment.Moment;
    template: string | undefined;
    id: string;
}

export class ProntuarioProfissionalDto implements IProntuarioProfissionalDto {
    nome: string | undefined;
    cpf: string | undefined;
    numeroRegistroClasse: string | undefined;
    tipoRegistroClasse: string | undefined;
    clinicaMedica: string | undefined;
    cidadeClinica: string | undefined;
    ufClinica: string | undefined;
    assinatura: string | undefined;
    nomeAssinatura: string | undefined;
    certificado: string | undefined;
    ufRegistro: string | undefined;
    permitirAssinaturaDigital: boolean;
    especializacoes: RQEDto[] | undefined;
    endereco: EnderecoDto;

    constructor(data?: IProntuarioProfissionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"];
            this.cpf = _data["cpf"];
            this.numeroRegistroClasse = _data["numeroRegistroClasse"];
            this.tipoRegistroClasse = _data["tipoRegistroClasse"];
            this.clinicaMedica = _data["clinicaMedica"];
            this.cidadeClinica = _data["cidadeClinica"];
            this.ufClinica = _data["ufClinica"];
            this.assinatura = _data["assinatura"];
            this.nomeAssinatura = _data["nomeAssinatura"];
            this.certificado = _data["certificado"];
            this.ufRegistro = _data["ufRegistro"];
            this.permitirAssinaturaDigital = _data["permitirAssinaturaDigital"];
            if (Array.isArray(_data["especializacoes"])) {
                this.especializacoes = [] as any;
                for (let item of _data["especializacoes"])
                    this.especializacoes.push(RQEDto.fromJS(item));
            }
            this.endereco = _data["endereco"] ? EnderecoDto.fromJS(_data["endereco"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProntuarioProfissionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProntuarioProfissionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome;
        data["cpf"] = this.cpf;
        data["numeroRegistroClasse"] = this.numeroRegistroClasse;
        data["tipoRegistroClasse"] = this.tipoRegistroClasse;
        data["clinicaMedica"] = this.clinicaMedica;
        data["cidadeClinica"] = this.cidadeClinica;
        data["ufClinica"] = this.ufClinica;
        data["assinatura"] = this.assinatura;
        data["nomeAssinatura"] = this.nomeAssinatura;
        data["certificado"] = this.certificado;
        data["ufRegistro"] = this.ufRegistro;
        data["permitirAssinaturaDigital"] = this.permitirAssinaturaDigital;
        if (Array.isArray(this.especializacoes)) {
            data["especializacoes"] = [];
            for (let item of this.especializacoes)
                data["especializacoes"].push(item.toJSON());
        }
        data["endereco"] = this.endereco ? this.endereco.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProntuarioProfissionalDto {
        const json = this.toJSON();
        let result = new ProntuarioProfissionalDto();
        result.init(json);
        return result;
    }
}

export interface IProntuarioProfissionalDto {
    nome: string | undefined;
    cpf: string | undefined;
    numeroRegistroClasse: string | undefined;
    tipoRegistroClasse: string | undefined;
    clinicaMedica: string | undefined;
    cidadeClinica: string | undefined;
    ufClinica: string | undefined;
    assinatura: string | undefined;
    nomeAssinatura: string | undefined;
    certificado: string | undefined;
    ufRegistro: string | undefined;
    permitirAssinaturaDigital: boolean;
    especializacoes: RQEDto[] | undefined;
    endereco: EnderecoDto;
}

export class MoveProntuarioDto implements IMoveProntuarioDto {
    idPastaPai: string | undefined;
    arquivos: ProntuarioArquivoDto[] | undefined;

    constructor(data?: IMoveProntuarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPastaPai = _data["idPastaPai"];
            if (Array.isArray(_data["arquivos"])) {
                this.arquivos = [] as any;
                for (let item of _data["arquivos"])
                    this.arquivos.push(ProntuarioArquivoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveProntuarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveProntuarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPastaPai"] = this.idPastaPai;
        if (Array.isArray(this.arquivos)) {
            data["arquivos"] = [];
            for (let item of this.arquivos)
                data["arquivos"].push(item.toJSON());
        }
        return data;
    }

    clone(): MoveProntuarioDto {
        const json = this.toJSON();
        let result = new MoveProntuarioDto();
        result.init(json);
        return result;
    }
}

export interface IMoveProntuarioDto {
    idPastaPai: string | undefined;
    arquivos: ProntuarioArquivoDto[] | undefined;
}

export class BryInitializeRequestDto implements IBryInitializeRequestDto {
    pdfBytes: string | undefined;
    fileName: string | undefined;
    base64Cert: string | undefined;
    email: string | undefined;
    algoritmoHash: string | undefined;
    metadados: { [key: string]: string; } | undefined;

    constructor(data?: IBryInitializeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdfBytes = _data["pdfBytes"];
            this.fileName = _data["fileName"];
            this.base64Cert = _data["base64Cert"];
            this.email = _data["email"];
            this.algoritmoHash = _data["algoritmoHash"];
            if (_data["metadados"]) {
                this.metadados = {} as any;
                for (let key in _data["metadados"]) {
                    if (_data["metadados"].hasOwnProperty(key))
                        (<any>this.metadados)[key] = _data["metadados"][key];
                }
            }
        }
    }

    static fromJS(data: any): BryInitializeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BryInitializeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdfBytes"] = this.pdfBytes;
        data["fileName"] = this.fileName;
        data["base64Cert"] = this.base64Cert;
        data["email"] = this.email;
        data["algoritmoHash"] = this.algoritmoHash;
        if (this.metadados) {
            data["metadados"] = {};
            for (let key in this.metadados) {
                if (this.metadados.hasOwnProperty(key))
                    (<any>data["metadados"])[key] = (<any>this.metadados)[key];
            }
        }
        return data;
    }

    clone(): BryInitializeRequestDto {
        const json = this.toJSON();
        let result = new BryInitializeRequestDto();
        result.init(json);
        return result;
    }
}

export interface IBryInitializeRequestDto {
    pdfBytes: string | undefined;
    fileName: string | undefined;
    base64Cert: string | undefined;
    email: string | undefined;
    algoritmoHash: string | undefined;
    metadados: { [key: string]: string; } | undefined;
}

export class AssinaturaInicializada implements IAssinaturaInicializada {
    messageDigest: string | undefined;
    nonce: string | undefined;

    constructor(data?: IAssinaturaInicializada) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageDigest = _data["messageDigest"];
            this.nonce = _data["nonce"];
        }
    }

    static fromJS(data: any): AssinaturaInicializada {
        data = typeof data === 'object' ? data : {};
        let result = new AssinaturaInicializada();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageDigest"] = this.messageDigest;
        data["nonce"] = this.nonce;
        return data;
    }

    clone(): AssinaturaInicializada {
        const json = this.toJSON();
        let result = new AssinaturaInicializada();
        result.init(json);
        return result;
    }
}

export interface IAssinaturaInicializada {
    messageDigest: string | undefined;
    nonce: string | undefined;
}

export class InicializacaoAssinaturaResponse implements IInicializacaoAssinaturaResponse {
    nonce: string | undefined;
    formatoDadosEntrada: string | undefined;
    formatoDadosSaida: string | undefined;
    algoritmoHash: string | undefined;
    assinaturasInicializadas: AssinaturaInicializada[] | undefined;

    constructor(data?: IInicializacaoAssinaturaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nonce = _data["nonce"];
            this.formatoDadosEntrada = _data["formatoDadosEntrada"];
            this.formatoDadosSaida = _data["formatoDadosSaida"];
            this.algoritmoHash = _data["algoritmoHash"];
            if (Array.isArray(_data["assinaturasInicializadas"])) {
                this.assinaturasInicializadas = [] as any;
                for (let item of _data["assinaturasInicializadas"])
                    this.assinaturasInicializadas.push(AssinaturaInicializada.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InicializacaoAssinaturaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InicializacaoAssinaturaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nonce"] = this.nonce;
        data["formatoDadosEntrada"] = this.formatoDadosEntrada;
        data["formatoDadosSaida"] = this.formatoDadosSaida;
        data["algoritmoHash"] = this.algoritmoHash;
        if (Array.isArray(this.assinaturasInicializadas)) {
            data["assinaturasInicializadas"] = [];
            for (let item of this.assinaturasInicializadas)
                data["assinaturasInicializadas"].push(item.toJSON());
        }
        return data;
    }

    clone(): InicializacaoAssinaturaResponse {
        const json = this.toJSON();
        let result = new InicializacaoAssinaturaResponse();
        result.init(json);
        return result;
    }
}

export interface IInicializacaoAssinaturaResponse {
    nonce: string | undefined;
    formatoDadosEntrada: string | undefined;
    formatoDadosSaida: string | undefined;
    algoritmoHash: string | undefined;
    assinaturasInicializadas: AssinaturaInicializada[] | undefined;
}

export class CreateQualidadeSonoDto implements ICreateQualidadeSonoDto {
    duracaoSono: string;
    qualidadeSonoEnum: QualidadeSonoEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateQualidadeSonoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duracaoSono = _data["duracaoSono"];
            this.qualidadeSonoEnum = _data["qualidadeSonoEnum"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateQualidadeSonoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualidadeSonoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duracaoSono"] = this.duracaoSono;
        data["qualidadeSonoEnum"] = this.qualidadeSonoEnum;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateQualidadeSonoDto {
        const json = this.toJSON();
        let result = new CreateQualidadeSonoDto();
        result.init(json);
        return result;
    }
}

export interface ICreateQualidadeSonoDto {
    duracaoSono: string;
    qualidadeSonoEnum: QualidadeSonoEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class UpdateQualidadeSonoDto implements IUpdateQualidadeSonoDto {
    duracaoSono: string;
    qualidadeSonoEnum: QualidadeSonoEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateQualidadeSonoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duracaoSono = _data["duracaoSono"];
            this.qualidadeSonoEnum = _data["qualidadeSonoEnum"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateQualidadeSonoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualidadeSonoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duracaoSono"] = this.duracaoSono;
        data["qualidadeSonoEnum"] = this.qualidadeSonoEnum;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateQualidadeSonoDto {
        const json = this.toJSON();
        let result = new UpdateQualidadeSonoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateQualidadeSonoDto {
    duracaoSono: string;
    qualidadeSonoEnum: QualidadeSonoEnum;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class QualidadeSonoDtoPagedResultDto implements IQualidadeSonoDtoPagedResultDto {
    totalCount: number;
    items: QualidadeSonoDto[] | undefined;

    constructor(data?: IQualidadeSonoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QualidadeSonoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualidadeSonoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualidadeSonoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): QualidadeSonoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new QualidadeSonoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IQualidadeSonoDtoPagedResultDto {
    totalCount: number;
    items: QualidadeSonoDto[] | undefined;
}

export class CreateRegistroAcessoProntuarioDto implements ICreateRegistroAcessoProntuarioDto {
    userId: number | undefined;
    pacienteId: string;
    nomeArquivo: string | undefined;
    destinatario: string[] | undefined;

    constructor(data?: ICreateRegistroAcessoProntuarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.pacienteId = _data["pacienteId"];
            this.nomeArquivo = _data["nomeArquivo"];
            if (Array.isArray(_data["destinatario"])) {
                this.destinatario = [] as any;
                for (let item of _data["destinatario"])
                    this.destinatario.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRegistroAcessoProntuarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistroAcessoProntuarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["pacienteId"] = this.pacienteId;
        data["nomeArquivo"] = this.nomeArquivo;
        if (Array.isArray(this.destinatario)) {
            data["destinatario"] = [];
            for (let item of this.destinatario)
                data["destinatario"].push(item);
        }
        return data;
    }

    clone(): CreateRegistroAcessoProntuarioDto {
        const json = this.toJSON();
        let result = new CreateRegistroAcessoProntuarioDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRegistroAcessoProntuarioDto {
    userId: number | undefined;
    pacienteId: string;
    nomeArquivo: string | undefined;
    destinatario: string[] | undefined;
}

export class RegistroAcessoProntuarioDto implements IRegistroAcessoProntuarioDto {
    userId: number;
    nomeResponsavel: string | undefined;
    cpfResponsavel: string | undefined;
    pacienteId: string;
    nomePaciente: string | undefined;
    cpfPaciente: string | undefined;
    dataHora: moment.Moment;
    descricao: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRegistroAcessoProntuarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.nomeResponsavel = _data["nomeResponsavel"];
            this.cpfResponsavel = _data["cpfResponsavel"];
            this.pacienteId = _data["pacienteId"];
            this.nomePaciente = _data["nomePaciente"];
            this.cpfPaciente = _data["cpfPaciente"];
            this.dataHora = _data["dataHora"] ? moment(_data["dataHora"].toString()) : <any>undefined;
            this.descricao = _data["descricao"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegistroAcessoProntuarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistroAcessoProntuarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["nomeResponsavel"] = this.nomeResponsavel;
        data["cpfResponsavel"] = this.cpfResponsavel;
        data["pacienteId"] = this.pacienteId;
        data["nomePaciente"] = this.nomePaciente;
        data["cpfPaciente"] = this.cpfPaciente;
        data["dataHora"] = this.dataHora ? this.dataHora.toISOString() : <any>undefined;
        data["descricao"] = this.descricao;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RegistroAcessoProntuarioDto {
        const json = this.toJSON();
        let result = new RegistroAcessoProntuarioDto();
        result.init(json);
        return result;
    }
}

export interface IRegistroAcessoProntuarioDto {
    userId: number;
    nomeResponsavel: string | undefined;
    cpfResponsavel: string | undefined;
    pacienteId: string;
    nomePaciente: string | undefined;
    cpfPaciente: string | undefined;
    dataHora: moment.Moment;
    descricao: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class RegistroAcessoProntuarioDtoPagedResultDto implements IRegistroAcessoProntuarioDtoPagedResultDto {
    totalCount: number;
    items: RegistroAcessoProntuarioDto[] | undefined;

    constructor(data?: IRegistroAcessoProntuarioDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RegistroAcessoProntuarioDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegistroAcessoProntuarioDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistroAcessoProntuarioDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RegistroAcessoProntuarioDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RegistroAcessoProntuarioDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRegistroAcessoProntuarioDtoPagedResultDto {
    totalCount: number;
    items: RegistroAcessoProntuarioDto[] | undefined;
}

export class CreateRegistroRespostaPacienteClinicaDto implements ICreateRegistroRespostaPacienteClinicaDto {
    remetenteId: string;
    pacienteId: string;
    notificacaoId: string;
    aceito: boolean;
    isClinica: boolean;

    constructor(data?: ICreateRegistroRespostaPacienteClinicaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remetenteId = _data["remetenteId"];
            this.pacienteId = _data["pacienteId"];
            this.notificacaoId = _data["notificacaoId"];
            this.aceito = _data["aceito"];
            this.isClinica = _data["isClinica"];
        }
    }

    static fromJS(data: any): CreateRegistroRespostaPacienteClinicaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistroRespostaPacienteClinicaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remetenteId"] = this.remetenteId;
        data["pacienteId"] = this.pacienteId;
        data["notificacaoId"] = this.notificacaoId;
        data["aceito"] = this.aceito;
        data["isClinica"] = this.isClinica;
        return data;
    }

    clone(): CreateRegistroRespostaPacienteClinicaDto {
        const json = this.toJSON();
        let result = new CreateRegistroRespostaPacienteClinicaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRegistroRespostaPacienteClinicaDto {
    remetenteId: string;
    pacienteId: string;
    notificacaoId: string;
    aceito: boolean;
    isClinica: boolean;
}

export class PagedRelatoriosResultRequestDto implements IPagedRelatoriosResultRequestDto {
    publicoAlvo: PublicoAlvoEnum;
    id: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    descricao: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IPagedRelatoriosResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicoAlvo = _data["publicoAlvo"];
            this.id = _data["id"];
            this.dataInicio = _data["dataInicio"] ? moment(_data["dataInicio"].toString()) : <any>undefined;
            this.dataFim = _data["dataFim"] ? moment(_data["dataFim"].toString()) : <any>undefined;
            this.descricao = _data["descricao"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): PagedRelatoriosResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedRelatoriosResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicoAlvo"] = this.publicoAlvo;
        data["id"] = this.id;
        data["dataInicio"] = this.dataInicio ? this.dataInicio.toISOString() : <any>undefined;
        data["dataFim"] = this.dataFim ? this.dataFim.toISOString() : <any>undefined;
        data["descricao"] = this.descricao;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }

    clone(): PagedRelatoriosResultRequestDto {
        const json = this.toJSON();
        let result = new PagedRelatoriosResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedRelatoriosResultRequestDto {
    publicoAlvo: PublicoAlvoEnum;
    id: string | undefined;
    dataInicio: moment.Moment | undefined;
    dataFim: moment.Moment | undefined;
    descricao: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class RelatorioDto implements IRelatorioDto {
    descricao: string | undefined;
    quantidade: number;

    constructor(data?: IRelatorioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descricao = _data["descricao"];
            this.quantidade = _data["quantidade"];
        }
    }

    static fromJS(data: any): RelatorioDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatorioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descricao"] = this.descricao;
        data["quantidade"] = this.quantidade;
        return data;
    }

    clone(): RelatorioDto {
        const json = this.toJSON();
        let result = new RelatorioDto();
        result.init(json);
        return result;
    }
}

export interface IRelatorioDto {
    descricao: string | undefined;
    quantidade: number;
}

export class RelatorioDtoPagedResultDto implements IRelatorioDtoPagedResultDto {
    totalCount: number;
    items: RelatorioDto[] | undefined;

    constructor(data?: IRelatorioDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RelatorioDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RelatorioDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatorioDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RelatorioDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RelatorioDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRelatorioDtoPagedResultDto {
    totalCount: number;
    items: RelatorioDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    nomeSocial: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    empresaId: string;
    validarAssinatura: boolean;
    assinaturaRegular: boolean;
    assinatura: AssinaturaDto;
    tipoUsuario: string | undefined;
    tipoUsuarioEnum: TipoUsuarioEnum;
    lastLogin: moment.Moment | undefined;
    roleNames: string[] | undefined;
    espacoUtilizado: string | undefined;
    urlFotoPerfil: string | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nomeSocial = _data["nomeSocial"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.empresaId = _data["empresaId"];
            this.validarAssinatura = _data["validarAssinatura"];
            this.assinaturaRegular = _data["assinaturaRegular"];
            this.assinatura = _data["assinatura"] ? AssinaturaDto.fromJS(_data["assinatura"]) : <any>undefined;
            this.tipoUsuario = _data["tipoUsuario"];
            this.tipoUsuarioEnum = _data["tipoUsuarioEnum"];
            this.lastLogin = _data["lastLogin"] ? moment(_data["lastLogin"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.espacoUtilizado = _data["espacoUtilizado"];
            this.urlFotoPerfil = _data["urlFotoPerfil"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nomeSocial"] = this.nomeSocial;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["empresaId"] = this.empresaId;
        data["validarAssinatura"] = this.validarAssinatura;
        data["assinaturaRegular"] = this.assinaturaRegular;
        data["assinatura"] = this.assinatura ? this.assinatura.toJSON() : <any>undefined;
        data["tipoUsuario"] = this.tipoUsuario;
        data["tipoUsuarioEnum"] = this.tipoUsuarioEnum;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["espacoUtilizado"] = this.espacoUtilizado;
        data["urlFotoPerfil"] = this.urlFotoPerfil;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    nomeSocial: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    empresaId: string;
    validarAssinatura: boolean;
    assinaturaRegular: boolean;
    assinatura: AssinaturaDto;
    tipoUsuario: string | undefined;
    tipoUsuarioEnum: TipoUsuarioEnum;
    lastLogin: moment.Moment | undefined;
    roleNames: string[] | undefined;
    espacoUtilizado: string | undefined;
    urlFotoPerfil: string | undefined;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    nomeFantasia: string | undefined;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.nomeFantasia = _data["nomeFantasia"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["nomeFantasia"] = this.nomeFantasia;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    nomeFantasia: string | undefined;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    assinaturaClinicaValida: boolean;
    clinicaMedicaId: string | undefined;
    profisionalSaudeId: string | undefined;
    pacienteId: string | undefined;
    funcionarioId: string | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.assinaturaClinicaValida = _data["assinaturaClinicaValida"];
            this.clinicaMedicaId = _data["clinicaMedicaId"];
            this.profisionalSaudeId = _data["profisionalSaudeId"];
            this.pacienteId = _data["pacienteId"];
            this.funcionarioId = _data["funcionarioId"];
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["assinaturaClinicaValida"] = this.assinaturaClinicaValida;
        data["clinicaMedicaId"] = this.clinicaMedicaId;
        data["profisionalSaudeId"] = this.profisionalSaudeId;
        data["pacienteId"] = this.pacienteId;
        data["funcionarioId"] = this.funcionarioId;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    assinaturaClinicaValida: boolean;
    clinicaMedicaId: string | undefined;
    profisionalSaudeId: string | undefined;
    pacienteId: string | undefined;
    funcionarioId: string | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class CreateTemperaturaDto implements ICreateTemperaturaDto {
    valorTemperatura: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;

    constructor(data?: ICreateTemperaturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorTemperatura = _data["valorTemperatura"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
        }
    }

    static fromJS(data: any): CreateTemperaturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemperaturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorTemperatura"] = this.valorTemperatura;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        return data;
    }

    clone(): CreateTemperaturaDto {
        const json = this.toJSON();
        let result = new CreateTemperaturaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTemperaturaDto {
    valorTemperatura: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
}

export class UpdateTemperaturaDto implements IUpdateTemperaturaDto {
    valorTemperatura: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;

    constructor(data?: IUpdateTemperaturaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorTemperatura = _data["valorTemperatura"];
            this.observacao = _data["observacao"];
            this.dataHoraString = _data["dataHoraString"];
            this.pacienteId = _data["pacienteId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTemperaturaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemperaturaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorTemperatura"] = this.valorTemperatura;
        data["observacao"] = this.observacao;
        data["dataHoraString"] = this.dataHoraString;
        data["pacienteId"] = this.pacienteId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateTemperaturaDto {
        const json = this.toJSON();
        let result = new UpdateTemperaturaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTemperaturaDto {
    valorTemperatura: number;
    observacao: string | undefined;
    dataHoraString: string;
    pacienteId: string;
    id: string;
}

export class TemperaturaDtoPagedResultDto implements ITemperaturaDtoPagedResultDto {
    totalCount: number;
    items: TemperaturaDto[] | undefined;

    constructor(data?: ITemperaturaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TemperaturaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemperaturaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperaturaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TemperaturaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TemperaturaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITemperaturaDtoPagedResultDto {
    totalCount: number;
    items: TemperaturaDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    tenancyName: string | undefined;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.tenancyName = _data["tenancyName"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["tenancyName"] = this.tenancyName;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    tenancyName: string | undefined;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    clinicaId: string | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            this.clinicaId = _data["clinicaId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["clinicaId"] = this.clinicaId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    clinicaId: string | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class CreateTokenNotificationDto implements ICreateTokenNotificationDto {
    pacienteId: string;
    token: string | undefined;
    tokenWeb: string | undefined;

    constructor(data?: ICreateTokenNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pacienteId = _data["pacienteId"];
            this.token = _data["token"];
            this.tokenWeb = _data["tokenWeb"];
        }
    }

    static fromJS(data: any): CreateTokenNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTokenNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pacienteId"] = this.pacienteId;
        data["token"] = this.token;
        data["tokenWeb"] = this.tokenWeb;
        return data;
    }

    clone(): CreateTokenNotificationDto {
        const json = this.toJSON();
        let result = new CreateTokenNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTokenNotificationDto {
    pacienteId: string;
    token: string | undefined;
    tokenWeb: string | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string | undefined;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string | undefined;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;
}

export class WebhookDataDto implements IWebhookDataDto {
    id: string | undefined;

    constructor(data?: IWebhookDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebhookDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): WebhookDataDto {
        const json = this.toJSON();
        let result = new WebhookDataDto();
        result.init(json);
        return result;
    }
}

export interface IWebhookDataDto {
    id: string | undefined;
}

export class MercadoPagoWebhookPayloadDto implements IMercadoPagoWebhookPayloadDto {
    type: string | undefined;
    data: WebhookDataDto;

    constructor(data?: IMercadoPagoWebhookPayloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.data = _data["data"] ? WebhookDataDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MercadoPagoWebhookPayloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoPagoWebhookPayloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }

    clone(): MercadoPagoWebhookPayloadDto {
        const json = this.toJSON();
        let result = new MercadoPagoWebhookPayloadDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoPagoWebhookPayloadDto {
    type: string | undefined;
    data: WebhookDataDto;
}

export class ShiftPayWebhookPayloadDto implements IShiftPayWebhookPayloadDto {
    paymentId: string | undefined;
    signatureId: string | undefined;
    transferId: string | undefined;
    currentStatus: number;
    token: string | undefined;

    constructor(data?: IShiftPayWebhookPayloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.signatureId = _data["signatureId"];
            this.transferId = _data["transferId"];
            this.currentStatus = _data["currentStatus"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ShiftPayWebhookPayloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftPayWebhookPayloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["signatureId"] = this.signatureId;
        data["transferId"] = this.transferId;
        data["currentStatus"] = this.currentStatus;
        data["token"] = this.token;
        return data;
    }

    clone(): ShiftPayWebhookPayloadDto {
        const json = this.toJSON();
        let result = new ShiftPayWebhookPayloadDto();
        result.init(json);
        return result;
    }
}

export interface IShiftPayWebhookPayloadDto {
    paymentId: string | undefined;
    signatureId: string | undefined;
    transferId: string | undefined;
    currentStatus: number;
    token: string | undefined;
}

export class ShiftPayWebhookResponseDto implements IShiftPayWebhookResponseDto {
    isSuccess: boolean;
    errorMessage: string | undefined;

    constructor(data?: IShiftPayWebhookResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ShiftPayWebhookResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftPayWebhookResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["errorMessage"] = this.errorMessage;
        return data;
    }

    clone(): ShiftPayWebhookResponseDto {
        const json = this.toJSON();
        let result = new ShiftPayWebhookResponseDto();
        result.init(json);
        return result;
    }
}

export interface IShiftPayWebhookResponseDto {
    isSuccess: boolean;
    errorMessage: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}